import { featuresEn, featuresRu } from './featuresDict';

export type Lang = 'ru' | 'en';

type Dict = Record<string, string>;

export const ru: Dict = {
  'collection.label': 'Подборка',
  'collection.all': 'Все данные',
  'collection.allZones': 'Все точки подборки',
  'collection.none': 'Без подборки',
  'collection.source': 'Исходное обращение',
  'collection.counts': 'Всего',
  'collection.ai': 'Размечено ИИ',
  'collection.human': 'Размечено человеком',
  'collection.remaining': 'Без разметки',
  'collection.loadError': 'Не удалось загрузить подборку',
  'collection.status.pending': 'Подборка ожидает подготовки',
  'collection.status.running': 'Идёт сбор и предразметка',
  'collection.status.partial': 'Подготовлено частично: некоторые примеры требуют проверки или повторной обработки',
  'collection.status.failed': 'Не удалось завершить подготовку',
  'collection.removeTitle': 'Что сделать с примером?',
  'collection.removeHelp': 'Можно убрать пример только из этой подборки или удалить его из общего пула данных.',
  'collection.unlink': 'Убрать из подборки',
  'collection.delete': 'Удалить полностью',
  'collection.unlinked': 'Пример убран из подборки',
  // Generic
  'common.save': 'Сохранить',
  'common.cancel': 'Отмена',
  'common.close': 'Закрыть',
  'common.copy': 'Копировать',
  'common.copied': 'Скопировано',
  'common.delete': 'Удалить',
  'common.create': 'Создать',
  'common.edit': 'Изменить',
  'common.loading': 'Загрузка…',
  'tables.confirmedState': 'Подтверждённое состояние — {{state}}',
  'tables.observedAt': 'Данные по {{time}}',
  'tables.photoAt': 'Снимок — {{time}}',
  'tables.photoUnavailable': 'Снимок недоступен',
  'common.retry': 'Повторить',
  'common.back': 'Назад',
  'common.error': 'Ошибка',
  'common.search': 'Поиск',
  'common.signOut': 'Выйти',
  'common.account': 'Аккаунт',
  'common.openMenu': 'Открыть меню',
  'common.settings': 'Настройки',
  'common.info': 'О разделе',
  'layout.branch': 'Филиал',
  'common.collapseMenu': 'Свернуть меню',
  'common.expandMenu': 'Развернуть меню',

  // Sidebar groups + items
  'sidebar.usage': 'Использование',
  'sidebar.configuration': 'Конфигурация',
  'sidebar.group.live': 'Live',
  'sidebar.group.analytics': 'Аналитика',
  'sidebar.group.main': 'Главное',
  'sidebar.group.settings': 'Настройки',
  'sidebar.group.experimental': 'Экспериментальные',
  'sidebar.portfolio': 'Все филиалы',
  'sidebar.dashboard': 'Дашборд смены',
  'sidebar.now': 'Сейчас',
  'sidebar.report': 'Отчёты',
  'sidebar.tasks': 'Задачи на смену',
  'sidebar.visitsLive': 'Визиты',

  // Unified report (Отчёт)
  'report.title': 'Отчёты',
  'report.subtitle': 'Что происходило в филиале',
  'report.allBranches': 'Все филиалы',
  'report.yesterday': 'вчера',
  'report.prevDay': 'Предыдущий день',
  'report.nextDay': 'Следующий день',
  'report.summary': 'Сводка',
  'report.heroDay': 'Главное за день',
  'report.observations': 'Наблюдения',
  'report.calmTitle': 'Итог дня',
  'report.allCalm': 'Вчера всё прошло спокойно',
  'report.allCalmSub': 'Выкладка, очередь, столы и задачи — без проблем.',
  'report.closed': 'Филиал был закрыт — данных за день нет',
  'report.showPrevDay': 'Показать предыдущий день',
  'report.details': 'Подробнее',
  'report.collapse': 'Свернуть',
  'report.openGrafana': 'Открыть в Grafana',
  'report.zoom.day': 'День',
  'report.zoom.week': 'Неделя',
  'report.zoom.dayShort': 'Дн',
  'report.zoom.weekShort': 'Нед',
  'report.zoom.dayTiny': 'Д',
  'report.zoom.weekTiny': 'Н',
  'report.prevWeek': 'было',
  'report.prevWeekNav': 'Предыдущая неделя',
  'report.nextWeekNav': 'Следующая неделя',
  'report.summaryWeek': 'Сводка за неделю',
  'report.noWeek': 'Отчёт за неделю ещё не сформирован',
  'report.generatedAt': 'Сформирован: {{time}}',
  'sidebar.setupWizard': 'Мастер настройки',
  'sidebar.general': 'Филиал',
  'sidebar.zoning': 'Зонирование',
  'sidebar.calibration': 'Калибровка полигонов',
  'sidebar.plan': 'План',
  'sidebar.checklists': 'Чек-листы',
  'sidebar.visits': 'Визиты',
  'sidebar.salesPlan': 'План продаж',
  'sidebar.receipts': 'Чеки',
  'sidebar.queuesStaff': 'Очереди и сотрудники',
  'sidebar.notifications': 'Уведомления',
  'sidebar.equipment': 'Оборудование',

  // Setup-master wizard (#47)
  'wizard.title.empty': 'Мастер настройки',
  'wizard.title.withBranch': 'Мастер настройки — {{name}}',
  'wizard.description': 'Пошаговая настройка нового филиала: подключение jetson’а, обнаружение оборудования, зонирование, дашборды, чаты, передача PM-у.',
  'wizard.pickBranchHint': 'Выберите филиал в селекторе сверху, чтобы открыть мастер настройки.',
  'wizard.openBranchPicker': 'Открыть страницу филиала',
  'wizard.stage.placeholderBody': 'Этот этап пока в скелетном виде — детали появятся в следующих коммитах.',
  'wizard.stage.jetson.title': 'Этап 1: Подключение jetson’а (curl-онбординг)',
  'wizard.stage.equipment.title': 'Этап 2: Обнаружение оборудования',
  'wizard.stage.zoning.title': 'Этап 3: Зонирование',
  'wizard.stage.grafana.title': 'Этап 4: Дашборды Grafana',
  'wizard.stage.notifications.title': 'Этап 5: Уведомления и клиентский чат',
  'wizard.stage.handoff.title': 'Этап 6: Передача PM-у',
  'wizard.summary.jetson.noLc': 'Jetson не привязан',
  'wizard.summary.jetson.archived': 'Архивирован',
  'wizard.summary.jetson.done': 'Готово — {{done}}/{{total}}',
  'wizard.summary.jetson.inProgress': 'В процессе — {{done}}/{{total}} этапов',
  'wizard.error.jetson.archived': 'Этот jetson помечен как архивный. Восстановите запись или привяжите другой jetson через /admin/local-computers.',
  'wizard.stage.jetson.noLcHint': 'Этот филиал ещё не привязан к jetson’у. Выпустите curl-токен в админке LC и выполните одну команду на новой коробке.',
  'wizard.stage.jetson.issueToken': 'Выпустить curl-токен',
  'wizard.stage.jetson.openLcDetail': 'Открыть карточку LC',
  'wizard.stage.equipment.openTab': 'Открыть вкладку «Оборудование»',
  'wizard.summary.grafana.empty': 'URL зоны: — · По стойкам: 0 · По кассам: 0',
  'wizard.summary.notifications.empty': 'PRS: — · CCS: — · TCS: — · ZRS: —',
  'wizard.summary.handoff.empty': 'PM-приглашений: 0 · Grafana-доступов: — · Инвайт чата: —',
  'wizard.blockedReason.noZone': 'Выберите филиал, чтобы начать мастер настройки.',
  'wizard.blockedReason.waitForDockerRunning': 'Ожидаем этап 1: jetson должен достичь стадии DOCKER_RUNNING.',
  'wizard.blockedReason.waitForCameras': 'Ожидаем этап 2: должна быть сохранена хотя бы одна камера.',

  // Theme
  'theme.system': 'Тема: системная',
  'theme.light': 'Тема: светлая',
  'theme.dark': 'Тема: тёмная',

  // Branch selector
  'branchSelector.placeholder': 'Выберите филиал',
  'branchSelector.search': 'Поиск филиала…',
  'branchSelector.empty': 'Нет филиалов',
  'branchSelector.notFound': 'Ничего не найдено',
  'branchSelector.create': 'Создать филиал',
  'branchSelector.createTitle': 'Создать филиал',
  'branchSelector.createNameLabel': 'Название филиала',
  'branchSelector.createSaving': 'Создание…',
  'branchSelector.createFail': 'Не удалось создать филиал.',
  'branchSelector.noAccess': 'Нет доступа',
  'branchSelector.loadError': 'Не удалось загрузить филиалы',
  'branchSelector.loadErrorHint': 'Проблема с загрузкой, а не с доступом. Повторяем автоматически — проверьте соединение.',
  'branchSelector.allBranches': 'Все филиалы',
  'branchSelector.group': 'Группа филиалов',
  'branchSelector.groups': 'Группы',
  'branchSelector.branches': 'Филиалы',
  'branchSelector.archived': 'Архив',
  'layout.archivedNotice': 'Филиал в архиве: данные доступны, включить анализ нельзя.',

  // Login / signup page
  'login.title': 'Вход в Linza Metrics',
  'login.chooseMethod': 'Выберите способ входа',
  'login.submit': 'Войти',
  'login.submitting': 'Вход…',
  'login.invalidCreds': 'Неверный логин или пароль.',
  'login.serverError': 'Ошибка сервера при входе',
  'login.networkError': 'Сервер недоступен. Проверьте подключение.',
  'login.telegramError': 'Ошибка входа через Telegram. Попробуйте снова.',
  'auth.usernameLabel': 'Логин',
  'auth.passwordLabel': 'Пароль',
  'auth.or': 'или',
  'auth.orPasswordLogin': 'или войти по логину и паролю',
  'auth.loginWithPassword': 'Войти по логину и паролю',
  'auth.signupWithPassword': 'Создать аккаунт с логином и паролем',
  'auth.backToTelegram': 'Назад к Telegram',
  'auth.telegramBlocked': 'Кажется, Telegram недоступен на вашем устройстве.',
  'auth.noAccountPrompt': 'Нет аккаунта?',
  'auth.noAccountCta': 'Создать аккаунт',
  'auth.haveAccountPrompt': 'Уже есть аккаунт?',
  'auth.haveAccountCta': 'Войти',
  'auth.inviteGreeting': 'Вас приглашают в «{{zone}}»',
  'auth.inviteGreetingSub': 'После входа вы получите роль {{role}}.',
  'auth.switchToSignup': 'Создать аккаунт с логином и паролем',
  'auth.switchToLogin': 'У меня уже есть аккаунт — войти',
  'auth.signupSubmit': 'Создать аккаунт',
  'auth.telegramUnreachable': 'Вход через Telegram недоступен в этой сети — используйте логин и пароль.',
  'auth.signInWithTelegram': 'Войти через Telegram',
  'auth.oidcExchanging': 'Завершаем вход через Telegram…',
  'auth.oidcMissingCode': 'Telegram не вернул код авторизации. Попробуйте ещё раз.',
  'auth.oidcStateMismatch': 'Сессия входа устарела. Попробуйте ещё раз.',
  'auth.oidcExchangeFailed': 'Не удалось завершить вход через Telegram.',
  'auth.backToLogin': 'Вернуться ко входу',
  'auth.tgNoBinding': 'Telegram-аккаунт не привязан ни к одному пользователю. Попросите администратора привязать ваш Telegram username или попросите пригласительную ссылку.',
  'auth.tgAlreadyBound': 'Этот Telegram-аккаунт уже привязан к другому пользователю системы. Войдите тем аккаунтом или попросите администратора отвязать его.',
  'auth.tgIdentityChanged': 'Вход через Telegram изменился, и аккаунт не распознан. Попросите администратора перепривязать ваш Telegram-аккаунт.',

  // Sidebar section dividers (FE-90)
  'sidebar.section.daily_ops': 'Ежедневные задачи',
  'sidebar.section.communication': 'Коммуникация',
  'sidebar.section.insights': 'Аналитика',
  'sidebar.section.setup': 'Настройка',

  // Access management (FE-20)
  'sidebar.access': 'Доступы',
  'sidebar.statistics': 'Данные',
  'sidebar.status': 'Статус',
  'status.title': 'Статус',
  'status.subtitle': 'Что требует внимания и как изменилось к прошлому периоду',
  'access.title': 'Управление доступом',
  'access.subtitle': 'Участники зоны и ссылки доступа.',
  'access.linksTitle': 'Ссылки доступа',
  'access.createLink': 'Создать ссылку',
  'access.addUser': 'Добавить пользователя',
  'access.noLinks': 'Активных ссылок нет.',
  'access.members': 'Участники',
  'access.noMembers': 'Участников пока нет.',
  'access.expiresOn': 'до {{date}}',
  'access.copied': 'Скопировано',
  'access.persistent.count': '· использована {{n}} раз',
  'access.copyLink': 'Скопировать ссылку',
  'access.copyTelegramLink': 'Скопировать ссылку для Telegram',
  'access.revoke': 'Удалить ссылку',
  'access.remove': 'Удалить участника',
  'access.leave': 'Покинуть филиал',
  'access.leaveConfirm': 'Вы уверены, что хотите покинуть этот филиал? Доступ можно будет восстановить только через приглашение.',
  'access.you': '(вы)',
  // Pin-message invite (the per-zone link pinned in the branch TG chat)
  'access.pin.badge': 'Постоянная ссылка',
  'access.pin.hint': 'Эта ссылка всегда доступна и не истекает — её можно оставить в любом постоянном месте, например, закрепить в чате филиала.',
  'access.pin.autoRenew': 'без срока истечения',
  'access.pin.reissue': 'Перевыпустить ссылку',
  'access.pinReissueConfirm': 'Перевыпустить постоянную ссылку? Старая ссылка перестанет работать. Если ссылка была закреплена в чате филиала, мы попробуем обновить закреплённое сообщение автоматически.',
  // Create-link dialog
  'access.create.title': 'Создать ссылку доступа',
  'access.create.role': 'Роль',
  'access.create.expires': 'Срок действия',
  'access.create.expires1d': '1 день',
  'access.create.expires7d': '7 дней',
  'access.create.expires30d': '30 дней',
  'access.create.expires90d': '90 дней',
  'access.create.expiresForever': 'Бессрочно',
  'access.create.oneShot': 'Одноразовая (сгорает после первого входа)',
  'access.create.submit': 'Создать',
  // Add-user dialog
  'access.add.title': 'Добавить пользователя',
  'access.add.createTitle': 'Создать пользователя',
  'access.add.role': 'Роль',
  'access.add.search': 'Найти пользователя',
  'access.add.searchSuperuser': 'Найти пользователя (или создать нового)',
  'access.add.searchPlaceholder': 'Логин',
  'access.add.noMatches': 'Совпадений не найдено.',
  'access.add.noMatchesScoped': 'Совпадений не найдено среди пользователей, с которыми у вас есть общие филиалы.',
  'access.add.createWith': 'Создать пользователя «{{username}}»',
  'access.add.usernameLabel': 'Логин',
  'access.add.passwordLabel': 'Пароль',
  'access.add.createSubmit': 'Создать и добавить',
  'invite.title': 'Приглашение в зону',
  'invite.description': 'Вас приглашают в «{{zone}}» с ролью {{role}}.',
  'invite.accept': 'Принять приглашение',
  'invite.haveAccount': 'У меня уже есть аккаунт — войти',
  'invite.createAccount': 'Создать новый аккаунт',
  'invite.createAccountHint': 'Придумайте имя пользователя и пароль. Если у вас уже есть аккаунт — лучше войти, чтобы не плодить дубли.',
  'invite.createAccountAndAccept': 'Создать аккаунт и принять',
  'invite.or': 'или',
  'invite.invalid': 'Ссылка недействительна или уже использована.',
  'invite.goToDashboard': 'На главную',

  // Selector empty states
  'page.selectBranchFirst': 'Сначала выберите филиал в верхнем селекторе.',
  'branchRequired.title': 'Филиал не выбран',
  'branchRequired.allTitle': 'Режим «Все филиалы» недоступен на этой странице',
  'branchRequired.groupTitle': 'Просмотр по группе филиалов недоступен на этой странице',
  'branchRequired.subtitle': 'Выберите филиал в селекторе наверху, чтобы увидеть данные.',
  // Экран «не загрузилось» (Алексей 26.10 #2635/#2639): офлайн / сервер обновляется / непонятно.
  'dataError.title': 'Не получилось подключиться к серверу',
  'dataError.retryHint': 'Попробуйте обновить страницу через минуту.',
  'dataError.contactPrefix': 'Если проблема сохранится, пожалуйста, напишите',
  'serverStatus.offline.title': 'Кажется, вы не в сети',
  'serverStatus.offline.hint': 'Проверьте интернет — как только связь вернётся, данные загрузятся сами.',
  'serverStatus.checking.title': 'Проверяем связь с сервером…',
  'serverStatus.updating.title': 'Сервер обновляется, подождите немного',
  'serverStatus.updating.hint': 'Обычно это около минуты. Страница обновится сама — ничего нажимать не нужно.',
  'serverStatus.updating.slow': 'Дольше обычного, но уже почти. Страница обновится сама.',
  'serverStatus.back.title': 'Сервер снова на связи — загружаем данные',
  'serverStatus.noResponse.title': 'Сервер не отвечает',
  'serverStatus.noResponse.hint': 'Проверяем каждые несколько секунд — страница обновится сама.',
  'serverStatus.partial.title': 'Часть данных не загрузилась',
  'serverStatus.partial.hint': 'Сервер отвечает с перебоями — повторяем сами.',
  'serverStatus.quiet': 'Не загрузилось',
  'noBranchAccess.title': 'У вас нет доступа к этому филиалу',
  'noBranchAccess.subtitle': 'Выберите другой филиал в селекторе наверху. Если доступ нужен — напишите',

  // Portfolio (multi-zone overview)
  'portfolio.title': 'Все филиалы',
  'portfolio.subtitle': 'Сводка по всем вашим локациям. Только проблемные — наверху.',
  'portfolio.tasks': 'Задач',
  'portfolio.overdue': '{{n}} просрочено',
  'portfolio.pending': '{{n}} открытых',
  'portfolio.dirtyTables': '{{n}} грязных столов',
  'portfolio.allGreen': 'Все в порядке',
  'portfolio.noZones': 'Нет доступных зон.',
  'portfolio.goToDashboard': 'Открыть дашборд',
  'portfolio.showMore': 'Показать ещё {{n}} филиалов',
  'portfolio.noReport': 'Нет отчёта за этот день',
  'portfolio.noWeekReport': 'Нет отчёта за эту неделю',
  'portfolio.zoneClosed': 'Закрыто',
  'portfolio.zoneDarkLc': 'Нет данных с камер — похоже, компьютер точки не в сети. Проверьте его.',
  'portfolio.zoneDarkNoLc': 'Нет данных с камер за сегодня',
  'portfolio.zoneDarkAffected': 'Недоступно: {{components}}',
  'portfolio.openReport': 'Открыть отчёт',
  'portfolio.day.queuePeak': 'пик {{n}} чел в {{time}}',
  'portfolio.day.queuePeakNoTime': 'пик {{n}} чел',
  'portfolio.day.tasksLine': '{{done}}/{{total}} задач',
  'portfolio.day.photoQueue': 'Самая длинная очередь',
  'portfolio.day.photoLayoutDrop': 'Самая большая просадка',
  'portfolio.day.photoTable': 'Дольше всех неубранный стол',
  'portfolio.day.longestTable': 'Дольше всех неубранный стол: {{name}} · {{m}} мин',
  'portfolio.day.longestTableNoName': 'Дольше всех неубранный стол · {{m}} мин',
  'portfolio.day.hoverAllDayOk': 'Весь день в порядке',
  'portfolio.day.hoverDayCritical': 'За день есть серьёзные замечания',
  'portfolio.day.hoverDayAttention': 'За день есть замечания',
  'portfolio.day.hoverClosed': 'В этот день филиал не работает по расписанию',
  'portfolio.day.hoverNoReport': 'Отчёт за этот день не сформирован',
  'portfolio.reportLoading': 'Загружаем отчёт…',
  'portfolio.day.todayOngoing': 'Сегодня ещё идёт',
  'portfolio.day.todayOngoingHint': 'Итоги дня появятся вечером, когда филиалы закроются',
  'portfolio.day.todayForming': 'Отчёт формируется',
  'portfolio.day.hoverLayoutBad': 'Заполненность ниже нормы на {{pct}}% · проблемы {{h}} ч',
  'portfolio.day.hoverLayoutShortage': 'Заполненность ниже нормы на {{pct}}%',
  'portfolio.day.hoverLayoutHours': 'Проблемы с выкладкой {{h}} ч',
  'portfolio.day.hoverLayoutIssue': 'Были проблемы с выкладкой',
  'portfolio.day.hoverQueuePeak': 'Пик {{n}} чел в {{time}}',
  'portfolio.day.hoverQueuePeakNoTime': 'Пик {{n}} чел',
  'portfolio.day.hoverQueueIssue': 'Очередь была больше нормы',
  'portfolio.day.hoverTasks': 'Выполнено {{done}} из {{total}} задач',
  'portfolio.day.hoverOpenClose': 'Заполненность витрин при открытии и при закрытии',
  'portfolio.day.atOpen': 'открытие',
  'portfolio.day.atClose': 'закрытие',
  'portfolio.weekFactLayout': 'Полки заполнены на {{v}}%',
  'portfolio.weekFactQueue': 'В очереди в среднем {{v}} чел',
  'portfolio.weekFactTables': 'Грязных столов ~{{v}} в день',
  'portfolio.weekFactTasks': 'Задачи выполнены на {{v}}%',
  'portfolio.weekDeltaChip': '{{delta}} vs пр. неделя',
  'portfolio.weekLowData': 'мало данных за неделю',
  'portfolio.weekNoBaseline': 'сравнить не с чем',
  'portfolio.weekWorst': 'хуже всего: {{label}} {{delta}}',
  'portfolio.rowTasks': 'Задачи',
  'portfolio.rowTables': 'Столы',
  'portfolio.rowLayout': 'Выкладка',
  'portfolio.rowQueues': 'Очереди',
  'portfolio.needsAttention': 'Требует внимания',
  'portfolio.problemsCarousel': 'Проблемы филиала',
  'portfolio.prevSlide': 'Предыдущая проблема',
  'portfolio.nextSlide': 'Следующая проблема',
  'portfolio.moreTasks': '+{{n}} ещё',

  // Dashboard cards
  'dashboard.title': 'Дашборд смены',
  'dashboard.subtitle': 'Сводка по задачам и состоянию филиала на сегодня.',
  'dashboard.cards.tasks': 'Чек-лист',
  'dashboard.avgCheck.title': 'Средний чек сегодня',
  'dashboard.upsell.title': 'Обычно сейчас берут',
  'dashboard.avgCheck.baseline': 'к среднему прошлых {{day}}',
  'dashboard.markUndo': 'Отменить',
  'dashboard.checking': 'Проверяем',
  'dashboard.cards.tasksOpenAll': 'Открыть все',
  'dashboard.fullscreen': 'На весь экран',
  'dashboard.hideBar': 'Спрятать панель — вернуть тапом в пустое место',
  'dashboard.holdToConfirm': 'Держите…',
  'dashboard.holdHint': 'Держите кнопку «{{label}}», чтобы пометить выполненным',
  'dashboard.robotHi': 'Привет! 👋',
  'dashboard.allFixed': 'Отлично, всё в порядке',
  'dashboard.robotHide': 'Скрыть робота',
  'dashboard.robotShow': 'Показать робота',
  'dashboard.fullscreenExit': 'Выйти из полноэкранного режима',
  'dashboard.zoomIn': 'Крупнее',
  'dashboard.zoomOut': 'Мельче',
  'dashboard.zoomReset': 'Сбросить масштаб',
  'dashboard.cards.tasksCount': 'Показано {{shown}} из {{total}} · Ещё {{hidden}} не показаны',
  'dashboard.cards.tasksDue': 'Срок: {{time}}',
  'dashboard.cards.tasksDueTomorrow': 'Срок: завтра {{time}}',
  'dashboard.cards.tasksEmpty': 'На сегодня задач нет.',
  'dashboard.cards.tables': 'Чистота столов',
  'dashboard.cards.tablesEmpty': 'Все столы чистые.',
  'dashboard.cards.queue': 'Очереди',
  'dashboard.cards.salesPlan': 'План продаж',
  'dashboard.tab.salesPlan': 'План',
  'dashboard.salesPlan.now': 'Сейчас предлагаем',
  'dashboard.salesPlan.nothingNow': 'Сейчас ничего особого — всё по меню',
  'dashboard.salesPlan.later': 'Дальше',
  'dashboard.salesPlan.targets': 'Цели на сегодня',
  'dashboard.salesPlan.pcs': 'шт',
  'dashboard.cards.queueGreen': 'Очереди в норме',
  'dashboard.cards.queueYellow': '{{n}} на пределе',
  'dashboard.cards.queueRed': '{{n}} превышают лимит',
  'dashboard.cards.queueNotConfigured': 'Очереди не размечены в этом филиале.',
  'dashboard.cards.layout': 'Выкладка товара',
  'dashboard.cards.layoutGreen': 'Все полки в порядке',
  'dashboard.tab.layout': 'Выкладка',
  'dashboard.tab.tables': 'Столы',
  'dashboard.tab.tasks': 'Чек-лист',
  'dashboard.tab.queue': 'Очередь',
  'dashboard.cards.layoutYellow': '{{n}} зон требуют внимания',
  'dashboard.cards.layoutRed': '{{n}} зон критически пусты',
  'dashboard.cards.layoutUnknown': '{{n}} зон ещё не оценено',
  'dashboard.cards.tasksNoChecklistAdmin': 'У филиала ещё нет чек-листов. Подключите их, чтобы задачи стали появляться у работников.',
  'dashboard.cards.tasksNoChecklistWorker': 'Чек-листы не подключены. Попросите администратора филиала включить их.',
  'dashboard.cards.tasksConfigureChecklists': 'Подключить чек-листы',
  'dashboard.cards.tablesNotConfigured': 'Столы не добавлены в зонировании.',
  'dashboard.cards.layoutNotConfigured': 'Полки не добавлены в оборудовании.',
  'dashboard.cards.tablesClean': 'Стол чистый',
  'dashboard.proof.page': 'Стр. {{page}} из {{total}}',
  'dashboard.proof.holdForCrop': 'Нажмите и удерживайте, чтобы увидеть фрагмент',
  'dashboard.proof.holdForFrame': 'Нажмите и удерживайте, чтобы увидеть весь кадр',
  'dashboard.noFramesToday': 'Нет кадров за сегодня',
  'dashboard.display.full': 'Полный кадр',
  'dashboard.display.crop': 'Кроп',
  'dashboard.display.label': 'Вид кадра',
  'dashboard.filter.problems': 'Только важное',
  'dashboard.filter.all': 'Все данные',
  'dashboard.filter.label': 'Данные',
  'dashboard.controls.label': 'Отображение',
  'dashboard.filter.allOk': 'Всё в порядке',
  'dashboard.proof.okUnits': 'Без замечаний ({{n}})',
  'dashboard.pager.prev': 'Назад',
  'dashboard.pager.next': 'Вперёд',
  'tables.reason.guestItems': 'Вещи гостя',
  'tables.rechecking': 'Перепроверяем',
  'tables.reason.clean': 'Чисто',
  'dashboard.status.tablesAllClean': 'Все столы чистые',
  'dashboard.status.tablesCheck': 'Есть столы на проверке',
  'dashboard.status.tablesDirty': 'Часть столов требует уборки',
  'dashboard.status.layoutAllFull': 'Выкладка в порядке',
  'dashboard.status.layoutAttention': 'Часть полок требует внимания',
  'dashboard.status.queueOk': 'Очереди в норме',
  'dashboard.status.queueBusy': 'Есть очереди на пределе',
  'dashboard.status.tasksAllDone': 'Все задачи выполнены',
  'dashboard.status.tasksOpen': 'Есть незавершённые задачи',
  'dashboard.status.noData': 'Нет данных',
  'dashboard.issueSince': 'с {{time}}',
  'dashboard.sectionOk.tables': 'Столы в норме',
  'dashboard.sectionOk.layout': 'Выкладка в норме',
  'dashboard.sectionOk.queue': 'Очереди в норме',
  'dashboard.sectionOk.tasks': 'Чек-лист выполнен',
  'dashboard.celebrate.tables': 'Все столы чистые',
  'dashboard.celebrate.layout': 'Выкладка в порядке',
  'dashboard.celebrate.queue': 'Очереди в норме',
  'dashboard.celebrate.tasks': 'Все задачи выполнены',
  'dashboard.updateReady': 'Пришли обновления — обновите страницу, чтобы применить',
  'dashboard.updated': 'Обновлено успешно',
  'dashboard.updatedFullscreen': 'Развернуть на весь экран',
  'dashboard.updatedDismiss': 'Не нужно',
  'dashboard.closedBanner': 'Филиал закрыт · данные за смену',
  'dashboard.closedBannerAt': 'Филиал закрыт · откроется в {{time}}',
  'dashboard.closedDay.title': 'Итоги дня',
  'dashboard.closedDay.avgTitle': 'Средний чек за день',
  'dashboard.closedDay.checks': 'чеков: {{n}}',
  'dashboard.closedDay.vsBaseline': 'к среднему прошлых {{day}}',
  'dashboard.closedDay.tasksOf': 'из {{total}} выполнено',
  'dashboard.closedDay.tasksPlanned': 'Задач на сегодня: {{n}}',
  'dashboard.closedDay.dayClosed': 'день закрыт',
  'dashboard.couldAppear.title': 'Что ещё может появиться здесь',
  'dashboard.couldAppear.desc': 'Эти разделы появятся на дашборде, как только их настроят для филиала.',
  'dashboard.landing.title': 'Дашборд смены: Сначала выберите филиал',
  'dashboard.landing.subtitle': 'Выберите филиал в селекторе сверху, чтобы открыть его дашборд смены.',
  'dashboard.apiMissing': 'Не удалось загрузить данные.',
  'dashboard.branchClosed': 'Филиал закрыт',
  'dashboard.opensAt': 'Откроется в {{time}}',
  'dashboard.alwaysOpen': 'Расписание не настроено',
  'dashboard.showShiftData': 'Показать данные за смену',
  'dashboard.zoneNotFound': 'Филиал не найден или у вас нет доступа.',
  'dashboard.backToPortfolio': 'Вернуться ко всем филиалам',

  // Plugin teasers (collapsed rows below dashboard grid)
  'dashboard.teaser.configure': 'Настроить',
  'dashboard.teaser.checklists.title': 'Чек-листы не настроены',
  'dashboard.teaser.checklists.desc': 'Плагин чек-листов создаёт задачи для работников смены по расписанию. Подключите, чтобы задачи начали появляться каждое утро.',
  'dashboard.teaser.checklists.cta': 'Настроить чек-листы',
  'dashboard.teaser.tables.title': 'Мониторинг столов не настроен',
  'dashboard.teaser.tables.desc': 'Плагин отслеживает чистоту столов. Когда стол долго остаётся грязным после гостей — он появится здесь. Разметьте столы в зонировании, чтобы начать.',
  'dashboard.teaser.tables.cta': 'Открыть зонирование',
  'dashboard.teaser.layout.title': 'Мониторинг выкладки не настроен',
  'dashboard.teaser.layout.desc': 'Плагин отслеживает наполненность полок в реальном времени. Вы будете видеть, какие зоны требуют пополнения. Добавьте стеллажи в оборудовании, чтобы начать.',
  'dashboard.teaser.layout.cta': 'Открыть оборудование',
  'dashboard.teaser.queue.title': 'Мониторинг очередей не настроен',
  'dashboard.teaser.queue.desc': 'Плагин показывает длину очереди в реальном времени и предупреждает, когда она превышает норму. Разметьте зоны очередей, чтобы начать.',
  'dashboard.teaser.queue.cta': 'Открыть зонирование',

  // Welcome card (fresh zone — all plugins unconfigured)
  'dashboard.welcome.title': 'Пока ничего нет',
  'dashboard.welcome.subtitleAdmin': 'Добавьте зоны мониторинга и чек-листы — и дашборд начнёт показывать данные.',
  'dashboard.welcome.subtitleWorker': 'Здесь пока ничего не настроено. Обратитесь к администратору.',
  'dashboard.welcome.cta': 'Открыть настройки',

  // Plugin setup panel (management/general)
  'management.plugins.heading': 'Подключенные функции',
  'management.plugins.configured': 'Настроен',
  'management.plugins.notConfigured': 'Не настроен',
  'management.plugins.active': 'Активен',
  'management.plugins.noTasks': 'Нет задач',
  'management.plugins.paused': 'На паузе',
  'management.plugins.noCameras': 'Нет камер',
  'management.plugin.checklists': 'Чек-листы',
  'management.plugin.tables': 'Мониторинг столов',
  'management.plugin.layout': 'Мониторинг выкладки',
  'management.plugin.queue': 'Мониторинг очередей',

  // Tasks page
  'tasks.title': 'Задачи на смену',
  'tasks.subtitle': 'Список задач для текущего филиала.',
  'tasks.onlyMine': 'Только мои',
  'tasks.onlyToday': 'Только на сегодня',
  'tasks.noChecklistAdmin': 'У этого филиала ещё нет чек-листов. Подключите их, чтобы задачи стали появляться у работников.',
  'tasks.noChecklistWorker': 'Чек-листы не подключены. Попросите администратора филиала включить их.',
  'tasks.prevDay': 'Предыдущий день',
  'tasks.nextDay': 'Следующий день',
  'tasks.today': 'Сегодня',
  'tasks.dueAt': 'До {{time}}',
  'tasks.reporterAt': '{{who}} в {{time}}',
  'tasks.commentShow': 'Показать комментарий',
  'tasks.commentHide': 'Скрыть',
  'tasks.submitReport': 'Сдать отчёт',
  'tasks.submitReportTitle': 'Отчёт по задаче',
  'tasks.reportText': 'Комментарий',
  'tasks.reportTextPlaceholder': 'Что сделано',
  'tasks.reportPhotos': 'Фото',
  'tasks.reportVideos': 'Видео',
  'tasks.filesSelected': 'Файлов выбрано: {{n}}',
  'tasks.addMoreMedia': 'Добавить ещё',
  'tasks.takePhoto': 'Сделать фото',
  'tasks.chooseFromGallery': 'Выбрать из галереи',
  'tasks.deadline': 'Дедлайн',
  'tasks.detail': 'Подробнее',
  'tasks.empty': 'На сегодня задач нет',
  'tasks.statusOverdue': 'Просрочено',
  'tasks.statusPreDeadline': 'Скоро дедлайн',
  'tasks.statusDone': 'Готово',
  'tasks.statusPending': 'В работе',
  'tasks.progressDone': 'Готово {{done}} из {{total}}',
  'tasks.remainingCount': 'Осталось {{n}}',
  'tasks.overdueCount': 'Просрочено {{n}}',
  'tasks.allDone': 'Все задачи закрыты',
  'tasks.allDoneHint': 'Смена идёт по плану.',
  'tasks.pastAllDoneHint': 'В этот день закрыли всё.',
  'tasks.doneSection': 'Готово ({{n}})',
  'tasks.planned': 'Запланировано',
  'tasks.plannedTitle': 'Запланировано на этот день',
  'tasks.plannedCount': 'Задач в плане: {{n}}',
  'tasks.plannedEmpty': 'На этот день задач не запланировано.',

  // Settings sections (page header descriptions stay short — pages have own headers)
  'settings.general': 'Филиал',
  'settings.generalDescription': 'Основные параметры филиала.',
  'settings.zoning': 'Зонирование',
  'settings.zoningDescription': 'Разметка зон на снимках камер.',
  'settings.plan': 'План зала',
  'settings.planDescription': 'Изображение плана и калибровка камер на план.',
  'settings.checklists': 'Чек-листы',
  'settings.checklistsDescription': 'Контрольные листы для смены.',
  'settings.visits': 'Визиты',
  'settings.queuesStaff': 'Очереди и сотрудники',
  'settings.queuesStaffDescription': 'Когда присылать алерт об очереди и следить ли, что сотрудники пришли к открытию.',
  'queuesStaff.people': 'чел.',
  'queuesStaff.queues.title': 'Очереди',
  'queuesStaff.queues.description': 'Алерт приходит, когда в очереди столько людей или больше.',
  'queuesStaff.queues.empty': 'Зона очереди ещё не размечена.',
  'queuesStaff.queues.emptyLink': 'Разметить',
  'queuesStaff.queues.unnamed': 'Очередь',
  'queuesStaff.queues.alertFrom': 'алерт от',
  'queuesStaff.arrival.title': 'Приход к открытию',
  'queuesStaff.arrival.description': 'Утром смотрим на зону бара и отмечаем, во сколько пришли сотрудники. Это видно в отчёте дня и статистике.',
  'queuesStaff.arrival.enable': 'Следить за приходом',
  'queuesStaff.arrival.needsBar': 'Сначала разметьте зону бара.',
  'queuesStaff.arrival.minutesPrefix': 'на месте за',
  'queuesStaff.arrival.minutesSuffix': 'мин до открытия',
  'queuesStaff.arrival.peoplePrefix': 'не меньше',
  'queuesStaff.arrival.messages': 'Сообщения утром',
  'queuesStaff.arrival.messagesOn': 'Если к нужному времени никого не видно, напишем в чат и попросим показаться.',
  'queuesStaff.arrival.messagesOff': 'В чат не пишем: время прихода только попадает в «Данные».',
  'queuesStaff.arrival.chatId': 'ID чата',
  'queuesStaff.arrival.threadId': 'ID темы',
  'queuesStaff.arrival.chatHint': 'Пусто — сообщения придут в основной чат филиала.',
  'queuesStaff.arrival.inZone': 'в зоне',
  'queuesStaff.arrival.allStaffZones': 'Все рабочие зоны',
  'queuesStaff.arrival.captureNote': 'Камеры включаются за 10 минут до этого времени — так видно, кто пришёл раньше.',
  'queuesStaff.arrival.drawNew': 'Разметить новую',
  'queuesStaff.arrival.noZone': 'Зона прихода ещё не размечена',
  'queuesStaff.arrival.noFrame': 'Кадр камеры сейчас недоступен',
  'zoning.hint.arrival.title': 'Выберите камеру и добавьте зону с типом «Одиночная зона»',
  'zoning.hint.arrival.body': 'Потом выберите её в настройке прихода. Другие типы зон влияют на работу системы: по «Очереди» считается размер очереди, по «Рабочей зоне» — сотрудники за баром, по «Стеллажу» — выкладка, по «Столу» — уборка столов.',
  'zoning.hint.arrival.back': 'Вернуться к настройке прихода',
  'settings.visitsDescription': 'Шаблоны оценки для проверок качества на спотах.',
  'settings.telegram': 'Уведомления',
  'settings.telegramDescription': 'Куда отправляются уведомления о выкладке, столах, очередях и задачах.',
  'telegram.setupHint.title': 'Подключите чаты для уведомлений',
  'telegram.setupHint.body': 'Добавьте {{bot}} в нужный Telegram-чат и напишите команду /chat_id — бот ответит ID, который нужно вставить в эту таблицу.',
  'telegram.setupHint.threads': 'Если в чате включены темы (топики), ту же команду можно отправить внутри темы — она вернёт и ID темы.',
  'telegram.targets.header.target': 'Уведомление',
  'telegram.targets.header.chatId': 'ID чата',
  'telegram.targets.header.threadId': 'Тема',
  'telegram.targets.layout.label': 'Выкладка',
  'telegram.targets.layout.description': 'Скриншоты и статус полок, включая «Статус к текущему моменту».',
  'telegram.targets.tables.label': 'Столы',
  'telegram.targets.tables.description': 'Сигналы о грязных столах в зале.',
  'telegram.targets.queues.label': 'Очереди',
  'telegram.targets.queues.description': 'Превышение лимита очереди у касс.',
  'telegram.targets.checklists.label': 'Чек-листы',
  'telegram.targets.checklists.description': 'Напоминания и просрочка по задачам смены.',
  'telegram.targets.daily.label': 'Дневной отчёт',
  'telegram.targets.daily.description': 'Сводка за вчерашний день.',
  'telegram.targets.visits.label': 'Визиты',
  'telegram.targets.visits.description': 'Карточка визита по кнопке «Отправить команде».',
  'telegram.targets.staffArrival.label': 'Приход к открытию',
  'telegram.targets.staffArrival.description': 'Утром, если сотрудников не видно к нужному времени. Пусто — в основной чат.',
  'settings.equipment': 'Оборудование',
  'settings.equipmentDescription': 'Камеры и устройства филиала.',
  'settings.integrations': 'Интеграции',
  'settings.integrationsDescription': 'Подключение Grafana и чатов Telegram для уведомлений.',

  // Integrations page — Grafana section
  'sidebar.grafanaDashboards': 'Интеграции',
  'sidebar.integrations': 'Интеграции',
  'settings.grafana.title': 'Дашборды Grafana',
  'settings.grafana.description': 'Ссылка на сводный дашборд филиала и идентификаторы дашбордов для отдельных стеллажей и касс.',
  'settings.grafana.zoneUrl': 'Ссылка на дашборд филиала',
  'settings.grafana.zoneUrlHint': 'Полный URL дашборда Grafana с обзором по филиалу. Можно оставить пустым.',
  'settings.grafana.urlSaveError': 'Не удалось сохранить ссылку на дашборд.',
  'settings.grafana.racks': 'Дашборды стеллажей',
  'settings.grafana.racksEmpty': 'В этом филиале пока нет стеллажей.',
  'settings.grafana.checkoutZones': 'Дашборды кассовых зон',
  'settings.grafana.checkoutZonesEmpty': 'В этом филиале пока нет кассовых зон.',
  'settings.grafana.col.name': 'Объект',
  'settings.grafana.col.dashboardId': 'ID дашборда',
  'settings.grafana.col.actions': 'Действия',
  'settings.grafana.notSet': 'не задан',
  'settings.grafana.respawn': 'Создать заново',
  'settings.grafana.respawnError': 'Не удалось запустить пересоздание дашборда.',
  'settings.grafana.respawnNoPermission': 'Нет прав на изменение настроек филиала.',
  'settings.grafana.loadError': 'Не удалось загрузить список объектов.',

  // Integrations page — Telegram chat-ID section
  'settings.telegramIntegrations.title': 'Чаты Telegram для уведомлений',
  'settings.telegramIntegrations.description': 'Для каждого вида уведомлений можно задать собственный чат и тред. Оставьте поля пустыми, чтобы использовать общие настройки бота.',
  'settings.telegramIntegrations.chatId': 'Chat ID',
  'settings.telegramIntegrations.threadId': 'Thread ID',
  'settings.telegramIntegrations.chatIdPlaceholder': 'например, -1001234567890',
  'settings.telegramIntegrations.threadIdPlaceholder': 'необязательно',
  'settings.telegramIntegrations.saveError': 'Не удалось сохранить настройки.',
  'settings.telegramIntegrations.loadError': 'Не удалось загрузить настройки плагина.',
  'settings.telegramIntegrations.periodicReports': 'Ежедневный отчёт',
  'settings.telegramIntegrations.periodicReportsHint': 'Чат для отправки сводки за день (плагин periodic_reports).',
  'settings.telegramIntegrations.checkoutControl': 'Контроль касс',
  'settings.telegramIntegrations.checkoutControlHint': 'Алерты о длинных очередях и пустых кассах (плагин checkout_control).',
  'settings.telegramIntegrations.tableControl': 'Чистота столов',
  'settings.telegramIntegrations.tableControlHint': 'Алерты о грязных столах и сменах (плагин table_control).',
  'settings.telegramIntegrations.opsTasks': 'Задачи смены',
  'settings.telegramIntegrations.opsTasksHint': 'Напоминания о задачах и просрочках (плагин ops_tasks).',

  'general.branchName': 'Название филиала',
  'general.timezone': 'Часовой пояс',
  'general.workingHours': 'График работы',
  'general.planImage': 'План зала',
  'general.planImage.upload': 'Загрузить изображение',
  'general.planImage.replace': 'Заменить',
  'general.planImage.delete': 'Удалить',

  // Plan auto-layout (calibration UI built on detection point cloud)
  'plan.autoLayoutTitle': 'Авто-разметка по детекциям',
  'plan.autoLayoutHint': 'Подберите параметры так, чтобы тепловая карта легла по проходам, минуя посадочные места и стены. Изоляция фильтрует людей, заслоняющих друг друга; aspect и размер бокса отсекают сидящих и обрезанные детекции.',
  'plan.period.7d': '7 дней',
  'plan.period.30d': '30 дней',
  'plan.resetParams': 'Сбросить',
  'plan.loading': 'считаем…',
  'plan.selectCamera': 'Выберите камеру в селекторе выше.',
  'plan.noFrame': 'У камеры пока нет сохранённых кадров.',
  'plan.truncated': 'Срез данных усечён до 1М детекций — сократите окно',
  'plan.layer.heatmap': 'Тепловая карта стоп',
  'plan.layer.points': 'Точки стоп (выборка)',
  'plan.count.raw': 'Всего',
  'plan.count.score': 'После score',
  'plan.count.size': 'После размера',
  'plan.count.aspect': 'После aspect',
  'plan.count.isolation': 'Чистая выборка',
  'plan.param.minScore': 'Мин. YOLO score',
  'plan.param.minScore.hint': 'Уверенность детектора. Выше — меньше шума, но и меньше детекций.',
  'plan.param.minBoxH': 'Мин. высота бокса',
  'plan.param.minBoxH.hint': 'Отсекает мелкие/далёкие/обрезанные детекции.',
  'plan.param.maxBoxH': 'Макс. высота бокса',
  'plan.param.maxBoxH.hint': 'Отсекает склеенные между собой боксы и аномалии.',
  'plan.param.minAspect': 'Мин. aspect (h/w)',
  'plan.param.minAspect.hint': 'Стоящий человек — вытянутый бокс. Сидящий — близкий к квадрату.',
  'plan.param.minIsolation': 'Мин. изоляция в кадре',
  'plan.param.minIsolation.hint': 'Расстояние до ближайшей соседней детекции в том же кадре. Отсекает группы и сидящие компании.',
  'general.zoneType': 'Тип филиала',
  'general.zoneType.RETAIL_BRANCH': 'Торговый филиал',
  'general.zoneType.COFFEESHOP': 'Кофейня',
  'general.zoneType.SHOP': 'Магазин',
  'general.zoneType.CANTEEN': 'Столовая',
  'general.zoneType.BUILDING': 'Здание',
  'general.zoneType.FLOOR': 'Этаж',
  'general.zoneType.HALLWAY': 'Коридор',
  'general.zoneType.ROOM': 'Комната',
  'general.zoneType.CLASSROOM': 'Учебный класс',
  'general.zoneType.GYM': 'Спортзал',
  'general.zoneType.COWORKING': 'Коворкинг',
  'general.dangerZone': 'Опасная зона',
  'general.archive': 'Архивировать филиал',
  'general.archiveConfirm': 'Архивировать этот филиал? Он исчезнет из списка для всех пользователей. Отменить можно только через поддержку.',
  'general.archiveConfirmBtn': 'Да, архивировать',
  'general.archiving': 'Архивирование…',
  'general.archiveError': 'Не удалось архивировать филиал.',
  'branchSelector.showService': 'Показать служебные зоны',
  'branchSelector.hideService': 'Скрыть служебные зоны',
  'branchSelector.showArchived': 'Показать архивные зоны',
  'branchSelector.hideArchived': 'Скрыть архивные зоны',

  // Camera selector
  'camera.loading': 'Загрузка камер…',
  'camera.label': 'Камера',
  'camera.placeholder': 'Выберите камеру',
  'camera.search': 'Поиск камеры…',
  'camera.empty': 'Нет камер',
  'camera.notFound': 'Ничего не найдено',
  'camera.online': 'Онлайн',
  'camera.offline': 'Оффлайн',
  'camera.inactive': 'Неактивна',

  // Zoning toolbar — zone types
  'zoning.types.rack': 'Стеллаж',
  'zoning.types.shelf': 'Секция',
  'zoning.types.table': 'Стол',
  'zoning.types.queue': 'Очередь',
  'zoning.types.order_waiting': 'Зона ожидания',
  'zoning.types.cashier': 'Касса',
  'zoning.types.staff': 'Рабочая зона',
  'zoning.types.standalone': 'Одиночная зона',
  'zoning.toolbar.hints': 'Подсказки',
  'zoning.toolbar.reload': 'Обновить кадр',
  'zoning.toolbar.selectCamera': 'Выберите камеру для загрузки кадра',
  'zoning.toolbar.add': 'Добавить зону',
  'zoning.sidebar.expand': 'Развернуть',
  'zoning.sidebar.collapse': 'Свернуть',
  'zoning.sidebar.resize': 'Изменить ширину',
  'zoning.sidebar.pin': 'Закрепить',
  'zoning.hints.drawing': 'Рисование',
  'zoning.hints.editing': 'Редактирование',
  'zoning.hints.general': 'Общее',
  'zoning.hints.draw.pickType': 'Выбор типа зоны',
  'zoning.hints.draw.pickTypeDesc': 'войти в режим рисования',
  'zoning.hints.draw.click': 'Клик по кадру',
  'zoning.hints.draw.clickDesc': 'добавить точку',
  'zoning.hints.draw.repeat': 'Повторный клик по точке',
  'zoning.hints.draw.repeatDesc': 'удалить точку',
  'zoning.hints.draw.save': 'Кнопка «Сохранить»',
  'zoning.hints.draw.saveDesc': 'завершить полигон (мин. 3 точки)',
  'zoning.hints.edit.click': 'Клик по полигону',
  'zoning.hints.edit.clickDesc': 'выбрать',
  'zoning.hints.edit.shift': 'Shift+клик',
  'zoning.hints.edit.shiftDesc': 'добавить к выделению',
  'zoning.hints.edit.edge': 'Клик по ребру',
  'zoning.hints.edit.edgeDesc': 'добавить точку',
  'zoning.hints.edit.box': 'Рамка мышью',
  'zoning.hints.edit.boxDesc': 'выделить несколько точек',
  'zoning.hints.edit.del': 'Del / Backspace',
  'zoning.hints.edit.delDesc': 'удалить выделенные точки',
  'zoning.hints.edit.undo': 'Ctrl+Z',
  'zoning.hints.edit.undoDesc': 'отмена',
  'zoning.hints.escDesc': 'сбросить точки / выйти из режима рисования',

  // Drawing status block
  'drawing.cancel': 'Отмена',
  'drawing.save': 'Сохранить',
  'drawing.minPoints': 'Поставьте минимум 3 точки.',
  'drawing.editing': 'Редактирование',
  'drawing.edit': 'Редактировать',
  'drawing.delete': 'Удалить',
  'drawing.adding': 'Добавление',
  'drawing.pointsOf': 'из',
  'drawing.points': 'точек',
  'drawing.selectCamera': 'Выберите камеру для загрузки кадра',
  'drawing.loadingImage': 'Загрузка изображения…',
  'drawing.loadingFrame': 'Загружаю кадр…',
  'drawing.deleteTitle': 'Удаление полигона',
  'drawing.deleteConfirm': 'Вы уверены, что хотите удалить этот полигон? Это действие нельзя отменить.',
  'drawing.discardTitle': 'Отменить изменения?',
  'drawing.discardConfirm': 'У редактируемого полигона есть несохранённые изменения. Перейти к другому полигону без сохранения?',
  'drawing.discard': 'Не сохранять',
  'drawing.hint.shelfRack': 'Кликните на стеллаж для привязки секции',
  'drawing.hint.shelfStart': 'Выберите левый верхний угол секции',
  'drawing.hint.continueClockwise': 'Продолжайте по часовой стрелке',
  'drawing.hint.rackStart': 'Начните с левого верхнего угла, далее — по часовой стрелке',
  'drawing.hint.tableStart': 'Поставьте 4 точки для стола',
  'drawing.hint.click': 'Кликните по кадру, чтобы поставить точку',

  // Polygon sidebar
  'sidebar.zonesTitle': 'Зоны и полигоны',
  'sidebar.empty': 'Нет полигонов',
  'sidebar.multiCamera': 'Мульти-камерные зоны',
  'sidebar.cameraName': 'Камера {{id}}',
  'sidebar.shelfName': 'Секция #{{id}}',
  'sidebar.zone': 'Зона',
  'sidebar.moving': 'Перемещение…',
  'sidebar.serviceZone': 'Зона обслуживания',
  'sidebar.standaloneZone': 'Одиночная зона',
  'sidebar.mergeWith': 'Объединить с другой зоной:',
  'sidebar.addTo': 'Добавить в зону обслуживания:',
  'sidebar.pickZone': 'Выберите зону…',
  'sidebar.areasCount': 'пол.',
  'sidebar.convertTo': 'Конвертировать в тип зоны:',
  'sidebar.pickType': 'Выберите тип…',
  'sidebar.deleting': 'Удаление…',
  'sidebar.deleteFailed': 'не удалось удалить, изменения отменены',
  'sidebar.deleteHint': 'Удаление зоны не удаляет полигоны — они станут «без привязки».',
  'sidebar.close': 'Закрыть',

  // Time relatives
  'time.inMin': 'через {{n}} мин',
  'time.minAgo': '{{n}} мин назад',
  'time.inH': 'через {{n}} ч',
  'time.hAgo': '{{n}} ч назад',

  // Errors
  'error.savingName': 'Не удалось сохранить название.',
  'error.savingTimezone': 'Не удалось сохранить часовой пояс.',
  'error.loadingPolygons': 'Не удалось загрузить данные полигонов',
  'error.loadingFrame': 'Не удалось загрузить снимок, попробуйте позже',
  'error.reloadingFrame': 'Не удалось обновить кадр. Используется предыдущий.',
  'error.canvasRender': 'Ошибка при отрисовке полигонов',
  'error.boundaryGeneric': 'Произошла ошибка',
  'error.boundaryRetry': 'Попробовать снова',
  'error.general': 'Не удалось загрузить данные. Попробуйте обновить страницу.',
  'tables.tableNum': 'Стол {{n}}',
  'tables.requireCleaning': 'Требует уборки',
  'tables.unknown': 'Состояние неизвестно',
  'tables.dirty': 'Грязно',
  'tables.markCleaned': 'Убрали',
  'layout.markFixed': 'Поправили',
  'layout.status.fixedPending': 'Поправили · проверяю по камере',
  'tables.openCrop': 'Открыть фото стола',
  'layout.openCrop': 'Открыть фото зоны',
  'layout.status.red': 'Почти пусто',
  'layout.status.grey': 'Почти пустая',
  'layout.status.orange': 'Заметно опустела',
  'layout.status.yellow': 'Частично опустела',
  'layout.status.green': 'Выкладка полная',
  'layout.status.unknown': 'Нет данных',
  'layout.status.occluded': 'Сейчас обзор зоны перекрыт',
  'layout.status.occludedShort': 'Перекрыт',
  'dashboard.lastClearFrame': 'последний кадр в {{time}}',
  'layout.goodRacks': 'Все остальные ОК',
  'queue.size': '{{n}} / {{max}} человек',
  'queue.unknown': 'Нет данных',
  'queue.openCrop': 'Открыть кадр очереди',

  // Analytics page (/management/analytics)
  'analytics.title': 'Данные',
  'analytics.subtitle': 'Все данные за период.',
  'analytics.period.today': 'Сегодня',
  'analytics.period.7d': '7 дней',
  'analytics.period.3m': '3 месяца',
  'analytics.period.allData': 'Все данные',
  'analytics.period.recommendedTip': 'Выбрать рекомендованный период: {{label}}',
  'analytics.tabsNav': 'Разделы данных',
  'analytics.period.30d': '30 дней',
  'analytics.period.from': 'Начало периода',
  'analytics.period.to': 'Конец периода',
  'analytics.period.yesterday': 'Вчера',
  'analytics.period.prevWeek': 'Прошлая неделя',
  'analytics.tab.layout': 'Выкладка',
  'analytics.tab.queue': 'Очереди и сотрудники',
  'analytics.tab.tables': 'Столы',
  'analytics.tab.tasks': 'Чек-листы',
  'analytics.tab.conversations': 'Речь',
  'analytics.speech.noMic.title': 'Чтобы видеть этот раздел, на кассе должен быть микрофон',
  'analytics.speech.noMic.summary': 'В разделе будут отображены запросы и жалобы гостей на кассе, а также общекомандные метрики по допродажам.',
  'analytics.layout.statLabel': 'Среднее заполнение полок',
  'analytics.layout.vsLabel': 'vs предыдущий период',
  'analytics.layout.chartLabel': 'Заполнение полок за период, %',
  'analytics.layout.photosLabel': 'Последние фото зон',
  'analytics.layout.notConfigured': 'Мониторинг выкладки не настроен для этого филиала.',
  'analytics.queue.statLabel': 'Среднее людей в очереди',
  'analytics.queue.vsLabel': 'vs предыдущий период',
  'analytics.queue.chartLabel': 'Среднее кол-во людей за период',
  'analytics.queue.photosLabel': 'Самые длинные очереди',
  'analytics.queue.notConfigured': 'Очереди не настроены для этого филиала.',
  'analytics.tables.medianLabel': 'Обычно убираем за',
  'analytics.tables.p90Label': 'Почти всегда — не дольше',
  'analytics.tables.vsLabel': 'vs предыдущий период',
  'analytics.tables.chartLabel': 'Сколько обычно ждёт грязный стол до уборки, мин',
  'analytics.tables.histLabel': 'Как долго столы ждут уборки',
  'analytics.tables.histBucket1': '≤ 2 мин',
  'analytics.tables.histBucket2': '2–5 мин',
  'analytics.tables.histBucket3': '5–15 мин',
  'analytics.tables.histBucket4': '> 15 мин',
  'analytics.tables.photosLabel': 'Последние фото столов',
  'analytics.tables.notConfigured': 'Мониторинг столов не настроен.',
  'analytics.tables.noData': 'Нет данных об обработке алертов за период.',
  'analytics.tables.maxLabel': 'Пиковая загрузка стола (99 перцентиль)',
  'analytics.tables.detailChartLabel': 'Людей за столом за период',
  'analytics.tables.peopleHistLabel': 'Сколько минут было N человек',
  'analytics.tables.stateLabel': 'В каком состоянии стол был чаще всего',
  'analytics.tasks.statLabel': 'Процент выполнения задач',
  'analytics.tasks.vsLabel': 'vs предыдущий период',
  'analytics.tasks.chartLabel': 'Выполнение задач за период, %',
  'analytics.tasks.noData': 'Данных о задачах за этот период нет.',
  'analytics.noData': 'Нет данных за выбранный период.',
  'analytics.grafana.openButton': 'Открыть подробные графики',
  'analytics.grafana.notMigrated': 'Ещё не все графики перенесены из Grafana — более подробные данные можно посмотреть там.',
  'analytics.couldAppear': 'Что ещё может появиться здесь',
  'analytics.addTabs': 'Добавить вкладки',
  'analytics.layout.peakLabel': 'Пик за период',
  'analytics.layout.worstLabel': 'Худший день',
  'analytics.layout.ungroupedTitle': 'Без категории',
  'analytics.layout.rackCount': '{{n}} стеллажей',
  'analytics.layout.worstMomentTitle': 'Худший момент за период',
  'analytics.layout.worstMomentLine': '{{rack}} · {{date}} · заполнено на {{pct}}%',
  'analytics.layout.byCategoryTitle': 'По категориям',
  'analytics.layout.eventCountLabel': 'Замечаний за период',
  'analytics.layout.totalTimeLabel': 'Время с замечаниями',
  'analytics.layout.worstFillLabel': 'Худшее заполнение',
  'analytics.layout.row.events': 'Замечаний: {{n}}',
  'analytics.layout.row.noEvents': 'Без замечаний',
  'analytics.layout.eventStats': '{{n}} замечаний · общая длительность {{total}} · самое долгое {{longest}}',
  'analytics.layout.eventStatsAllResolved': 'Все замечания закрыты вовремя.',
  'analytics.layout.noEventsExpanded': 'За этот период проблем с выкладкой не было.',
  'analytics.layout.shelfChartLabel': 'Заполнение полок этого стеллажа, %',
  'analytics.layout.equiPhotosLabel': 'Стеллаж в разные моменты периода',
  'analytics.layout.hourRhythmLabel': 'Средний ритм по часам (МСК), %',
  'analytics.queue.peakLabel': 'Пик очереди',
  'analytics.queue.overlayLabel': 'Очередь, кухня, открытые кассы, ожидающие',
  'analytics.queue.histogramLabel': 'Сколько минут в зоне было N человек',
  'analytics.queue.area.queue': 'Очередь',
  'analytics.queue.area.kitchen': 'Кухня',
  'analytics.queue.area.waiting': 'Ожидают',
  'analytics.queue.waitTimeLabel': 'Оценка времени ожидания в очереди',
  'analytics.queue.workerMatrixLabel': 'Сколько сотрудников за баром при скольких гостях у кассы',
  'analytics.queue.workerMatrixKitchen': 'Сотрудников за баром',
  'analytics.queue.workerMatrixFront': 'Гостей у кассы',
  'analytics.queue.decreaseSpeedLabel': 'Скорость уменьшения очереди (чел. за 15с) при разной длине',
  'analytics.sectionAnalytics': 'Аналитика',
  'analytics.tasks.completedLabel': 'Выполнено',
  'analytics.tasks.totalLabel': 'Всего задач',
  'analytics.tasks.onTimeLabel': 'Вовремя',
  'analytics.tasks.timingLabel': 'Когда выполняли относительно дедлайна',
  'analytics.tasks.chronicFail.title': 'Часто не выполняются',
  'analytics.tasks.chronicFail.empty': 'Все задачи выполняются стабильно (> 70%)',
  'analytics.tasks.chronicFail.rate': 'выполнение',
  'analytics.tasks.topDone.title': 'Чаще всего выполняются',
  'analytics.tasks.topDone.empty': 'Пока нет задач со стабильным выполнением (≥ 70%).',
  'analytics.tasks.taskAt': '{{text}} · {{time}}',
  'analytics.tasks.showAll': 'Смотреть все (+{{n}})',
  'analytics.tasks.collapse': 'Свернуть',
  'analytics.tasks.expand.loading': 'Загружаем последние отчёты…',
  'analytics.tasks.expand.empty': 'За этот период по этой задаче отчётов нет.',
  'analytics.tasks.expand.photosLabel': 'Фото из отчётов',
  'analytics.tasks.expand.count': 'Всего: {{n}}',
  'analytics.tasks.expand.expandAll': 'Развернуть все',
  'analytics.tasks.expand.collapseAll': 'Свернуть все',
  'analytics.tasks.expand.reportAt': 'отчёт {{time}}',
  'analytics.tasks.expand.status.created': 'создана',
  'analytics.tasks.expand.status.pending': 'ожидает',
  'analytics.tasks.expand.status.pre_deadline': 'скоро дедлайн',
  'analytics.tasks.expand.status.overdue': 'просрочена',
  'analytics.tasks.expand.status.done': 'выполнена',

  'language.label': 'Язык',
  'language.russian': 'Русский',
  'language.english': 'English',

  // Account / settings page
  'account.title': 'Настройки аккаунта',
  'account.subtitle': 'Профиль, пароль и оформление интерфейса.',
  'account.profile': 'Профиль',
  'account.profileDescription': 'Эти поля приходят с сервера.',
  'account.username': 'Имя пользователя',
  'account.email': 'Email',
  'account.role': 'Роль',
  'account.roleSuperuser': 'Суперпользователь',
  'account.roleStaff': 'Сотрудник Linza',
  'account.roleMember': 'Пользователь',
  'account.loadError': 'Не удалось загрузить данные аккаунта.',
  'account.password': 'Смена пароля',
  'account.passwordDescription': 'Минимум {{n}} символов. Подтвердите текущим паролем.',
  'account.passwordMinHint': 'Минимум {{n}} символов.',
  'account.passwordCurrent': 'Текущий пароль',
  'account.passwordNew': 'Новый пароль',
  'account.passwordConfirm': 'Повторите новый пароль',
  'account.passwordSubmit': 'Сменить пароль',
  'account.passwordSubmitting': 'Сохранение…',
  'account.passwordChanged': 'Пароль успешно изменён.',
  'account.passwordTooShort': 'Пароль должен быть не короче {{n}} символов.',
  'account.passwordMismatch': 'Пароли не совпадают.',
  'account.passwordSameAsCurrent': 'Новый пароль должен отличаться от текущего.',
  'account.passwordRejected': 'Сервер отклонил пароль (проверьте текущий пароль или сложность нового).',
  'account.telegram': 'Telegram',
  'account.telegramDescription': 'Привяжите Telegram-аккаунт для быстрого входа без пароля.',
  'account.telegramBindPrompt': 'Нажмите кнопку ниже, чтобы привязать ваш Telegram-аккаунт.',
  'account.telegramBindSuccess': 'Telegram успешно привязан.',
  'account.telegramBindError': 'Не удалось привязать Telegram. Попробуйте снова.',
  'account.telegramAlreadyTaken': 'Этот Telegram-аккаунт уже привязан к другому пользователю.',
  'account.telegramBindCta': 'Привязать Telegram',
  'account.telegramBound': 'Telegram привязан:',
  'account.telegramPendingFirstLogin': '(администратор привязал @username; ждём вашего первого входа через Telegram)',
  'account.appearance': 'Внешний вид',
  'account.appearanceDescription': 'Тема и язык интерфейса.',
  'telegram.pin.title': 'Закреплённое сообщение в чате',
  'telegram.pin.subtitle': 'Ссылки филиала: личный кабинет и приглашение в чат. Бот закрепляет сообщение в чате только по нажатию кнопки.',
  'telegram.pin.field.chatInvite': 'Приглашение в чат филиала (t.me/+…)',
  'telegram.pin.previewLabel': 'Превью сообщения',
  'telegram.pin.chatIdLabel': 'Chat ID получателя (переопределение)',
  'telegram.pin.chatIdHint': 'По умолчанию используется чат филиала из таблицы выше. Заполните, чтобы отправить в другой чат разово.',
  'telegram.pin.threadIdLabel': 'Топик чата (message_thread_id)',
  'telegram.pin.threadIdHint': 'Если чат разбит на топики — номер нужного топика. Телеграм не отдаёт список топиков боту, поэтому его нужно указать вручную: откройте топик в веб-версии и возьмите число из адреса сообщения. Пусто — сообщение уйдёт в общий раздел чата.',
  'telegram.pin.threadIdPlaceholder': '3',
  'telegram.pin.adminNote': 'Робота нужно сделать администратором чата — иначе он не сможет закрепить сообщение.',
  'telegram.pin.send': 'Отправить и закрепить',
  'telegram.pin.update': 'Обновить закреп',
  'telegram.pin.notPinned': 'Сейчас не закреплено',
  'telegram.pin.lastPinnedAt': 'Закреплено: {{at}}',
  'telegram.pin.sendFailed': 'Не удалось отправить сообщение в чат.',
  'telegram.pin.chatIdPlaceholder': '−1001234567890',
  'pwa.install.title': 'Установить как приложение',
  'pwa.install.iosHowTo': 'В Safari нажмите «Поделиться» → «На экран Домой».',
  'pwa.install.browserMenuHint': 'Если кнопка не сработала — в меню браузера (⋮) пункт «Установить приложение».',
  'pwa.install.cta': 'Установить',
  'pwa.install.later': 'Позже',
  'pwa.install.laterHint': 'Установить позже всегда можно в настройках профиля (в левом нижнем углу).',
  'pwa.installCard.title': 'Установить приложение',
  'pwa.installCard.subtitle': 'Такой же интерфейс, как на этом сайте, но по кнопке с главного экрана. Занимает {{size}}.',
  'common.dismiss': 'Скрыть',
  'common.ok': 'OK',
  'account.themeLabel': 'Тема',
  'account.languageLabel': 'Язык интерфейса',
  'theme.lightShort': 'Светлая',
  'theme.darkShort': 'Тёмная',
  'theme.systemShort': 'Системная',

  // Telegram bot settings page (/management/telegram)
  'telegram.loading': 'Загрузка настроек…',
  'telegram.notConfigured': 'Для этого филиала ещё не настроен Telegram-бот. Нажмите кнопку ниже, чтобы начать.',
  'telegram.connectAction': 'Подключить Telegram',
  'telegram.connecting': 'Инициализация…',
  'telegram.fetchFailed': 'Не удалось загрузить настройки.',
  'telegram.initFailed': 'Не удалось инициализировать настройки.',
  'telegram.saveFailed': 'Не удалось сохранить настройки.',
  'telegram.saved': 'Сохранено.',
  'telegram.saving': 'Сохранение…',
  'telegram.mainSection': 'Основной чат уведомлений',
  'telegram.mainDescription': 'Сюда приходят уведомления о полках и другие системные сообщения. Для чек-листов чат настраивается отдельно во вкладке «Чек-лист».',
  'telegram.prodChatLabel': 'ID основного чата (prod_chat_id)',
  'telegram.prodChatHint': 'Chat ID Telegram-группы. Отрицательное число для групп.',
  'telegram.prodThreadLabel': 'ID темы (prod_thread_id)',
  'telegram.prodThreadHint': 'Необязательно. Thread ID для супергрупп с темами.',
  'telegram.systemSection': 'Системные чаты',
  'telegram.systemWarning': 'Изменение этих полей влияет на отладочные и служебные сообщения для всех зон, наследующих настройки.',
  'telegram.debugChatLabel': 'Debug chat ID',
  'telegram.cancelChatLabel': 'Cancel chat ID',

  // Account.passwordDescription uses {{n}}; pre-format below isn't needed

  'sidebar.summaries': 'Итоги дня',
  'summaries.title': 'Итоги дня',
  'summaries.subtitle': 'Ежедневные отчёты по филиалу.',
  'summaries.prevDay': 'Предыдущий день',
  'summaries.nextDay': 'Следующий день',
  'summaries.today': 'Сегодня',
  'summaries.noReport': 'Отчёт за этот день ещё не сформирован.',
  'summaries.statusPending': 'Ожидает подтверждения',
  'summaries.statusConfirmed': 'Подтверждён',
  'summaries.statusCancelled': 'Отменён',
  'summaries.loading': 'Загрузка отчёта…',
  'summaries.generatedAt': 'Сформирован: {{time}}',
  'summaries.dashboards': 'Дашборды:',
  'summaries.layoutPhotos': 'Выкладка в течение дня',
  'summaries.queuePhotos': 'Очередь в течение дня',
  'summaries.photosCardTitle': 'Характерные кадры за день',
  'summaries.chatReportTitle': 'Отчёт для чата',
  'summaries.dashboardsGrafana': 'Дашборды Grafana',
  'summaries.kadryLayoutTitle': 'Характерные кадры дня: Выкладка',
  'summaries.kadryQueueTitle': 'Характерные кадры дня: Очередь',
  'summaries.tableLongestTitle': 'Самый долгий неубранный стол',
  'summaries.tablesLongestTitle': 'Самые долгие неубранные столы',
  'summaries.tasksDone': 'Готово {{done}} из {{total}}',
  'summaries.tableCleanupTitle': 'Уборка столов',

  // Отчёт · День — full-day queue + racks cards
  'report.day.queueCardTitle': 'Очередь за день',
  'report.day.queueLen': 'Очередь, чел.',
  'report.day.openCashiers': 'Открытых касс',
  'report.day.queuePhotos': 'Кадры очереди в течение дня',
  'report.day.racksCardTitle': 'Выкладка за день',
  'report.day.rackPicker': 'Стеллаж',
  'report.day.shelfChartLabel': 'Заполненность полок в течение дня',
  'report.day.rackPhotos': 'Кадры стеллажа в течение дня',
  'report.day.expand': 'Развернуть на весь экран',
  'report.day.zoomReset': 'Сброс',
  'report.day.zoomHint': 'Выделите период на графике, чтобы приблизить · двойное касание — вернуться к графику за весь день',
  'report.day.zoomHintRange': 'Выделите период на графике, чтобы приблизить · двойное касание — вернуться к графику за весь период',
  'report.day.loadingFrames': 'Загружаем кадры за выбранный период…',
  'report.day.allRacks': 'Все',
  'report.day.kitchenStaff': 'За баром',
  'report.day.noDirtyTables': 'Долго неубранных столов не обнаружено',
  // #264: pencil-gated (daily_report.manage) correction of a false dirty-table incident.
  'report.day.editIncidents': 'Редактировать случаи',
  'report.day.removeIncident': 'Исправить этот случай',
  'report.day.removeIncidentFailed': 'Не удалось исправить случай. Попробуйте ещё раз.',
  // 2026-09-01 (Alexey follow-up): the X now opens a 3-way state picker
  // instead of a window.confirm — the picked state also corrects the
  // underlying TableOccupancy rows, so «Состояние столов за день» below
  // repaints, not just the report card.
  'report.day.correctIncidentFree': 'Стол свободен',
  'report.day.correctIncidentOccupied': 'Стол занят',
  'report.day.correctIncidentShifted': 'Стол не на месте',
  // Alexey 21.10: «Нативные объекты» + per-photo cut («старт грязь, финиш нативные»).
  'report.day.correctIncidentNative': 'Нативные объекты',
  'report.day.correctFromPhoto': 'Исправить с этого фото',
  'report.day.correctScopeFromHere': 'С этого фото до конца',
  'report.day.correctScopeOnlyThis': 'Только это фото',
  'report.day.correctPersonal': 'Личные вещи',
  'report.day.correctFood': 'Еда / напитки',
  'report.day.correctDirty': 'Грязная посуда / мусор',
  'report.day.correctScope': 'Применить исправление',
  'report.day.correctScopeEpisode': 'Весь эпизод',
  'report.day.correctPresence': '1. Стол занят?',
  'report.day.correctPosition': '2. Стол на месте?',
  'report.day.correctInFrame': 'На месте',
  'report.day.correctSurface': '3. Что на столе? Можно выбрать несколько',
  'report.day.correctCleanHint': 'Если ничего из перечисленного нет, оставьте все флажки выключенными.',
  'report.day.correctTrainingHint': 'Эти признаки применятся к выбранному периоду. Кадры поступят в данные как размеченные человеком.',

  // Отчёт — график состояния столов (state strips)
  'report.tables.stripsDayTitle': 'Состояние столов за день',
  'report.tables.stripsWeekTitle': 'Состояние столов за неделю',
  'report.tables.stripsTitle': 'Состояние столов',
  'report.tables.newFeature': 'Новая функция — данные могут быть неточными',
  'report.tables.stateFree': 'Свободен',
  'report.tables.stateOccupied': 'Занят',
  'report.tables.stateDirty': 'Не убран',
  'report.tables.stateShifted': 'Стол не на месте',
  'report.tables.stateUnknown': 'Трудно однозначно определить',
  'tables.spoiledReason.several_tables': 'в кадре несколько столов',
  'tables.spoiledReason.obstructed': 'стол перекрыт',
  'tables.spoiledReason.glare': 'засвет',
  'report.tables.stateNoData': 'Нет данных',
  'report.tables.stateOffHours': 'Нерабочее время',
  'report.tables.durationMin': '{{mins}} мин',
  'report.tables.durationHM': '{{h}} ч {{m}} мин',
  'report.tables.durationH': '{{h}} ч',

  // Отчёт · Неделя — tables stats (reused from Аналитика → Статистика → Столы)
  'report.week.tablesMedian': 'Медиана уборки',
  'report.week.tablesP90': '90-й перцентиль',
  'report.week.tablesNoData': 'Грязных столов за неделю не было',
  'report.week.layoutTitle': 'Выкладка за неделю',
  'report.week.queueTitle': 'Очередь за неделю',
  'report.week.dropsTitle': 'Самые долгие просадки',
  'report.week.dropLabel': 'просадка {{mins}} мин',
  'report.week.percentilesTitle': 'Типичная выкладка за неделю',
  'report.week.showOtherRacks': 'Показать: {{racks}}',
  'report.week.hideOtherRacks': 'Скрыть дополнительные стеллажи',
  'report.week.tasksNotDone': 'Не выполнялось',
  'weeklyReport.layoutHighlights': 'Выкладка за неделю — характерные моменты',
  'weeklyReport.queueHighlights': 'Очередь за неделю — характерные моменты',
  'summaries.cancelledPlaceholder': 'Недостаточно данных для отчёта.',
  'summaries.actions.edit': 'Редактировать',
  'summaries.actions.cancel': 'Отменить отчёт',
  'summaries.actions.confirm': 'Подтвердить',
  'summaries.actions.send': 'Отправить в основной чат',
  'summaries.actions.editTitle': 'Редактирование отчёта',
  'summaries.actions.editDescription': 'Сохранение обновит и сообщение в Telegram.',
  'summaries.actions.save': 'Сохранить',
  'summaries.actions.discard': 'Отмена',
  'summaries.actions.confirmCancelTitle': 'Отменить отчёт?',
  'summaries.actions.confirmCancelDescription': 'В UI будет отображаться: «Недостаточно данных для отчёта». Сообщение в Telegram также будет помечено как отменённое.',
  'summaries.actions.confirmSendTitle': 'Отправить в основной чат?',
  'summaries.actions.confirmSendDescription': 'Отчёт будет скопирован в основной чат филиала и помечен как подтверждённый.',
  'summaries.actions.errorEdit': 'Не удалось сохранить отчёт.',
  'summaries.actions.errorConfirm': 'Не удалось подтвердить отчёт.',
  'summaries.actions.errorCancel': 'Не удалось отменить отчёт.',
  'summaries.actions.errorSend': 'Не удалось отправить отчёт.',
  'summaries.queue.prev': 'Предыдущий неподтверждённый',
  'summaries.queue.next': 'Следующий неподтверждённый',
  'summaries.queue.position': '{{index}} из {{total}} ожидают подтверждения',
  'summaries.queue.outside': '{{total}} ожидают подтверждения',
  'summaries.unsentQueue.prev': 'Предыдущий неотправленный',
  'summaries.unsentQueue.next': 'Следующий неотправленный',
  'summaries.unsentQueue.position': '{{index}} из {{total}} ожидают отправки',
  'summaries.unsentQueue.outside': '{{total}} ожидают отправки',
  'sidebar.weeklyReport': 'Итоги недели',
  'sidebar.heatmap': 'Тепловая карта',
  'conversations.title': 'Качество обслуживания',
  'conversations.selectZone': 'Выберите зону для просмотра аналитики.',
  'conversations.noData': 'Нет данных за выбранный период.',
  'conversations.period.today': 'Сегодня',
  'conversations.period.7d': '7 дней',
  'conversations.period.30d': '30 дней',
  'conversations.kpi.avgScore': 'Средняя оценка',
  'conversations.kpi.analyzed': 'проанализировано',
  'conversations.kpi.total': 'Всего разговоров',
  'conversations.kpi.problems': 'С проблемами',
  'conversations.kpi.upsellRate': 'Допродажа',
  'conversations.kpi.attempts': 'попыток',
  'conversations.chart.score': 'Оценка качества по времени',
  'conversations.chart.count': 'Количество разговоров',
  'conversations.criteria.title': 'Средние оценки по критериям',
  'conversations.criteria.greeting': 'Приветствие',
  'conversations.criteria.farewell': 'Прощание',
  'conversations.criteria.politeness': 'Вежливость',
  'conversations.criteria.orderConfirmation': 'Подтверждение заказа',
  'conversations.criteria.upselling': 'Допродажа',
  'conversations.criteria.loyalty': 'Лояльность',
  'conversations.table.title': 'Проанализированные разговоры',
  'conversations.table.subtitle': 'Только разговоры с готовой оценкой LLM. Идущие записи и неудавшиеся анализы здесь не показаны.',
  'conversations.table.empty': 'Нет проанализированных разговоров за период.',
  'conversations.table.time': 'Время',
  'conversations.table.duration': 'Длит.',
  'conversations.table.score': 'Оценка',
  'conversations.table.problem': 'Проблема',
  'conversations.table.summary': 'Описание',
  'conversations.table.pageOf': 'Стр. {{page}} из {{total}}',
  'conversations.table.recording': 'Запись',
  'conversations.recording.clip': 'Фрагмент',
  'conversations.internal.title': 'Сырые данные (только Linza)',
  'conversations.internal.subtitle': 'Каждый записанный 30-сек фрагмент со статусом, транскриптом и аудио. Видно только сотрудникам Linza.',
  'conversations.internal.transcript': 'Транскрипт',
  'conversations.internal.segments': 'Сегменты',
  'conversations.internal.recommendations': 'Рекомендации',
  'conversations.internal.rawLlm': 'Ответ LLM',
  'conversations.internal.empty': 'Нет транскрипта.',
  'conversations.internal.noData': 'Нет фрагментов за период.',
  'conversations.internal.belongsTo': 'Входит в разговор',
  'conversations.internal.convShort': 'разговор',
  'conversations.internal.clipShort': 'фрагмент',
  'conversations.internal.clipId': 'ID фрагмента (AudioRecord)',
  'conversations.internal.recordedAt': 'Записано',
  'conversations.internal.recordedUnknown': 'время записи неизвестно (клип старого формата)',
  'conversations.status.PENDING': 'В обработке',
  'conversations.status.RECORDING': 'Запись',
  'conversations.status.TRANSCRIBED': 'Расшифрован',
  'conversations.status.ANALYZED': 'Проанализирован',
  'conversations.status.NO_SPEECH': 'Нет речи',
  'conversations.status.NO_AUDIO': 'Нет аудио',
  'conversations.status.NOT_CONVERSATION': 'Не клиентский разговор',
  'conversations.search.placeholder': 'Поиск по тексту разговора',
  'conversations.search.addChip': 'Особый фильтр: апселл, общение, лояльность, проблема, номер разговора',
  'conversations.overview.pickValue': 'Поставить значение в поиск',
  'conversations.overview.pickPhrase': 'В поиск',
  'conversations.overview.otherPhrases': 'прочее',
  'conversations.search.button': 'Найти',
  'conversations.search.reset': 'сбросить',
  'conversations.search.found': 'Найдено разговоров: {{count}} — по запросу «{{q}}» за выбранный период.',
  'conversations.search.empty': 'За выбранный период ничего не найдено.',
  'conversations.table.showPartial': 'показать частично записанные',
  'conversations.table.hidePartial': 'скрыть частично записанные',
  'conversations.status.PARTIAL': 'Частичная запись',
  'conversations.status.FAILED': 'Ошибка',
  // Collapsible conversation rows
  'conversations.row.problem': 'Проблема',
  'conversations.row.clips': '{{n}} фрагм.',
  'conversations.detail.summary': 'Описание',
  'conversations.detail.recommendations': 'Рекомендации',
  'conversations.detail.dialogue': 'Восстановленный диалог',
  'conversations.dialogue.restored': 'Восстановленный',
  'conversations.dialogue.raw': 'Как распознано',
  'conversations.dialogue.showSource': 'исходник',
  'conversations.dialogue.hideSource': 'скрыть исходник',
  'conversations.dialogue.showPlain': 'Показать сырой текст',
  'conversations.dialogue.showParsed': 'показать разбор по репликам',
  'conversations.dialogue.cashier': 'Сотрудник',
  'conversations.dialogue.priorTitle': 'Сказано до начала этой записи — слышно в конце предыдущего разговора',
  'conversations.dialogue.guest': 'Гость',
  'conversations.transcript.beep': 'оплата',
  'conversations.transcript.scan': 'приложили карту',
  'conversations.transcript.chime': 'звон · уведомление или QR',
  'conversations.transcript.print': 'печать чека',
  'conversations.transcript.unclear': 'неразборчиво · {{sec}} с',
  'conversations.transcript.unclearFar': 'тихий голос, гость или зал · {{sec}} с',
  'conversations.transcript.noise': 'шум зала · {{sec}} с',
  'conversations.transcript.taps': 'стук у кассы · {{sec}} с',
  'conversations.transcript.insert': 'вставка другого голоса · {{sec}} с',
  'conversations.transcript.murmur': 'короткий звук голоса («м?», «угу») · {{sec}} с',
  'conversations.transcript.parts': 'в реплике два голоса',
  'conversations.transcript.silence': 'тишина · {{sec}} с',
  'conversations.dialogue.pause': 'пауза · {{sec}} с',
  'conversations.dialogue.pauseTitle': 'Пауза',
  'conversations.dialogue.pauseSec': '{{sec}} с',
  'conversations.dialogue.event.payment': 'Оплата',
  'conversations.dialogue.event.scan': 'Отсканировали лицензию',
  'conversations.dialogue.event.chime': 'Звон · уведомление или QR',
  'conversations.dialogue.event.print': 'Печать чека',
  'conversations.dialogue.event.hz': 'писк {{hz}} Гц',
  'conversations.dialogue.settings': 'Настройки плеера',
  'conversations.dialogue.oneSegment': 'Играть один сегмент',
  'conversations.dialogue.oneSegmentHint': 'Клик по реплике или отрезку на дорожке проигрывает только этот сегмент и останавливается в его конце.',
  'conversations.dialogue.flagForMarkup': 'Пометить для разметки',
  'conversations.dialogue.seekHint': 'Перейти к этому месту записи',
  'conversations.dialogue.noSource': 'Реплика восстановлена по смыслу — в записи её нет',
  'conversations.dialogue.sourceHint': 'Показать, как это распознано',
  'conversations.detail.transcript': 'Транскрипт',
  // 22-criteria checklist
  'conversations.checklist.title': 'Чек-лист (22 критерия)',
  'conversations.stage.greeting': 'Приветствие',
  'conversations.stage.order': 'Приём заказа',
  'conversations.stage.upsell': 'Апселл',
  'conversations.stage.loyalty': 'Программа лояльности',
  'conversations.stage.payment': 'Оплата и завершение диалога',
  'conversations.stage.closing': 'Завершение',
  'conversations.stage.manner': 'Общее настроение и вежливость',
  'conversations.stage.skipped': 'этап пропущен',
  'conversations.checklist.notRated': 'Не оценивалось ({{n}})',
  'conversations.checklist.notRatedOpen': 'не оценивалось {{n}} параметров, посмотреть',
  'conversations.checklist.hiddenOpen': 'Скрытые параметры ({{n}})',
  'conversations.checklist.item.greeting': 'Поздоровался',
  'conversations.checklist.item.greeting_informal': 'Тип приветствия',
  'conversations.checklist.item.asked_volume': 'Спросил объём',
  'conversations.checklist.item.client_named_volume': 'Гость назвал объём сам',
  'conversations.checklist.item.asked_here_or_togo': 'Спросил, здесь или с собой',
  'conversations.checklist.item.offered_ceramic': 'Предложил керамику',
  'conversations.checklist.item.repeated_order': 'Повторил заказ',
  'conversations.checklist.item.warned_wait_before_pay': 'Предупредил об ожидании до оплаты',
  'conversations.checklist.item.asked_hot_cold': 'Спросил, холодный или горячий',
  'conversations.checklist.item.client_asked_togo': 'Гость попросил с собой',
  'conversations.checklist.item.client_own_cup': 'Гость со своей посудой',
  'conversations.checklist.item.own_cup_fulfilled': 'Налили в свою посуду',
  'conversations.checklist.item.upsell_offered': 'Предложил дополнительно',
  'conversations.checklist.item.upsell_filter_instead_americano': 'Предложил фильтр вместо американо',
  'conversations.checklist.item.upsell_item': 'Что предложил',
  'conversations.checklist.item.upsell_types': 'Тип апселла',
  'conversations.checklist.choice.upsell_complementary': 'товарная пара',
  'conversations.checklist.choice.upsell_seasonal': 'сезонный',
  'conversations.checklist.choice.upsell_margin': 'маржинальный',
  'conversations.checklist.choice.upsell_daypart': 'ко времени суток',
  'conversations.checklist.choice.upsell_open_question': 'общий вопрос «Что ещё?»',
  'conversations.checklist.choice.upsell_anything_else': 'Что-то ещё?',
  'conversations.checklist.choice.upsell_addons': 'сахар-сироп-корица',
  'conversations.checklist.choice.upsell_food': 'еда к напитку',
  'conversations.checklist.choice.upsell_better_choice': 'позиция интереснее выбранной',
  'conversations.checklist.item.upsell_food_items': 'Какую еду предложил',
  'conversations.checklist.item.upsell_better_items': 'Что на что предложил заменить',
  'conversations.checklist.item.upsell_addons_syrup': 'Предложил сироп',
  'conversations.checklist.item.loyalty_phrase': 'Как назвал программу',
  'conversations.overview.title': 'Сводка',
  'conversations.overview.analyzed': 'разобрано разговоров: {{n}}',
  'conversations.overview.of': 'из {{n}}',
  'conversations.overview.list': 'список · {{n}}',
  'conversations.overview.all': 'все',
  'conversations.overview.play': 'Прослушать',
  'conversations.overview.stop': 'Остановить',
  'conversations.overview.open': 'к разговору',
  'conversations.overview.requested': 'Просили',
  'conversations.overview.answer': 'Ответ',
  'conversations.overview.missingGoods': 'Чего не было:',
  'conversations.overview.problems': 'Проблемы',
  'conversations.overview.noProblems': 'За период проблем нет',
  'conversations.overview.page': '{{page}} из {{pages}}',
  'conversations.overview.examples': 'Примеры',
  'conversations.overview.phrases': 'Формулировки',
  'conversations.overview.showMore': 'показать ещё {{n}}',
  'conversations.overview.hideList': 'свернуть список',
  'conversations.checklist.item.upsell_weak': 'только слабое предложение',
  'conversations.problem.kind.out_of_stock': 'нет товара',
  'conversations.problem.kind.dialogue': 'в общении',
  'conversations.problem.kind.product': 'с товаром',
  'conversations.problem.kind.cafe': 'в кофейне',
  'conversations.problem.severity.low': 'мелочь',
  'conversations.problem.severity.medium': 'заметно',
  'conversations.problem.severity.high': 'серьёзно',
  'conversations.detail.problems': 'Проблемы',
  'conversations.checklist.item.upsell_accepted': 'Гость согласился',
  'conversations.checklist.item.asked_loyalty': 'Спросил про программу',
  'conversations.checklist.item.named_license_surfer': 'Назвал «лицензия серфера»',
  'conversations.checklist.item.offered_loyalty_signup': 'Предложил подключить',
  'conversations.checklist.item.client_has_loyalty': 'У гостя программа есть',
  'conversations.checklist.item.guest_showed_loyalty': 'Гость показал сам',
  'conversations.checklist.item.client_agreed_signup': 'Гость согласился подключить',
  'conversations.checklist.item.named_total': 'Назвал сумму',
  'conversations.checklist.item.payment_taken': 'Принял оплату',
  'conversations.checklist.item.asked_receipt': 'Спросил про чек',
  'conversations.checklist.item.positive_closing': 'Позитивная завершающая фраза',
  'conversations.checklist.item.told_wait_time': 'Сориентировал по времени',
  'conversations.checklist.item.active_communication': 'Активное общение',
  'conversations.checklist.item.interesting_communication': 'Интересное общение',
  'conversations.checklist.item.friendly': 'Доброжелательное общение',
  'conversations.checklist.item.dry_minimal': 'Сухое общение, минимум фраз',
  'conversations.checklist.item.rude': 'Явная невежливость',
  'conversations.checklist.item.address_on_vy': 'Форма обращения',
  'conversations.checklist.yes': 'да',
  'conversations.checklist.no': 'нет',
  'conversations.checklist.na': 'Н/П',
  'conversations.checklist.vy': '«на вы»',
  'conversations.checklist.ty': '«на ты»',
  'conversations.checklist.group.greeting': 'Приветствие',
  'conversations.checklist.group.politeness': 'Вежливость и настроение',
  'conversations.checklist.group.upsell': 'Апселл',
  'conversations.checklist.group.orderDetails': 'Детали заказа',
  'conversations.checklist.group.loyalty': 'Программа лояльности',
  'conversations.checklist.item.greeting_formal': 'Формальное приветствие',
  'common.prev': 'Назад',
  'common.next': 'Вперёд',
  'heatmap.title': 'Аналитика посадки',
  'heatmap.subtitle': 'Тепловые карты и статистика по зонам за выбранный период.',
  'heatmap.loading': 'Загрузка данных…',
  'heatmap.error': 'Ошибка загрузки данных.',
  'heatmap.period.7d': '7 дней',
  'heatmap.period.30d': '30 дней',
  'heatmap.period.8we': '8 выходных',
  'heatmap.period.10wd': '10 будних',
  'heatmap.periodLabel': 'Период',
  'heatmap.layerLabel': 'Слой карты',
  'heatmap.type.scatter': 'Точки',
  'heatmap.type.gradient': 'Градиент',
  'heatmap.type.isolines': 'Изолинии',
  'heatmap.compareOn': 'Сравнить',
  'heatmap.compareOff': 'Без сравнения',
  'heatmap.compareExit': 'Выйти из сравнения',
  'heatmap.compareHint': 'Сравните рядом два периода или филиала.',
  'heatmap.thisZone': 'Этот филиал',
  'heatmap.comparedZone': 'Сравниваемый филиал',
  'heatmap.overlayAlt': 'Тепловая карта зала',
  'heatmap.noFloorplan': 'План зала не настроен — обратитесь к команде Linza.',
  'heatmap.insight.topZone': '{{name}} занята в {{ratio}}× чаще средней зоны',
  'heatmap.barchart.title': 'Посещаемость зон',
  'heatmap.barchart.metric': 'Среднее число людей',
  'heatmap.barchart.avgWhenOccupied': '{{avg}} чел когда есть люди',
  'heatmap.barchart.hoursPerDay': '{{hours}} ч/день',
  'heatmap.barchart.groupSizeHistogram': 'Состав посадки:',
  'heatmap.barchart.hint': 'Нажмите на зону для просмотра распределения по времени суток.',
  'heatmap.tod.title': 'По времени суток',
  'heatmap.tod.mon': 'Пн', 'heatmap.tod.tue': 'Вт', 'heatmap.tod.wed': 'Ср',
  'heatmap.tod.thu': 'Чт', 'heatmap.tod.fri': 'Пт', 'heatmap.tod.sat': 'Сб',
  'heatmap.tod.sun': 'Вс',
  'heatmap.tod.cellTooltip': '{{day}} {{hour}}:00 — ≈ {{val}} чел',
  'heatmap.tod.error': 'Не удалось загрузить данные по времени суток.',
  'heatmap.compare.error': 'Не удалось загрузить данные сравнения.',
  'heatmap.empty.title': 'Зоны посадки не размечены',
  'heatmap.empty.desc': 'Чтобы получить аналитику посадки, разметьте столы и зоны ожидания:',
  'heatmap.empty.step1': 'Откройте «Зонирование» в настройках филиала.',
  'heatmap.empty.step2': 'Нарисуйте полигон для каждого стола или зоны ожидания.',
  'heatmap.empty.step3': 'Дайте каждой зоне понятное название.',
  'heatmap.empty.cta': 'Открыть зонирование →',
  'heatmap.seatingCta.title': 'Разметьте зоны посадки, чтобы увидеть подробную статистику по столам',
  'heatmap.seatingCta.button': 'Разметить →',
  'heatmap.unnamed.zone': 'Зона {{id}}',
  'heatmap.unnamed.camera': 'Камера {{id}}',
  'heatmap.camera.noImage': 'Нет изображения с камеры',
  'heatmap.camera.loadingFrame': 'Загрузка кадра…',
  'heatmap.camera.frameFetchFailed': 'Не удалось загрузить кадр',
  'heatmap.camera.loadingOverlays': 'Загрузка зон…',
  'heatmap.camera.loadingHeatmap': 'Загрузка тепловой карты…',
  'heatmap.camera.loadingHotZones': 'Загрузка зон активности…',
  'heatmap.layer.frame': 'Кадр',
  'heatmap.layer.zones': 'По зонам',
  'heatmap.layer.heatmap': 'Тепловая карта',
  'heatmap.layer.hotzones': 'Зоны активности',
  'heatmap.workingHours.label': 'Часы работы: {{hours}}',
  'heatmap.planCta.title': 'Загрузите план зала, чтобы просмотреть тепловые карты на плане',
  'heatmap.planCta.button': 'Загрузить план →',
  'heatmap.isoline.tooltipHours': '{{hours}} часов/день в этой точке есть люди',
  'heatmap.isoline.tooltipMinutes': '{{minutes}} минут/день в этой точке есть люди',
  'heatmap.colorbar.peak': 'ч/день',
  'heatmap.colorbar.cutoffMinutes': '{{minutes}} мин/день',
  'heatmap.cellTod.byDay': 'По дням',
  'heatmap.cellTod.byHour': 'По часам',
  'heatmap.coverage.noDataTitle': 'Нет данных',
  'heatmap.coverage.noDataHint': 'Камера не записывала во время работы заведения за выбранный период.',
  'heatmap.coverage.partialChip': 'Часть данных пропущена ({{pct}}%)',
  'heatmap.coverage.detailRecorded': 'Записано',
  'heatmap.coverage.detailMissing': 'Пропущено',
  'heatmap.coverage.detailFullDays': 'Дней с полной записью',
  'heatmap.coverage.detailNote': 'Тепловая карта построена по доступным данным и может быть неточной.',
  'heatmap.freedraw.start': 'Нарисовать зону',
  'heatmap.freedraw.startShort': 'Зона',
  'heatmap.freedraw.cancel': 'Очистить',
  'heatmap.freedraw.hint': 'Обведите область кликами и закройте контур',
  'heatmap.freedraw.computing': 'Считаем…',
  'weeklyReport.title': 'Итоги недели',
  'weeklyReport.subtitle': 'Динамика за неделю: текущая неделя vs предыдущая.',
  'weeklyReport.prevWeek': 'Предыдущая неделя',
  'weeklyReport.nextWeek': 'Следующая неделя',
  'weeklyReport.noReport': 'Отчёт за эту неделю ещё не сформирован.',
  'weeklyReport.loading': 'Загрузка отчёта…',
  'weeklyReport.generatedAt': 'Сформирован: {{time}}',
  'weeklyReport.weekOf': 'Неделя {{from}} — {{to}}',
  'weeklyReport.notConfigured': 'Плагин не настроен',
  'weeklyReport.noData': 'Нет данных за период',
  'weeklyReport.layout': 'Выкладка',
  'weeklyReport.layoutDesc': 'Средняя наполненность полок',
  'weeklyReport.queue': 'Очередь',
  'weeklyReport.queueDesc': 'Среднее количество человек в очереди',
  'weeklyReport.tasks': 'Задачи',
  'weeklyReport.tasksDesc': 'Процент выполненных чек-листов',
  'weeklyReport.tables': 'Столы',
  'weeklyReport.tablesDesc': 'Среднее количество грязных столов в день',
  'weeklyReport.prevWeekLabel': 'Прошлая:',
  'weeklyReport.prevInParens': 'В скобках — значение за прошлую неделю.',
  'weeklyReport.notConfiguredHeading': 'Не подключено',
  'weeklyReport.unitPersons': 'чел.',
  'weeklyReport.unitItems': 'шт.',
  'role.zone_admin': 'Администратор',
  'role.zone_manager': 'Менеджер',
  'role.zone_employee': 'Сотрудник',
  'role.line_worker': 'Линейный работник',
  'role.chain_office': 'Центральный офис',
  'dashboard.summaryTitle': 'Итоги вчера',
  'dashboard.summaryEmpty': 'Отчёт за вчера ещё не сформирован.',
  'dashboard.summaryLink': 'Все итоги дня →',

  // Polygon edit form (UnifiedEditForm)
  'zoning.form.titleCreate': 'Создание полигона',
  'zoning.form.titleEdit': 'Редактирование полигона',
  'zoning.form.labelType': 'Тип',
  'zoning.form.labelName': 'Название',
  'zoning.form.labelRackType': 'Тип стеллажа',
  'zoning.form.labelPerspectiveWidth': 'Перспективная ширина',
  'zoning.form.labelPerspectiveHeight': 'Перспективная высота',
  'zoning.form.recalcPerspective': 'Пересчитать по сторонам',
  'zoning.form.recalcHint': 'Подставить ширину и высоту по реальным пропорциям полигона',
  'zoning.form.cropPreviewTitle': 'Предпросмотр кропа',
  'zoning.form.cropBrighten': 'Осветление',
  'zoning.form.cropBrightenHelp': 'Для тёмных столов: фото валидаторам и на дашборд светлее. 0 — выкл, 1 — максимум.',
  'zoning.form.canBePhysicallyMoved': 'Стол можно физически сдвинуть',
  'zoning.form.canBePhysicallyMovedHint': 'Снимите для барных стоек и других закреплённых поверхностей — для них не будет статуса «стол не на месте».',
  'zoning.form.spoiledGlareOnly': '«Кадр испорчен» — только засвет',
  'zoning.form.spoiledGlareOnlyHint': 'Для столов, где в полигоне по разметке всегда несколько столешниц (диван с двумя-тремя столами): не спрашивать «несколько столов / перекрыт», следить только за засветом.',
  'zoning.form.cropPreviewEmpty': 'Заполните перспективную ширину и высоту',
  'zoning.form.initialDimsHint': 'Должны совпадать с разрешением камеры',
  'zoning.grid.button': 'Авто-заполнить полками по сетке',
  'zoning.grid.title': 'Сетка полок',
  'zoning.grid.count': 'Количество полок',
  'zoning.grid.gap': 'Зазор между полками, px',
  'zoning.grid.gapHint': 'В перспективных пикселях. Держите близко к толщине полки: в режиме подсчёта товары, попавшие в зазор, не учитываются ни одной полкой.',
  'zoning.grid.padding': 'Отступы, %',
  'zoning.grid.paddingExpand': 'Разные отступы по сторонам',
  'zoning.grid.paddingTop': 'Сверху',
  'zoning.grid.paddingBottom': 'Снизу',
  'zoning.grid.paddingLeft': 'Слева',
  'zoning.grid.paddingRight': 'Справа',
  'zoning.grid.naming': 'Именование',
  'zoning.grid.namingRyad': 'Первый ряд, Второй ряд…',
  'zoning.grid.namingPolka': 'Первая полка, Вторая полка…',
  'zoning.grid.orientation': 'Ориентация',
  'zoning.grid.orientationB2T': 'Снизу вверх',
  'zoning.grid.orientationL2R': 'Слева направо',
  'zoning.grid.cancel': 'Убрать сетку',
  'zoning.grid.error': 'Не удаётся построить сетку: зазор или отступы не оставляют места.',
  'zoning.grid.shelfFailed': 'Не удалось создать полку',
  'zoning.form.labelInitialWidth': 'Начальная ширина',
  'zoning.form.labelInitialHeight': 'Начальная высота',
  'zoning.form.labelComposite': 'Составной',
  'zoning.form.labelSingleShelf': 'Одна полка = стеллаж',
  'zoning.form.singleShelfHelp': 'Полка едет за полигоном стеллажа при правке, отдельно её не таскают. Включать для стеллажей с одной полкой.',
  'zoning.form.labelPredictPct': 'Прогнозировать процент',
  'zoning.form.labelModel': 'Нейросеть',
  'zoning.form.modelQuant': 'количественная — боксы, процент от ширины вдоль линии полки',
  'zoning.form.modelPct': 'процентная — процент от площади полки',
  'zoning.form.modelInherit': 'как у стеллажа',
  'zoning.form.modelPerShelf': 'Настроено по полкам',
  'zoning.form.labelMerchandisingDashId': 'ID мерчандайзинг-дашборда',
  'zoning.form.labelMerchandisingDashHelper': 'Необязательно. Для связки с системой мерчандайзинга.',
  'zoning.form.labelBottomPoints': 'Нижние точки (через запятую)',
  'zoning.form.labelTopPoints': 'Верхние точки (через запятую)',
  'zoning.form.labelEmptyShelfScore': 'Порог пустой секции',
  'zoning.form.labelShelfNum': 'Номер секции на стеллаже',
  'zoning.form.labelMaxEffPct': 'Поправка модели (делитель, model_correction_max_pct)',
  'zoning.form.labelMaxEffPctHelper': 'Порог для расчёта заполненности (по умолч. 0.8)',
  'zoning.form.labelRackId': 'ID стеллажа',
  'zoning.form.labelMaxQueueSize': 'Размер очереди для алерта',
  'zoning.form.labelMaxWorkers': 'Макс. сотрудников',
  'zoning.form.labelOpsDashId': 'ID операционного дашборда',
  'zoning.form.labelOpsDashHelper': 'Необязательно. Используется для связки с системой мониторинга.',
  'zoning.form.sectionAttach': 'Привязка к зоне обслуживания',
  'zoning.form.radioCreateNew': 'Создать новую зону',
  'zoning.form.radioAddExisting': 'Добавить в существующую зону',
  'zoning.form.labelExistingZone': 'Существующая зона',
  'zoning.form.untitled': 'Без названия',
  'zoning.form.polygonsShort': 'пол.',
  'zoning.form.buttonCancel': 'Отмена',
  'zoning.form.buttonSave': 'Сохранить',
  'zoning.form.buttonSaving': 'Сохранение…',
  'zoning.form.typeChangeWarning': 'Тип будет изменён с «{{from}}» на «{{to}}». Данные предыдущего типа будут утеряны.',
  'zoning.form.errorDetach': 'Не удалось отвязать полигон.',
  'zoning.form.errorDeleteZone': 'Не удалось удалить зону.',
  'zoning.form.errorMove': 'Не удалось перенести полигон.',
  'zoning.form.errorNameRequired': 'Название обязательно.',
  'zoning.form.errorCameraNotSelected': 'Камера не выбрана.',
  'zoning.form.errorSelectZone': 'Выберите существующую зону для привязки.',
  'zoning.form.errorCompleteDrawing': 'Завершите рисование полигона перед сохранением.',
  'zoning.form.errorSavePrefix': 'Не удалось сохранить:',

  // Common — added with admin user mgmt
  'common.saving': 'Сохранение…',
  'common.saved': 'Сохранено',
  'common.refresh': 'Обновить',

  // Superuser sidebar group
  'sidebar.group.system': 'Система',
  'sidebar.systemBranches': 'Филиалы',
  'sidebar.systemUsers': 'Пользователи',
  'sidebar.systemGroups': 'Группы',
  'sidebar.systemLocalComputers': 'Компьютеры Linza',
  'sidebar.systemHostInfra': 'Хост-инфраструктура',
  'sidebar.systemData': 'Данные',
  'sidebar.group.service': 'Служебные',
  'sidebar.reportValidation': 'Проверка отчётов',
  'sidebar.predictionsFeed': 'Лента предсказаний',
  'reportValidation.stub': 'Страница в разработке.',
  'reportValidation.day': 'День',
  'reportValidation.nextUnconfirmed': 'След. неподтверждённый',
  'reportValidation.nextUnsent': 'След. неотправленный',
  'reportValidation.editor.title': 'Текст отчёта',
  'reportValidation.editor.formatted': 'Форматирование',
  'reportValidation.editor.raw': 'Исходный текст',
  'reportValidation.editor.link': 'Ссылка',
  'reportValidation.editor.linkPrompt': 'Адрес ссылки',
  'reportValidation.editor.save': 'Сохранить',
  'reportValidation.editor.saved': 'Сохранено',
  'reportValidation.editor.reset': 'Сбросить',
  'reportValidation.editor.unsaved': 'Есть несохранённые изменения',
  'reportValidation.editor.saveFailed': 'Не удалось сохранить. Попробуйте ещё раз.',
  'reportValidation.editor.preview': 'Предпросмотр отчёта',
  'reportValidation.action.confirm': 'Подтвердить',
  'reportValidation.action.send': 'Отправить',
  'reportValidation.action.cancel': 'Отменить',
  'reportValidation.action.sent': 'Отправлено',
  'reportValidation.action.confirmFailed': 'Не удалось подтвердить',
  'reportValidation.action.sendFailed': 'Не удалось отправить',
  'reportValidation.action.sendDeliveryFailed': 'Подтверждён, но в чат клиента НЕ доставлен',
  'reportValidation.action.cancelFailed': 'Не удалось отменить',
  'reportValidation.editor.chartsHint': 'Графики для справки (только просмотр).',
  'reportValidation.editor.mode': 'Режим редактирования',
  'reportValidation.editor.moreModes': 'Ещё режимы (форматирование, исходный текст)',
  'reportValidation.editor.constructor': 'Конструктор',
  'reportValidation.editor.interactive': 'Интерактив',
  'reportValidation.action.sendTooOld': 'Старше недели: клиенту не отправляется, достаточно подтвердить',
  'reportValidation.interactive.title': 'Интерактивная разметка на графиках',
  'reportValidation.interactive.wip':
    'Скоро: перетаскивайте выделения прямо по графикам, чтобы задавать проблемы и ключевые точки — значения подставляются из данных.',
  'reportValidation.interactive.f1': 'Выкладка: перетащите по графику, чтобы отметить нехватку (% из данных).',
  'reportValidation.interactive.f2': 'Ключевые точки: перетаскивайте точки открытия / нормы / закрытия.',
  'reportValidation.interactive.f3': 'Очередь: отмечайте пиковые интервалы и вторую кассу.',
  'reportValidation.interactive.hint':
    'Перетащите по графику под строкой, чтобы задать проблему/точку; выделите — появится редактор значения.',
  'reportValidation.interactive.dragHint': 'Перетащите по графику, чтобы добавить.',
  'reportValidation.interactive.removeSegment': 'Удалить сегмент',
  'reportValidation.interactive.removeKeypoint': 'Удалить точку',
  'reportValidation.interactive.queueLabel': 'Очередь',
  'reportValidation.interactive.addProblem': 'Добавить проблему',
  // item 6 (round-2): was the unclear "Добавить событие" — names what actually
  // gets added (a queue>threshold event). LONG_QUEUE_THRESHOLD in
  // services/plugins/periodic_reports/tasks/daily_report/sections/checkout_control.py
  // is a fixed constant (=4), not a per-zone setting, so this is static text.
  'reportValidation.interactive.addEvent': 'Очередь длиннее 4 человек',
  'reportValidation.interactive.saveEdit': 'Сохранить',
  'reportValidation.interactive.cancelEdit': 'Отмена',
  'reportValidation.constructor.hint':
    'Нажмите на значок в конце строки, чтобы отредактировать её по полям.',
  'reportValidation.constructor.editLine': 'Редактировать строку',
  'reportValidation.constructor.editStatusLine': 'Редактировать статус выкладки',
  'reportValidation.form.rackType': 'Тип выкладки',
  'reportValidation.form.status': 'Статус',
  'reportValidation.form.statusOk': 'не было',
  'reportValidation.form.statusProblem': 'Проблемы',
  'reportValidation.form.severity': 'Серьёзность',
  'reportValidation.form.sev_yellow': 'Жёлтый',
  'reportValidation.form.sev_orange': 'Оранжевый',
  'reportValidation.form.sev_red': 'Красный',
  'reportValidation.form.sev_grey': 'Пустая (серый)',
  'reportValidation.form.shelfCount': 'Кол-во полок',
  'reportValidation.form.shelfCountHelp': 'Суммарно по всем стойкам этого типа',
  'reportValidation.form.avgShortage': 'Средняя нехватка, %',
  'reportValidation.form.duration': 'Длительность, ч',
  'reportValidation.form.dipVisitors': 'Посетителей в очереди за просадку, чел·мин',
  'reportValidation.form.links': 'Проблемные зоны (ссылки)',
  'reportValidation.form.noLinks': 'Ссылки не добавлены',
  'reportValidation.form.linkName': 'Название зоны',
  'reportValidation.form.linkUrl': 'Ссылка (Grafana)',
  'reportValidation.form.addLink': 'Добавить зону',
  'reportValidation.form.preview': 'Предпросмотр строки',
  'reportValidation.form.apply': 'Применить',
  'reportValidation.form.cancel': 'Отмена',
  'reportValidation.form.value': 'Значение',
  'reportValidation.form.period': 'Период проблемы (МСК)',
  'reportValidation.form.periodHint': 'обновляет ссылки на зоны',
  'reportValidation.constructor.hide': 'Убрать раздел (не отправлять)',
  'reportValidation.constructor.unhide': 'Вернуть раздел',
  'reportValidation.constructor.removeLine': 'Убрать строку (не отправлять)',
  'reportValidation.constructor.restoreLine': 'Вернуть строку',
  'reportValidation.form.addZone': 'Добавить зону',
  'reportValidation.form.zoneLinked': 'ссылка',
  'reportValidation.form.noZoneLink': 'без ссылки',
  'reportValidation.tf.kp_open': 'Заполненность на открытии',
  'reportValidation.tf.kp_norm': 'Выход на норму',
  'reportValidation.tf.kp_decline': 'Снижение',
  'reportValidation.tf.kp_close': 'Заполненность на закрытии',
  'reportValidation.tf.q_longest': 'Самая длинная очередь',
  'reportValidation.tf.q_novisit': 'Без посетителей',
  'reportValidation.tf.q_longqueue': 'Длинная очередь / вторая касса',
  'reportValidation.tf.openPct': 'Заполненность на открытии, %',
  'reportValidation.tf.normTime': 'Время выхода на норму (МСК)',
  'reportValidation.tf.declineTime': 'Время начала снижения (МСК)',
  'reportValidation.tf.closePct': 'Заполненность на закрытии, %',
  'reportValidation.tf.peak': 'Пик очереди, чел.',
  'reportValidation.tf.drainMin': 'Спала за, мин.',
  'reportValidation.tf.hoursNoVisit': 'Часов без посетителей',
  'reportValidation.tf.totalHours': 'Всего часов',
  'reportValidation.tf.threshold': 'Порог очереди, чел.',
  'reportValidation.tf.events': 'Случаев (> 1 мин)',
  'reportValidation.tf.secondCashierOn': 'Открывали вторую кассу',
  'reportValidation.tf.secondCashier': 'Раз открыли вторую кассу',
  'reportValidation.tf.secondCashierMinutes': 'Вторая касса была открыта, минут',
  'reportValidation.tf.peakTime': 'Время пика (МСК)',
  'reportValidation.tf.oneCashierWarn': 'В филиале одна касса — вторую открыть нельзя.',
  'reportValidation.kp.title': 'Ключевые точки',
  'reportValidation.kp.external': 'Внешние причины (не вышло на норму)',
  'reportValidation.kp.opening': 'Открытие',
  'reportValidation.kp.fast': 'Сразу при открытии',
  'reportValidation.kp.normal': 'Довели до нормы',
  'reportValidation.kp.decline': 'Было снижение',
  'reportValidation.kp.closeEmptyHint': 'До 15% → «почти не было на прилавке»',
  'reportValidation.kp.color': 'Цвет (степень серьёзности)',
  'reportValidation.kp.neverFilled': 'Не вышла на норму',
  'reportValidation.kp.openingProblem': 'Проблема на открытии',
  'reportValidation.kp.closingProblem': 'Проблема на закрытии (было пополнение)',
  'reportValidation.kp.closingHighlighted': 'Выделить значение на закрытии',
  'reportValidation.tree.variant_issues': 'Проблема',
  'reportValidation.tree.variant_ok': 'ОК',
  'reportValidation.tree.details': 'Ветки «На открытии» / «Остаток на закрытии»',
  'reportValidation.tree.variant_no_data': 'Нет измерений',
  'reportValidation.tree.hasReplenished': 'Было последнее пополнение',
  'reportValidation.tree.replenishedAt': 'Время последнего пополнения (МСК)',
  'reportValidation.tree.manualFallback': 'время открытия точки неизвестно, укажите вручную',
  'reportValidation.tree.openingLowFill': 'Низкая заполненность на открытии',
  'reportValidation.tree.openingLowFillHint': 'Если отметить — появятся процент и время выхода в норму',
  'reportValidation.tree.openingAutoProblem': 'Позже 20 мин после открытия → отмечено как проблема',
  'reportValidation.tree.openingAutoOk': 'В первые 20 мин после открытия → не проблема',
  'reportValidation.tree.openingAutoEmpty': 'Пусто = вышла в норму в первые 20 мин, не проблема',
  'reportValidation.tree.editCategory': 'Редактировать категорию выкладки',
  'reportValidation.tree.editLongest': 'Редактировать самую длинную очередь',
  'reportValidation.tree.editLongQueue': 'Редактировать длинную очередь',
  'reportValidation.tree.editNoVisitors': 'Редактировать «без посетителей»',
  'reportValidation.tree.queueMinutes': 'Минут в очереди (>= порога)',
  'reportValidation.tree.queueNone': 'Такая очередь не наблюдалась',
  'reportValidation.tree.queueNoneInline': 'не наблюдалась',
  'reportValidation.tree.secondCashierInline': 'Вторая касса была открыта',
  'reportValidation.tree.drainUnmeasured': 'время спада не измерено',
  'reportValidation.tree.colorAuto': 'авто',
  'reportValidation.tree.colorPick': 'Цвет строки: считается по значению, можно задать вручную',
  'reportValidation.tf.checklist': 'Чек-лист',
  'reportValidation.tree.editChecklist': 'Редактировать чек-лист',
  'reportValidation.tree.checklistDone': 'Выполнено (через запятую)',
  'reportValidation.tree.checklistNotDone': 'Не выполнено (через запятую)',
  'data.title': 'Данные',
  'data.subtitle': 'ClearML датасеты и разметка',
  'data.tab.hierarchy': 'Датасеты',
  'data.tab.annotate': 'Разметка',
  'data.empty': 'Датасеты не найдены',
  'data.bootstrap.button': 'Разметить через ИИ',
  'data.bootstrap.title': 'Первичная разметка через ИИ',
  'data.bootstrap.description': 'Кропы столов за последние дни разметит Claude, оператору останется только проверить. Каждый кроп стоит денег — запускайте один раз на точку.',
  'data.bootstrap.notOnboarded': 'Зона не заведена в ClearML — сначала онбординг.',
  'data.bootstrap.tables': 'Столы ({n}) и доступные кропы',
  'data.bootstrap.thin': 'У {n} стол(ов) меньше {target} кропов — данные ещё копятся.',
  'data.bootstrap.history': 'Прошлые запуски',
  'data.bootstrap.runDone': 'готово, размечено {n}',
  'data.bootstrap.runRunning': 'выполняется',
  'data.bootstrap.runFailed': 'ошибка',
  'data.bootstrap.launch': 'Запустить разметку',
  'data.bootstrap.launched': 'Разметка запущена. Займёт время — результат появится новой версией датасета, затем проверьте её во вкладке «Разметка».',
  'data.bootstrap.launchFailed': 'Не удалось запустить разметку',
  // Сбор неразмеченных кропов в общий пул. Зона появляется в выборе зон для разметки
  // только после того, как в пуле есть её кропы, — эта форма единственная показывает
  // зоны со стороны СТОЛОВ, поэтому зоны с нулём кропов идут первыми.
  'data.collect.button': 'Собрать кропы',
  'data.collect.title': 'Сбор неразмеченных кропов',
  'data.collect.description': 'Кропы столов из уже снятых кадров попадут в очередь «Неразмеченные». Ничего не размечается автоматически — это только сбор данных. Дубликаты не собираются повторно.',
  'data.collect.zone': 'Зона',
  'data.collect.period': 'Период',
  'data.collect.lastDays': 'последние {n} дн.',
  'data.collect.size': 'Сколько собрать',
  'data.collect.available': 'Доступно за период',
  'data.collect.alreadyPooled': 'Уже в пуле (всего)',
  'data.collect.willCollect': 'Будет собрано',
  'data.collect.noneAvailable': 'За этот период кропов нет. Возьмите период шире или дождитесь накопления данных.',
  'data.collect.noTables': 'В зоне не размечено ни одного полигона стола — собирать нечего.',
  'data.collect.noShelves': 'В зоне нет полок с расчётом заполненности — собирать нечего.',
  'data.collect.history': 'История сборов',
  'data.collect.runRunning': 'идёт сбор…',
  'data.collect.runSkipped': '({n} уже были)',
  'data.collect.runFailed': '{n} не удалось',
  'data.collect.runError': 'ошибка',
  'data.collect.launch': 'Собрать',
  'data.collect.launchFailed': 'Не удалось запустить сбор',
  'data.refresh': 'Обновить',
  'data.locked': 'заблокирован',
  'data.unlocked': 'свободен',
  'data.lock': 'Заблокировать',
  'data.unlock': 'Разблокировать',
  'data.download': 'Скачать копию',
  'data.open': 'Открыть',
  'data.last': 'посл.',
  'data.noVersions': 'Нет версий',
  'data.latestVersion': 'Последняя версия',
  'data.kind.table_crops': 'Столы (кропы)',
  'data.kind.audio': 'Аудио-транскрипты',
  'data.kind.shelf_percentage': 'Выкладка (проценты)',
  'data.annotate.shelfPct.title': 'Заполненность полки, %',
  'data.annotate.shelfPct.hint': 'Оцените, насколько полка заполнена (0 — пустая, 100 — полная). Цифры 0-9 = десятки % и переход дальше; E = 0%, F = 100%; слайдер/поле — точное значение.',
  'data.annotate.shelfPct.shelfFilter': 'Фильтр по полке',
  'data.annotate.shelfPct.deciles': 'десятки %',
  'data.annotate.shelfPct.labelled': 'размечено',
  'data.localCopy': 'Локальная копия (старее последней)',
  'data.annotate.pickHint': 'Выберите датасет на вкладке «Датасеты» и нажмите «Скачать копию».',
  'data.annotate.soon': 'Загрузка копии… редактор откроется здесь.',
  'data.annotate.downloading': 'Скачивается копия датасета',
  'data.annotate.failed': 'Ошибка скачивания',
  'data.annotate.noCrops': 'В датасете нет кропов',
  'data.annotate.subtype.presence': 'Вокруг стола',
  'data.annotate.subtype.state': 'Состояние стола',
  'data.annotate.stateBlocked': 'Зона занята (есть люди/вещи) — состояние стола не размечается: вторая модель запускается только для пустой зоны.',
  'data.annotate.flowHint': 'Модель 1 смотрит ВОКРУГ стола (занято: люди или их вещи). Модель 2 — что на САМОМ столе (доступна только когда вокруг свободно).',
  'data.annotate.by': 'разметил',
  'data.annotate.unedited': 'не размечено вручную',
  'data.annotate.upload': 'Залить в ClearML',
  'data.annotate.discard': 'Отменить (удалить копию)',
  'data.annotate.uploadConfirm': 'Залить новую версию датасета в ClearML с текущей разметкой? Локальная копия сохранится.',
  'data.annotate.discardConfirm': 'Удалить локальную копию без загрузки? Несохранённая в ClearML разметка останется только в нашей БД.',
  'data.annotate.mode.presence': 'Люди/вещи (модель 1)',
  'data.annotate.mode.in_frame': 'Стол в кадре (модель 2)',
  'data.annotate.mode.state': 'Состояние стола (модель 3)',
  'data.annotate.bin.presence.yes': 'есть люди/вещи',
  'data.annotate.bin.presence.no': 'свободно',
  'data.annotate.bin.in_frame.yes': 'в кадре',
  'data.annotate.bin.in_frame.no': 'сдвинут (<70%)',
  'data.annotate.occupied': 'занято',
  'data.annotate.free': 'свободно',
  'data.annotate.next': 'следующая',
  'data.annotate.freeOnly': 'только без людей/вещей',
  'data.annotate.freeInFrameOnly': 'без людей/вещей и в кадре',
  'data.annotate.filter.all': 'Все (размеченные)',
  'data.annotate.filter.human': 'Размечено человеком',
  'data.annotate.filter.ai': 'Размечено ИИ',
  'data.annotate.filter.unlabeled': 'Все (неразмеченные)',
  'data.annotate.filter.report_fix': 'Исправлено в отчёте',
  'data.annotate.filter.cancelled': 'Отменённые',
  'data.annotate.filter.collected': 'Просто неразмеченные',
  'data.annotate.aiBadge': 'Размечено ИИ',
  'data.annotate.unlabeledBadge': 'Не размечено',
  'data.annotate.unset': 'не разм.',
  'data.annotate.frame': 'кадр',
  'data.annotate.left': 'осталось',
  'data.annotate.counterHint': 'Позиция курсора / кропов в текущей выборке (стол × фильтр × этап). «осталось» — сколько ещё не доведено до конца воронки.',
  'data.pool.tab': 'Разметка (общий пул)',
  'data.pool.open': 'Открыть разметку',
  'data.pool.retrain': 'Запустить обучение',
  'data.pool.retrainHint': 'Обучить модель на том, что размечено СЕЙЧАС. Перед стартом делается неизменяемый снимок разметки — потом всегда видно, на чём училась модель.',
  'data.pool.retrainConfirm': 'Запустить обучение на текущей разметке? Будет арендован GPU (обычно $0.03-0.06) и создан снимок датасета.',
  'data.pool.retrainStarted': 'Обучение запущено:',
  'data.pool.retrainAlreadyRunning': 'Обучение уже идёт, новое не запускал:',
  'data.pool.trainOn': 'Будет обучение на кадрах',
  'data.pool.trainNew': 'Из них новых с прошлого обучения',
  'data.pool.trainSkipped': 'Не пойдут в обучение (неразмеченные)',
  'data.pool.trainFirstPooled': 'Это первое обучение на общем пуле — сравнивать пока не с чем.',
  'data.pool.trainSinceLast': 'новых с прошлого обучения',
  'data.pool.trainReady': 'размеченных кадров готово к обучению',
  'data.pool.trainHint': 'Считается по факту: сколько размеченных кадров в базе сейчас против того, сколько было на момент старта прошлого обучения. Неразмеченные не учитываются — они физически не попадают в обучение.',
  'data.pool.cancelledBadge': 'отменён',
  'data.pool.reportFixBadge': 'исправлен',
  'data.pool.reportFixHint': 'Кадры случаев, которые вручную исправили в отчёте или Статусе: модель ошиблась так, что это увидел клиент. Самое острое — размечать первыми и по всем классам.',
  'data.pool.sortLabel': 'Порядок',
  'data.pool.sortDefault': 'по столам',
  'data.pool.sortHint': 'Порядок показа уже размеченных кадров. «Сначала новые» — быстрый способ найти кадр, который вы только что разметили: например, если ошиблись или оборвался интернет и непонятно, что успело сохраниться.',
  'data.pool.sortNewest': 'сначала новые',
  'data.pool.sortOldest': 'сначала старые',
  'data.pool.batchStart': 'Собрать набор',
  'data.pool.batchActive': 'Мой набор',
  'data.pool.listActive': 'Список по ссылке',
  'data.pool.listHint': 'кропы из аудита разметки, в порядке ссылки',
  'data.pool.batchZones': 'зон',
  'data.pool.batchExit': 'выйти',
  'data.pool.batchHint': 'Собрать себе набор на разметку: указанное число неразмеченных кадров с КАЖДОЙ зоны, выбранных случайно. Если в зоне осталось меньше — возьмётся сколько есть. Набор закреплён за вами на сегодня: перезагрузка страницы вернёт тот же самый, а не новый.',
  'data.pool.cancelledHint': 'Кропы из отменённых алертов: модель сказала «грязно», человек отменил. Такие кадры ценнее обычных — они и учат модель не ошибаться, поэтому их стоит размечать в первую очередь.',
  'data.pool.onStage': 'на этапе',
  'data.pool.currentStageSource': 'Этот этап',
  'data.pool.outOf': 'из',
  'data.pool.gate.presence': 'Этап 1 спрашивает про ВСЕ кадры зоны.',
  'data.pool.gate.in_frame': 'Этап 2 спрашивает только про кадры, помеченные «свободно» на этапе 1 — занятые дальше не идут.',
  'data.pool.gate.state': 'Этап 3 спрашивает только про кадры «свободно» + «стол в кадре» — остальные отсеяны предыдущими этапами.',
  'data.pool.badge': 'общий пул · разметка в Postgres',
  'data.pool.domain.table': 'Столы',
  'data.pool.domain.shelf': 'Выкладка',
  'data.pool.domain.audio': 'Аудио',
  'data.pool.domain.boxes': 'Боксы',
  'data.boxes.view.queue': 'Очередь',
  'data.boxes.view.modified': 'Исправленные',
  'data.boxes.view.correct': 'Корректные',
  'data.boxes.queueHint': 'Отменённые алерты YOLO-стеллажей: модель сказала «пусто», валидатор ответил «полная». Ложное «пусто» — это лишние или кривые боксы. Только камеры с одним YOLO-стеллажом: в таблице боксов нет привязки к стеллажу.',
  'data.boxes.allZones': 'Все точки',
  'data.boxes.days': 'дней',
  'data.boxes.save': 'Сохранить',
  'data.boxes.confirm': 'Разметка корректная',
  'data.boxes.confirmHint': 'Подтвердить все нетронутые фото на этой странице: боксы детектора верны как есть',
  'data.boxes.showWeak': 'слабые боксы',
  'data.boxes.showWeakHint': 'Боксы ниже порога детектора — в подсчёт не шли. Удалять их не нужно',
  'data.boxes.whole': 'весь',
  'data.boxes.keys': 'клик — бокс (повторный — следующий из наложенных) · Ctrl/⌘+рамка — выделить · D — удалить · R — вернуть · Z — отменить · рамка — новый бокс · 1…9 — полка, 0 — весь · Space — корректно · ←→↑↓',
  'data.boxes.empty': 'Здесь пусто',
  'data.boxes.saved': 'сохранено',
  'data.boxes.saveFailed': 'не сохранилось — повторите',
  'data.boxes.pending': 'к сохранению',
  'data.boxes.unsaved': 'Есть несохранённые правки — сохранить перед уходом?',
  'data.boxes.deletedN': 'удалено',
  'data.boxes.addedN': 'добавлено',
  'data.boxes.boxesN': 'боксов',
  'data.boxes.model': 'модель',
  'data.boxes.validator': 'валидатор',
  'data.boxes.status.modified': 'исправлено',
  'data.boxes.status.correct': 'корректно',
  'data.boxes.unlabel': 'Вернуть в очередь',
  'data.boxes.page': 'стр.',
  'data.audio.segments': 'Сегменты',
  'data.audio.dialogues': 'Диалоги',
  'data.audio.clips': 'Текст клипов',
  'data.kind.audio_transcripts': 'Аудио (расшифровки)',
  'data.audio.hint': 'Прослушайте клип и исправьте черновик до ДОСЛОВНОЙ расшифровки — что реально произнесено. Если речи нет или неразборчиво, нажмите «Шум»: пустая расшифровка это тоже настоящая метка, она учит модель молчать.',
  'data.audio.accept': 'Принять',
  'data.audio.save': 'Сохранить',
  'data.audio.noise': 'Шум/неразборчиво',
  'data.audio.noiseHint': 'Речи нет или неразборчиво → пустая цель. Модель учится не выдумывать текст на шуме.',
  'data.audio.retract': 'Снять метку',
  'data.audio.retractHint': 'Вернуть клип в очередь неразмеченных. Нужно, если ошиблись — иначе неверная метка молча попадёт в обучение.',
  'data.audio.placeholder': 'Дословная расшифровка (что реально сказано)…',
  'data.audio.prodModel': 'прод-модель',
  'data.audio.marked': 'размечено',
  'data.audio.markedNoise': 'шум',
  'data.audio.noAudio': 'Файл клипа недоступен',
  'data.audio.waveShow': 'волна / участки',
  'data.audio.waveHide': 'скрыть волну',
  'data.audio.blanks': 'шум',
  'data.audio.trainHint': 'Речь + клипы, помеченные шумом. Если шума сильно больше, модель научится молчать.',
  'data.audio.retrainConfirm': 'Запустить дообучение модели распознавания на текущей разметке?\n\nБудет арендован GPU, а по завершении тег боевой модели переедет на новую — центральный хаб начнёт распознавать ею.',
  'data.audio.retrainHint': 'Дообучить GigaAM на размеченных клипах. Это не обучение с нуля: берутся веса текущей модели и уточняются на нашем звуке.',
  'data.audio.heldOut': 'Отложено для проверки',
  'data.audio.sortNewestRec': 'сначала свежие записи',
  'data.audio.sortOldestRec': 'сначала старые записи',
  'data.audio.view.imported': 'Импорт',
  'data.audio.view.collected': 'Из пула',
  'data.audio.view.unlabeled': 'Все неразмеченные',
  'data.audio.view.human': 'Размечено человеком',
  'data.audio.view.ai': 'Размечено ИИ',
  'data.audio.view.all': 'Все размеченные',
  'data.shelf.hint': 'Оцените заполненность полки в процентах: 0% — полка пустая, 100% — полная. Шаг 5%. Пустая полка — это настоящая оценка, а не «не размечено»: именно из-за неё срабатывает алерт.',
  'data.shelf.usefulArea': 'Полезная площадь',
  'data.shelf.usefulAreaHint': 'Серым закрыто то, где на полке товар лежать не может (разметка «Полезная площадь» в калибровке полигонов). Пунктир — полигон полки сдвинули после разметки, её надо повторить. Счётчик — сколько кропов на странице с разметкой.',
  'data.shelf.allShelves': 'Все полки',
  'data.shelf.sortDefault': 'по полкам',
  'data.shelf.empty': 'Нет кадров под эти фильтры — переключите фильтр или зону.',
  'data.shelf.cancelledBadge': 'исправлен',
  'data.shelf.cancelledHint': 'Кропы стоек, где оператор не согласился с моделью: она сказала, что товар заканчивается, человек ответил, что всё в порядке. Такие кадры ценнее обычных — они и учат модель не ошибаться, поэтому их стоит размечать в первую очередь.',
  'data.collect.descriptionShelf': 'Кропы полок из уже снятых кадров попадут в очередь «Неразмеченные». Ничего не размечается автоматически — это только сбор данных. Дубликаты не собираются повторно.',
  'data.shelf.shelfFilter': 'Фильтр по полке',
  'data.shelf.keyDigits': '0%…90%',
  'data.shelf.keyClear': 'снять оценку',
  'data.shelf.keyAgree': 'согласен, засчитать себе',
  'data.sam.title': 'Песочница SAM 3',
  'data.sam.subtitle': 'проверить промпт на картинке — ничего не сохраняется',
  'data.sam.prompts': 'Промпты через запятую',
  'data.sam.threshold': 'Порог',
  'data.sam.maxFrac': 'Макс. доля объекта',
  'data.sam.maxFracHint': 'объект крупнее этой доли кадра считается подносом или витриной, а не товаром. Для кропа одной полки 0.25; боевой проход работает на кропе стойки, там 0.03',
  'data.sam.run': 'Запустить',
  'data.sam.clearImage': 'убрать картинку',
  'data.sam.pasteHint': 'вставьте картинку через Ctrl+V',
  'data.sam.pasted': 'картинка вставлена',
  'data.sam.willUseFocused': 'без вставки возьмём кроп под курсором',
  'data.sam.needImage': 'нечего сегментировать: вставьте картинку или встаньте на кроп',
  'data.sam.failed': 'не удалось выполнить запрос',
  'data.sam.paneOriginal': 'оригинал',
  'data.sam.paneMasked': 'после SAM 3',
  'data.sam.coverage': 'покрытие',
  'data.sam.coverageShelf': 'заполненность этой полки по маскам SAM',
  'data.sam.notProduction': 'боевой проход меряет на кропе стойки целиком и с отсечкой 0.03 — здесь кроп одной полки и отсечка 0.25, поэтому число близкое, но не то же самое',
  'data.sam.coveragePasted': 'доля вставленной картинки, закрашенная масками',
  'data.sam.pixels': 'пикселей',
  'data.sam.takeFocused': 'взять этот кроп',
  'data.sam.takenFocused': 'взят кроп из разметки',
  'data.sam.preview': 'что уйдёт в SAM 3',
  'data.sam.reset': 'по умолчанию',
  'data.mask.onlyWithMasks': 'только с масками',
  'data.mask.by.ai': 'ИИ',
  'data.mask.by.user': 'человек',
  'data.pool.saveRetry': 'не сохранилось, повторю при следующей правке',
  'data.mask.notComputed': 'маски для этого кропа ещё не посчитаны',
  'data.mask.compute': 'запустить SAM 3',
  'data.mask.recut': 'прогнать шире',
  'data.mask.recutHint': 'вырезать полку из исходного кадра с запасом вокруг и найти объекты заново',
  'data.mask.recutQueued': 'перерезаю и ищу заново…',
  'data.mask.queued': 'поставлено в очередь',
  'data.mask.queuedHint': 'считается примерно минуту — лимит Replicate 6 запросов в минуту',
  'data.mask.imgExpired': 'ссылка на картинку протухла (живёт 6 часов) — обнови страницу',
  'data.mask.mode.view': 'смотреть',
  'data.mask.mode.cursor': 'курсор',
  'data.mask.mode.pen': 'ручка',
  'data.mask.delete': 'удалить объект',
  'data.mask.split': 'разбить',
  'data.mask.splitHint': 'вернуть объект в исходные контуры промптов — чтобы удалить или подвинуть то, что попало внутрь склеенного',
  'data.mask.keysHint': 'Z — отменить, Y — вернуть, S — разбить объект',
  'data.mask.objects': 'объектов',
  'data.mask.base': 'база (нашли 2+ промпта)',
  'data.mask.byMasks': 'маски',
  'data.mask.emptyBase': 'ни один объект не подтверждён двумя промптами — включи галочку промпта',
  'data.mask.prelabel': 'разметить ИИ',
  'data.mask.prelabelHint': 'запустит джобу: SAM 3 найдёт объекты на неразмеченных кропах и поставит процент, кропы уйдут в «размечено ИИ». Примерно минута на кроп — лимит Replicate',
  'data.mask.prelabelStarted': 'джоба запущена, кропов:',
  'data.mask.prelabelFailed': 'не удалось запустить джобу',
  'data.mask.byMasksHint': 'сколько закрывают объекты, которые нашли минимум два промпта — то, с чего открывается редактор',
  'data.mask.stored': 'сохранено',
  'data.mask.deduped': 'склеено дублей: {n}',
  'data.mask.save': 'сохранить',
  'data.mask.confirm': 'согласен, засчитать',
  'data.mask.saved': 'сохранено:',
  'data.mask.saveFailed': 'не удалось сохранить',
  'data.mask.slider': 'сколько объектов засчитать',
  'data.mask.viewHint': 'просмотр: ничего не меняется',
  'data.mask.cursorHint': 'клик — выбрать объект, тянуть за белую точку — двигать угол, Delete — удалить',
  'data.mask.penHint': 'клики ставят точки, двойной клик или Enter замыкает контур, Escape отменяет',
  'data.sam.production': 'боевой набор',
  'data.sam.productionHint': 'ровно то, чем размечает прод: 14 промптов и отсечка 0.03 — но она посчитана для кропа стойки, а тут кроп полки',
  'data.sam.throttled': 'лимит',
  'data.sam.throttledHint': 'часть промптов не отработала: Replicate режет частоту запросов, пока на счету меньше $5 — промпты тут ни при чём, итоговый процент неполный',
  'data.sam.resetHint': 'широкий набор, с которого удобно начинать',
  'data.sam.unionOf': 'объединение {n} промптов',
  'data.sam.overlapNote': 'проценты по промптам не складываются: маски пересекаются, итог — их объединение',
  'data.sam.colPrompt': 'промпт',
  'data.sam.colFound': 'найдено',
  'data.sam.colKept': 'оставлено',
  'data.sam.colDropped': 'отброшено',
  'data.sam.colCoverage': 'покрытие',
  'data.sam.calls': 'вызовов к API',
  'data.shelf.legacyHint': 'Импорт из чужого датасета (перекрёсток/хлебник) — другой магазин, другие полки. Полезно для обучения, но по нему нельзя судить о качестве на наших точках.',
  'data.shelf.lowBand': 'Из них почти пустых (0–20%)',
  'data.pool.refresh': 'Обновить',
  'data.pool.refreshHint': 'Пересчитать счётчики и подтянуть страницу. Размеченное сохраняется сразу — обновление нужно только чтобы увидеть новые числа.',
  'data.pool.inFilter': 'в выборке',
  'data.pool.counterHint': 'Кадр на странице / всего на странице · «в выборке» — сколько подходит под фильтры · «осталось» — сколько в зоне ещё не размечено на этом этапе.',
  'data.pool.cleanReviewed': 'чисто (проверено)',
  'data.pool.empty': 'Нет кадров под эти фильтры — переключите этап, фильтр или зону.',
  'data.annotate.tableFilter.label': 'Фильтр по столу',
  'data.annotate.tableFilter.all': 'Все столы',
  'data.annotate.markReviewed': 'Проверено',
  'data.annotate.reviewHint': 'Подтвердить текущую разметку видимых кадров как проверенную человеком. Метки не меняются — кадры просто уходят из фильтра «ИИ», чтобы не пересматривать их в следующий раз.',
  'data.annotate.reviewConfirm': 'Отметить {n} кадров как проверенные человеком? Разметка не изменится; в фильтре «ИИ» они больше не появятся.',
  'data.annotate.reviewedDone': 'Отмечено проверенными: {n} ✓',
  'data.annotate.humanBadge': 'Проверено человеком',
  'data.annotate.localVersion': 'Локальная копия',
  'data.annotate.point': 'Точка',
  'data.annotate.version': 'Версия',
  'data.annotate.zoomIn': 'Крупнее (меньше в ряд)',
  'data.annotate.zoomOut': 'Мельче (больше в ряд)',
  'data.annotate.descLabel': 'Описание разметки (необязательно)',
  'data.annotate.descHelp': 'Короткая заметка о том, что вы разметили в этой версии — сохранится в задаче ClearML при заливке (видно в истории датасета).',
  'data.annotate.descPlaceholder': 'Напр.: перепроверил занятость по всем столам, поправил грязную посуду на столах 12–18',
  'data.annotate.gate.in_frame.title': 'Сначала модель 1 (люди/вещи)',
  'data.annotate.gate.in_frame.body': '«Стол в кадре» (модель 2) размечается только на кадрах без людей/вещей (occupied=false) — так же работает каскад на проде. Сначала пройдите «Люди/вещи», затем сюда: будут показаны только свободные кадры.',
  'data.annotate.gate.state.title': 'Сначала модели 1 и 2',
  'data.annotate.gate.state.body': 'Состояние стола (модель 3) размечается только на кадрах без людей/вещей И где стол в кадре. Сначала пройдите «Люди/вещи» и «Стол в кадре», затем сюда.',
  'data.annotate.gate.back': 'Назад',
  'data.annotate.gate.ok': 'Понятно, продолжить',
  'data.annotate.deleteLocal': 'Удалить локальную копию',
  'data.annotate.deleteConfirm': 'Удалить локальную копию? Разметку, не залитую в ClearML, потеряете.',
  'data.annotate.deletePhoto': 'Удалить фото из датасета',
  'data.annotate.deletePhotoConfirm': 'Удалить это фото из датасета вместе с разметкой? Оно исчезнет из новой версии при заливке в ClearML.',
  'data.annotate.photoDeleted': 'Фото удалено ✓',
  'data.annotate.uploaded': 'Залито в ClearML ✓',
  'data.annotate.hint.presence': 'Модель 1 — есть ли люди/вещи за столом. Q = есть (занято), W = свободно; курсор переходит сам. Все кадры.',
  'data.annotate.hint.in_frame': 'Модель 2 — стол в кадре или сдвинут (виден <70% → сдвинут). Q = в кадре, W = сдвинут. Только кадры без людей/вещей.',
  'data.annotate.hint.state': 'Модель 3 — на САМОМ столе. Q/W/E/R — независимые флаги, Пробел — следующая. Только кадры без людей/вещей И где стол в кадре.',

  // Superuser system — host-infra cron status page
  'system.hostInfra.title': 'Хост-инфраструктура',
  'system.hostInfra.subtitle': 'Крон-скрипты на linza-deployments и linza-dev',
  'system.hostInfra.installHeading': 'Установка',
  'system.hostInfra.installCurlError': '# не удалось получить команду установки — обновите страницу',
  'system.hostInfra.loadError': 'Не удалось загрузить статус крон-скриптов.',
  'system.hostInfra.colHost': 'Хост',
  'system.hostInfra.colScript': 'Скрипт',
  'system.hostInfra.colPurpose': 'Назначение',
  'system.hostInfra.colSchedule': 'Расписание',
  'system.hostInfra.colStatus': 'Статус',
  'system.hostInfra.colMtime': 'Последнее обновление',
  'system.hostInfra.ago': 'назад',
  'system.hostInfra.showLog': 'лог',
  'system.hostInfra.hideLog': 'скрыть',
  'system.hostInfra.deployedVersions': 'Версии',
  'system.hostInfra.emptyList': 'Канонических крон-строк не задано.',
  'system.hostInfra.purpose.dump_reverse_tunnels': 'Запрашивает у linza-dev (ssh.dev.linzametrics.com) список реверс-туннельных портов 23NN по SSH раз в минуту — туннели терминируются на linza-dev, не на этом хосте.',
  'system.hostInfra.purpose.dump_wg_peers': 'Экспортирует wg-пиры в /var/lib/linza/ каждую минуту.',
  'system.hostInfra.purpose.add_wg_peer': 'Применяет новые wg-пиры из очереди.',
  'system.hostInfra.purpose.generate_hosts_from_wg': 'Генерирует /etc/hosts из wg-конфига (раз в сутки).',
  'system.hostInfra.purpose.sync_lc_pubkeys_dev': 'Синхронизирует SSH-ключи всех компьютеров с linza-dev раз в минуту.',
  'system.hostInfra.purpose.model_deploy': 'Перезапускает Triton центрального сервера, когда в S3 обновилась какая-либо задеплоенная модель (раз в сутки, 00:00 МСК).',
  'system.hostInfra.devKeysPath.note': 'Dev/admin SSH-ключи, разрешённые для входа на LC, поддерживаются вручную в файле',

  // Admin local computers (LocalComputer platform)
  'admin.lc.title': 'Компьютеры Linza',
  'admin.lc.subtitle': 'Список локальных компьютеров по филиалам.',
  'admin.lc.searchPlaceholder': 'Поиск по названию или deployment_key…',
  'admin.lc.empty': 'Нет компьютеров.',
  'admin.lc.colName': 'Филиал',
  'admin.lc.colDeviceNumber': '№',
  'admin.lc.colHostname': 'Хост',
  'admin.lc.colWgIp': 'WireGuard',
  'admin.lc.colSshPort': 'SSH',
  'admin.lc.colHardware': 'Железо',
  'admin.lc.colStage': 'Этап',
  'admin.lc.colHeartbeat': 'Последний пинг',
  'admin.lc.heartbeatNever': 'нет данных',
  'admin.lc.unbound': 'Не привязан',
  'admin.lc.unboundHint': 'Подключился, но не привязан к филиалу',
  // "bind" historically meant "attach to a branch" — but the action
  // only assigns a deployment_key + display_name; it doesn't actually
  // tie the LC to a Zone row. Re-labelled 2026-05-22 so the UI stops
  // promising something it doesn't deliver.
  'admin.lc.bindAction': 'Назначить deployment-ключ…',
  'admin.lc.bindDialog.title': 'Назначить deployment-ключ',
  'admin.lc.bindDialog.deploymentKeyLabel': 'Deployment-ключ',
  'admin.lc.bindDialog.displayNameLabel': 'Человеческое название',
  'admin.lc.bindDialog.submit': 'Назначить',

  // Discovery dialog (task #82 / xxvii) — replaces the old IssueTokenDialog.
  // No inputs upfront; just a token-less curl. The jetson POSTs its
  // eth0 MAC + already-set state to /remote/register/; a new LC row
  // appears in the list.
  'admin.lc.discoverAction': 'Зарегистрировать',
  'admin.lc.emptyHint': 'Чтобы добавить первый компьютер, нажмите «Зарегистрировать» выше и выполните полученную discovery-команду на устройстве.',
  'admin.lc.discoveryDialog.title': 'Регистрация компьютера',
  'admin.lc.discoveryDialog.description': 'Выполните на компьютере (требуется sudo). Скрипт читает MAC и уже настроенные ключи и отправляет на сервер.',
  'admin.lc.discoveryDialog.waiting': 'Ждём первый отклик от компьютера…',
  'admin.lc.discoveryDialog.issuingToken': 'Выдаём токен регистрации…',
  // Legacy IssueTokenDialog strings — kept temporarily because some
  // FE consumers still reference them (e.g. `admin.lc.bindDialog.*`
  // shares the deploymentKey/displayName labels). Safe to delete in
  // a follow-up i18n sweep once those callsites are audited.
  'admin.lc.issueAction': 'Зарегистрировать (legacy)',
  'admin.lc.issueDialog.title': 'Регистрация нового компьютера (legacy)',
  'admin.lc.issueDialog.titleIssued': 'Токен выдан',
  'admin.lc.issueDialog.displayNameHint': 'Необязательное человеко-понятное название филиала.',
  'admin.lc.issueDialog.deviceNumberLabel': 'Номер устройства',
  'admin.lc.issueDialog.deviceNumberHint': '1..99, уникально. Резервирует reverse-SSH порт 2300+N.',
  'admin.lc.issueDialog.deviceNumberInvalid': 'Номер устройства должен быть целым числом от 1 до 99.',
  'admin.lc.issueDialog.wgIpLabel': 'WireGuard IP',
  'admin.lc.issueDialog.wgIpHint': '10.99.0.X, где X=2..254. Должен быть уникален среди всех LC.',
  'admin.lc.issueDialog.wgIpInvalid': 'WireGuard IP должен быть в формате 10.99.0.X (X=2..254).',
  'admin.lc.issueDialog.submit': 'Создать токен',
  'admin.lc.issueDialog.successHint': 'Скопируйте curl ниже и выполните его на компьютере. Токен действителен 24 часа и расходуется одним вызовом.',
  'admin.lc.issueDialog.curlLabel': 'Команда для компьютера',

  // Detail modal
  'admin.lc.detail.title': 'Компьютер',
  'admin.lc.detail.stagesHeading': 'Этапы установки',
  // Action-card framing (one card, three modes — failed / in-progress /
  // need-action; no shared header). The "Получить новый токен" link
  // was removed 2026-05-22 because Reset Keys covers the recovery path.
  'admin.lc.detail.actionNowDoing': 'Сейчас: {{stage}}',
  'admin.lc.detail.actionFailedHint': 'Исправьте проблему на устройстве, затем нажмите «Сбросить ключи» внизу и запустите curl ещё раз.',
  'admin.lc.detail.actionReissueFailedHint': 'Попробуйте «Сбросить ключи» внизу — это очистит сохранённые ключи и выдаст новый токен.',
  'admin.lc.detail.curlContinueLabel': 'Запустите на устройстве, чтобы продолжить установку:',
  // Per-stage "what's happening right now" detail; keyed by the
  // next-to-do SetupStage value.
  'admin.lc.detail.inProgressDetail.WG_CONFIGURED': 'Устройство устанавливает WireGuard и сообщает свой публичный ключ серверу.',
  'admin.lc.detail.inProgressDetail.WG_HANDSHAKE_VERIFIED': 'Ждём первое WireGuard-рукопожатие от устройства (≤60с после того, как хост-крон добавит peer).',
  'admin.lc.detail.inProgressDetail.SSH_PUBKEY_AUTHORIZED': 'Устройство сгенерировало SSH-ключ и отправил его серверу. Хост-крон применит его в /home/linza/.ssh/authorized_keys (~60с).',
  'admin.lc.detail.inProgressDetail.AUTHORIZED_KEYS_PULLED': 'Устройство скачивает authorized_keys.example с сервера и сливает с локальным.',
  'admin.lc.detail.inProgressDetail.REVERSE_SSH_LIVE': 'Устройство поднимает обратный SSH-туннель на ssh.dev.linzametrics.com.',
  'admin.lc.detail.inProgressDetail.TRAEFIK_REGISTERED': 'Регистрация маршрута в Traefik.',
  'admin.lc.detail.inProgressDetail.DOCKER_RUNNING': 'Запуск Docker-контейнеров (celery-cctv и сопутствующие).',
  'admin.lc.detail.field.id': 'Идентификатор',
  'admin.lc.detail.field.state': 'Состояние',
  'admin.lc.detail.field.stateLive': 'Активен',
  'admin.lc.detail.field.stateArchived': 'Архивирован',
  'admin.lc.detail.field.wgIp': 'WireGuard IP',
  'admin.lc.detail.field.sshPort': 'Reverse-SSH порт',
  'admin.lc.detail.field.hostname': 'Имя в /etc/hosts',
  'admin.lc.detail.field.hostnameHint': 'например surf_iq.linza',
  'admin.lc.detail.field.hostnameInvalid': 'Только латиница, цифры, дефис, подчёркивание и точки — например surf_iq.linza.',
  'admin.lc.detail.field.deviceNumber': 'Номер устройства',
  'admin.lc.detail.field.hardware': 'Оборудование',
  'admin.lc.detail.field.deployment': 'Развёртывание',
  'admin.lc.detail.field.deploymentNone': 'не привязан',
  'admin.lc.detail.field.gitlabEnvironmentName': 'Окружение GitLab',
  'admin.lc.detail.field.prometheusDeploymentName': 'Имя в Prometheus',
  'admin.lc.detail.field.bareMetalVariableName': 'Ключ переменных GitLab',
  // GitLab config subsection (#96 / #97). GitLab is the
  // source-of-truth for jetson app.env + BARE_METAL_VARIABLES;
  // operator fills fields here → pushes to GitLab → after that
  // fields go read-only + pull pulls back any external edits.
  'admin.lc.detail.zoneBind.title': 'Связанные филиалы',
  'admin.lc.detail.zoneBind.noKeyHint': 'Чтобы связать филиал, сначала задайте deployment_key в полях идентичности выше.',
  'admin.lc.detail.zoneBind.noBound': 'Ни один филиал не связан с этим устройством.',
  'admin.lc.detail.zoneBind.pickerPlaceholder': 'Выберите филиал…',
  'admin.lc.detail.zoneBind.bindButton': 'Связать',
  'admin.lc.detail.zoneBind.unbindAria': 'Отвязать',
  'admin.lc.detail.gitlabConfig.title': 'Конфигурация GitLab',
  'admin.lc.detail.gitlabConfig.group.ssh': 'SSH-доступ',
  'admin.lc.detail.gitlabConfig.group.runtime': 'Параметры запуска',
  'admin.lc.detail.gitlabConfig.group.secrets': 'Секреты',
  'admin.lc.detail.gitlabConfig.created': '✓ создано',
  'admin.lc.detail.gitlabConfig.createdAt': 'создано {{when}}',
  'admin.lc.detail.gitlabConfig.bool.on': 'включено',
  'admin.lc.detail.gitlabConfig.bool.off': 'выключено',
  'admin.lc.detail.gitlabConfig.secret.set': '✓ установлен',
  'admin.lc.detail.gitlabConfig.secret.unset': 'не задан',
  'admin.lc.detail.gitlabConfig.secret.setBtn': 'Задать',
  'admin.lc.detail.gitlabConfig.secret.replace': 'Заменить',
  'admin.lc.detail.gitlabConfig.secret.save': 'Сохранить',
  'admin.lc.detail.gitlabConfig.secret.placeholder': 'новое значение',
  'admin.lc.detail.gitlabConfig.field.plugins_list': 'Плагины',
  'admin.lc.detail.gitlabConfig.field.plugins_list.hint': 'Список через запятую: table_control,empty_shelf,…',
  'admin.lc.detail.gitlabConfig.field.modules_list': 'Модули',
  'admin.lc.detail.gitlabConfig.field.service_mode': 'Режим сервиса',
  'admin.lc.detail.gitlabConfig.field.service_port': 'Порт сервиса',
  'admin.lc.detail.gitlabConfig.field.service_name': 'Имя сервиса',
  'admin.lc.detail.gitlabConfig.field.metal_machine_host': 'Хост SSH-прокси',
  'admin.lc.detail.gitlabConfig.field.metal_machine_user': 'Пользователь SSH-прокси',
  'admin.lc.detail.gitlabConfig.field.ssh_port': 'Порт SSH-прокси',
  'admin.lc.detail.gitlabConfig.field.metal_machine_password': 'Пароль SSH-прокси',
  'admin.lc.detail.gitlabConfig.field.password.hint': 'Хранится в GitLab. БЭ хранит только факт установки.',
  'admin.lc.detail.gitlabConfig.field.need_sstpc_vpn': 'Использовать SSTPC VPN',
  'admin.lc.detail.gitlabConfig.field.router_domain': 'Домен роутера',
  'admin.lc.detail.gitlabConfig.field.sstpc_user': 'Пользователь SSTPC',
  'admin.lc.detail.gitlabConfig.field.sstpc_password': 'Пароль SSTPC',
  'admin.lc.detail.gitlabConfig.field.rebuild_triton': 'Пересобрать Triton',
  'admin.lc.detail.gitlabConfig.field.proxy_url': 'Прокси URL',
  'admin.lc.detail.gitlabConfig.field.telegram_data_save_path': 'Путь сохранения Telegram',
  // Phase B (#98) — advanced runtime config + additional secrets.
  // Hidden behind "Показать дополнительные" toggle by default.
  'admin.lc.detail.gitlabConfig.advanced.show': 'Показать дополнительные параметры',
  'admin.lc.detail.gitlabConfig.advanced.hide': 'Скрыть дополнительные параметры',
  'admin.lc.detail.gitlabConfig.field.batch_size': 'Размер пакета',
  'admin.lc.detail.gitlabConfig.field.queue_threads_num': 'Потоков обработки',
  'admin.lc.detail.gitlabConfig.field.default_triton_url': 'URL Triton',
  'admin.lc.detail.gitlabConfig.field.redis_url': 'URL Redis',
  'admin.lc.detail.gitlabConfig.field.gstreamer_pipeline': 'GStreamer pipeline',
  'admin.lc.detail.gitlabConfig.field.model_empty_shelf_name': 'Модель пустых полок',
  'admin.lc.detail.gitlabConfig.field.yolo_model_name': 'Модель YOLO',
  'admin.lc.detail.gitlabConfig.field.yolo_model_version': 'Версия YOLO',
  'admin.lc.detail.gitlabConfig.field.yolo_detectable_class_ids': 'Классы YOLO',
  'admin.lc.detail.gitlabConfig.field.enable_s3': 'Включить S3',
  'admin.lc.detail.gitlabConfig.field.s3_bucket': 'S3 bucket',
  'admin.lc.detail.gitlabConfig.field.s3_access_key': 'S3 access key',
  'admin.lc.detail.gitlabConfig.field.frame_workload_enabled': 'Обработка кадров',
  'admin.lc.detail.gitlabConfig.field.conn_health_checks': 'Проверка соединений',
  'admin.lc.detail.gitlabConfig.field.debug': 'Режим отладки',
  'admin.lc.detail.gitlabConfig.field.postgres_password': 'Пароль Postgres',
  'admin.lc.detail.gitlabConfig.field.django_salt': 'Django SECRET_KEY',
  'admin.lc.detail.gitlabConfig.field.s3_secret_access_key': 'S3 secret access key',
  'admin.lc.detail.gitlabConfig.field.sentry_dsn': 'Sentry DSN',
  'admin.lc.detail.gitlabConfig.field.telegram_alert_token': 'Токен Telegram-бота',
  // Pull-from-GitLab: refreshes the LC mirror from GitLab after the
  // operator edits values directly in the GitLab UI.
  'admin.lc.detail.gitlabConfig.pull.button': 'Подтянуть из GitLab',
  'admin.lc.detail.gitlabConfig.pull.pulling': 'Подтягиваем…',
  'admin.lc.detail.gitlabConfig.pull.upToDate': 'Уже синхронизировано с GitLab.',
  'admin.lc.detail.gitlabConfig.pull.success': 'Обновлено полей: {{count}}. Изменены: {{fields}}.',
  // 3-section workspace (task #82 / xxvii / commit 4e).
  'admin.lc.detail.backToList': 'К списку',
  'admin.lc.detail.sections.params': 'Параметры',
  'admin.lc.detail.sections.setup': 'Установка',
  'admin.lc.detail.sections.steps': 'Шаги настройки',
  'admin.lc.detail.sections.nextStep': 'Текущий шаг',
  'admin.lc.detail.sections.maintenance': 'Дополнительно',
  'admin.lc.detail.modelDeploy.title': 'Обновление моделей',
  'admin.lc.detail.modelDeploy.desc': 'Точка сама раз в сутки тянет новые версии моделей и перезапускает Triton.',
  'admin.lc.detail.modelDeploy.installBtn': 'Показать команду установки',
  'admin.lc.detail.modelDeploy.installHint': 'Запустите один раз на точке (root):',
  'admin.lc.detail.modelConvert.title': 'Конвертация моделей',
  'admin.lc.detail.modelConvert.desc': 'Точка-конвертер собирает TensorRT .plan из обученной модели и заливает в S3. Назначьте точку и поставьте крон командой ниже — флаг станет активным, когда джетсон реально начнёт конвертацию.',
  'admin.lc.detail.modelConvert.installBtn': 'Показать команду установки конвертации',
  'admin.lc.detail.modelConvert.designateBtn': 'Назначить convert-host и показать команду',
  'admin.lc.detail.modelConvert.statusActive': 'активен ✓',
  'admin.lc.detail.modelConvert.statusAwaiting': 'ожидает джетсон',
  'admin.lc.detail.modelConvert.awaitingHint': 'Флаг станет активным, когда convert_drainer на джетсоне впервые опросит бэкенд.',
  'admin.lc.detail.modelDeploy.modeLabel': 'Режим',
  'admin.lc.detail.modelDeploy.modeJetson': 'Джетсон (скачать + рестарт)',
  'admin.lc.detail.modelDeploy.modeHost': 'Хост (только рестарт)',
  'admin.lc.detail.modelDeploy.runs': 'Запуски крона',
  'admin.lc.detail.modelDeploy.noRuns': 'Пока нет запусков',
  'admin.lc.detail.modelDeploy.versions': 'Версии',
  'admin.lc.detail.modelDeploy.showLog': 'Лог',
  'admin.lc.detail.modelDeploy.refresh': 'Обновить',
  'admin.lc.detail.modelDeploy.rc.0': 'успех',
  'admin.lc.detail.modelDeploy.rc.1': 'нет конфига',
  'admin.lc.detail.modelDeploy.rc.2': 'Triton не найден',
  'admin.lc.detail.modelDeploy.rc.3': 'запрос версий не удался',
  'admin.lc.detail.modelDeploy.rc.4': 'нет пути к модели',
  'admin.lc.detail.modelDeploy.rc.5': 'не скачалась модель',
  'admin.lc.detail.modelDeploy.rc.6': 'рестарт Triton не удался',
  'admin.lc.detail.modelDeploy.rc.7': 'Triton не поднялся',
  'admin.lc.detail.modelDeploy.rc.unknown': 'код {rc}',
  'admin.lc.detail.steps.fillParams': 'Заполнить параметры ниже',
  'admin.lc.detail.field.displayName': 'Человеческое название',
  'admin.lc.detail.field.eth0Mac': 'MAC eth0',
  'admin.lc.detail.field.wgPubkey': 'WireGuard pubkey',
  'admin.lc.detail.field.sshPubkey': 'SSH pubkey',
  'admin.lc.detail.field.wgIpLocked': 'Заблокировано — WG handshake уже установлен.',
  'admin.lc.detail.field.deviceNumberLocked': 'Заблокировано — reverse-SSH туннель уже работает.',
  'admin.lc.detail.jetsonOriginatedHint': 'MAC, WG pubkey и SSH pubkey приходят с самого устройства и обновляются только при запуске discovery curl ниже.',
  'admin.lc.detail.discoveryPanel.title': 'Обновить параметры с устройства',
  'admin.lc.detail.discoveryPanel.hint': 'Выполните эту команду на устройстве, чтобы обновить MAC, WG pubkey и SSH pubkey в этой записи. На параметры GitLab (раздел ниже) не влияет. Команда содержит токен, привязанный к этой LC — её безопасно запускать только на этом устройстве.',
  'admin.lc.detail.discoveryPanel.issuingToken': 'Выдаём токен…',
  'admin.lc.detail.discoveryPanel.timeout': 'Сервер не отвечает (10 с). Возможно, истёк сеанс — обновите страницу и попробуйте снова.',
  'admin.lc.detail.discoveryPanel.retry': 'Повторить',
  // Section 3 states (xxvii — Alexey verbatim 2026-05-23):
  // running / failure / pending mirror Section 2's next-row state.
  'admin.lc.detail.nextStep.running': 'Идёт «{{stage}}» — подождите, устройство работает.',
  'admin.lc.detail.nextStep.failure': 'Ошибка во время установки',
  'admin.lc.detail.nextStep.failureStage': 'На этапе: «{{stage}}».',
  'admin.lc.detail.nextStep.exitCode': 'Код выхода: {{code}}',
  'admin.lc.detail.nextStep.failureHint': 'Проверьте состояние устройства и запустите discovery curl выше, чтобы обновить значения. После исправления повторно выполните команду установки.',
  'admin.lc.detail.nextStep.fillParamsHint': 'Заполните недостающие параметры выше — они отмечены * — затем здесь появится команда для запуска установки.',
  'admin.lc.detail.nextStep.hostnameClashWarning': 'Hostname устройства по умолчанию ({{hostname}}) — поменяйте «Человеческое название» выше на что-то осмысленное (например, «Surf Coffee Лефорт»), иначе несколько устройств сольются в один безымянный список.',
  'admin.lc.detail.nextStep.runSetupHint': 'Выполните эту команду на устройстве, чтобы запустить установку. Токен действителен 24 часа.',
  'admin.lc.detail.nextStep.issuingToken': 'Выдаём токен…',
  'admin.lc.detail.nextStep.retryIssue': 'Попробовать ещё раз',
  'admin.lc.detail.nextStep.setupCurlLabel': 'Установка (одноразово)',
  'admin.lc.detail.nextStep.tokenStaleHint': 'токен скоро истечёт',
  'admin.lc.detail.nextStep.refreshToken': 'Обновить токен',
  'admin.lc.detail.discoveryPanel.label': 'Discovery (повторяемо)',
  // Manual stages — sections of the setup that the BE can't yet
  // detect automatically. Per Alexey 2026-05-23, NO manual progress
  // buttons on FE — operator does the external work, the FE waits
  // for the BE auto-detect (flagged to team-lead as BE follow-up).
  'admin.lc.detail.nextStep.openGitlab': 'Открыть GitLab',
  // GITLAB_REGISTERED desc is unused since #99 — the stage is
  // rendered by GitlabMatchOrCreatePanel below, not the generic
  // manual-stage body. Kept here for FE crossover safety.
  'admin.lc.detail.nextStep.manual.GITLAB_REGISTERED.desc': 'Нужен один запуск pipeline в GitLab — он зарегистрирует окружение для компьютера в системе развёртывания, и этап перейдёт автоматически. Запустите вручную или дождитесь очередного запуска по расписанию.',
  // GitLab match-or-create state machine (task #99 / Phase D).
  // Rendered as Section 3 body when the LC waits at GITLAB_REGISTERED.
  'admin.lc.detail.gitlabMatch.initialHint': 'Параметры заполнены. Нажмите «Продолжить», чтобы проверить наличие окружения GitLab для этого компьютера.',
  'admin.lc.detail.gitlabMatch.continue': 'Продолжить',
  'admin.lc.detail.gitlabMatch.checking': 'Проверяем наличие окружения в GitLab CI…',
  'admin.lc.detail.gitlabMatch.creating': 'Создаём окружение и переменные в GitLab…',
  'admin.lc.detail.gitlabMatch.noMatch': 'Не найдено окружение GitLab по host: {{host}}, port: {{port}}. Создать новое?',
  'admin.lc.detail.gitlabMatch.recheck': 'Проверить ещё раз',
  'admin.lc.detail.gitlabMatch.createNew': 'Да, создать',
  'admin.lc.detail.gitlabMatch.clashTitle': 'Конфликт уникальности — создание невозможно',
  'admin.lc.detail.gitlabMatch.clashHint': 'Измените соответствующие поля в разделе выше и нажмите «К продолжению».',
  'admin.lc.detail.gitlabMatch.clash.duplicateLc': 'уже используется в записи «{{lcName}}»',
  'admin.lc.detail.gitlabMatch.clash.envExists': 'окружение «{{envName}}» уже существует в GitLab',
  'admin.lc.detail.gitlabMatch.clash.varExists': 'переменная «{{varKey}}» уже существует в GitLab',
  'admin.lc.detail.gitlabMatch.backToContinue': 'К продолжению',
  'admin.lc.detail.gitlabMatch.retry': 'Повторить',
  'admin.lc.detail.nextStep.manual.TRAEFIK_REGISTERED.desc': 'Проверяем сетевую конфигурацию. Этап проходит автоматически.',
  'admin.lc.detail.nextStep.manual.DOCKER_RUNNING.desc': 'Нужен запуск pipeline в GitLab — он развернёт приложение на компьютере. Как только оно поднимется, этап перейдёт автоматически.',
  // Param-entry placeholders for empty operator-fillable fields
  // (visual cue that the field IS clickable + editable).
  'admin.lc.detail.field.empty': 'нажмите, чтобы заполнить',
  // Delete action surfaced in the page header.
  'admin.lc.detail.maintenance.deleteAction': 'Удалить запись',
  'admin.lc.detail.maintenance.deleteConfirm': 'Подтвердите удаление',
  'admin.lc.detail.resetKeysAction': 'Сбросить ключи',
  'admin.lc.detail.resetKeysConfirmAction': 'Сбросить',
  'admin.lc.detail.resetKeysConfirm': 'Очистит сохранённые WireGuard и SSH ключи на сервере. Потребуется заново выполнить curl на устройстве. Существующие peer-записи в /etc/wireguard/wg0.conf и ключи в /home/linza/.ssh/authorized_keys НЕ удаляются автоматически — это требует ручной очистки от админа.',
  'admin.lc.detail.resetKeysWgLabel': 'WireGuard pubkey',
  'admin.lc.detail.resetKeysWgHint': 'Очистит lc.wg_pubkey.',
  'admin.lc.detail.resetKeysSshLabel': 'SSH pubkey',
  'admin.lc.detail.resetKeysSshHint': 'Очистит machine_facts.ssh_pubkey.',
  'admin.lc.detail.mismatchBanner': 'Ключи на устройстве не совпадают',
  'admin.lc.detail.mismatchHint': 'Устройство сообщило pubkey, отличающийся от сохранённого на сервере. Скорее всего, его переустановили. Сбросьте сохранённые ключи перед повторным запуском curl.',
  'admin.lc.detail.curlPathLabel': 'Запустите на компьютере:',
  'admin.lc.detail.curlExpiredHint': 'Токен закрыт или истёк. Создайте новый через «Зарегистрировать».',
  'admin.lc.detail.curlReissuing': 'Обновляем токен…',
  'admin.lc.detail.curlReissueFailed': 'Не удалось обновить токен: {{error}}',
  'admin.lc.detail.curlReissueRetry': 'Повторить',
  'admin.lc.detail.curlReissueAction': 'Получить новый токен',
  'admin.lc.detail.curlPostEnrolledHint': 'Curl-токен уже использован — устройство продолжает установку. Дождитесь следующих этапов в чек-листе.',
  'admin.lc.detail.curlTtyHint': 'Нужен интерактивный терминал: sudo запросит пароль. Через reverse-ssh или любой неинтерактивный SSH — запустите screen или tmux перед выполнением команды.',
  'admin.lc.detail.alreadyConnectedToggle': 'Компьютер уже подключён',
  'admin.lc.detail.connKindLabel': 'Тип подключения',
  'admin.lc.detail.connKind.wg': 'WireGuard',
  'admin.lc.detail.connKind.reverse_ssh': 'Reverse SSH',
  'admin.lc.detail.connKind.legacy': 'Старый сервер',
  'admin.lc.detail.wgIpLabel': 'WireGuard IP',
  'admin.lc.detail.wgPubkeyLabel': 'WireGuard public key',
  'admin.lc.detail.wgPubkeyHint': 'Из /etc/wireguard/wg0.conf на сервере (рядом с этим IP).',
  'admin.lc.detail.wgPubkeyFetched': 'WireGuard pubkey (с сервера)',
  'admin.lc.detail.wgCommentFromConf': 'Комментарий из wg0.conf',
  'admin.lc.detail.wgHandshakeRecent': 'wg рукопожатие: недавнее',
  'admin.lc.detail.wgHandshakeNone': 'wg рукопожатие: нет',
  'admin.lc.detail.wgPeerNotFound': 'Этот IP не найден среди wg-пиров на сервере',
  'admin.lc.detail.wgPeerUnavailable': 'Состояние wg недоступно — попробуйте позже',
  'admin.lc.detail.reverseSshPortLabel': 'Reverse SSH порт',
  'admin.lc.detail.legacyEndpointLabel': 'SSH строка',
  'admin.lc.detail.legacyEndpointHint': 'Например: ssh linza@62.84.114.224 -p 2234. Сохраняется в заметки как обычный текст и НЕ выполняется системой — это только справка для оператора.',
  'admin.lc.detail.checkAction': 'Проверить',
  'admin.lc.detail.registerAction': 'Зарегистрировать как подключённый',
  'admin.lc.detail.fullySetupLabel': 'Полностью настроен (Docker уже работает)',
  'admin.lc.detail.checkBadWgIp': 'IP должен быть в 10.99.0.0/24',
  'admin.lc.detail.checkBadPubkey': 'Public key выглядит некорректно',
  'admin.lc.detail.checkBadPort': 'Порт должен быть числом',
  'admin.lc.detail.checkBadLegacy': 'Введите SSH строку',
  'admin.lc.detail.checkClashWgIp': 'Этот IP уже занят: {{name}}',
  'admin.lc.detail.checkClashPubkey': 'Этот pubkey уже занят: {{name}}',
  'admin.lc.detail.checkClashPort': 'Этот порт уже занят: {{name}}',
  'admin.lc.detail.checkOkWg': 'OK — pubkey получен с сервера',
  'admin.lc.detail.checkOkRevSsh': 'OK — порт свободен',
  'admin.lc.detail.checkOkLegacy': 'OK — запишем в notes',
  'admin.lc.detail.checkWgHandshakeOk': 'OK — pubkey найден, рукопожатие активно',
  'admin.lc.detail.checkWgNoHandshake': 'Pubkey найден, но рукопожатие не активно — компьютер может быть offline',
  'admin.lc.detail.deleteAction': 'Удалить',
  'admin.lc.detail.deleteConfirm': 'Точно удалить?',
  'admin.lc.detail.wgPeerWaiting': 'Устройство ещё не подключилось к WG',
  'admin.lc.detail.wgPeerWaitingHint': 'Запустите curl на устройстве, чтобы установить туннель.',
  'admin.lc.detail.wgPeerShowCurl': 'Показать curl',
  'admin.lc.detail.networkIdentityCurlRerunHint': 'Изменение wg_ip / device # потребует повторного запуска curl на устройстве (новый порт reverse-ssh / WG IP не привяжется автоматически).',
  'admin.lc.detail.wgPeerMissingHeading': 'wg-пир ещё не зарегистрирован на сервере',
  'admin.lc.detail.wgPeerMissingHint': 'Демон автодобавления (#48) не отработал. Проверьте, что host-крон add_wg_peer.sh жив.',
  'admin.lc.detail.wgPeerMissingCta': 'Открыть Хост-инфраструктуру',
  'admin.lc.detail.wgPeerConnected': 'WireGuard подключён, рукопожатие {{ago}}',
  'admin.lc.detail.ago': 'назад',
  // SSH-pubkey copy-paste snippet (sshPubkeyAdd*) was removed 2026-05-22.
  // Pre-#54 the operator had to append the jetson's pubkey to
  // /home/linza/authorized_keys.example by hand. Since #54's add_ssh_key.sh
  // cron, the BE auto-enqueues + host cron applies within ~60s — no
  // operator action, no UI surface needed (the SetupStageChecklist's
  // SSH_PUBKEY_AUTHORIZED ✓ row carries the signal).
  'admin.lc.detail.infraSnippetsHeading': 'Подключение в инфраструктуру',
  // Whole `snippet*` block removed — these keys served the old
  // manual-deploy flow with copy-paste snippets + operator
  // "mark done" buttons. The detail page no longer renders any
  // of them (auto-detect path supplants the manual flow); the
  // strings were orphans.
  'admin.lc.detail.nodeExporterHeading': 'node_exporter',
  'admin.lc.detail.nodeExporterProbe': 'Проверить :9100',
  'admin.lc.detail.nodeExporterNoWg': 'wg_ip не задан — проверка невозможна.',
  'admin.lc.detail.nodeExporterUp': 'OK — {{url}} отвечает',
  'admin.lc.detail.nodeExporterDown': 'Недоступен: {{reason}}',
  'admin.lc.detail.lastErrorHeading': '{{at}} · этап {{stage}} · exit {{exit_code}}',
  'admin.lc.detail.scriptFailedHeading': 'Скрипт упал — исправьте проблему и запустите curl снова',
  'admin.lc.detail.curlPostFailureHint': 'Получите новый токен и запустите curl на устройстве ещё раз. Полный лог ошибки отправлен в Telegram.',
  'admin.lc.detail.bindHeading': 'Назначить deployment-ключ',
  'admin.lc.detail.editHeading': 'Редактирование',
  'admin.lc.detail.notesLabel': 'Заметки',

  // Equipment-side LocalComputer panel
  'equipment.lc.title': 'Компьютер Linza',
  'equipment.lc.lastSeen': 'последний пинг',
  'equipment.lc.loadError': 'Не удалось загрузить данные компьютера.',
  // Group D — peer discovery on the LC card (2026-06-02 redesign).
  // Same `<DiscoveredPeerList>` Group B built for the Router card,
  // fed by the LC's master `subnet-scan` run instead of a router probe.
  'equipment.lc.discovery.title': 'Поиск устройств в сети',
  'equipment.lc.discovery.idleHint': 'Найдите камеры, NVR и роутер в локальной сети джетсона.',
  'equipment.lc.discovery.start': 'Запустить поиск',
  'equipment.lc.discovery.runAgain': 'Запустить снова',
  'equipment.lc.discovery.dismiss': 'Закрыть',
  'equipment.lc.discovery.headerTitle': 'Поиск устройств',
  'equipment.lc.discovery.searching': 'Сканируем подсеть джетсона…',
  'equipment.lc.discovery.emptyTerminal': 'Не нашли подходящих устройств. Проверьте, что джетсон подключён к нужной подсети.',
  'equipment.lc.discovery.candidatesTitle': 'Найденные устройства',
  'equipment.lc.discovery.candidatesHelp': 'Выберите, что добавить: камеру, NVR или роутер. Тройные точки — переопределить тип или проверить связь.',
  'equipment.lc.discovery.othersTitle': 'Остальные устройства в сети',
  'equipment.lc.discovery.othersHelp': 'Тип не определён автоматически. Через тройные точки можно явно назначить.',
  'equipment.lc.discovery.peersCount': 'найдено {{count}}',
  'equipment.lc.discovery.actions.addAsNvrTitle': 'Добавить устройство как NVR',
  'equipment.lc.discovery.actions.addAsRouterTitle': 'Добавить устройство как роутер',
  // Equipment-side NVR panel
  'equipment.nvr.title': 'Видеорегистратор (NVR)',
  'equipment.nvr.vendor': 'Производитель',
  'equipment.nvr.ipAddress': 'IP в LAN',
  'equipment.nvr.port': 'Порт',
  'equipment.nvr.username': 'Логин',
  'equipment.nvr.password': 'Пароль',
  'equipment.nvr.model': 'Модель',
  'equipment.nvr.serialNumber': 'Серийный номер',
  'equipment.nvr.firmwareVersion': 'Прошивка',
  'equipment.nvr.deviceId': 'ID устройства',
  'equipment.nvr.macAddress': 'MAC-адрес',
  'equipment.nvr.identity': 'Идентификация',
  'equipment.nvr.notes': 'Заметки',
  'equipment.nvr.show': 'Показать',
  'equipment.nvr.hide': 'Скрыть',
  'equipment.nvr.importCameras': 'Импортировать камеры',
  'equipment.nvr.importResult': 'Добавлено: {{added}}, уже было: {{existing}}, ошибок: {{errors}}.',
  'equipment.nvr.delete': 'Удалить',
  'equipment.nvr.deleteConfirm': 'Точно удалить?',
  // Equipment-side Router panel (Brick 7)
  'equipment.router.title': 'Роутер',
  'equipment.router.empty': 'Роутер не настроен. Добавьте данные для удалённого доступа.',
  'equipment.router.add': 'Добавить роутер',
  'equipment.router.modelName': 'Модель',
  'equipment.router.modelName.keenetic': 'Keenetic',
  'equipment.router.modelName.linzaRouter': 'Роутер Linza Metrics',
  'equipment.router.modelName.mikrotik': 'Mikrotik',
  'equipment.router.modelName.asus': 'ASUS',
  'equipment.router.modelName.tplink': 'TP-Link',
  'equipment.router.modelName.other': 'Другое',
  'equipment.router.modelName.otherPlaceholder': 'Название модели',
  'equipment.router.gatewayIp': 'IP в LAN',
  'equipment.router.adminUrl': 'Адрес админ-панели',
  'equipment.router.remoteAccessUrl': 'Удалённый доступ',
  'equipment.router.username': 'Логин',
  'equipment.router.password': 'Пароль',
  'equipment.router.notes': 'Заметки',
  'equipment.router.show': 'Показать',
  'equipment.router.hide': 'Скрыть',
  'equipment.router.delete': 'Удалить',
  'equipment.router.deleteConfirm': 'Точно удалить?',
  // Router autodiscovery Phase A — read-only RCI probe + LAN host preview
  'equipment.router.autodiscover': 'Поиск устройств',
  'equipment.router.probe.wgState': 'WireGuard',
  'equipment.router.probe.wgConfigured': 'настроен',
  'equipment.router.probe.wgAbsent': 'не настроен',
  'equipment.router.probe.wgWrongScope': 'маршруты вне диапазона',
  'equipment.router.probe.lanHosts': 'Устройства в сети',
  'equipment.router.probe.existingForwards': 'Проброс портов',
  'equipment.router.probe.likelyCameras': 'Похожих на камеры',
  'equipment.router.probe.suggestedCameras': 'Возможные камеры',
  'equipment.router.probe.suggestedCamerasHelp': 'Отметьте камеры, которые нужно добавить в зону. Без проброса порта 554 устройство пока недоступно.',
  'equipment.router.probe.showHosts': 'Показать устройства',
  'equipment.router.probe.showAllHosts': 'Остальные устройства в сети',
  'equipment.router.probe.offline': 'офлайн',
  'equipment.router.probe.credentialsRejected': 'Логин или пароль не подошли',
  'equipment.router.probe.unreachable': 'Не удалось достучаться до роутера',
  'equipment.router.probe.enumerateFailed': 'Роутер ответил, но данные прочитать не удалось',
  'equipment.router.probe.searching': 'Определяем модель и сеть…',
  // Router edit modal (2026-06-02 restructure)
  'equipment.router.editDialog.title': 'Изменить роутер',
  'equipment.router.editDialog.advanced': 'Расширенные настройки',
  'equipment.router.editDialog.probeFailed': 'Не удалось определить модель — заполните вручную.',
  'equipment.router.editDialog.detected': 'определено автоматически',
  'equipment.router.editDialog.bridgeLayoutShow': 'JSON',
  'equipment.router.editDialog.bridgeLayoutCount': '{{count}} интерфейсов',
  'equipment.router.wanIp': 'WAN IP',
  'equipment.router.modelFullSku': 'Полная модель',
  'equipment.router.firmware': 'Прошивка',
  'equipment.router.firmwareFactory': 'Заводская прошивка',
  'equipment.router.bridgeLayout': 'Сетевые интерфейсы',
  'equipment.router.remoteAccessUrlHelp': 'Дополнительный адрес для случаев, когда основной не пускает (например, keenetic.link или DDNS). Необязательно.',
  // Router card (2026-06-02 restructure)
  'equipment.router.refresh': 'Обновить',
  'equipment.router.refreshTooltip': 'Перепросмотреть устройства и сеть',
  'equipment.router.fetchedAt': 'обновлено в {{time}}',
  'equipment.router.fetchedJustNow': 'обновлено только что',
  'equipment.router.fetchedNever': 'Данные не загружены — нажмите «Обновить» в правом верхнем углу.',
  'equipment.router.refreshing': 'Обновляем…',
  'equipment.router.connection': 'Подключение',
  'equipment.router.status': 'Сводка',
  'equipment.router.devicesCount': 'Устройства в сети',
  'equipment.router.camerasCount': 'Похожих на камеры',
  'equipment.router.forwardsCount': 'Пробросы портов',
  'equipment.router.statusWgConfigured': 'настроен · {{ip}}',
  'equipment.router.statusWgAbsent': 'не настроен',
  'equipment.router.statusWgWrongScope': 'маршруты вне диапазона',
  'equipment.router.dash': '—',
  'equipment.router.actionsLabel': 'Действия',
  'equipment.router.refreshError': 'Не удалось обновить — показаны предыдущие данные.',
  'equipment.router.suggested': 'Возможные камеры',
  'equipment.router.suggestedOthers': 'Остальные устройства',
  'equipment.router.actionsMore': 'Ещё',
  // Port-forwards section (autodiscovery Phase C)
  'equipment.router.forwards.title': 'Проброс портов',
  'equipment.router.forwards.add': 'Добавить проброс',
  'equipment.router.forwards.delete': 'Удалить',
  'equipment.router.forwards.empty': 'Пробросов пока нет.',
  'equipment.router.forwards.field.interface': 'Интерфейс',
  'equipment.router.forwards.field.protocol': 'Протокол',
  'equipment.router.forwards.field.externalPort': 'Внешний порт',
  'equipment.router.forwards.field.internalPort': 'Внутренний порт',
  'equipment.router.forwards.field.toHost': 'IP/MAC устройства в LAN',
  'equipment.router.forwards.field.comment': 'Комментарий',
  'equipment.router.forwards.field.commentPlaceholder': 'Необязательно — что это за поток',
  'equipment.router.forwards.addDialog.title': 'Новый проброс портов',
  'equipment.router.forwards.addDialog.submit': 'Добавить',
  'equipment.router.forwards.deleteDialog.title': 'Удалить проброс?',
  'equipment.router.forwards.deleteDialog.body': 'Правило исчезнет с роутера. Камеры, которые на него опираются, перестанут отвечать.',
  // Typed write errors — map to the BE's `error:` field 1:1.
  'equipment.router.forwards.errors.unsupported_router_model': 'Эта модель роутера не поддерживается для записи правил.',
  'equipment.router.forwards.errors.credentials_rejected': 'Роутер отверг логин/пароль.',
  'equipment.router.forwards.errors.unreachable': 'Не удалось достучаться до роутера.',
  'equipment.router.forwards.errors.missing_field': 'Не все поля заполнены.',
  'equipment.router.forwards.errors.bad_protocol': 'Протокол должен быть TCP или UDP.',
  'equipment.router.forwards.errors.bad_external_port': 'Внешний порт должен быть от 1 до 65535.',
  'equipment.router.forwards.errors.bad_internal_port': 'Внутренний порт должен быть от 1 до 65535.',
  'equipment.router.forwards.errors.bad_comment': 'Комментарий не должен быть длиннее 200 символов и не должен содержать перенос строки.',
  'equipment.router.forwards.errors.external_port_reserved': 'Порт 80 зарезервирован под админку роутера — выберите другой (например 8080).',
  'equipment.router.forwards.errors.device_rejected': 'Роутер не принял правило (ответ CLI был непонятным).',
  'equipment.router.forwards.errors.readback_missing': 'Запись прошла, но правило не появилось в конфиге — попробуйте ещё раз.',
  'equipment.router.forwards.errors.readback_still_present': 'Удаление прошло, но правило осталось в конфиге — попробуйте ещё раз.',
  // Router import-cameras (autodiscovery Phase A.5)
  'equipment.router.probe.forwardLabel': 'RTSP',
  'equipment.router.probe.noForward': 'Нет проброса — добавьте на роутере',
  'equipment.router.probe.noForwardYet': 'Нет проброса порта 554',
  'equipment.router.import.button': 'Импортировать выбранные',
  'equipment.router.import.dialogTitle': 'Импорт камер с роутера',
  'equipment.router.import.dialogIntro': 'Логин и пароль ниже применятся ко всем выбранным камерам. Изменить можно потом — на вкладке Камеры.',
  'equipment.router.import.username': 'Имя пользователя',
  'equipment.router.import.password': 'Пароль',
  'equipment.router.import.submit': 'Импортировать',
  'equipment.router.import.cancel': 'Отмена',
  'equipment.router.import.selected': 'Выбрано',
  'equipment.router.import.wgRequired': 'Сначала настройте WireGuard-туннель на роутере — без него камеры будут недоступны центру.',
  'equipment.router.import.successCreated': 'Создано камер',
  'equipment.router.import.successSkipped': 'Пропущено (уже есть)',
  'equipment.router.import.errorRows': 'Ошибки',
  'equipment.router.import.error': 'Не удалось импортировать',
  // Router redesign 2026-06-02 — per-host import, collapsible sections,
  // host designation menu, connectivity checks. Shared `discoveredPeer.*`
  // namespace is consumed by both the router card and (Group D)
  // LocalComputer peer list.
  'equipment.router.modelSubcaption': 'модель',
  'equipment.router.modelUnknown': 'Модель неизвестна',
  'equipment.router.firmwareInline': 'прошивка {{version}}',
  'equipment.router.subcard.connection': 'Подключение',
  'equipment.router.subcard.overview': 'Сводка',
  'equipment.router.sectionForwards.collapsed': 'Проброс портов',
  'equipment.router.sectionForwards.expand': 'Развернуть',
  'equipment.router.sectionForwards.collapse': 'Свернуть',
  'equipment.router.sectionDevices.collapsed': 'Возможные камеры',
  'equipment.router.sectionDevices.expand': 'Развернуть',
  'equipment.router.sectionDevices.collapse': 'Свернуть',
  'equipment.router.sectionDevices.othersTitle': 'Остальные устройства в сети',
  'equipment.router.sectionDevices.othersHelp': 'Отметьте «Это камера / NVR / роутер», если что-то не определилось автоматически.',
  'equipment.router.sectionDevices.alreadyImported': 'Уже добавлено',
  'equipment.discoveredPeer.import.camera': 'Добавить как камеру',
  'equipment.discoveredPeer.import.nvr': 'Добавить как NVR',
  'equipment.discoveredPeer.import.router': 'Добавить как роутер',
  'equipment.discoveredPeer.alreadyImported': 'Уже добавлено',
  'equipment.discoveredPeer.viaNvr': 'через NVR',
  'equipment.discoveredPeer.jetsonNote': 'Линза-устройство — проброс не нужен',
  'equipment.discoveredPeer.bulkSelect': 'Выбрать',
  'equipment.discoveredPeer.bulkUnselect': 'Снять выделение',
  'equipment.discoveredPeer.designate.camera': 'Это камера',
  'equipment.discoveredPeer.designate.nvr': 'Это NVR',
  'equipment.discoveredPeer.designate.router': 'Это роутер',
  'equipment.discoveredPeer.designate.reset': 'Сбросить',
  'equipment.discoveredPeer.check.ping': 'Пинг',
  'equipment.discoveredPeer.check.tcp': 'Порт открыт',
  'equipment.discoveredPeer.check.rtsp': 'RTSP-поток',
  'equipment.discoveredPeer.check.running': 'проверяем…',
  'equipment.discoveredPeer.check.fail': 'нет ответа',
  'equipment.discoveredPeer.check.ms': '{{ms}} мс',
  'equipment.discoveredPeer.check.idleTooltip': 'нажмите для проверки',
  'equipment.discoveredPeer.check.noForwardHint': 'Сначала создайте проброс для этого устройства — без него роутер не сможет проверить связь.',
  'equipment.discoveredPeer.check.err.host_unreachable': 'хост недоступен',
  'equipment.discoveredPeer.check.err.port_closed': 'порт закрыт',
  'equipment.discoveredPeer.check.err.rtsp_unauthorized': 'нужны логин/пароль',
  'equipment.discoveredPeer.check.err.rtsp_no_stream': 'поток не найден',
  'equipment.discoveredPeer.check.err.timeout': 'таймаут',
  'equipment.discoveredPeer.check.err.target_required': 'обновите страницу',
  'equipment.discoveredPeer.menu.label': 'Действия',
  'equipment.discoveredPeer.menu.checksGroup': 'Проверка связи',
  'equipment.discoveredPeer.menu.designateGroup': 'Назначить устройство',
  'equipment.discoveredPeer.import.confirm.existingForward.title': 'Импортировать камеру?',
  'equipment.discoveredPeer.import.confirm.existingForward.body': 'Будет добавлена камера {{addr}}.',
  'equipment.discoveredPeer.import.confirm.autoForward.title': 'Создать проброс и импортировать?',
  'equipment.discoveredPeer.import.confirm.autoForward.body': 'Создадим проброс {{externalPort}} → {{internalPort}} на интерфейс {{iface}}. Камера будет добавлена как неактивная — заполните логин и пароль в её настройках.',
  'equipment.discoveredPeer.import.confirm.autoForward.bodyPending': 'Создадим проброс 554 → 554 (внешний порт выберет роутер автоматически). Камера будет добавлена как неактивная — заполните логин и пароль в её настройках.',
  'equipment.discoveredPeer.import.confirm.submit': 'Импортировать',
  'equipment.discoveredPeer.import.confirm.cancel': 'Отмена',
  'equipment.discoveredPeer.import.confirm.credsHelp': 'Логин и пароль камеры заполните в её настройках после импорта — это не учётка роутера.',
  'equipment.discoveredPeer.import.confirm.credsLater': 'заполните после импорта',
  'equipment.discoveredPeer.import.confirm.storedAs': 'В Linza Metrics:',
  'equipment.discoveredPeer.import.confirm.routerPath': 'На роутере:',
  'equipment.discoveredPeer.import.error.no_reachable_path': 'Нельзя пробросить порт: на роутере не настроен WireGuard и нет публичного WAN IP.',
  'equipment.discoveredPeer.import.error.endpoint_not_deployed': 'Серверная часть автопроброса ещё не задеплоена.',
  'equipment.discoveredPeer.import.error.autoForwardNoPort': 'Не удалось получить внешний порт от роутера — импорт камеры отменён, чтобы не создать «висящую» запись.',
  'equipment.discoveredPeer.import.error.generic': 'Не удалось импортировать',
  // Source-type picker + EZVIZ RTSP-retrieval card.
  'equipment.discoveredPeer.import.sourceType': 'Тип источника',
  'equipment.discoveredPeer.import.ezviz.title': 'Получение RTSP с Ezviz',
  'equipment.discoveredPeer.import.ezviz.run': 'Запустить',
  'equipment.discoveredPeer.import.ezviz.runAgain': 'Запустить ещё раз',
  'equipment.discoveredPeer.import.ezviz.running': 'Выполняется…',
  'equipment.discoveredPeer.import.ezviz.close': 'Закрыть',
  'equipment.discoveredPeer.import.ezviz.done': 'Готово',
  'equipment.discoveredPeer.import.ezviz.successTitle': 'Камера «{{name}}» добавлена',
  'equipment.discoveredPeer.import.ezviz.successHint': 'RTSP включён, разрешение и кодек сохранены',
  'equipment.discoveredPeer.import.ezviz.verificationCode': 'Код проверки (verification code)',
  'equipment.discoveredPeer.import.ezviz.verificationCodePlaceholder': 'код с наклейки на камере',
  'equipment.discoveredPeer.import.ezviz.needVerificationCode': 'Укажите код проверки камеры (на наклейке) — он же пароль RTSP.',
  'equipment.discoveredPeer.import.ezviz.forwardsDone': 'RTSP → внешний {{rtsp}}, SDK → внешний {{sdk}}',
  'equipment.discoveredPeer.import.ezviz.alreadyRunning': 'Включение RTSP уже выполняется для этой камеры — подождите и запустите ещё раз.',
  'equipment.discoveredPeer.import.ezviz.bootstrapFailed': 'Не удалось включить RTSP через SDK.',
  'equipment.discoveredPeer.import.ezviz.probeNoMeta': 'Поток доступен, но метаданные не определены.',
  'equipment.discoveredPeer.import.ezviz.previewAlt': 'Кадр предпросмотра RTSP',
  'equipment.discoveredPeer.import.ezviz.step.forwards': 'Пробросы портов (RTSP 554 + SDK 8000)',
  'equipment.discoveredPeer.import.ezviz.step.rtsp': 'Включение RTSP на камере (Hik SDK)',
  'equipment.discoveredPeer.import.ezviz.step.import': 'Импорт камеры',
  'equipment.discoveredPeer.import.ezviz.step.probe': 'Проба RTSP: разрешение и кодек',
  'equipment.discoveredPeer.bulk.footer': 'Выбрано: {{count}}',
  'equipment.discoveredPeer.bulk.importCameras': 'Импортировать как камеры',
  'equipment.discoveredPeer.bulk.createForwards': 'Создать пробросы 554',
  'equipment.discoveredPeer.bulk.cancel': 'Отменить',
  'equipment.router.forwards.field.toHost.picker': 'Устройство в LAN',
  'equipment.router.forwards.field.toHost.pickerPlaceholder': 'Выберите устройство…',
  'equipment.router.forwards.field.toHost.alreadyImported': 'уже импортирован',
  'equipment.router.forwards.field.toHost.alreadyImportedHint': 'на устройстве уже есть камера',
  'equipment.router.forwards.field.family': 'Назначение',
  'equipment.router.forwards.field.family.rtsp': 'Камера: RTSP',
  'equipment.router.forwards.field.family.api': 'Камера: API',
  'equipment.router.forwards.field.family.other': 'Другое',
  'equipment.router.forwards.field.family.cameraPrefix': 'Камера:',
  'equipment.router.forwards.field.family.shortRtsp': 'RTSP',
  'equipment.router.forwards.field.family.shortApi': 'API',
  'equipment.router.forwards.field.family.shortOther': 'Другое',
  'equipment.router.forwards.internalPortMismatch': 'Не совпадает с рекомендованным {{suggested}} для семейства «{{family}}».',
  'equipment.router.forwards.autoPort': 'авто',
  'equipment.router.forwards.autoPortHint': 'роутер подберёт свободный',
  'equipment.router.forwards.errors.no_reachable_path': 'Нельзя пробросить порт: на роутере не настроен WireGuard и нет публичного WAN IP.',
  'equipment.router.forwards.errors.endpoint_not_deployed': 'Серверная часть автопроброса ещё не задеплоена — используется обычный режим.',
  // On-demand admin tunnel button (issue #34)
  'equipment.adminTunnel.open': 'Админ-панель',
  'equipment.adminTunnel.tooltip': 'Открыть админ-панель устройства через джетсон',
  'equipment.adminTunnel.error': 'Не удалось открыть туннель',
  // Vendor-API parameter tweaks for cameras (issue #34 part 3)
  'equipment.vendorParams.title': 'Параметры изображения',
  'equipment.vendorParams.subtitle': 'Значения читаются и пишутся напрямую в камеру',
  'equipment.vendorParams.brightness': 'Яркость',
  'equipment.vendorParams.contrast': 'Контраст',
  'equipment.vendorParams.saturation': 'Насыщенность',
  'equipment.vendorParams.sharpness': 'Резкость',
  'equipment.vendorParams.hue': 'Оттенок',
  'equipment.vendorParams.backlightEnabled': 'Компенсация засветки',
  'equipment.vendorParams.backlightLevel': 'Уровень компенсации засветки',
  'equipment.vendorParams.loadError': 'Не удалось получить параметры',
  'equipment.vendorParams.writeError': 'Не удалось записать значение',
  'equipment.vendorParams.clickToOpen': 'Нажмите, чтобы прочитать значения с камеры',
  'equipment.vendorParams.unsupported': 'Камера не поддерживает чтение параметров через API',
  'equipment.vendorParams.loadingValues': 'Читаем значения с камеры…',
  'equipment.vendorParams.refresh': 'Перечитать с камеры',
  // Targets — где лежат настройки изображения
  'equipment.vendorParams.target.nvr': 'На NVR',
  'equipment.vendorParams.target.camera': 'На камере',
  // Groups (заголовки разделов параметров)
  'equipment.vendorParams.wdr': 'WDR (расширенный динамический диапазон)',
  'equipment.vendorParams.wdr.mode': 'Режим WDR',
  'equipment.vendorParams.wdr.level': 'Уровень WDR',
  'equipment.vendorParams.wdr.mode.auto': 'Авто',
  'equipment.vendorParams.wdr.mode.off': 'Выкл',
  'equipment.vendorParams.wdr.mode.on': 'Вкл',
  'equipment.vendorParams.blc': 'BLC (компенсация засветки)',
  'equipment.vendorParams.blc.enabled': 'Включить BLC',
  'equipment.vendorParams.blc.mode': 'Направление компенсации',
  'equipment.vendorParams.blc.level': 'Уровень BLC',
  'equipment.vendorParams.blc.mode.off': 'Выкл',
  'equipment.vendorParams.blc.mode.up': 'Вверх',
  'equipment.vendorParams.blc.mode.down': 'Вниз',
  'equipment.vendorParams.blc.mode.left': 'Влево',
  'equipment.vendorParams.blc.mode.right': 'Вправо',
  'equipment.vendorParams.blc.mode.center': 'По центру',
  'equipment.vendorParams.hlc': 'HLC (подавление яркого света)',
  'equipment.vendorParams.hlc.enabled': 'Включить HLC',
  'equipment.vendorParams.hlc.level': 'Уровень HLC',
  'equipment.vendorParams.color': 'Цветопередача',
  'equipment.vendorParams.shutter': 'Затвор',
  'equipment.vendorParams.shutter.level': 'Скорость затвора',
  'equipment.vendorParams.supplementLight': 'Подсветка',
  'equipment.vendorParams.supplementLight.mode': 'Режим подсветки',
  'equipment.vendorParams.supplementLight.whiteBrightness': 'Яркость белой подсветки',
  'equipment.vendorParams.supplementLight.irBrightness': 'Яркость ИК-подсветки',
  'equipment.vendorParams.supplementLight.mode.off': 'Выкл',
  'equipment.vendorParams.supplementLight.mode.ir': 'ИК',
  'equipment.vendorParams.supplementLight.mode.colorVu': 'ColorVu (белая подсветка)',
  'equipment.vendorParams.supplementLight.mode.eventIntel': 'По событию',
  'equipment.vendorParams.imageFlip': 'Отражение / поворот',
  'equipment.vendorParams.imageFlip.enabled': 'Включить отражение',
  'equipment.vendorParams.imageFlip.style': 'Тип отражения',
  // Live 1 fps preview in camera detail (issue #34 part 2)
  'equipment.liveStream.title': 'Картинка с камеры',
  'equipment.liveStream.subtitle': 'Обновляется примерно раз в секунду',
  'equipment.liveStream.error': 'Не удалось получить кадр',
  'equipment.liveStream.noFrame': 'Нет кадра',
  'equipment.liveStream.idle': 'Нажмите «Запустить», чтобы увидеть картинку',
  'equipment.liveStream.play': 'Запустить',
  'equipment.liveStream.stop': 'Остановить',
  'equipment.liveStream.unsupported': 'Камера не поддерживает снимки через API',
  // EZVIZ pan/tilt pad in camera detail
  'equipment.ptz.title': 'Поворот камеры',
  'equipment.ptz.up': 'Вверх',
  'equipment.ptz.down': 'Вниз',
  'equipment.ptz.left': 'Влево',
  'equipment.ptz.right': 'Вправо',
  'equipment.ptz.savePosition': 'Запомнить позицию',
  'equipment.ptz.gotoPosition': 'К сохранённой позиции',
  'equipment.ptz.error': 'Не удалось повернуть камеру',
  // Equipment-side autodiscovery flow (2026-05-17 design)
  'equipment.discovery.creds.title': 'Требуется пароль',
  'equipment.discovery.creds.lastTried': 'последний пробованный логин: {{username}}',
  'equipment.discovery.creds.addRow': 'Добавить ещё пару',
  'equipment.discovery.creds.removeRow': 'Удалить строку',
  'equipment.discovery.creds.submit': 'Попробовать',
  'equipment.discovery.creds.skip': 'Пропустить это устройство',
  'equipment.discovery.idleHint': 'Автоматический поиск роутера, NVR и камер в сети джетсона.',
  'equipment.discovery.startMaster': 'Запустить автообнаружение',
  'equipment.discovery.headerTitle': 'Автообнаружение',
  'equipment.discovery.collapse': 'Свернуть',
  'equipment.discovery.expand': 'Развернуть',
  'equipment.discovery.cancel': 'Отменить',
  'equipment.discovery.runAgain': 'Запустить снова',
  'equipment.discovery.done': 'Готово',
  'equipment.discovery.collapsedHint': 'Автообнаружение продолжается ({{status}}).',
  'equipment.discovery.status.created': 'старт',
  'equipment.discovery.status.running': 'идёт',
  'equipment.discovery.status.paused_on_creds': 'ждёт пароль',
  'equipment.discovery.status.ok': 'готово',
  'equipment.discovery.status.partial': 'частично',
  'equipment.discovery.status.failed': 'ошибка',
  'equipment.discovery.status.cancelled': 'отменено',
  'equipment.discovery.summary.terminal.ok': 'Автообнаружение завершено успешно.',
  'equipment.discovery.summary.terminal.partial': 'Автообнаружение завершено с пропусками.',
  'equipment.discovery.summary.terminal.failed': 'Автообнаружение не удалось.',
  'equipment.discovery.summary.terminal.cancelled': 'Автообнаружение отменено.',
  'equipment.discovery.summary.kind.router': 'Роутеры',
  'equipment.discovery.summary.kind.nvr': 'NVR',
  'equipment.discovery.summary.kind.camera': 'Камеры',
  'equipment.discovery.summary.line': 'добавлено {{added}}, уже было {{existing}}, пропущено {{skipped}}',
  'equipment.discovery.summary.errors': 'Ошибок при обнаружении: {{n}}',
  // Equipment-side "+ Add device" dropdown (2026-05-17 design §2.3)
  'equipment.addDevice.button': 'Добавить устройство',
  'equipment.addDevice.router': 'Роутер',
  'equipment.addDevice.nvr': 'NVR',
  'equipment.addDevice.camera': 'Камера',
  'equipment.addDevice.microphone': 'Микрофон',
  // Microphone panel + new-mic form (audio capture device on the Jetson).
  'equipment.mic.title': 'Микрофон',
  'equipment.mic.alsaDevice': 'ALSA-устройство',
  'equipment.mic.cardName': 'Звуковая карта',
  'equipment.mic.capture': 'Захват',
  'equipment.mic.enabled': 'Включён',
  'equipment.mic.disabled': 'Выключен',
  'equipment.mic.delete': 'Удалить',
  'equipment.mic.deleteConfirm': 'Точно удалить?',
  'equipment.mic.networkTitle': 'Сетевой микрофон (роутер)',
  'equipment.mic.address': 'Адрес',
  'equipment.mic.check': 'Проверить звук',
  'equipment.mic.checking': 'Слушаю…',
  'equipment.mic.online': 'в сети',
  'equipment.mic.offline': 'не отвечает',
  'equipment.mic.levels': 'средний {{rms}} дБ · пики {{peak}} дБ',
  'equipment.newMic.title': 'Новый микрофон',
  'equipment.newMic.discover': 'Найти устройства',
  'equipment.newMic.discovered': 'Найденные устройства',
  'equipment.newMic.noDevices': 'Микрофоны на Jetson не найдены.',
  'equipment.newMic.alsaDevice': 'ALSA-устройство',
  'equipment.newMic.alsaHint': 'Адрес вида hw:X,Y. Выберите из списка выше или введите вручную.',
  'equipment.newMic.alsaDeviceRequired': 'Укажите ALSA-устройство (например, hw:2,0).',
  'equipment.newMic.kindUsb': 'USB на джетсоне',
  'equipment.newMic.kindNetwork': 'Сетевой (роутер)',
  'equipment.newMic.address': 'Адрес микрофона',
  'equipment.newMic.addressHint': 'WG-адрес роутера с микрофоном и порт, обычно 5555. Запись ведёт централь.',
  'equipment.newMic.addressInvalid': 'Адрес вида tcp://10.99.0.N:5555.',
  'equipment.newRouter.title': 'Новый роутер',
  'equipment.newNVR.title': 'Новый NVR',
  'equipment.newNVR.ipAddress': 'IP-адрес',
  'equipment.newNVR.port': 'HTTP-порт (ISAPI)',
  'equipment.newNVR.username': 'Логин',
  'equipment.newNVR.password': 'Пароль',
  'equipment.newNVR.vendor': 'Производитель',
  'equipment.newNVR.notes': 'Заметки',
  'equipment.newNVR.ipAddressRequired': 'Укажите IP-адрес NVR.',
  'admin.lc.live': 'Работает',
  'admin.lc.notReady': 'Не настроен',
  'admin.lc.archived': 'Архив',
  // Process-noun labels — read consistently in done / in-progress / failed
  // states (a past-tense label like "Зарегистрирован" only makes sense
  // for `done`; the same row when in-progress or failed would read wrong).
  'admin.lc.stage.ENROLLED': 'Регистрация',
  'admin.lc.stage.WG_CONFIGURED': 'Настройка WireGuard',
  'admin.lc.stage.WG_HANDSHAKE_VERIFIED': 'WireGuard-рукопожатие',
  'admin.lc.stage.SSH_PUBKEY_AUTHORIZED': 'Авторизация SSH-ключа',
  'admin.lc.stage.AUTHORIZED_KEYS_PULLED': 'Синхронизация ключей',
  'admin.lc.stage.REVERSE_SSH_LIVE': 'Обратный SSH',
  'admin.lc.stage.GITLAB_REGISTERED': 'Регистрация в GitLab CI',
  'admin.lc.stage.TRAEFIK_REGISTERED': 'Регистрация в Traefik',
  'admin.lc.stage.DOCKER_RUNNING': 'Запуск Docker',

  // Admin user list
  'admin.branches.title': 'Филиалы',
  'admin.branches.subtitle': 'Все филиалы системы',
  'admin.branches.searchPlaceholder': 'Поиск филиала…',
  'admin.branches.empty': 'Филиалы не найдены',
  'admin.branches.total': 'Всего: {{n}}',
  'admin.branches.colName': 'Название',
  'admin.branches.colType': 'Тип',
  'admin.branches.colTimezone': 'Часовой пояс',
  'admin.branches.colStatus': 'Статус',
  'admin.branches.archived': 'Архивный',
  'admin.branches.active': 'Активный',
  'admin.branches.openSettings': 'Настройки',
  'admin.branches.colCapture': 'Захват',
  'admin.branches.captureLc': 'Компьютер',
  'admin.branches.captureRouter': 'Роутер',
  'admin.users.title': 'Пользователи',
  'admin.users.subtitle': 'Управление учётными записями системы.',
  'admin.users.searchPlaceholder': 'Поиск по имени или e-mail…',
  'admin.users.colUsername': 'Логин',
  'admin.users.colEmail': 'E-mail',
  'admin.users.colRole': 'Роль',
  'admin.users.colBranches': 'Филиалов',
  'admin.users.colLastLogin': 'Последний вход',
  'admin.users.neverLoggedIn': 'не входил',
  'admin.users.openProfile': 'Открыть',
  'admin.users.empty': 'Нет пользователей.',
  'admin.users.pageOf': '{{from}}–{{to}} из {{total}}',
  'admin.users.prev': 'Предыдущая страница',
  'admin.users.next': 'Следующая страница',
  'admin.users.roleSuperuser': 'Суперпользователь',
  'admin.users.roleStaff': 'Staff',
  'admin.users.roleMember': 'Пользователь',

  // Admin user detail
  'admin.user.title': 'Профиль пользователя',
  'admin.user.subtitle': 'Доступы, роли и сброс пароля.',
  'admin.user.backToList': 'К списку пользователей',
  'admin.user.profile': 'Профиль',
  'admin.user.profileDescription': 'Учётная запись {{username}}.',
  'admin.user.flagSuperuser': 'Суперпользователь',
  'admin.user.flagSuperuserDescription': 'Полный доступ ко всему: BE-эндпоинтам, Django-админке, любым филиалам.',
  'admin.user.flagStaff': 'Staff (доступ в Django-админку)',
  'admin.user.flagStaffDescription': 'Может зайти в /core/admin/. Сами по себе права не дают, но без них админка недоступна.',
  'admin.user.cannotSelfRevoke': 'Нельзя снять права суперпользователя у самого себя.',
  'admin.user.staffImpliedBySuperuser': 'У суперпользователей staff-флаг включён автоматически.',
  'admin.user.password': 'Сброс пароля',
  'admin.user.passwordDescription': 'Установить новый пароль пользователю. Минимум {{n}} символов. Старый пароль не требуется.',
  'admin.user.passwordSubmit': 'Сбросить пароль',
  'admin.user.passwordResetSuccess': 'Пароль для {{username}} обновлён.',
  'admin.user.telegram.title': 'Telegram-аккаунт',
  'admin.user.telegram.hint': 'Привяжите Telegram-логин этого пользователя, чтобы при входе через TG он попадал именно в эту учётку. Без привязки случайный человек с тем же ником попасть сюда не сможет.',
  'admin.user.telegram.placeholder': 'username (без @)',
  'admin.user.telegram.bind': 'Привязать',
  'admin.user.telegram.unbind': 'Отвязать',
  'admin.user.telegram.usernameRequired': 'Введите telegram-логин.',
  'admin.user.telegram.verified': '✓ подтверждено',
  'admin.user.telegram.pending': 'ожидает первого входа',
  'admin.user.branches': 'Доступы к филиалам',
  'admin.user.branchesDescription': 'Филиалы, к которым у пользователя есть доступ, и его роль в каждом.',
  'admin.user.noBranches': 'У пользователя нет доступа ни к одному филиалу.',
  'admin.user.noBranchesAvailable': 'Все филиалы уже добавлены.',
  'admin.user.grantBranch': 'Выдать доступ к филиалу',
  'admin.user.pickBranch': 'Выберите филиал',
  'admin.user.grant': 'Выдать',
  'admin.user.removeBranch': 'Убрать доступ',
  'admin.user.removeBranchConfirm': 'Убрать доступ к филиалу «{{zone}}»?',
  'admin.user.inheritedFromGroup': 'Унаследовано из группы: {{groups}}',
  'admin.user.roleLockedHint': 'Доступ выдан через группу — измените роль или уберите доступ там.',

  'admin.groups.title': 'Группы',
  'admin.groups.subtitle': 'Группы пользователей и группы филиалов — доступ выдаётся группе на группу.',
  'admin.groups.userGroupsTitle': 'Группы пользователей',
  'admin.groups.userGroupsDescription': 'Наборы пользователей, которым можно выдавать доступ одним действием.',
  'admin.groups.newUserGroup': 'Новая группа',
  'admin.groups.newUserGroupPrompt': 'Название группы пользователей',
  'admin.groups.noUserGroups': 'Групп пользователей пока нет.',
  'admin.groups.memberCount': '{{n}} участников',
  'admin.groups.noMembers': 'В группе пока никого нет.',
  'admin.groups.pickUser': 'Выберите пользователя',
  'admin.groups.addMember': 'Добавить',
  'admin.groups.removeMember': 'Убрать из группы',
  'admin.groups.deleteGroup': 'Удалить группу',
  'admin.groups.deleteUserGroupConfirm': 'Удалить группу пользователей «{{name}}»? Участники потеряют доступ, выданный через неё.',
  'admin.groups.grantsOnThisGroup': 'Права, выданные этой группе',

  'admin.groups.branchGroupsTitle': 'Группы филиалов',
  'admin.groups.branchGroupsDescription': 'Наборы филиалов — добавление филиала в группу сразу даёт доступ всем, кому выдана роль на эту группу.',
  'admin.groups.newBranchGroup': 'Новая группа',
  'admin.groups.newBranchGroupPrompt': 'Название группы филиалов',
  'admin.groups.noBranchGroups': 'Групп филиалов пока нет.',
  'admin.groups.zoneCount': '{{n}} филиалов',
  'admin.groups.branchesInGroup': 'Филиалы в группе',
  'admin.groups.noBranchesInGroup': 'Филиалов в группе пока нет.',
  'admin.groups.pickBranch': 'Выберите филиал',
  'admin.groups.addBranch': 'Добавить',
  'admin.groups.removeBranch': 'Убрать из группы',
  'admin.groups.grantsTitle': 'Кому выдан доступ к этой группе',
  'admin.groups.noGrants': 'Доступ пока никому не выдан.',
  'admin.groups.pickUserGroup': 'Выберите группу пользователей',
  'admin.groups.addGrant': 'Выдать',
  'admin.groups.removeGrant': 'Отозвать',
  'admin.groups.deleteBranchGroupConfirm': 'Удалить группу филиалов «{{name}}»? Доступ, выданный через неё, пропадёт.',

  'visits.featureDescription': 'Периодические проверки качества на спотах по шаблону оценки.',
  'visits.enableLabel': 'Включить Визиты для этого филиала',
  'visits.enableHint': 'По умолчанию выключено. При включении в разделе «Live» появится вкладка «Визиты».',
  'visits.templatesTitle': 'Шаблоны оценки',
  'visits.templatesDescription': 'Группы параметров, веса «да»/«нет», коэффициент группы в итоговой формуле.',
  'visits.newTemplate': 'Новый шаблон',
  'visits.newTemplatePrompt': 'Название шаблона',
  'visits.noTemplates': 'Шаблонов пока нет.',
  'visits.zoneCount': '{{n}} филиалов',
  'visits.attachToThisBranch': 'Привязать к этому филиалу',
  'visits.detachFromThisBranch': 'Отвязать от этого филиала',
  'visits.attachToBranchGroup': 'Привязать к группе филиалов…',
  'visits.attachToBranchGroupAction': 'Привязать группу',
  'visits.chooseTemplatePrompt': 'На этом филиале несколько шаблонов визитов — выберите, каким провести визит',
  'visits.attachedBranches': 'Привязанные филиалы',
  'visits.viewMode': 'Просмотр',
  'visits.editMode': 'Редактировать',
  'visits.deleteTemplate': 'Удалить шаблон',
  'visits.deleteTemplateConfirm': 'Удалить шаблон «{{name}}»?',
  'visits.formulaCoefficient': 'коэффициент',
  'visits.deleteGroup': 'Удалить группу',
  'visits.deleteGroupConfirm': 'Удалить группу параметров «{{name}}»?',
  'visits.newGroupPlaceholder': 'Название группы параметров',
  'visits.addGroup': 'Добавить группу',
  'visits.yes': 'да',
  'visits.no': 'нет',
  'visits.deleteParameter': 'Удалить параметр',
  'visits.deleteParameterConfirm': 'Удалить параметр «{{name}}»?',
  'visits.newParameterPlaceholder': 'Название параметра',
  'visits.addParameter': 'Добавить параметр',

  // VISITS-3 (#176): Live-tab «Визиты» — taking/viewing an actual visit.
  'visits.liveTitle': 'Визиты',
  'visits.liveSubtitle': 'Проверки качества на споте',
  'visits.notEnabled': 'Визиты не включены для этого филиала.',
  'visits.startHint': 'Начните визит, чтобы оценить спот по шаблону.',
  'visits.draftInProgress': 'У вас есть незавершённый черновик визита.',
  'visits.startVisit': 'Начать визит',
  'visits.continueDraft': 'Продолжить черновик',
  'visits.empty': 'Визитов пока нет.',
  'visits.draftBadge': 'Черновик',
  'visits.notFound': 'Визит не найден или недоступен.',
  'visits.backToList': 'К списку визитов',
  'visits.submittedAt': 'Сдан {{time}}',
  'visits.readOnly': 'Только просмотр',
  'visits.visitTime': 'Время визита',
  'visits.total': 'Итого',
  'visits.generalComment': 'Общий комментарий по споту',
  'visits.generalCommentPlaceholder': 'Комментарий по споту…',
  'visits.submit': 'Отправить визит',
  'visits.sendToTeam': 'Отправить команде',
  'visits.sendToTeamSent': 'Отправлено',
  'visits.sendToTeamError': 'Не удалось отправить',
  'visits.sendConfirm': 'Подтвердить',
  'visits.chatSectionTitle': 'Telegram-чат (ID и тема)',
  'visits.chatIdLabel': 'ID чата Telegram',
  'visits.chatThreadLabel': 'ID темы (thread)',
  'visits.chatSectionHint': 'Пусто = сообщения идут в чат по умолчанию для этого филиала.',
  'visits.deleteDraft': 'Удалить черновик',
  'visits.deleteDraftConfirm': 'Удалить этот черновик визита? Действие необратимо.',
  'visits.deleteVisit': 'Удалить визит',
  'visits.deleteVisitConfirm': 'Удалить этот визит? Действие необратимо.',
  'visits.noComment': 'Комментария нет.',

  // VISITS-3: report-tab panel + statistics table.
  'visits.reportPanelTitle': 'Визиты',
  'visits.reportPanelEmpty': 'Визитов за этот период не было.',
  'visits.reportPanelCount': '{{n}} визитов',
  'visits.statsColAuthor': 'Кто проводил',
  'visits.statsColTime': 'Время',
  'visits.statsColTotal': 'Итого',
  'visits.statsEmpty': 'За выбранный период визитов не было.',
};

export const en: Dict = {
  'collection.label': 'Collection',
  'collection.all': 'All data',
  'collection.allZones': 'All collection locations',
  'collection.none': 'Without a collection',
  'collection.source': 'Original request',
  'collection.counts': 'Total',
  'collection.ai': 'AI labelled',
  'collection.human': 'Human labelled',
  'collection.remaining': 'Unlabelled',
  'collection.loadError': 'Could not load collection',
  'collection.status.pending': 'Waiting for preparation',
  'collection.status.running': 'Collecting and prelabelling',
  'collection.status.partial': 'Partially prepared: some examples need review or retry',
  'collection.status.failed': 'Preparation failed',
  'collection.removeTitle': 'What should happen to this example?',
  'collection.removeHelp': 'Remove it only from this collection, or delete it from the shared data pool.',
  'collection.unlink': 'Remove from collection',
  'collection.delete': 'Delete everywhere',
  'collection.unlinked': 'Example removed from collection',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.copy': 'Copy',
  'common.copied': 'Copied',
  'common.delete': 'Delete',
  'common.create': 'Create',
  'common.edit': 'Edit',
  'common.loading': 'Loading…',
  'tables.confirmedState': 'Confirmed state — {{state}}',
  'tables.observedAt': 'Data through {{time}}',
  'tables.photoAt': 'Photo — {{time}}',
  'tables.photoUnavailable': 'Photo unavailable',
  'common.retry': 'Retry',
  'common.back': 'Back',
  'common.error': 'Error',
  'common.search': 'Search',
  'common.signOut': 'Sign out',
  'common.account': 'Account',
  'common.openMenu': 'Open menu',
  'common.settings': 'Settings',
  'common.info': 'About this page',
  'layout.branch': 'Branch',
  'common.collapseMenu': 'Collapse menu',
  'common.expandMenu': 'Expand menu',

  'sidebar.usage': 'Usage',
  'sidebar.configuration': 'Configuration',
  'sidebar.group.live': 'Live',
  'sidebar.group.analytics': 'Analytics',
  'sidebar.group.main': 'Main',
  'sidebar.group.settings': 'Settings',
  'sidebar.group.experimental': 'Experimental',
  'sidebar.portfolio': 'All branches',
  'sidebar.dashboard': 'Shift dashboard',
  'sidebar.now': 'Now',
  'sidebar.report': 'Reports',

  // Unified report
  'report.title': 'Reports',
  'report.subtitle': 'What happened at the branch',
  'report.allBranches': 'All branches',
  'report.yesterday': 'yesterday',
  'report.prevDay': 'Previous day',
  'report.nextDay': 'Next day',
  'report.summary': 'Summary',
  'report.heroDay': 'Headline of the day',
  'report.observations': 'Observations',
  'report.calmTitle': 'Day summary',
  'report.allCalm': 'Yesterday went smoothly',
  'report.allCalmSub': 'Layout, queue, tables and tasks — no issues.',
  'report.closed': 'The branch was closed — no data for the day',
  'report.showPrevDay': 'Show previous day',
  'report.details': 'Details',
  'report.collapse': 'Collapse',
  'report.openGrafana': 'Open in Grafana',
  'report.zoom.day': 'Day',
  'report.zoom.week': 'Week',
  'report.zoom.dayShort': 'Day',
  'report.zoom.weekShort': 'Wk',
  'report.zoom.dayTiny': 'D',
  'report.zoom.weekTiny': 'W',
  'report.prevWeek': 'was',
  'report.prevWeekNav': 'Previous week',
  'report.nextWeekNav': 'Next week',
  'report.summaryWeek': 'Week summary',
  'report.noWeek': 'Weekly report not generated yet',
  'report.generatedAt': 'Generated: {{time}}',
  'sidebar.tasks': 'Shift tasks',
  'sidebar.visitsLive': 'Visits',
  'sidebar.setupWizard': 'Setup wizard',
  'sidebar.general': 'Branch',
  'sidebar.zoning': 'Zoning',
  'sidebar.calibration': 'Polygon calibration',
  'sidebar.plan': 'Floor plan',
  'sidebar.checklists': 'Checklists',
  'sidebar.visits': 'Visits',
  'sidebar.salesPlan': 'Sales plan',
  'sidebar.receipts': 'Receipts',
  'sidebar.queuesStaff': 'Queues & team',
  'sidebar.notifications': 'Notifications',
  'sidebar.equipment': 'Equipment',

  // Setup-master wizard (#47)
  'wizard.title.empty': 'Setup wizard',
  'wizard.title.withBranch': 'Setup wizard — {{name}}',
  'wizard.description': 'Step-by-step branch onboarding: jetson bring-up, equipment discovery, zoning, dashboards, chats, hand-off to PM.',
  'wizard.pickBranchHint': 'Pick a branch in the selector above to open the setup wizard.',
  'wizard.openBranchPicker': 'Open branch page',
  'wizard.stage.placeholderBody': 'This stage is still a skeleton — details land in follow-up commits.',
  'wizard.stage.jetson.title': 'Stage 1: Jetson onboarding (curl flow)',
  'wizard.stage.equipment.title': 'Stage 2: Equipment discovery',
  'wizard.stage.zoning.title': 'Stage 3: Zoning',
  'wizard.stage.grafana.title': 'Stage 4: Grafana dashboards',
  'wizard.stage.notifications.title': 'Stage 5: Notifications and customer chat',
  'wizard.stage.handoff.title': 'Stage 6: Hand-off',
  'wizard.summary.jetson.noLc': 'No jetson bound',
  'wizard.summary.jetson.archived': 'Archived',
  'wizard.summary.jetson.done': 'Done — {{done}}/{{total}}',
  'wizard.summary.jetson.inProgress': 'In progress — {{done}}/{{total}} stages',
  'wizard.error.jetson.archived': 'This jetson is archived. Restore the row or bind a different jetson via /admin/local-computers.',
  'wizard.stage.jetson.noLcHint': 'This branch isn’t bound to a jetson yet. Issue a curl token in the LC admin and run one command on the new device.',
  'wizard.stage.jetson.issueToken': 'Issue curl token',
  'wizard.stage.jetson.openLcDetail': 'Open LC detail',
  'wizard.stage.equipment.openTab': 'Open the Equipment tab',
  'wizard.summary.grafana.empty': 'Zone URL: — · Racks: 0 · Checkout zones: 0',
  'wizard.summary.notifications.empty': 'PRS: — · CCS: — · TCS: — · ZRS: —',
  'wizard.summary.handoff.empty': 'PM invites: 0 · Grafana grants: — · Chat invite: —',
  'wizard.blockedReason.noZone': 'Pick a branch to start the setup wizard.',
  'wizard.blockedReason.waitForDockerRunning': 'Waiting on stage 1: the jetson must reach DOCKER_RUNNING.',
  'wizard.blockedReason.waitForCameras': 'Waiting on stage 2: at least one camera must be persisted.',

  'theme.system': 'Theme: system',
  'theme.light': 'Theme: light',
  'theme.dark': 'Theme: dark',

  'branchSelector.placeholder': 'Select branch',
  'branchSelector.search': 'Search branches…',
  'branchSelector.empty': 'No branches',
  'branchSelector.notFound': 'Nothing found',
  'branchSelector.create': 'Create branch',
  'branchSelector.createTitle': 'Create branch',
  'branchSelector.createNameLabel': 'Branch name',
  'branchSelector.createSaving': 'Creating…',
  'branchSelector.createFail': 'Failed to create the branch.',
  'branchSelector.noAccess': 'No access',
  'branchSelector.loadError': 'Failed to load branches',
  'branchSelector.loadErrorHint': 'This is a loading problem, not an access one. Retrying automatically — check your connection.',
  'branchSelector.allBranches': 'All branches',
  'branchSelector.group': 'Branch group',
  'branchSelector.groups': 'Groups',
  'branchSelector.branches': 'Branches',
  'branchSelector.archived': 'Archive',
  'layout.archivedNotice': 'This branch is archived: data is available, analysis cannot be switched back on.',

  'login.title': 'Sign in to Linza Metrics',
  'login.chooseMethod': 'Choose how to sign in',
  'login.submit': 'Sign in',
  'login.submitting': 'Signing in…',
  'login.invalidCreds': 'Invalid username or password.',
  'login.serverError': 'Login server error',
  'login.networkError': 'Server unreachable. Check your connection.',
  'login.telegramError': 'Telegram login failed. Please try again.',
  'auth.usernameLabel': 'Username',
  'auth.passwordLabel': 'Password',
  'auth.or': 'or',
  'auth.orPasswordLogin': 'or sign in with username + password',
  'auth.loginWithPassword': 'Sign in with username + password',
  'auth.signupWithPassword': 'Create account with username + password',
  'auth.backToTelegram': 'Back to Telegram',
  'auth.telegramBlocked': 'Telegram seems to be unavailable on your device.',
  'auth.noAccountPrompt': 'No account?',
  'auth.noAccountCta': 'Create account',
  'auth.haveAccountPrompt': 'Already have an account?',
  'auth.haveAccountCta': 'Sign in',
  'auth.inviteGreeting': 'You are being invited to "{{zone}}"',
  'auth.inviteGreetingSub': 'After signing in you will get the {{role}} role.',
  'auth.switchToSignup': 'Create an account with username + password',
  'auth.switchToLogin': 'I already have an account — sign in',
  'auth.signupSubmit': 'Create account',
  'auth.telegramUnreachable': 'Telegram sign-in is not reachable on this network — use username + password.',
  'auth.signInWithTelegram': 'Sign in with Telegram',
  'auth.oidcExchanging': 'Finishing Telegram sign-in…',
  'auth.oidcMissingCode': 'Telegram did not return an authorization code. Please try again.',
  'auth.oidcStateMismatch': 'Sign-in session expired. Please try again.',
  'auth.oidcExchangeFailed': 'Could not complete Telegram sign-in.',
  'auth.backToLogin': 'Back to sign-in',
  'auth.tgNoBinding': 'This Telegram account is not bound to any user. Ask an admin to bind your Telegram username, or request an invite link.',
  'auth.tgAlreadyBound': 'This Telegram account is already linked to a different user. Sign in with that account, or ask an admin to unlink it.',
  'auth.tgIdentityChanged': 'Your Telegram sign-in has changed and the account was not recognized. Ask an admin to re-bind your Telegram account.',

  // Sidebar section dividers (FE-90)
  'sidebar.section.daily_ops': 'Daily ops',
  'sidebar.section.communication': 'Communication',
  'sidebar.section.insights': 'Insights',
  'sidebar.section.setup': 'Setup',

  // Access management (FE-20)
  'sidebar.access': 'Access',
  'sidebar.statistics': 'Statistics',
  'sidebar.status': 'Status',
  'status.title': 'Status',
  'status.subtitle': 'What needs attention and how it changed vs the previous period',
  'access.title': 'Access management',
  'access.subtitle': 'Zone members and access links.',
  'access.linksTitle': 'Access links',
  'access.createLink': 'Create link',
  'access.addUser': 'Add user',
  'access.noLinks': 'No active links.',
  'access.members': 'Members',
  'access.noMembers': 'No members yet.',
  'access.expiresOn': 'until {{date}}',
  'access.copied': 'Copied',
  'access.persistent.count': '· used {{n}}×',
  'access.copyLink': 'Copy link',
  'access.copyTelegramLink': 'Copy Telegram link',
  'access.revoke': 'Delete link',
  'access.remove': 'Remove member',
  'access.leave': 'Leave branch',
  'access.leaveConfirm': 'Are you sure you want to leave this branch? You will need a new invite to return.',
  'access.you': '(you)',
  'access.pin.badge': 'Persistent link',
  'access.pin.hint': 'Always available and never expires — leave it anywhere durable, e.g. pinned in the branch chat.',
  'access.pin.autoRenew': 'never expires',
  'access.pin.reissue': 'Reissue link',
  'access.pinReissueConfirm': 'Reissue the persistent link? The old link will stop working. If the link was pinned in the branch chat, we will try to update the pinned message automatically.',
  'access.create.title': 'Create access link',
  'access.create.role': 'Role',
  'access.create.expires': 'Valid for',
  'access.create.expires1d': '1 day',
  'access.create.expires7d': '7 days',
  'access.create.expires30d': '30 days',
  'access.create.expires90d': '90 days',
  'access.create.expiresForever': 'No expiry',
  'access.create.oneShot': 'Single-use (burns after first sign-in)',
  'access.create.submit': 'Create',
  'access.add.title': 'Add user',
  'access.add.createTitle': 'Create user',
  'access.add.role': 'Role',
  'access.add.search': 'Find user',
  'access.add.searchSuperuser': 'Find user (or create a new one)',
  'access.add.searchPlaceholder': 'Username',
  'access.add.noMatches': 'No matches found.',
  'access.add.noMatchesScoped': 'No matches among users you share a branch with.',
  'access.add.createWith': 'Create new user "{{username}}"',
  'access.add.usernameLabel': 'Username',
  'access.add.passwordLabel': 'Password',
  'access.add.createSubmit': 'Create and add',
  'invite.title': 'Zone invitation',
  'invite.description': 'You have been invited to "{{zone}}" as {{role}}.',
  'invite.accept': 'Accept invitation',
  'invite.haveAccount': 'I already have an account — sign in',
  'invite.createAccount': 'Create a new account',
  'invite.createAccountHint': 'Pick a username and password. If you already have an account, sign in instead to avoid creating a duplicate.',
  'invite.createAccountAndAccept': 'Create account and accept',
  'invite.or': 'or',
  'invite.invalid': 'This invite link is invalid or has already been used.',
  'invite.goToDashboard': 'Go to dashboard',

  'page.selectBranchFirst': 'Select a branch using the picker above.',
  'branchRequired.title': 'No branch selected',
  'branchRequired.allTitle': 'The all-branches mode is not available on this page',
  'branchRequired.groupTitle': 'The branch-group view is not available on this page',
  'branchRequired.subtitle': 'Pick a branch in the selector at the top to see its data.',
  'dataError.title': 'Could not connect to the server',
  'dataError.retryHint': 'Try refreshing the page in a minute.',
  'dataError.contactPrefix': 'If it keeps happening, please write to',
  'serverStatus.offline.title': 'Looks like you are offline',
  'serverStatus.offline.hint': 'Check your internet connection — the data will load by itself once you are back online.',
  'serverStatus.checking.title': 'Checking the connection to the server…',
  'serverStatus.updating.title': 'The server is updating, please wait a moment',
  'serverStatus.updating.hint': 'Usually about a minute. The page will refresh by itself — no need to press anything.',
  'serverStatus.updating.slow': 'Taking longer than usual, but almost there. The page will refresh by itself.',
  'serverStatus.back.title': 'The server is back — loading the data',
  'serverStatus.noResponse.title': 'The server is not responding',
  'serverStatus.noResponse.hint': 'Checking every few seconds — the page will refresh by itself.',
  'serverStatus.partial.title': 'Some data did not load',
  'serverStatus.partial.hint': 'The server is responding intermittently — retrying automatically.',
  'serverStatus.quiet': 'Not loaded',
  'noBranchAccess.title': 'You do not have access to this branch',
  'noBranchAccess.subtitle': 'Pick another branch in the selector at the top. If you need access, write to',

  // Portfolio (multi-zone overview)
  'portfolio.title': 'All branches',
  'portfolio.subtitle': 'Health summary across all your locations. Issues are sorted to the top.',
  'portfolio.tasks': 'Tasks',
  'portfolio.overdue': '{{n}} overdue',
  'portfolio.pending': '{{n}} open',
  'portfolio.dirtyTables': '{{n}} dirty tables',
  'portfolio.allGreen': 'All clear',
  'portfolio.noZones': 'No accessible zones.',
  'portfolio.goToDashboard': 'Open dashboard',
  'portfolio.showMore': 'Show {{n}} more branches',
  'portfolio.noReport': 'No report for this day',
  'portfolio.noWeekReport': 'No report for this week',
  'portfolio.zoneClosed': 'Closed',
  'portfolio.zoneDarkLc': 'No camera data — the on-site computer looks offline. Please check it.',
  'portfolio.zoneDarkNoLc': 'No camera data today',
  'portfolio.zoneDarkAffected': 'Unavailable: {{components}}',
  'portfolio.openReport': 'Open report',
  'portfolio.day.queuePeak': 'peak {{n}} people at {{time}}',
  'portfolio.day.queuePeakNoTime': 'peak {{n}} people',
  'portfolio.day.tasksLine': '{{done}}/{{total}} tasks',
  'portfolio.day.photoQueue': 'Longest queue',
  'portfolio.day.photoLayoutDrop': 'Biggest display drop',
  'portfolio.day.photoTable': 'Longest uncleaned table',
  'portfolio.day.longestTable': 'Longest uncleaned table: {{name}} · {{m}} min',
  'portfolio.day.longestTableNoName': 'Longest uncleaned table · {{m}} min',
  'portfolio.day.hoverAllDayOk': 'Fine all day',
  'portfolio.day.hoverDayCritical': 'The day has serious issues',
  'portfolio.day.hoverDayAttention': 'The day has minor issues',
  'portfolio.day.hoverClosed': 'The branch is closed on this day per its schedule',
  'portfolio.day.hoverNoReport': 'No report was generated for this day',
  'portfolio.reportLoading': 'Loading report…',
  'portfolio.day.todayOngoing': 'Today is still in progress',
  'portfolio.day.todayOngoingHint': 'The day’s summary appears in the evening, once branches close',
  'portfolio.day.todayForming': 'Report is being prepared',
  'portfolio.day.hoverLayoutBad': 'Fill {{pct}}% below norm · issues for {{h}} h',
  'portfolio.day.hoverLayoutShortage': 'Fill {{pct}}% below norm',
  'portfolio.day.hoverLayoutHours': 'Display issues for {{h}} h',
  'portfolio.day.hoverLayoutIssue': 'There were display issues',
  'portfolio.day.hoverQueuePeak': 'Peak {{n}} people at {{time}}',
  'portfolio.day.hoverQueuePeakNoTime': 'Peak {{n}} people',
  'portfolio.day.hoverQueueIssue': 'The queue ran above norm',
  'portfolio.day.hoverTasks': '{{done}} of {{total}} tasks done',
  'portfolio.day.hoverOpenClose': 'Display fill at opening and at closing',
  'portfolio.day.atOpen': 'open',
  'portfolio.day.atClose': 'close',
  'portfolio.weekFactLayout': 'Shelves {{v}}% full',
  'portfolio.weekFactQueue': 'Avg {{v}} people in queue',
  'portfolio.weekFactTables': '~{{v}} dirty tables a day',
  'portfolio.weekFactTasks': '{{v}}% of tasks done',
  'portfolio.weekDeltaChip': '{{delta}} vs prev week',
  'portfolio.weekLowData': 'not enough data this week',
  'portfolio.weekNoBaseline': 'nothing to compare with',
  'portfolio.weekWorst': 'worst: {{label}} {{delta}}',
  'portfolio.rowTasks': 'Tasks',
  'portfolio.rowTables': 'Tables',
  'portfolio.rowLayout': 'Layout',
  'portfolio.rowQueues': 'Queues',
  'portfolio.needsAttention': 'Needs attention',
  'portfolio.problemsCarousel': 'Branch problems',
  'portfolio.prevSlide': 'Previous problem',
  'portfolio.nextSlide': 'Next problem',
  'portfolio.moreTasks': '+{{n}} more',

  'dashboard.title': 'Shift dashboard',
  'dashboard.subtitle': "Today's tasks and branch status at a glance.",
  'dashboard.cards.tasks': 'Checklist',
  'dashboard.avgCheck.title': 'Average check today',
  'dashboard.upsell.title': 'Usually selling now',
  'dashboard.avgCheck.baseline': 'vs avg of past {{day}}',
  'dashboard.markUndo': 'Undo',
  'dashboard.checking': 'Checking',
  'dashboard.cards.tasksOpenAll': 'Open all',
  'dashboard.fullscreen': 'Full screen',
  'dashboard.hideBar': 'Hide panel — tap an empty spot to bring it back',
  'dashboard.holdToConfirm': 'Keep holding…',
  'dashboard.holdHint': 'Hold the “{{label}}” button to mark it done',
  'dashboard.robotHi': 'Hi! 👋',
  'dashboard.allFixed': 'Great, all good',
  'dashboard.robotHide': 'Hide the robot',
  'dashboard.robotShow': 'Show the robot',
  'dashboard.fullscreenExit': 'Exit full screen',
  'dashboard.zoomIn': 'Zoom in',
  'dashboard.zoomOut': 'Zoom out',
  'dashboard.zoomReset': 'Reset zoom',
  'dashboard.cards.tasksCount': 'Showing {{shown}} of {{total}} · {{hidden}} more hidden',
  'dashboard.cards.tasksDue': 'Due: {{time}}',
  'dashboard.cards.tasksDueTomorrow': 'Due: tomorrow {{time}}',
  'dashboard.cards.tasksEmpty': 'No tasks for today.',
  'dashboard.cards.tables': 'Table cleanliness',
  'dashboard.cards.tablesEmpty': 'All tables are clean.',
  'dashboard.cards.queue': 'Queues',
  'dashboard.cards.salesPlan': 'Sales plan',
  'dashboard.tab.salesPlan': 'Plan',
  'dashboard.salesPlan.now': 'Offer now',
  'dashboard.salesPlan.nothingNow': 'Nothing special right now — regular menu',
  'dashboard.salesPlan.later': 'Later',
  'dashboard.salesPlan.targets': "Today's targets",
  'dashboard.salesPlan.pcs': 'pcs',
  'dashboard.cards.queueGreen': 'Queues are fine',
  'dashboard.cards.queueYellow': '{{n}} at the limit',
  'dashboard.cards.queueRed': '{{n}} over the limit',
  'dashboard.cards.queueNotConfigured': 'Queue zones are not configured for this branch.',
  'dashboard.cards.layout': 'Layout health',
  'dashboard.cards.layoutGreen': 'All shelves are in order',
  'dashboard.tab.layout': 'Layout',
  'dashboard.tab.tables': 'Tables',
  'dashboard.tab.tasks': 'Checklist',
  'dashboard.tab.queue': 'Queue',
  'dashboard.cards.layoutYellow': '{{n}} zones need attention',
  'dashboard.cards.layoutRed': '{{n}} zones are critically empty',
  'dashboard.cards.layoutUnknown': '{{n}} zones not assessed yet',
  'dashboard.cards.tasksNoChecklistAdmin': 'This branch has no checklists yet. Connect them so tasks start appearing for staff.',
  'dashboard.cards.tasksNoChecklistWorker': 'Checklists are not connected. Ask the branch manager to enable them.',
  'dashboard.cards.tasksConfigureChecklists': 'Connect checklists',
  'dashboard.cards.tablesNotConfigured': 'No tables added in zoning yet.',
  'dashboard.cards.layoutNotConfigured': 'No shelves added in equipment yet.',
  'dashboard.cards.tablesClean': 'Table is clean',
  'dashboard.proof.page': 'Page {{page}} of {{total}}',
  'dashboard.proof.holdForCrop': 'Press and hold to see the crop',
  'dashboard.proof.holdForFrame': 'Press and hold to see the full frame',
  'dashboard.noFramesToday': 'No frames today',
  'dashboard.display.full': 'Full frame',
  'dashboard.display.crop': 'Crop',
  'dashboard.display.label': 'Frame view',
  'dashboard.filter.problems': 'Important only',
  'dashboard.filter.all': 'All data',
  'dashboard.filter.label': 'Data',
  'dashboard.controls.label': 'Display',
  'dashboard.filter.allOk': 'All clear',
  'dashboard.proof.okUnits': 'No issues ({{n}})',
  'dashboard.pager.prev': 'Previous',
  'dashboard.pager.next': 'Next',
  'tables.reason.guestItems': 'Guest belongings',
  'tables.rechecking': 'Rechecking',
  'tables.reason.clean': 'Clean',
  'dashboard.status.tablesAllClean': 'All tables are clean',
  'dashboard.status.tablesCheck': 'Tables awaiting check',
  'dashboard.status.tablesDirty': 'Some tables need cleaning',
  'dashboard.status.layoutAllFull': 'Layout is in order',
  'dashboard.status.layoutAttention': 'Some shelves need attention',
  'dashboard.status.queueOk': 'Queues are fine',
  'dashboard.status.queueBusy': 'Some queues are at the limit',
  'dashboard.status.tasksAllDone': 'All tasks are done',
  'dashboard.status.tasksOpen': 'Some tasks are open',
  'dashboard.status.noData': 'No data',
  'dashboard.issueSince': 'since {{time}}',
  'dashboard.sectionOk.tables': 'Tables OK',
  'dashboard.sectionOk.layout': 'Shelf layout OK',
  'dashboard.sectionOk.queue': 'Queues OK',
  'dashboard.sectionOk.tasks': 'Checklist done',
  'dashboard.celebrate.tables': 'All tables are clean',
  'dashboard.celebrate.layout': 'Shelves are in order',
  'dashboard.celebrate.queue': 'Queues are fine',
  'dashboard.celebrate.tasks': 'All tasks are done',
  'dashboard.updateReady': 'An update arrived — reload the page to apply it',
  'dashboard.updated': 'Updated successfully',
  'dashboard.updatedFullscreen': 'Go fullscreen',
  'dashboard.updatedDismiss': 'Not now',
  'dashboard.closedBanner': 'Branch closed · end-of-shift data',
  'dashboard.closedBannerAt': 'Branch closed · opens at {{time}}',
  'dashboard.closedDay.title': 'Day results',
  'dashboard.closedDay.avgTitle': 'Average check today',
  'dashboard.closedDay.checks': '{{n}} checks',
  'dashboard.closedDay.vsBaseline': 'vs avg of past {{day}}',
  'dashboard.closedDay.tasksOf': 'of {{total}} done',
  'dashboard.closedDay.tasksPlanned': 'Tasks today: {{n}}',
  'dashboard.closedDay.dayClosed': 'day closed',
  'dashboard.couldAppear.title': 'What else could appear here',
  'dashboard.couldAppear.desc': 'These sections show up on the dashboard once they are configured for the branch.',
  'dashboard.landing.title': 'Shift dashboard: pick a branch first',
  'dashboard.landing.subtitle': 'Pick a branch in the selector above to open its shift dashboard.',
  'dashboard.apiMissing': 'Couldn’t load the data.',
  'dashboard.branchClosed': 'Branch closed',
  'dashboard.opensAt': 'Opens at {{time}}',
  'dashboard.alwaysOpen': 'No schedule configured',
  'dashboard.showShiftData': 'Show shift data',
  'dashboard.zoneNotFound': 'Branch not found or you don’t have access.',
  'dashboard.backToPortfolio': 'Back to all branches',

  // Plugin teasers
  'dashboard.teaser.configure': 'Configure',
  'dashboard.teaser.checklists.title': 'Checklists are not configured',
  'dashboard.teaser.checklists.desc': 'The checklists plugin creates scheduled tasks for shift workers. Connect it so tasks appear every morning.',
  'dashboard.teaser.checklists.cta': 'Configure checklists',
  'dashboard.teaser.tables.title': 'Table monitoring is not configured',
  'dashboard.teaser.tables.desc': 'This plugin tracks table cleanliness. When a table stays dirty after guests leave, it appears here. Mark tables in zoning to get started.',
  'dashboard.teaser.tables.cta': 'Open zoning',
  'dashboard.teaser.layout.title': 'Shelf layout monitoring is not configured',
  'dashboard.teaser.layout.desc': 'This plugin monitors shelf fill levels in real time. You will see which zones need restocking. Add racks in equipment to get started.',
  'dashboard.teaser.layout.cta': 'Open equipment',
  'dashboard.teaser.queue.title': 'Queue monitoring is not configured',
  'dashboard.teaser.queue.desc': 'This plugin shows current queue length in real time and alerts when it exceeds the limit. Mark queue zones to get started.',
  'dashboard.teaser.queue.cta': 'Open zoning',

  // Welcome card
  'dashboard.welcome.title': 'Nothing here yet',
  'dashboard.welcome.subtitleAdmin': 'Add monitoring zones and checklists — and the dashboard will start showing data.',
  'dashboard.welcome.subtitleWorker': 'Nothing is set up here yet. Contact your branch manager.',
  'dashboard.welcome.cta': 'Open settings',

  // Plugin setup panel (management/general)
  'management.plugins.heading': 'Connected functions',
  'management.plugins.configured': 'Configured',
  'management.plugins.notConfigured': 'Not configured',
  'management.plugins.active': 'Active',
  'management.plugins.noTasks': 'No tasks',
  'management.plugins.paused': 'Paused',
  'management.plugins.noCameras': 'No cameras',
  'management.plugin.checklists': 'Checklists',
  'management.plugin.tables': 'Table monitoring',
  'management.plugin.layout': 'Shelf layout monitoring',
  'management.plugin.queue': 'Queue monitoring',

  'tasks.title': 'Shift tasks',
  'tasks.subtitle': 'Task list for the current branch.',
  'tasks.onlyMine': 'Only mine',
  'tasks.onlyToday': 'Today only',
  'tasks.noChecklistAdmin': 'This branch has no checklists yet. Connect them so tasks start appearing for staff.',
  'tasks.noChecklistWorker': 'Checklists are not connected. Ask the branch manager to enable them.',
  'tasks.prevDay': 'Previous day',
  'tasks.nextDay': 'Next day',
  'tasks.today': 'Today',
  'tasks.dueAt': 'Due {{time}}',
  'tasks.reporterAt': '{{who}} at {{time}}',
  'tasks.commentShow': 'Show comment',
  'tasks.commentHide': 'Hide',
  'tasks.submitReport': 'Submit report',
  'tasks.submitReportTitle': 'Task report',
  'tasks.reportText': 'Comment',
  'tasks.reportTextPlaceholder': 'What you did',
  'tasks.reportPhotos': 'Photos',
  'tasks.reportVideos': 'Videos',
  'tasks.filesSelected': 'Files selected: {{n}}',
  'tasks.addMoreMedia': 'Add more',
  'tasks.takePhoto': 'Take photo',
  'tasks.chooseFromGallery': 'Choose from gallery',
  'tasks.deadline': 'Due',
  'tasks.detail': 'Details',
  'tasks.empty': 'No tasks for today',
  'tasks.statusOverdue': 'Overdue',
  'tasks.statusPreDeadline': 'Due soon',
  'tasks.statusDone': 'Done',
  'tasks.statusPending': 'In progress',
  'tasks.progressDone': '{{done}} of {{total}} done',
  'tasks.remainingCount': '{{n}} left',
  'tasks.overdueCount': '{{n}} overdue',
  'tasks.allDone': 'All tasks closed',
  'tasks.allDoneHint': 'The shift is on track.',
  'tasks.pastAllDoneHint': 'Everything was closed on this day.',
  'tasks.doneSection': 'Done ({{n}})',
  'tasks.planned': 'Planned',
  'tasks.plannedTitle': 'Planned for this day',
  'tasks.plannedCount': 'Tasks planned: {{n}}',
  'tasks.plannedEmpty': 'No tasks are planned for this day.',

  'settings.general': 'Branch',
  'settings.generalDescription': 'Core branch parameters.',
  'settings.zoning': 'Zoning',
  'settings.zoningDescription': 'Annotate camera frames with zones.',
  'settings.plan': 'Floor plan',
  'settings.planDescription': 'Plan image and per-camera calibration onto the plan.',
  'settings.checklists': 'Checklists',
  'settings.checklistsDescription': 'Shift checklist templates.',
  'settings.visits': 'Visits',
  'settings.queuesStaff': 'Queues & team',
  'settings.queuesStaffDescription': 'When to alert about a queue and whether to check that the team arrived before opening.',
  'queuesStaff.people': 'people',
  'queuesStaff.queues.title': 'Queues',
  'queuesStaff.queues.description': 'An alert is sent when the queue reaches this many people.',
  'queuesStaff.queues.empty': 'No queue zone has been drawn yet.',
  'queuesStaff.queues.emptyLink': 'Draw one',
  'queuesStaff.queues.unnamed': 'Queue',
  'queuesStaff.queues.alertFrom': 'alert from',
  'queuesStaff.arrival.title': 'Arrival before opening',
  'queuesStaff.arrival.description': 'In the morning we watch the bar zone and record when the team arrived. It shows up in the day report and statistics.',
  'queuesStaff.arrival.enable': 'Track arrival',
  'queuesStaff.arrival.needsBar': 'Draw the bar zone first.',
  'queuesStaff.arrival.minutesPrefix': 'in place',
  'queuesStaff.arrival.minutesSuffix': 'min before opening',
  'queuesStaff.arrival.peoplePrefix': 'at least',
  'queuesStaff.arrival.messages': 'Morning messages',
  'queuesStaff.arrival.messagesOn': 'If nobody is seen by the set time, we write to the chat and ask the team to show up.',
  'queuesStaff.arrival.messagesOff': 'No chat messages: arrival time only goes to statistics.',
  'queuesStaff.arrival.chatId': 'Chat ID',
  'queuesStaff.arrival.threadId': 'Topic ID',
  'queuesStaff.arrival.chatHint': 'Empty — messages go to the branch main chat.',
  'queuesStaff.arrival.inZone': 'in zone',
  'queuesStaff.arrival.allStaffZones': 'All work zones',
  'queuesStaff.arrival.captureNote': 'Cameras switch on 10 minutes before this time, so early arrivals are visible too.',
  'queuesStaff.arrival.drawNew': 'Draw a new one',
  'queuesStaff.arrival.noZone': 'No arrival zone drawn yet',
  'queuesStaff.arrival.noFrame': 'Camera frame is unavailable right now',
  'zoning.hint.arrival.title': 'Pick a camera and add a zone of type “Standalone zone”',
  'zoning.hint.arrival.body': 'Then select it in the arrival settings. Other zone types affect how the system works: “Queue” counts the queue size, “Work zone” counts staff behind the bar, “Rack” tracks shelf stock, “Table” tracks table cleaning.',
  'zoning.hint.arrival.back': 'Back to arrival settings',
  'settings.visitsDescription': 'Scoring templates for on-site quality checks.',
  'settings.telegram': 'Notifications',
  'settings.telegramDescription': 'Where layout / tables / queues / task notifications go.',
  'telegram.setupHint.title': 'Connect chats for notifications',
  'telegram.setupHint.body': 'Add {{bot}} to your Telegram chat and send /chat_id — the bot will reply with the ID to paste into this table.',
  'telegram.setupHint.threads': 'If the chat uses topics, send the same command inside a topic — it will return the topic ID too.',
  'telegram.targets.header.target': 'Notification',
  'telegram.targets.header.chatId': 'Chat ID',
  'telegram.targets.header.threadId': 'Topic',
  'telegram.targets.layout.label': 'Layout (Выкладка)',
  'telegram.targets.layout.description': 'Shelf images and status, including the "current snapshot" message.',
  'telegram.targets.tables.label': 'Tables',
  'telegram.targets.tables.description': 'Dirty-table alerts.',
  'telegram.targets.queues.label': 'Queues',
  'telegram.targets.queues.description': 'Checkout queue over-limit alerts.',
  'telegram.targets.checklists.label': 'Checklists',
  'telegram.targets.checklists.description': 'Task reminders + overdue messages.',
  'telegram.targets.daily.label': 'Daily report',
  'telegram.targets.daily.description': 'Yesterday\'s digest.',
  'telegram.targets.visits.label': 'Visits',
  'telegram.targets.visits.description': 'Visit card via the "Send to team" button.',
  'telegram.targets.staffArrival.label': 'Arrival before opening',
  'telegram.targets.staffArrival.description': 'In the morning, if the team is not seen by the set time. Empty — main chat.',
  'settings.equipment': 'Equipment',
  'settings.equipmentDescription': 'Cameras and devices.',
  'settings.integrations': 'Integrations',
  'settings.integrationsDescription': 'Grafana dashboards and Telegram chat IDs for alerts.',

  // Integrations page — Grafana section
  'sidebar.grafanaDashboards': 'Integrations',
  'sidebar.integrations': 'Integrations',
  'settings.grafana.title': 'Grafana dashboards',
  'settings.grafana.description': 'Branch-level Grafana URL plus per-rack and per-checkout-zone dashboard IDs.',
  'settings.grafana.zoneUrl': 'Branch dashboard URL',
  'settings.grafana.zoneUrlHint': 'Full URL of the Grafana overview dashboard for this branch. Optional.',
  'settings.grafana.urlSaveError': 'Failed to save dashboard URL.',
  'settings.grafana.racks': 'Rack dashboards',
  'settings.grafana.racksEmpty': 'No racks configured in this branch yet.',
  'settings.grafana.checkoutZones': 'Checkout-zone dashboards',
  'settings.grafana.checkoutZonesEmpty': 'No checkout zones configured in this branch yet.',
  'settings.grafana.col.name': 'Object',
  'settings.grafana.col.dashboardId': 'Dashboard ID',
  'settings.grafana.col.actions': 'Actions',
  'settings.grafana.notSet': 'not set',
  'settings.grafana.respawn': 'Re-spawn',
  'settings.grafana.respawnError': 'Failed to schedule dashboard re-spawn.',
  'settings.grafana.respawnNoPermission': 'You do not have permission to manage branch settings.',
  'settings.grafana.loadError': 'Failed to load objects.',

  // Integrations page — Telegram chat-ID section
  'settings.telegramIntegrations.title': 'Telegram chats for alerts',
  'settings.telegramIntegrations.description': 'Each plugin can send to its own chat and thread. Leave empty to fall back to the global bot configuration.',
  'settings.telegramIntegrations.chatId': 'Chat ID',
  'settings.telegramIntegrations.threadId': 'Thread ID',
  'settings.telegramIntegrations.chatIdPlaceholder': 'e.g. -1001234567890',
  'settings.telegramIntegrations.threadIdPlaceholder': 'optional',
  'settings.telegramIntegrations.saveError': 'Failed to save settings.',
  'settings.telegramIntegrations.loadError': 'Failed to load plugin settings.',
  'settings.telegramIntegrations.periodicReports': 'Daily report',
  'settings.telegramIntegrations.periodicReportsHint': 'Chat for the end-of-day summary (periodic_reports plugin).',
  'settings.telegramIntegrations.checkoutControl': 'Checkout control',
  'settings.telegramIntegrations.checkoutControlHint': 'Alerts for long queues and missing cashiers (checkout_control plugin).',
  'settings.telegramIntegrations.tableControl': 'Table cleanliness',
  'settings.telegramIntegrations.tableControlHint': 'Alerts for dirty tables and shift suggestions (table_control plugin).',
  'settings.telegramIntegrations.opsTasks': 'Shift tasks',
  'settings.telegramIntegrations.opsTasksHint': 'Task reminders and overdue notifications (ops_tasks plugin).',

  'general.branchName': 'Branch name',
  'general.timezone': 'Time zone',
  'general.workingHours': 'Working hours',
  'general.planImage': 'Floor plan',
  'general.planImage.upload': 'Upload image',
  'plan.autoLayoutTitle': 'Auto-layout from detections',
  'plan.autoLayoutHint': 'Tune the parameters so the heatmap traces walking paths and avoids seating areas and walls. Isolation filters mutually-occluding people; aspect and box-size filters drop sitting people and clipped detections.',
  'plan.period.7d': '7 days',
  'plan.period.30d': '30 days',
  'plan.resetParams': 'Reset',
  'plan.loading': 'computing…',
  'plan.selectCamera': 'Pick a camera in the selector above.',
  'plan.noFrame': 'This camera has no stored frames yet.',
  'plan.truncated': 'Slice truncated at 1M detections — shorten the window',
  'plan.layer.heatmap': 'Foot density',
  'plan.layer.points': 'Foot points (sample)',
  'plan.count.raw': 'Total',
  'plan.count.score': 'After score',
  'plan.count.size': 'After size',
  'plan.count.aspect': 'After aspect',
  'plan.count.isolation': 'Clean subset',
  'plan.param.minScore': 'Min YOLO score',
  'plan.param.minScore.hint': 'Detector confidence. Higher = less noise, fewer detections.',
  'plan.param.minBoxH': 'Min box height',
  'plan.param.minBoxH.hint': 'Drops tiny / far / clipped detections.',
  'plan.param.maxBoxH': 'Max box height',
  'plan.param.maxBoxH.hint': 'Drops merged-together boxes and anomalies.',
  'plan.param.minAspect': 'Min aspect (h/w)',
  'plan.param.minAspect.hint': 'Standing person: tall box. Sitting: closer to square.',
  'plan.param.minIsolation': 'Min isolation in frame',
  'plan.param.minIsolation.hint': 'Distance to nearest neighbor in the same frame. Drops groups and sitting companies.',
  'general.planImage.replace': 'Replace',
  'general.planImage.delete': 'Delete',
  'general.zoneType': 'Branch type',
  'general.zoneType.RETAIL_BRANCH': 'Retail branch',
  'general.zoneType.COFFEESHOP': 'Coffee shop',
  'general.zoneType.SHOP': 'Shop',
  'general.zoneType.CANTEEN': 'Canteen',
  'general.zoneType.BUILDING': 'Building',
  'general.zoneType.FLOOR': 'Floor',
  'general.zoneType.HALLWAY': 'Hallway',
  'general.zoneType.ROOM': 'Room',
  'general.zoneType.CLASSROOM': 'Classroom',
  'general.zoneType.GYM': 'Gym',
  'general.zoneType.COWORKING': 'Coworking',
  'general.dangerZone': 'Danger zone',
  'general.archive': 'Archive branch',
  'general.archiveConfirm': 'Archive this branch? It will disappear from the list for all users. Can only be restored via support.',
  'general.archiveConfirmBtn': 'Yes, archive',
  'general.archiving': 'Archiving…',
  'general.archiveError': 'Failed to archive the branch.',
  'branchSelector.showService': 'Show service zones',
  'branchSelector.hideService': 'Hide service zones',
  'branchSelector.showArchived': 'Show archived zones',
  'branchSelector.hideArchived': 'Hide archived zones',

  'camera.loading': 'Loading cameras…',
  'camera.label': 'Camera',
  'camera.placeholder': 'Select camera',
  'camera.search': 'Search cameras…',
  'camera.empty': 'No cameras',
  'camera.notFound': 'Nothing found',
  'camera.online': 'Online',
  'camera.offline': 'Offline',
  'camera.inactive': 'Inactive',

  'zoning.types.rack': 'Rack',
  'zoning.types.shelf': 'Shelf',
  'zoning.types.table': 'Table',
  'zoning.types.queue': 'Queue',
  'zoning.types.order_waiting': 'Order waiting',
  'zoning.types.cashier': 'Cashier',
  'zoning.types.staff': 'Staff zone',
  'zoning.types.standalone': 'Standalone zone',
  'zoning.toolbar.hints': 'Hints',
  'zoning.toolbar.reload': 'Reload frame',
  'zoning.toolbar.selectCamera': 'Select a camera to load a frame',
  'zoning.toolbar.add': 'Add zone',
  'zoning.sidebar.expand': 'Expand',
  'zoning.sidebar.collapse': 'Collapse',
  'zoning.sidebar.resize': 'Resize',
  'zoning.sidebar.pin': 'Pin',
  'zoning.hints.drawing': 'Drawing',
  'zoning.hints.editing': 'Editing',
  'zoning.hints.general': 'General',
  'zoning.hints.draw.pickType': 'Pick a zone type',
  'zoning.hints.draw.pickTypeDesc': 'enter drawing mode',
  'zoning.hints.draw.click': 'Click on the frame',
  'zoning.hints.draw.clickDesc': 'add a point',
  'zoning.hints.draw.repeat': 'Click again on a point',
  'zoning.hints.draw.repeatDesc': 'remove the point',
  'zoning.hints.draw.save': '"Save" button',
  'zoning.hints.draw.saveDesc': 'finish the polygon (min 3 points)',
  'zoning.hints.edit.click': 'Click on a polygon',
  'zoning.hints.edit.clickDesc': 'select it',
  'zoning.hints.edit.shift': 'Shift+click',
  'zoning.hints.edit.shiftDesc': 'add to selection',
  'zoning.hints.edit.edge': 'Click on an edge',
  'zoning.hints.edit.edgeDesc': 'insert a point',
  'zoning.hints.edit.box': 'Drag with the mouse',
  'zoning.hints.edit.boxDesc': 'select multiple points',
  'zoning.hints.edit.del': 'Del / Backspace',
  'zoning.hints.edit.delDesc': 'delete selected points',
  'zoning.hints.edit.undo': 'Ctrl+Z',
  'zoning.hints.edit.undoDesc': 'undo',
  'zoning.hints.escDesc': 'reset points / leave drawing mode',

  'drawing.cancel': 'Cancel',
  'drawing.save': 'Save',
  'drawing.minPoints': 'Add at least 3 points.',
  'drawing.editing': 'Editing',
  'drawing.edit': 'Edit',
  'drawing.delete': 'Delete',
  'drawing.adding': 'Adding',
  'drawing.pointsOf': 'of',
  'drawing.points': 'points',
  'drawing.selectCamera': 'Select a camera to load a frame',
  'drawing.loadingImage': 'Loading image…',
  'drawing.loadingFrame': 'Loading frame…',
  'drawing.deleteTitle': 'Delete polygon',
  'drawing.deleteConfirm': 'Are you sure you want to delete this polygon? This action cannot be undone.',
  'drawing.discardTitle': 'Discard changes?',
  'drawing.discardConfirm': 'The polygon you are editing has unsaved changes. Switch to another polygon without saving?',
  'drawing.discard': 'Discard',
  'drawing.hint.shelfRack': 'Click the rack to attach the shelf',
  'drawing.hint.shelfStart': 'Pick the top-left corner of the shelf',
  'drawing.hint.continueClockwise': 'Continue clockwise',
  'drawing.hint.rackStart': 'Start from the top-left corner, then go clockwise',
  'drawing.hint.tableStart': 'Place 4 points to define the table',
  'drawing.hint.click': 'Click on the frame to add a point',

  'sidebar.zonesTitle': 'Zones and polygons',
  'sidebar.empty': 'No polygons',
  'sidebar.multiCamera': 'Multi-camera zones',
  'sidebar.cameraName': 'Camera {{id}}',
  'sidebar.shelfName': 'Shelf #{{id}}',
  'sidebar.zone': 'Zone',
  'sidebar.moving': 'Moving…',
  'sidebar.serviceZone': 'Service zone',
  'sidebar.standaloneZone': 'Standalone zone',
  'sidebar.mergeWith': 'Merge with another zone:',
  'sidebar.addTo': 'Add to a service zone:',
  'sidebar.pickZone': 'Pick a zone…',
  'sidebar.areasCount': 'polys',
  'sidebar.convertTo': 'Convert to zone type:',
  'sidebar.pickType': 'Pick a type…',
  'sidebar.deleting': 'Deleting…',
  'sidebar.deleteFailed': 'could not delete, changes reverted',
  'sidebar.deleteHint': 'Deleting a zone does not remove its polygons — they become unattached.',
  'sidebar.close': 'Close',

  'time.inMin': 'in {{n}} min',
  'time.minAgo': '{{n}} min ago',
  'time.inH': 'in {{n}} h',
  'time.hAgo': '{{n}} h ago',

  'error.savingName': 'Failed to save the name.',
  'error.savingTimezone': 'Failed to save the time zone.',
  'error.loadingPolygons': 'Failed to load polygon data.',
  'error.loadingFrame': 'Failed to load the frame, please try again later.',
  'error.reloadingFrame': 'Failed to refresh the frame. Showing the previous one.',
  'error.canvasRender': 'Polygon rendering error.',
  'error.boundaryGeneric': 'Something went wrong',
  'error.boundaryRetry': 'Try again',
  'error.general': 'Failed to load data. Try refreshing the page.',
  'tables.tableNum': 'Table {{n}}',
  'tables.requireCleaning': 'Needs cleaning',
  'tables.unknown': 'Unknown state',
  'tables.dirty': 'Dirty',
  'tables.markCleaned': 'Cleaned',
  'layout.markFixed': 'Fixed',
  'layout.status.fixedPending': 'Fixed · checking on camera',
  'tables.openCrop': 'Open table photo',
  'layout.openCrop': 'Open zone photo',
  'layout.status.red': 'Almost empty',
  'layout.status.grey': 'Almost empty',
  'layout.status.orange': 'Noticeably empty',
  'layout.status.yellow': 'Partially empty',
  'layout.status.green': 'Full',
  'layout.status.unknown': 'No data',
  'layout.status.occluded': 'The view is blocked right now',
  'layout.status.occludedShort': 'Blocked',
  'dashboard.lastClearFrame': 'last clear frame at {{time}}',
  'layout.goodRacks': 'All other shelves are OK',
  'queue.size': '{{n}} / {{max}} people',
  'queue.unknown': 'No data',
  'queue.openCrop': 'Open queue frame',

  // Analytics page (/management/analytics)
  'analytics.title': 'Statistics',
  'analytics.subtitle': 'All data for the selected period.',
  'analytics.period.today': 'Today',
  'analytics.period.7d': '7 days',
  'analytics.period.3m': '3 months',
  'analytics.period.allData': 'All data',
  'analytics.period.recommendedTip': 'Pick the recommended period: {{label}}',
  'analytics.tabsNav': 'Statistics sections',
  'analytics.period.30d': '30 days',
  'analytics.period.from': 'Period start',
  'analytics.period.to': 'Period end',
  'analytics.period.yesterday': 'Yesterday',
  'analytics.period.prevWeek': 'Previous week',
  'analytics.tab.layout': 'Layout',
  'analytics.tab.queue': 'Queues & staff',
  'analytics.tab.tables': 'Tables',
  'analytics.tab.tasks': 'Checklists',
  'analytics.tab.conversations': 'Speech',
  'analytics.speech.noMic.title': 'To see this section, a microphone has to be installed at the checkout.',
  'analytics.speech.noMic.summary': 'This section will show customer requests + complaints at the checkout, plus aggregate team metrics on upsell.',
  'analytics.layout.statLabel': 'Avg shelf fill',
  'analytics.layout.vsLabel': 'vs previous period',
  'analytics.layout.chartLabel': 'Shelf fill over period, %',
  'analytics.layout.photosLabel': 'Recent zone photos',
  'analytics.layout.notConfigured': 'Layout monitoring is not configured for this branch.',
  'analytics.queue.statLabel': 'Avg people in queue',
  'analytics.queue.vsLabel': 'vs previous period',
  'analytics.queue.chartLabel': 'Avg people per day',
  'analytics.queue.photosLabel': 'Longest queues',
  'analytics.queue.notConfigured': 'Queue monitoring is not configured for this branch.',
  'analytics.tables.statLabel': 'Dirty events / day (avg)',
  'analytics.tables.medianLabel': 'Usually cleaned within',
  'analytics.tables.p90Label': 'Almost always within',
  'analytics.tables.vsLabel': 'vs previous period',
  'analytics.tables.chartLabel': 'How long dirty tables wait for cleanup, min',
  'analytics.tables.histLabel': 'How long tables wait for cleanup',
  'analytics.tables.histBucket1': '≤ 2 min',
  'analytics.tables.histBucket2': '2–5 min',
  'analytics.tables.histBucket3': '5–15 min',
  'analytics.tables.histBucket4': '> 15 min',
  'analytics.tables.photosLabel': 'Recent table photos',
  'analytics.tables.notConfigured': 'Table monitoring is not configured.',
  'analytics.tables.noData': 'No alert-handling data for this period.',
  'analytics.tasks.statLabel': 'Task completion rate',
  'analytics.tasks.vsLabel': 'vs previous period',
  'analytics.tasks.chartLabel': 'Completion rate over period, %',
  'analytics.tasks.noData': 'No task data for this period.',
  'analytics.noData': 'No data for the selected period.',
  'analytics.grafana.openButton': 'Open detailed charts',
  'analytics.grafana.notMigrated': 'Not all charts are migrated from Grafana yet — more detailed data is available there.',
  'analytics.couldAppear': 'What else could appear here',
  'analytics.addTabs': 'Add tabs',
  'analytics.layout.peakLabel': 'Period peak',
  'analytics.layout.worstLabel': 'Worst day',
  'analytics.layout.ungroupedTitle': 'Uncategorized',
  'analytics.layout.rackCount': '{{n}} racks',
  'analytics.layout.worstMomentTitle': 'Worst moment in period',
  'analytics.layout.worstMomentLine': '{{rack}} · {{date}} · filled to {{pct}}%',
  'analytics.layout.byCategoryTitle': 'By category',
  'analytics.layout.eventCountLabel': 'Issues in period',
  'analytics.layout.totalTimeLabel': 'Time with issues',
  'analytics.layout.worstFillLabel': 'Worst fill',
  'analytics.layout.row.events': 'Issues: {{n}}',
  'analytics.layout.row.noEvents': 'No issues',
  'analytics.layout.eventStats': '{{n}} issues · total duration {{total}} · longest {{longest}}',
  'analytics.layout.eventStatsAllResolved': 'All issues resolved on time.',
  'analytics.layout.noEventsExpanded': 'No layout issues in this period.',
  'analytics.layout.shelfChartLabel': 'Shelf fill on this rack, %',
  'analytics.layout.equiPhotosLabel': 'Rack across the period',
  'analytics.layout.hourRhythmLabel': 'Hour-of-day rhythm (MSK), %',
  'analytics.queue.peakLabel': 'Queue peak',
  'analytics.queue.overlayLabel': 'Queue, kitchen, open cashiers, waiting',
  'analytics.queue.histogramLabel': 'How many minutes had N people in the area',
  'analytics.queue.area.queue': 'Queue',
  'analytics.queue.area.kitchen': 'Kitchen',
  'analytics.queue.area.waiting': 'Waiting',
  'analytics.queue.waitTimeLabel': 'Estimated queue wait time',
  'analytics.queue.workerMatrixLabel': 'Bar staffing at each register load',
  'analytics.queue.workerMatrixKitchen': 'Bar staff',
  'analytics.queue.workerMatrixFront': 'Guests at register',
  'analytics.queue.decreaseSpeedLabel': 'Queue decrease rate (ppl / 15 s) by length',
  'analytics.sectionAnalytics': 'Analytics',
  'analytics.tables.maxLabel': 'Table peak load (99th percentile)',
  'analytics.tables.detailChartLabel': 'People at table over period',
  'analytics.tables.peopleHistLabel': 'Minutes with N people',
  'analytics.tables.stateLabel': 'Table state breakdown',
  'analytics.tasks.completedLabel': 'Completed',
  'analytics.tasks.totalLabel': 'Total tasks',
  'analytics.tasks.onTimeLabel': 'On time',
  'analytics.tasks.timingLabel': 'When tasks were submitted vs deadline',
  'analytics.tasks.chronicFail.title': 'Often not completed',
  'analytics.tasks.chronicFail.empty': 'All tasks are completed reliably (> 70%)',
  'analytics.tasks.chronicFail.rate': 'completion',
  'analytics.tasks.topDone.title': 'Most often completed',
  'analytics.tasks.topDone.empty': 'No tasks reach a steady completion rate (≥ 70%).',
  'analytics.tasks.taskAt': '{{text}} · {{time}}',
  'analytics.tasks.showAll': 'See all (+{{n}})',
  'analytics.tasks.collapse': 'Collapse',
  'analytics.tasks.expand.loading': 'Loading recent reports…',
  'analytics.tasks.expand.empty': 'No reports for this task in the selected period.',
  'analytics.tasks.expand.photosLabel': 'Report photos',
  'analytics.tasks.expand.count': 'Total: {{n}}',
  'analytics.tasks.expand.expandAll': 'Expand all',
  'analytics.tasks.expand.collapseAll': 'Collapse all',
  'analytics.tasks.expand.reportAt': 'submitted {{time}}',
  'analytics.tasks.expand.status.created': 'created',
  'analytics.tasks.expand.status.pending': 'pending',
  'analytics.tasks.expand.status.pre_deadline': 'due soon',
  'analytics.tasks.expand.status.overdue': 'overdue',
  'analytics.tasks.expand.status.done': 'done',

  'language.label': 'Language',
  'language.russian': 'Русский',
  'language.english': 'English',

  // Account / settings page
  'account.title': 'Account settings',
  'account.subtitle': 'Profile, password and interface preferences.',
  'account.profile': 'Profile',
  'account.profileDescription': 'These fields come straight from the server.',
  'account.username': 'Username',
  'account.email': 'Email',
  'account.role': 'Role',
  'account.roleSuperuser': 'Superuser',
  'account.roleStaff': 'Linza staff',
  'account.roleMember': 'Member',
  'account.loadError': 'Could not load account data.',
  'account.password': 'Change password',
  'account.passwordDescription': 'At least {{n}} characters. Confirm with your current password.',
  'account.passwordMinHint': 'At least {{n}} characters.',
  'account.passwordCurrent': 'Current password',
  'account.passwordNew': 'New password',
  'account.passwordConfirm': 'Repeat new password',
  'account.passwordSubmit': 'Change password',
  'account.passwordSubmitting': 'Saving…',
  'account.passwordChanged': 'Password changed.',
  'account.passwordTooShort': 'Password must be at least {{n}} characters long.',
  'account.passwordMismatch': 'Passwords do not match.',
  'account.passwordSameAsCurrent': 'New password must differ from the current one.',
  'account.passwordRejected': 'Server rejected the password (check the current password or its strength).',
  'account.telegram': 'Telegram',
  'account.telegramDescription': 'Link your Telegram account for passwordless sign-in.',
  'account.telegramBindPrompt': 'Click the button below to link your Telegram account.',
  'account.telegramBindSuccess': 'Telegram linked successfully.',
  'account.telegramBindError': 'Failed to link Telegram. Please try again.',
  'account.telegramAlreadyTaken': 'This Telegram account is already linked to another user.',
  'account.telegramBindCta': 'Link Telegram',
  'account.telegramBound': 'Telegram linked:',
  'account.telegramPendingFirstLogin': '(admin linked @username; awaiting your first Telegram sign-in)',
  'account.appearance': 'Appearance',
  'account.appearanceDescription': 'Theme and interface language.',
  'telegram.pin.title': 'Pinned branch message',
  'telegram.pin.subtitle': 'Branch links: personal cabinet and chat invite. The bot pins it in the chat only on explicit click.',

  'telegram.pin.field.chatInvite': 'Branch chat invite (t.me/+…)',
  'telegram.pin.previewLabel': 'Message preview',
  'telegram.pin.chatIdLabel': 'Override recipient chat ID',
  'telegram.pin.chatIdHint': 'Defaults to the branch chat from the table above. Fill in to send to a different chat one-off.',
  'telegram.pin.threadIdLabel': 'Chat topic (message_thread_id)',
  'telegram.pin.threadIdHint': 'For forum chats — the id of the target topic. Telegram gives bots no way to list a chat\'s topics, so it has to be entered by hand: open the topic in Telegram Web and take the number from a message link. Empty sends to the chat\'s General section.',
  'telegram.pin.threadIdPlaceholder': '3',
  'telegram.pin.adminNote': 'The bot must be made a chat administrator — otherwise it cannot pin the message.',
  'telegram.pin.send': 'Send and pin',
  'telegram.pin.update': 'Update pin',
  'telegram.pin.notPinned': 'Not currently pinned',
  'telegram.pin.lastPinnedAt': 'Pinned: {{at}}',
  'telegram.pin.sendFailed': 'Failed to send to chat.',
  'telegram.pin.chatIdPlaceholder': '−1001234567890',
  'pwa.install.title': 'Install as an app',
  'pwa.install.iosHowTo': 'In Safari: Share → Add to Home Screen.',
  'pwa.install.browserMenuHint': 'If the button didn’t work — use the browser menu (⋮) → “Install app”.',
  'pwa.install.cta': 'Install',
  'pwa.install.later': 'Later',
  'pwa.install.laterHint': 'You can install later from your profile settings (bottom-left corner).',
  'pwa.installCard.title': 'Install app',
  'pwa.installCard.subtitle': 'Same interface as this site, but launched from the home-screen icon. Takes about {{size}}.',
  'common.dismiss': 'Dismiss',
  'common.ok': 'OK',
  'account.themeLabel': 'Theme',
  'account.languageLabel': 'Interface language',
  'theme.lightShort': 'Light',
  'theme.darkShort': 'Dark',
  'theme.systemShort': 'System',

  // Telegram bot settings page
  'telegram.loading': 'Loading settings…',
  'telegram.notConfigured': 'No Telegram bot is configured for this branch yet. Click below to start.',
  'telegram.connectAction': 'Connect Telegram',
  'telegram.connecting': 'Initialising…',
  'telegram.fetchFailed': 'Could not load settings.',
  'telegram.initFailed': 'Could not initialise settings.',
  'telegram.saveFailed': 'Could not save settings.',
  'telegram.saved': 'Saved.',
  'telegram.saving': 'Saving…',
  'telegram.mainSection': 'Main notifications chat',
  'telegram.mainDescription': 'Receives shelf notifications and other system messages. The checklist chat is configured separately on the Checklist tab.',
  'telegram.prodChatLabel': 'Main chat ID (prod_chat_id)',
  'telegram.prodChatHint': 'Telegram group chat ID. Negative number for groups.',
  'telegram.prodThreadLabel': 'Thread ID (prod_thread_id)',
  'telegram.prodThreadHint': 'Optional. Thread ID for supergroups with topics.',
  'telegram.systemSection': 'System chats',
  'telegram.systemWarning': 'Changing these fields affects debug and service messages for every zone inheriting these settings.',
  'telegram.debugChatLabel': 'Debug chat ID',
  'telegram.cancelChatLabel': 'Cancel chat ID',

  'sidebar.summaries': 'Daily Summaries',
  'summaries.title': 'Daily Summaries',
  'summaries.subtitle': 'Daily end-of-day reports for this branch.',
  'summaries.prevDay': 'Previous day',
  'summaries.nextDay': 'Next day',
  'summaries.today': 'Today',
  'summaries.noReport': 'No report has been generated for this day yet.',
  'summaries.statusPending': 'Awaiting confirmation',
  'summaries.statusConfirmed': 'Confirmed',
  'summaries.statusCancelled': 'Cancelled',
  'summaries.loading': 'Loading report…',
  'summaries.generatedAt': 'Generated: {{time}}',
  'summaries.layoutPhotos': 'Layout throughout the day',
  'summaries.queuePhotos': 'Queue throughout the day',
  'summaries.photosCardTitle': 'Characteristic frames of the day',
  'summaries.chatReportTitle': 'Chat report',
  'summaries.dashboardsGrafana': 'Grafana dashboards',
  'summaries.kadryLayoutTitle': 'Key frames of the day: Layout',
  'summaries.kadryQueueTitle': 'Key frames of the day: Queue',
  'summaries.tableLongestTitle': 'Longest uncleaned table',
  'summaries.tablesLongestTitle': 'Longest uncleaned tables',
  'summaries.tasksDone': 'Done {{done}} of {{total}}',
  'summaries.tableCleanupTitle': 'Table cleanup',
  'report.day.queueCardTitle': 'Queue over the day',
  'report.day.queueLen': 'Queue, people',
  'report.day.openCashiers': 'Open cashiers',
  'report.day.queuePhotos': 'Queue frames over the day',
  'report.day.racksCardTitle': 'Layout over the day',
  'report.day.rackPicker': 'Rack',
  'report.day.shelfChartLabel': 'Shelf fill over the day',
  'report.day.rackPhotos': 'Rack frames over the day',
  'report.day.expand': 'Expand to fullscreen',
  'report.day.zoomReset': 'Reset',
  'report.day.zoomHint': 'Drag to select a period to zoom in · double-tap to return to the whole day',
  'report.day.zoomHintRange': 'Drag to select a period to zoom in · double-tap to return to the whole period',
  'report.day.loadingFrames': 'Loading frames for the selected period…',
  'report.day.allRacks': 'All',
  'report.day.kitchenStaff': 'Behind the bar',
  'report.day.noDirtyTables': 'No long-uncleaned tables detected',
  // #264: pencil-gated (daily_report.manage) correction of a false dirty-table incident.
  'report.day.editIncidents': 'Edit incidents',
  'report.day.removeIncident': 'Correct this incident',
  'report.day.removeIncidentFailed': 'Failed to correct the incident. Please try again.',
  'report.day.correctIncidentFree': 'Table is free',
  'report.day.correctIncidentOccupied': 'Table is occupied',
  'report.day.correctIncidentShifted': 'Table is out of place',
  'report.day.correctIncidentNative': 'Native table objects',
  'report.day.correctFromPhoto': 'Correct from this photo',
  'report.day.correctScopeFromHere': 'From this photo to the end',
  'report.day.correctScopeOnlyThis': 'This photo only',
  'report.day.correctPersonal': 'Personal belongings',
  'report.day.correctFood': 'Food / drinks',
  'report.day.correctDirty': 'Dirty dishes / trash',
  'report.day.correctScope': 'Apply correction to',
  'report.day.correctScopeEpisode': 'Whole episode',
  'report.day.correctPresence': '1. Is the table occupied?',
  'report.day.correctPosition': '2. Is the table in position?',
  'report.day.correctInFrame': 'In position',
  'report.day.correctSurface': '3. What is on the table? Select all that apply',
  'report.day.correctCleanHint': 'If none of these objects are present, leave all boxes unchecked.',
  'report.day.correctTrainingHint': 'These labels apply to the selected period. Crops will enter the data pool as human-labelled.',
  'report.tables.stripsDayTitle': 'Table states over the day',
  'report.tables.stripsWeekTitle': 'Table states over the week',
  'report.tables.stripsTitle': 'Table states',
  'report.tables.newFeature': 'New feature — data may be imprecise',
  'report.tables.stateFree': 'Free',
  'report.tables.stateOccupied': 'Occupied',
  'report.tables.stateDirty': 'Uncleaned',
  'report.tables.stateShifted': 'Table out of place',
  'report.tables.stateUnknown': 'Hard to determine',
  'tables.spoiledReason.several_tables': 'several tables in frame',
  'tables.spoiledReason.obstructed': 'table obstructed',
  'tables.spoiledReason.glare': 'glare',
  'report.tables.stateNoData': 'No data',
  'report.tables.stateOffHours': 'Outside working hours',
  'report.tables.durationMin': '{{mins}} min',
  'report.tables.durationHM': '{{h}} h {{m}} min',
  'report.tables.durationH': '{{h}} h',
  'report.week.tablesMedian': 'Median cleanup',
  'report.week.tablesP90': '90th percentile',
  'report.week.tablesNoData': 'No dirty tables this week',
  'report.week.layoutTitle': 'Layout over the week',
  'report.week.queueTitle': 'Queue over the week',
  'report.week.dropsTitle': 'Longest fill drops',
  'report.week.dropLabel': '{{mins}} min drop',
  'report.week.percentilesTitle': 'Typical layout over the week',
  'report.week.showOtherRacks': 'Show: {{racks}}',
  'report.week.hideOtherRacks': 'Hide extra racks',
  'report.week.tasksNotDone': 'Not completed',
  'weeklyReport.layoutHighlights': 'Layout — characteristic moments of the week',
  'weeklyReport.queueHighlights': 'Queue — characteristic moments of the week',
  'summaries.dashboards': 'Dashboards:',
  'summaries.cancelledPlaceholder': 'Not enough data to report.',
  'summaries.actions.edit': 'Edit',
  'summaries.actions.cancel': 'Cancel report',
  'summaries.actions.confirm': 'Confirm',
  'summaries.actions.send': 'Send to production chat',
  'summaries.actions.editTitle': 'Edit report',
  'summaries.actions.editDescription': 'Saving will also update the Telegram message.',
  'summaries.actions.save': 'Save',
  'summaries.actions.discard': 'Cancel',
  'summaries.actions.confirmCancelTitle': 'Cancel report?',
  'summaries.actions.confirmCancelDescription': 'The UI will show "Not enough data to report." The Telegram message will also be marked cancelled.',
  'summaries.actions.confirmSendTitle': 'Send to production chat?',
  'summaries.actions.confirmSendDescription': 'The report will be copied to the branch production chat and marked as confirmed.',
  'summaries.actions.errorEdit': 'Failed to save the report.',
  'summaries.actions.errorConfirm': 'Failed to confirm the report.',
  'summaries.actions.errorCancel': 'Failed to cancel the report.',
  'summaries.actions.errorSend': 'Failed to send the report.',
  'summaries.queue.prev': 'Previous unverified',
  'summaries.queue.next': 'Next unverified',
  'summaries.queue.position': '{{index}} of {{total}} pending',
  'summaries.queue.outside': '{{total}} pending',
  'summaries.unsentQueue.prev': 'Previous unsent',
  'summaries.unsentQueue.next': 'Next unsent',
  'summaries.unsentQueue.position': '{{index}} of {{total}} unsent',
  'summaries.unsentQueue.outside': '{{total}} unsent',
  'sidebar.weeklyReport': 'Weekly Report',
  'weeklyReport.title': 'Weekly Report',
  'weeklyReport.subtitle': 'Week-over-week dynamics for this branch.',
  'weeklyReport.prevWeek': 'Previous week',
  'weeklyReport.nextWeek': 'Next week',
  'weeklyReport.noReport': 'No report has been generated for this week yet.',
  'weeklyReport.loading': 'Loading report…',
  'weeklyReport.generatedAt': 'Generated: {{time}}',
  'weeklyReport.weekOf': 'Week of {{from}} – {{to}}',
  'weeklyReport.notConfigured': 'Plugin not configured',
  'weeklyReport.noData': 'No data for this period',
  'weeklyReport.layout': 'Shelf fill',
  'weeklyReport.layoutDesc': 'Average shelf fill percentage',
  'weeklyReport.queue': 'Queue',
  'weeklyReport.queueDesc': 'Average number of people in queue',
  'weeklyReport.tasks': 'Tasks',
  'weeklyReport.tasksDesc': 'Checklist completion rate',
  'weeklyReport.tables': 'Tables',
  'weeklyReport.tablesDesc': 'Average dirty tables per day',
  'weeklyReport.prevWeekLabel': 'Previous:',
  'weeklyReport.prevInParens': 'Value in parentheses is the previous week.',
  'weeklyReport.notConfiguredHeading': 'Not connected',
  'weeklyReport.unitPersons': 'ppl.',
  'weeklyReport.unitItems': 'items',
  'role.zone_admin': 'Admin',
  'role.zone_manager': 'Manager',
  'role.zone_employee': 'Employee',
  'role.line_worker': 'Line worker',
  'role.chain_office': 'Chain office',
  'dashboard.summaryTitle': "Yesterday's summary",
  'dashboard.summaryEmpty': 'No report generated for yesterday yet.',
  'dashboard.summaryLink': 'All daily summaries →',
  'sidebar.heatmap': 'Heatmap',
  'conversations.internal.recordedAt': 'Recorded',
  'conversations.internal.recordedUnknown': 'recording time unknown (legacy clip)',
  // Clip statuses (the Linza-staff raw-data section)
  'conversations.status.PENDING': 'Processing',
  'conversations.status.RECORDING': 'Recording',
  'conversations.status.TRANSCRIBED': 'Transcribed',
  'conversations.status.ANALYZED': 'Analyzed',
  'conversations.status.NO_SPEECH': 'No speech',
  'conversations.status.NO_AUDIO': 'No audio',
  'conversations.status.NOT_CONVERSATION': 'Not a customer conversation',
  'conversations.search.placeholder': 'Search conversation text',
  'conversations.search.addChip': 'Special filter: upsell, communication, loyalty, problem, conversation id',
  'conversations.overview.pickValue': 'Put this value into search',
  'conversations.overview.pickPhrase': 'Search for it',
  'conversations.overview.otherPhrases': 'other',
  'conversations.search.button': 'Search',
  'conversations.search.reset': 'reset',
  'conversations.search.found': 'Conversations found: {{count}} — for «{{q}}» in the selected period.',
  'conversations.search.empty': 'Nothing found in the selected period.',
  'conversations.table.showPartial': 'show partially recorded',
  'conversations.table.hidePartial': 'hide partially recorded',
  'conversations.status.PARTIAL': 'Partial recording',
  'conversations.status.FAILED': 'Failed',
  // Collapsible conversation rows
  'conversations.detail.dialogue': 'Reconstructed dialogue',
  'conversations.dialogue.restored': 'Restored',
  'conversations.dialogue.raw': 'As recognised',
  'conversations.dialogue.showSource': 'source',
  'conversations.dialogue.hideSource': 'hide source',
  'conversations.dialogue.showPlain': 'Show raw text',
  'conversations.dialogue.showParsed': 'show parsed utterances',
  'conversations.dialogue.cashier': 'Cashier',
  'conversations.dialogue.priorTitle': 'Said before this recording starts — audible at the end of the previous conversation',
  'conversations.dialogue.guest': 'Guest',
  'conversations.transcript.beep': 'payment',
  'conversations.transcript.scan': 'card tapped',
  'conversations.transcript.chime': 'chime · notification or QR',
  'conversations.transcript.print': 'receipt printing',
  'conversations.transcript.unclear': 'unclear speech · {{sec}}s',
  'conversations.transcript.unclearFar': 'faint voice, guest or room · {{sec}}s',
  'conversations.transcript.insert': 'another voice cuts in · {{sec}}s',
  'conversations.transcript.murmur': 'short voice sound (“mm?”, “uh-huh”) · {{sec}}s',
  'conversations.transcript.noise': 'room noise · {{sec}}s',
  'conversations.transcript.taps': 'tapping at the till · {{sec}}s',
  'conversations.transcript.parts': 'two voices in one utterance',
  'conversations.transcript.silence': 'silence · {{sec}}s',
  'conversations.dialogue.pause': 'pause · {{sec}}s',
  'conversations.dialogue.pauseTitle': 'Pause',
  'conversations.dialogue.pauseSec': '{{sec}}s',
  'conversations.dialogue.event.payment': 'Payment',
  'conversations.dialogue.event.scan': 'License scanned',
  'conversations.dialogue.event.chime': 'Chime · notification or QR',
  'conversations.dialogue.event.print': 'Receipt printing',
  'conversations.dialogue.event.hz': '{{hz}} Hz beep',
  'conversations.dialogue.settings': 'Player settings',
  'conversations.dialogue.oneSegment': 'Play one segment',
  'conversations.dialogue.oneSegmentHint': 'Clicking a line or a track segment plays only that segment and stops at its end.',
  'conversations.dialogue.flagForMarkup': 'Flag for labelling',
  'conversations.dialogue.seekHint': 'Jump to this point in the recording',
  'conversations.dialogue.noSource': 'Reconstructed from context — not present in the recording',
  'conversations.dialogue.sourceHint': 'Show how this was recognised',
  'conversations.detail.transcript': 'Transcript',
  // 22-criteria checklist
  'conversations.checklist.title': 'Checklist (22 criteria)',
  'conversations.stage.greeting': 'Greeting',
  'conversations.stage.order': 'Taking the order',
  'conversations.stage.upsell': 'Upsell',
  'conversations.stage.loyalty': 'Loyalty programme',
  'conversations.stage.payment': 'Payment and closing',
  'conversations.stage.closing': 'Closing',
  'conversations.stage.manner': 'Manner',
  'conversations.stage.skipped': 'stage skipped',
  'conversations.checklist.notRated': 'Not rated ({{n}})',
  'conversations.checklist.notRatedOpen': '{{n}} criteria not rated — view',
  'conversations.checklist.hiddenOpen': 'Hidden parameters ({{n}})',
  'conversations.checklist.item.greeting': 'Greeted the guest',
  'conversations.checklist.item.greeting_informal': 'Greeting was informal',
  'conversations.checklist.item.asked_volume': 'Asked about size',
  'conversations.checklist.item.client_named_volume': 'Guest named the size',
  'conversations.checklist.item.asked_here_or_togo': 'Asked: here or to go',
  'conversations.checklist.item.offered_ceramic': 'Offered ceramic',
  'conversations.checklist.item.repeated_order': 'Repeated the order',
  'conversations.checklist.item.warned_wait_before_pay': 'Warned about the wait before payment',
  'conversations.checklist.item.asked_hot_cold': 'Asked: hot or cold',
  'conversations.checklist.item.client_asked_togo': 'Guest asked for to-go',
  'conversations.checklist.item.client_own_cup': 'Guest brought their own cup',
  'conversations.checklist.item.own_cup_fulfilled': 'Poured into the guest cup',
  'conversations.checklist.item.upsell_offered': 'Offered something extra',
  'conversations.checklist.item.upsell_filter_instead_americano': 'Offered filter instead of americano',
  'conversations.checklist.item.upsell_item': 'What was offered',
  'conversations.checklist.item.upsell_types': 'Upsell type',
  'conversations.checklist.choice.upsell_complementary': 'product pairing',
  'conversations.checklist.choice.upsell_seasonal': 'seasonal',
  'conversations.checklist.choice.upsell_margin': 'high-margin',
  'conversations.checklist.choice.upsell_daypart': 'daypart',
  'conversations.checklist.choice.upsell_open_question': 'open «anything else?»',
  'conversations.checklist.choice.upsell_anything_else': 'Anything else?',
  'conversations.checklist.choice.upsell_addons': 'sugar-syrup-cinnamon',
  'conversations.checklist.choice.upsell_food': 'food with the drink',
  'conversations.checklist.choice.upsell_better_choice': 'better option than chosen',
  'conversations.checklist.item.upsell_food_items': 'Food offered',
  'conversations.checklist.item.upsell_better_items': 'Suggested swap',
  'conversations.checklist.item.upsell_addons_syrup': 'Offered syrup',
  'conversations.checklist.item.loyalty_phrase': 'How the programme was named',
  'conversations.overview.title': 'Summary',
  'conversations.overview.analyzed': 'conversations analysed: {{n}}',
  'conversations.overview.of': 'of {{n}}',
  'conversations.overview.list': 'list · {{n}}',
  'conversations.overview.all': 'all',
  'conversations.overview.play': 'Play',
  'conversations.overview.stop': 'Stop',
  'conversations.overview.open': 'open',
  'conversations.overview.requested': 'Asked for',
  'conversations.overview.answer': 'Answer',
  'conversations.overview.missingGoods': 'Missing:',
  'conversations.overview.problems': 'Problems',
  'conversations.overview.noProblems': 'No problems in this period',
  'conversations.overview.page': '{{page}} of {{pages}}',
  'conversations.overview.examples': 'Examples',
  'conversations.overview.phrases': 'Wording',
  'conversations.overview.showMore': 'show {{n}} more',
  'conversations.overview.hideList': 'collapse list',
  'conversations.checklist.item.upsell_weak': 'weak offer only',
  'conversations.problem.kind.out_of_stock': 'out of stock',
  'conversations.problem.kind.dialogue': 'conversation',
  'conversations.problem.kind.product': 'product',
  'conversations.problem.kind.cafe': 'café',
  'conversations.problem.severity.low': 'minor',
  'conversations.problem.severity.medium': 'noticeable',
  'conversations.problem.severity.high': 'serious',
  'conversations.detail.problems': 'Problems',
  'conversations.checklist.item.upsell_accepted': 'Guest accepted',
  'conversations.checklist.item.asked_loyalty': 'Asked about the programme',
  'conversations.checklist.item.named_license_surfer': 'Called it «surfer licence»',
  'conversations.checklist.item.offered_loyalty_signup': 'Offered to sign up',
  'conversations.checklist.item.client_has_loyalty': 'Guest is in the programme',
  'conversations.checklist.item.guest_showed_loyalty': 'Guest showed it themselves',
  'conversations.checklist.item.client_agreed_signup': 'Guest agreed to sign up',
  'conversations.checklist.item.named_total': 'Named the total',
  'conversations.checklist.item.payment_taken': 'Took the payment',
  'conversations.checklist.item.asked_receipt': 'Asked about the receipt',
  'conversations.checklist.item.positive_closing': 'Positive closing line',
  'conversations.checklist.item.told_wait_time': 'Gave a wait-time estimate',
  'conversations.checklist.item.active_communication': 'Active communication',
  'conversations.checklist.item.interesting_communication': 'Interesting, lively talk',
  'conversations.checklist.item.friendly': 'Clearly friendly',
  'conversations.checklist.item.dry_minimal': 'Dry, minimal talk',
  'conversations.checklist.item.rude': 'Clear rudeness',
  'conversations.checklist.item.address_on_vy': 'Formal «you»',
  'conversations.checklist.yes': 'yes',
  'conversations.checklist.no': 'no',
  'conversations.checklist.na': 'N/A',
  'conversations.row.problem': 'Problem',
  'conversations.checklist.vy': 'formal (вы)',
  'conversations.checklist.ty': 'informal (ты)',
  'conversations.checklist.group.greeting': 'Greeting',
  'conversations.checklist.group.politeness': 'Politeness & mood',
  'conversations.checklist.group.upsell': 'Upsell',
  'conversations.checklist.group.orderDetails': 'Order details',
  'conversations.checklist.group.loyalty': 'Loyalty program',
  'conversations.checklist.item.greeting_formal': 'Formal greeting',
  'common.prev': 'Prev',
  'common.next': 'Next',
  'heatmap.title': 'Seating Analytics',
  'heatmap.subtitle': 'Heatmaps and zone statistics for the selected period.',
  'heatmap.loading': 'Loading data…',
  'heatmap.error': 'Failed to load data.',
  'heatmap.period.7d': '7 days',
  'heatmap.period.30d': '30 days',
  'heatmap.period.8we': '8 weekend days',
  'heatmap.period.10wd': '10 workdays',
  'heatmap.periodLabel': 'Period',
  'heatmap.layerLabel': 'Map layer',
  'heatmap.type.scatter': 'Scatter',
  'heatmap.type.gradient': 'Gradient',
  'heatmap.type.isolines': 'Isolines',
  'heatmap.compareOn': 'Compare',
  'heatmap.compareOff': 'Single view',
  'heatmap.compareExit': 'Exit compare',
  'heatmap.compareHint': 'Compare two periods or branches side by side.',
  'heatmap.thisZone': 'This branch',
  'heatmap.comparedZone': 'Compared branch',
  'heatmap.overlayAlt': 'Floor plan heatmap',
  'heatmap.noFloorplan': 'Floor plan not configured — contact Linza team.',
  'heatmap.insight.topZone': '{{name}} is occupied {{ratio}}× more than average',
  'heatmap.barchart.title': 'Zone popularity',
  'heatmap.barchart.metric': 'Average people present',
  'heatmap.barchart.avgWhenOccupied': '{{avg}} ppl when present',
  'heatmap.barchart.hoursPerDay': '{{hours}} h/day',
  'heatmap.barchart.groupSizeHistogram': 'Group sizes:',
  'heatmap.barchart.hint': 'Click a zone to see time-of-day distribution.',
  'heatmap.tod.title': 'Time of day',
  'heatmap.tod.mon': 'Mon', 'heatmap.tod.tue': 'Tue', 'heatmap.tod.wed': 'Wed',
  'heatmap.tod.thu': 'Thu', 'heatmap.tod.fri': 'Fri', 'heatmap.tod.sat': 'Sat',
  'heatmap.tod.sun': 'Sun',
  'heatmap.tod.cellTooltip': '{{day}} {{hour}}:00 — ≈ {{val}} ppl',
  'heatmap.tod.error': 'Failed to load time-of-day data.',
  'heatmap.compare.error': 'Failed to load comparison data.',
  'heatmap.empty.title': 'No seating zones marked up',
  'heatmap.empty.desc': 'To get seating analytics, mark up tables and waiting zones:',
  'heatmap.empty.step1': 'Open "Zoning" in branch settings.',
  'heatmap.empty.step2': 'Draw a polygon for each table or waiting zone.',
  'heatmap.empty.step3': 'Give each zone a descriptive name.',
  'heatmap.empty.cta': 'Open zoning →',
  'heatmap.seatingCta.title': 'Annotate seating zones to see detailed per-table stats',
  'heatmap.seatingCta.button': 'Annotate →',
  'heatmap.unnamed.zone': 'Zone {{id}}',
  'heatmap.unnamed.camera': 'Camera {{id}}',
  'heatmap.camera.noImage': 'No camera image available',
  'heatmap.camera.loadingFrame': 'Loading frame…',
  'heatmap.camera.frameFetchFailed': 'Failed to load frame',
  'heatmap.camera.loadingOverlays': 'Loading zones…',
  'heatmap.camera.loadingHeatmap': 'Loading heatmap…',
  'heatmap.camera.loadingHotZones': 'Loading activity zones…',
  'heatmap.layer.frame': 'Frame',
  'heatmap.layer.zones': 'By zones',
  'heatmap.layer.heatmap': 'Heatmap',
  'heatmap.layer.hotzones': 'Activity zones',
  'heatmap.workingHours.label': 'Working hours: {{hours}}',
  'heatmap.planCta.title': 'Upload a floor plan to view heatmaps on the plan',
  'heatmap.planCta.button': 'Upload floor plan →',
  'heatmap.isoline.tooltipHours': '{{hours}} h/day people are present at this point',
  'heatmap.isoline.tooltipMinutes': '{{minutes}} min/day people are present at this point',
  'heatmap.colorbar.peak': 'h/day',
  'heatmap.colorbar.cutoffMinutes': '{{minutes}} min/day',
  'heatmap.cellTod.byDay': 'By day',
  'heatmap.cellTod.byHour': 'By hour',
  'heatmap.coverage.noDataTitle': 'No data',
  'heatmap.coverage.noDataHint': 'The camera was not recording during business hours in the selected period.',
  'heatmap.coverage.partialChip': 'Some data missing ({{pct}}%)',
  'heatmap.coverage.detailRecorded': 'Recorded',
  'heatmap.coverage.detailMissing': 'Missing',
  'heatmap.coverage.detailFullDays': 'Days with full recording',
  'heatmap.coverage.detailNote': 'The heatmap is built from the available data and may be imprecise.',
  'heatmap.freedraw.start': 'Draw region',
  'heatmap.freedraw.startShort': 'Draw',
  'heatmap.freedraw.cancel': 'Clear',
  'heatmap.freedraw.hint': 'Outline a region with clicks and close the loop',
  'heatmap.freedraw.computing': 'Computing…',
  // Polygon edit form (UnifiedEditForm)
  'zoning.form.titleCreate': 'Create polygon',
  'zoning.form.titleEdit': 'Edit polygon',
  'zoning.form.labelType': 'Type',
  'zoning.form.labelName': 'Name',
  'zoning.form.labelRackType': 'Rack type',
  'zoning.form.labelPerspectiveWidth': 'Perspective width',
  'zoning.form.labelPerspectiveHeight': 'Perspective height',
  'zoning.form.recalcPerspective': 'Recalc from sides',
  'zoning.form.recalcHint': 'Fill width/height from the polygon’s real proportions',
  'zoning.form.cropPreviewTitle': 'Crop preview',
  'zoning.form.cropBrighten': 'Brightening',
  'zoning.form.cropBrightenHelp': 'For dark tables: lighter photos for validators and the dashboard. 0 — off, 1 — max.',
  'zoning.form.canBePhysicallyMoved': 'Table can be physically moved',
  'zoning.form.canBePhysicallyMovedHint': 'Clear this for bar counters and other fixed surfaces — they will never report «table out of place».',
  'zoning.form.spoiledGlareOnly': '«Frame spoiled» — glare only',
  'zoning.form.spoiledGlareOnlyHint': 'For tables whose polygon always covers several tabletops (a sofa with two or three tables): skip the «several tables / obstructed» questions and watch for glare only.',
  'zoning.form.cropPreviewEmpty': 'Fill perspective width and height',
  'zoning.form.initialDimsHint': 'Should match the camera resolution',
  'zoning.grid.button': 'Auto-fill shelves by grid',
  'zoning.grid.title': 'Shelf grid',
  'zoning.grid.count': 'Number of shelves',
  'zoning.grid.gap': 'Gap between shelves, px',
  'zoning.grid.gapHint': 'In perspective pixels. Keep close to the shelf-board thickness: in detection mode, products that land in the gap are counted by no shelf.',
  'zoning.grid.padding': 'Padding, %',
  'zoning.grid.paddingExpand': 'Per-side padding',
  'zoning.grid.paddingTop': 'Top',
  'zoning.grid.paddingBottom': 'Bottom',
  'zoning.grid.paddingLeft': 'Left',
  'zoning.grid.paddingRight': 'Right',
  'zoning.grid.naming': 'Naming',
  'zoning.grid.namingRyad': 'First row, Second row…',
  'zoning.grid.namingPolka': 'First shelf, Second shelf…',
  'zoning.grid.orientation': 'Orientation',
  'zoning.grid.orientationB2T': 'Bottom to top',
  'zoning.grid.orientationL2R': 'Left to right',
  'zoning.grid.cancel': 'Remove grid',
  'zoning.grid.error': 'Cannot build grid: gap or padding leaves no room.',
  'zoning.grid.shelfFailed': 'Failed to create shelf',
  'zoning.form.labelInitialWidth': 'Initial width',
  'zoning.form.labelInitialHeight': 'Initial height',
  'zoning.form.labelComposite': 'Composite',
  'zoning.form.labelSingleShelf': 'Single shelf = rack',
  'zoning.form.singleShelfHelp': 'The shelf follows the rack polygon when it is edited, no separate dragging. For racks with one shelf.',
  'zoning.form.labelPredictPct': 'Predict percentage',
  'zoning.form.labelModel': 'Neural model',
  'zoning.form.modelQuant': 'quantitative — boxes, share of shelf width along its line',
  'zoning.form.modelPct': 'percentage — share of shelf area',
  'zoning.form.modelInherit': 'same as the rack',
  'zoning.form.modelPerShelf': 'Configured per shelf',
  'zoning.form.labelMerchandisingDashId': 'Merchandising dashboard ID',
  'zoning.form.labelMerchandisingDashHelper': 'Optional. For linking to the merchandising system.',
  'zoning.form.labelBottomPoints': 'Bottom points (comma-separated)',
  'zoning.form.labelTopPoints': 'Top points (comma-separated)',
  'zoning.form.labelEmptyShelfScore': 'Empty shelf threshold',
  'zoning.form.labelShelfNum': 'Shelf number on rack',
  'zoning.form.labelMaxEffPct': 'Model correction (divisor, model_correction_max_pct)',
  'zoning.form.labelMaxEffPctHelper': 'Threshold for fill calculation (default 0.8)',
  'zoning.form.labelRackId': 'Rack ID',
  'zoning.form.labelMaxQueueSize': 'Queue size for alert',
  'zoning.form.labelMaxWorkers': 'Max workers',
  'zoning.form.labelOpsDashId': 'Operations dashboard ID',
  'zoning.form.labelOpsDashHelper': 'Optional. Used for linking to the monitoring system.',
  'zoning.form.sectionAttach': 'Attach to checkout zone',
  'zoning.form.radioCreateNew': 'Create new zone',
  'zoning.form.radioAddExisting': 'Add to existing zone',
  'zoning.form.labelExistingZone': 'Existing zone',
  'zoning.form.untitled': 'Untitled',
  'zoning.form.polygonsShort': 'pol.',
  'zoning.form.buttonCancel': 'Cancel',
  'zoning.form.buttonSave': 'Save',
  'zoning.form.buttonSaving': 'Saving…',
  'zoning.form.typeChangeWarning': 'Type will be changed from «{{from}}» to «{{to}}». Data from the previous type will be lost.',
  'zoning.form.errorDetach': 'Failed to detach polygon.',
  'zoning.form.errorDeleteZone': 'Failed to delete zone.',
  'zoning.form.errorMove': 'Failed to move polygon.',
  'zoning.form.errorNameRequired': 'Name is required.',
  'zoning.form.errorCameraNotSelected': 'No camera selected.',
  'zoning.form.errorSelectZone': 'Select an existing zone to attach to.',
  'zoning.form.errorCompleteDrawing': 'Complete polygon drawing before saving.',
  'zoning.form.errorSavePrefix': 'Failed to save:',

  // Common — added with admin user mgmt
  'common.saving': 'Saving…',
  'common.saved': 'Saved',
  'common.refresh': 'Refresh',

  // Superuser sidebar group
  'sidebar.group.system': 'System',
  'sidebar.systemBranches': 'Branches',
  'sidebar.systemUsers': 'Users',
  'sidebar.systemGroups': 'Groups',
  'sidebar.systemLocalComputers': 'Linza Computers',
  'sidebar.systemHostInfra': 'Host Infrastructure',
  'sidebar.systemData': 'Data',
  'sidebar.group.service': 'Service',
  'sidebar.reportValidation': 'Report validation',
  'sidebar.predictionsFeed': 'Predictions feed',
  'reportValidation.stub': 'Page under construction.',
  'reportValidation.day': 'Day',
  'reportValidation.nextUnconfirmed': 'Next unconfirmed',
  'reportValidation.nextUnsent': 'Next unsent',
  'reportValidation.editor.title': 'Report text',
  'reportValidation.editor.formatted': 'Formatted',
  'reportValidation.editor.raw': 'Source',
  'reportValidation.editor.link': 'Link',
  'reportValidation.editor.linkPrompt': 'Link URL',
  'reportValidation.editor.save': 'Save',
  'reportValidation.editor.saved': 'Saved',
  'reportValidation.editor.reset': 'Reset',
  'reportValidation.editor.unsaved': 'Unsaved changes',
  'reportValidation.editor.saveFailed': 'Save failed. Try again.',
  'reportValidation.editor.preview': 'Report preview',
  'reportValidation.action.confirm': 'Confirm',
  'reportValidation.action.send': 'Send',
  'reportValidation.action.cancel': 'Cancel',
  'reportValidation.action.sent': 'Sent',
  'reportValidation.action.confirmFailed': 'Confirm failed',
  'reportValidation.action.sendFailed': 'Send failed',
  'reportValidation.action.sendDeliveryFailed': 'Confirmed, but NOT delivered to the client chat',
  'reportValidation.action.cancelFailed': 'Cancel failed',
  'reportValidation.editor.chartsHint': 'Charts for reference (read-only).',
  'reportValidation.editor.mode': 'Edit mode',
  'reportValidation.editor.moreModes': 'More modes (formatted, source)',
  'reportValidation.editor.constructor': 'Constructor',
  'reportValidation.editor.interactive': 'Interactive',
  'reportValidation.action.sendTooOld': 'Older than a week: not sent to the client, just confirm it',
  'reportValidation.interactive.title': 'Interactive chart annotation',
  'reportValidation.interactive.wip':
    'Coming soon: drag selections right on the charts to set problems and key points — values are filled in from the data.',
  'reportValidation.interactive.f1': 'Layout: drag on the chart to mark a shortage (% from data).',
  'reportValidation.interactive.f2': 'Key points: drag the opening / target / closing points.',
  'reportValidation.interactive.f3': 'Queue: mark peak intervals and the second cashier.',
  'reportValidation.interactive.hint':
    'Drag on the chart under a line to set a problem/point; select it to edit the value.',
  'reportValidation.interactive.dragHint': 'Drag on the chart to add.',
  'reportValidation.interactive.removeSegment': 'Remove segment',
  'reportValidation.interactive.removeKeypoint': 'Remove point',
  'reportValidation.interactive.queueLabel': 'Queue',
  'reportValidation.interactive.addProblem': 'Add problem',
  'reportValidation.interactive.addEvent': 'Queue longer than 4 people',
  'reportValidation.interactive.saveEdit': 'Save',
  'reportValidation.interactive.cancelEdit': 'Cancel',
  'reportValidation.constructor.hint':
    'Click the icon at the end of a line to edit it by fields.',
  'reportValidation.constructor.editLine': 'Edit line',
  'reportValidation.constructor.editStatusLine': 'Edit layout status',
  'reportValidation.form.rackType': 'Layout type',
  'reportValidation.form.status': 'Status',
  'reportValidation.form.statusOk': 'OK',
  'reportValidation.form.statusProblem': 'Problems',
  'reportValidation.form.severity': 'Severity',
  'reportValidation.form.sev_yellow': 'Yellow',
  'reportValidation.form.sev_orange': 'Orange',
  'reportValidation.form.sev_red': 'Red',
  'reportValidation.form.sev_grey': 'Empty (grey)',
  'reportValidation.form.shelfCount': 'Shelves',
  'reportValidation.form.shelfCountHelp': 'Total across all racks of this type',
  'reportValidation.form.avgShortage': 'Avg shortage, %',
  'reportValidation.form.duration': 'Duration, h',
  'reportValidation.form.dipVisitors': 'Queue visitors during the dip, person-min',
  'reportValidation.form.links': 'Problem zones (links)',
  'reportValidation.form.noLinks': 'No links added',
  'reportValidation.form.linkName': 'Zone name',
  'reportValidation.form.linkUrl': 'Link (Grafana)',
  'reportValidation.form.addLink': 'Add zone',
  'reportValidation.form.preview': 'Line preview',
  'reportValidation.form.apply': 'Apply',
  'reportValidation.form.cancel': 'Cancel',
  'reportValidation.form.value': 'Value',
  'reportValidation.form.period': 'Problem period (MSK)',
  'reportValidation.form.periodHint': 'updates zone links',
  'reportValidation.constructor.hide': 'Remove section (do not send)',
  'reportValidation.constructor.unhide': 'Restore section',
  'reportValidation.constructor.removeLine': 'Remove line (do not send)',
  'reportValidation.constructor.restoreLine': 'Restore line',
  'reportValidation.form.addZone': 'Add zone',
  'reportValidation.form.zoneLinked': 'linked',
  'reportValidation.form.noZoneLink': 'no link',
  'reportValidation.tf.kp_open': 'Fill at opening',
  'reportValidation.tf.kp_norm': 'Reached target',
  'reportValidation.tf.kp_decline': 'Decline',
  'reportValidation.tf.kp_close': 'Fill at closing',
  'reportValidation.tf.q_longest': 'Longest queue',
  'reportValidation.tf.q_novisit': 'No visitors',
  'reportValidation.tf.q_longqueue': 'Long queue / second cashier',
  'reportValidation.tf.openPct': 'Fill at opening, %',
  'reportValidation.tf.normTime': 'Reached-target time (MSK)',
  'reportValidation.tf.declineTime': 'Decline-start time (MSK)',
  'reportValidation.tf.closePct': 'Fill at closing, %',
  'reportValidation.tf.peak': 'Queue peak, ppl',
  'reportValidation.tf.drainMin': 'Drained in, min',
  'reportValidation.tf.hoursNoVisit': 'Hours with no visitors',
  'reportValidation.tf.totalHours': 'Total hours',
  'reportValidation.tf.threshold': 'Queue threshold, ppl',
  'reportValidation.tf.events': 'Events (> 1 min)',
  'reportValidation.tf.secondCashierOn': 'Opened a second cashier',
  'reportValidation.tf.secondCashier': 'Times second cashier opened',
  'reportValidation.tf.secondCashierMinutes': 'Second register open, minutes',
  'reportValidation.tf.peakTime': 'Peak time (MSK)',
  'reportValidation.tf.oneCashierWarn': 'The branch has one cashier — a second one is impossible.',
  'reportValidation.kp.title': 'Key points',
  'reportValidation.kp.external': 'External reason (never reached norm)',
  'reportValidation.kp.opening': 'Opening',
  'reportValidation.kp.fast': 'Right at opening',
  'reportValidation.kp.normal': 'Reached target',
  'reportValidation.kp.decline': 'Had a decline',
  'reportValidation.kp.closeEmptyHint': '≤15% → “almost nothing on the shelf”',
  'reportValidation.kp.color': 'Colour (severity)',
  'reportValidation.kp.neverFilled': 'Did not reach the norm',
  'reportValidation.kp.openingProblem': 'Opening problem',
  'reportValidation.kp.closingProblem': 'Closing problem (was replenished)',
  'reportValidation.kp.closingHighlighted': 'Highlight the closing value',
  'reportValidation.tree.variant_issues': 'Problem',
  'reportValidation.tree.variant_ok': 'OK',
  'reportValidation.tree.details': 'Opening / closing branches',
  'reportValidation.tree.variant_no_data': 'No measurements',
  'reportValidation.tree.hasReplenished': 'Had a last replenishment',
  'reportValidation.tree.replenishedAt': 'Last replenishment time (MSK)',
  'reportValidation.tree.manualFallback': 'opening time unknown, set manually',
  'reportValidation.tree.openingLowFill': 'Low fill at opening',
  'reportValidation.tree.openingLowFillHint': 'Check to reveal the opening percentage and time reached',
  'reportValidation.tree.openingAutoProblem': 'Later than 20 min after opening → flagged as a problem',
  'reportValidation.tree.openingAutoOk': 'Within 20 min of opening → not a problem',
  'reportValidation.tree.openingAutoEmpty': 'Empty = reached norm within 20 min, not a problem',
  'reportValidation.tree.editCategory': 'Edit layout category',
  'reportValidation.tree.editLongest': 'Edit longest queue',
  'reportValidation.tree.editLongQueue': 'Edit long queue',
  'reportValidation.tree.editNoVisitors': 'Edit "no visitors"',
  'reportValidation.tree.queueMinutes': 'Minutes in queue (>= threshold)',
  'reportValidation.tree.queueNone': 'No such queue observed',
  'reportValidation.tree.queueNoneInline': 'not observed',
  'reportValidation.tree.secondCashierInline': 'Second register was open',
  'reportValidation.tree.drainUnmeasured': 'drain time not measured',
  'reportValidation.tree.colorAuto': 'auto',
  'reportValidation.tree.colorPick': 'Row colour: derived from the value, can be set manually',
  'reportValidation.tf.checklist': 'Checklist',
  'reportValidation.tree.editChecklist': 'Edit checklist',
  'reportValidation.tree.checklistDone': 'Done (comma-separated)',
  'reportValidation.tree.checklistNotDone': 'Not done (comma-separated)',
  'data.title': 'Data',
  'data.subtitle': 'ClearML datasets & annotation',
  'data.tab.hierarchy': 'Datasets',
  'data.tab.annotate': 'Annotation',
  'data.empty': 'No datasets found',
  'data.bootstrap.button': 'Label with AI',
  'data.bootstrap.title': 'AI pre-labelling',
  'data.bootstrap.description': 'Claude labels the table crops from the last few days; the operator only reviews them. Every crop costs money — run this once per point.',
  'data.bootstrap.notOnboarded': 'Zone is not registered in ClearML — onboard it first.',
  'data.bootstrap.tables': 'Tables ({n}) and available crops',
  'data.bootstrap.thin': '{n} table(s) have fewer than {target} crops — data is still accumulating.',
  'data.bootstrap.history': 'Past runs',
  'data.bootstrap.runDone': 'done, {n} labelled',
  'data.bootstrap.runRunning': 'running',
  'data.bootstrap.runFailed': 'failed',
  'data.bootstrap.launch': 'Start labelling',
  'data.bootstrap.launched': 'Labelling started. It takes a while — the result lands as a new dataset version; review it in the Annotation tab.',
  'data.bootstrap.launchFailed': 'Could not start labelling',
  'data.collect.button': 'Collect crops',
  'data.collect.title': 'Collect unlabelled crops',
  'data.collect.description': 'Table crops from already-captured frames land in the «Unlabelled» queue. Nothing is labelled automatically — this only collects data. Crops already in the pool are never collected twice.',
  'data.collect.zone': 'Zone',
  'data.collect.period': 'Period',
  'data.collect.lastDays': 'last {n} days',
  'data.collect.size': 'How many',
  'data.collect.available': 'Available in period',
  'data.collect.alreadyPooled': 'Already pooled (total)',
  'data.collect.willCollect': 'Will collect',
  'data.collect.noneAvailable': 'No crops in this period. Widen the window or wait for data to accumulate.',
  'data.collect.noTables': 'No table polygons are configured in this zone — there is nothing to collect.',
  'data.collect.noShelves': 'No fullness-predicting shelves are configured in this zone — there is nothing to collect.',
  'data.collect.history': 'Collection history',
  'data.collect.runRunning': 'collecting…',
  'data.collect.runSkipped': '({n} already pooled)',
  'data.collect.runFailed': '{n} failed',
  'data.collect.runError': 'error',
  'data.collect.launch': 'Collect',
  'data.collect.launchFailed': 'Could not start the collection',
  'data.refresh': 'Refresh',
  'data.locked': 'locked',
  'data.unlocked': 'free',
  'data.lock': 'Lock',
  'data.unlock': 'Unlock',
  'data.download': 'Download copy',
  'data.open': 'Open',
  'data.last': 'last',
  'data.noVersions': 'No versions',
  'data.latestVersion': 'Latest version',
  'data.kind.table_crops': 'Tables (crops)',
  'data.kind.audio': 'Audio transcripts',
  'data.kind.shelf_percentage': 'Shelf fullness (%)',
  'data.annotate.shelfPct.title': 'Shelf fullness, %',
  'data.annotate.shelfPct.hint': 'Rate how full the shelf is (0 = empty, 100 = full). Keys 0-9 = deciles + advance; E = 0%, F = 100%; slider/field for a precise value.',
  'data.annotate.shelfPct.shelfFilter': 'Filter by shelf',
  'data.annotate.shelfPct.deciles': 'deciles %',
  'data.annotate.shelfPct.labelled': 'labelled',
  'data.localCopy': 'Local copy (older than latest)',
  'data.annotate.pickHint': 'Pick a dataset on the "Datasets" tab and click "Download copy".',
  'data.annotate.soon': 'Downloading copy… the editor will open here.',
  'data.annotate.downloading': 'Downloading dataset copy',
  'data.annotate.failed': 'Download failed',
  'data.annotate.noCrops': 'No crops in this dataset',
  'data.annotate.subtype.presence': 'Around table',
  'data.annotate.subtype.state': 'Table state',
  'data.annotate.stateBlocked': 'Zone occupied (people/items) — table state is not annotated: the second model only runs for an empty zone.',
  'data.annotate.flowHint': 'Model 1 looks AROUND the table (occupied: people or their belongings). Model 2 looks at the table SURFACE (available only when the surroundings are free).',
  'data.annotate.by': 'annotated by',
  'data.annotate.unedited': 'not manually annotated',
  'data.annotate.upload': 'Push to ClearML',
  'data.annotate.discard': 'Discard (delete copy)',
  'data.annotate.uploadConfirm': 'Push a new dataset version to ClearML with the current annotations? The local copy is kept.',
  'data.annotate.discardConfirm': 'Delete the local copy without uploading? Edits not pushed to ClearML remain only in our DB.',
  'data.annotate.mode.presence': 'People/items (model 1)',
  'data.annotate.mode.in_frame': 'Table in frame (model 2)',
  'data.annotate.mode.state': 'Table state (model 3)',
  'data.annotate.bin.presence.yes': 'people/items',
  'data.annotate.bin.presence.no': 'free',
  'data.annotate.bin.in_frame.yes': 'in frame',
  'data.annotate.bin.in_frame.no': 'moved (<70%)',
  'data.annotate.occupied': 'occupied',
  'data.annotate.free': 'free',
  'data.annotate.next': 'next',
  'data.annotate.freeOnly': 'free crops only',
  'data.annotate.freeInFrameOnly': 'free & in-frame only',
  'data.annotate.filter.all': 'All (labeled)',
  'data.annotate.tableFilter.label': 'Filter by table',
  'data.annotate.tableFilter.all': 'All tables',
  'data.annotate.filter.human': 'Human-labeled',
  'data.annotate.filter.ai': 'AI-labeled',
  'data.annotate.filter.unlabeled': 'All (unlabeled)',
  'data.annotate.filter.report_fix': 'Fixed in report',
  'data.annotate.filter.cancelled': 'Cancelled',
  'data.annotate.filter.collected': 'Plain unlabeled',
  'data.annotate.aiBadge': 'AI-labeled',
  'data.annotate.unlabeledBadge': 'Unlabeled',
  'data.annotate.unset': 'unset',
  'data.annotate.frame': 'crop',
  'data.annotate.left': 'left',
  'data.annotate.counterHint': 'Cursor position / crops in the current view (table × filter × stage). "left" = how many are not yet finished through the funnel.',
  'data.pool.tab': 'Labeling (pool)',
  'data.pool.open': 'Open annotator',
  'data.pool.retrain': 'Start training',
  'data.pool.retrainHint': 'Train on what is labelled RIGHT NOW. An immutable snapshot of the labels is taken first, so what the model trained on stays reproducible.',
  'data.pool.retrainConfirm': 'Start training on the current labels? This rents a GPU (typically $0.03-0.06) and creates a dataset snapshot.',
  'data.pool.retrainStarted': 'Training started:',
  'data.pool.retrainAlreadyRunning': 'Training is already running, no new run started:',
  'data.pool.trainOn': 'Will train on crops',
  'data.pool.trainNew': 'New since the last training',
  'data.pool.trainSkipped': 'Excluded (unlabelled)',
  'data.pool.trainFirstPooled': 'This is the first training on the pooled dataset — nothing to compare against yet.',
  'data.pool.trainSinceLast': 'new since the last training',
  'data.pool.trainReady': 'labelled crops ready to train on',
  'data.pool.trainHint': 'Measured, not tracked: labelled crops in the database now vs the count recorded when the last training started. Unlabelled crops are excluded — they cannot reach training at all.',
  'data.pool.onStage': 'on stage',
  'data.pool.currentStageSource': 'This stage',
  'data.pool.outOf': 'of',
  'data.pool.gate.presence': 'Stage 1 asks about EVERY crop in the zone.',
  'data.pool.gate.in_frame': 'Stage 2 only asks about crops marked free at stage 1 — occupied ones stop there.',
  'data.pool.gate.state': 'Stage 3 only asks about crops that are free AND in frame — the rest were filtered out by earlier stages.',
  'data.pool.badge': 'pooled · labels in Postgres',
  'data.pool.domain.table': 'Tables',
  'data.pool.domain.shelf': 'Shelves',
  'data.pool.domain.audio': 'Audio',
  'data.pool.domain.boxes': 'Boxes',
  'data.boxes.view.queue': 'Queue',
  'data.boxes.view.modified': 'Corrected',
  'data.boxes.view.correct': 'Correct',
  'data.boxes.queueHint': 'Cancelled alerts of YOLO racks: the model said «empty», the validator answered «full». A false «empty» means extra or misplaced boxes. Single-YOLO-rack cameras only: boxes are not linked to a rack in the table.',
  'data.boxes.allZones': 'All branches',
  'data.boxes.days': 'days',
  'data.boxes.save': 'Save',
  'data.boxes.confirm': 'Markup is correct',
  'data.boxes.confirmHint': 'Confirm every untouched photo on this page: the detector boxes are right as they are',
  'data.boxes.showWeak': 'weak boxes',
  'data.boxes.showWeakHint': 'Boxes below the detector threshold — not counted. No need to delete them',
  'data.boxes.whole': 'whole',
  'data.boxes.keys': 'click — box (again — next overlapping) · Ctrl/⌘+drag — select · D — delete · R — restore · Z — undo · drag — new box · 1…9 — shelf, 0 — whole · Space — correct · ←→↑↓',
  'data.boxes.empty': 'Nothing here',
  'data.boxes.saved': 'saved',
  'data.boxes.saveFailed': 'not saved — try again',
  'data.boxes.pending': 'to save',
  'data.boxes.unsaved': 'There are unsaved edits — save before leaving?',
  'data.boxes.deletedN': 'deleted',
  'data.boxes.addedN': 'added',
  'data.boxes.boxesN': 'boxes',
  'data.boxes.model': 'model',
  'data.boxes.validator': 'validator',
  'data.boxes.status.modified': 'corrected',
  'data.boxes.status.correct': 'correct',
  'data.boxes.unlabel': 'Back to queue',
  'data.boxes.page': 'p.',
  'data.audio.segments': 'Segments',
  'data.audio.dialogues': 'Dialogues',
  'data.audio.clips': 'Clip transcripts',
  'data.kind.audio_transcripts': 'Audio (transcripts)',
  'data.audio.hint': 'Play the clip and fix the draft into a VERBATIM transcript — what was actually said. If there is no speech or it is unintelligible, press «Noise»: a blank is a real label too, and it teaches the model to stay silent.',
  'data.audio.accept': 'Accept',
  'data.audio.save': 'Save',
  'data.audio.noise': 'Noise/unintelligible',
  'data.audio.noiseHint': 'No speech or unintelligible → a blank target. Teaches the model not to invent text over noise.',
  'data.audio.retract': 'Clear label',
  'data.audio.retractHint': 'Send the clip back to the unlabelled queue. Needed after a mistake — otherwise a wrong label reaches training silently.',
  'data.audio.placeholder': 'Verbatim transcript (what was actually said)…',
  'data.audio.prodModel': 'prod model',
  'data.audio.marked': 'labelled',
  'data.audio.markedNoise': 'noise',
  'data.audio.noAudio': 'Clip file unavailable',
  'data.audio.waveShow': 'waveform / spans',
  'data.audio.waveHide': 'hide waveform',
  'data.audio.blanks': 'noise',
  'data.audio.trainHint': 'Speech + clips marked as noise. If blanks dominate, the model learns to stay silent.',
  'data.audio.retrainConfirm': 'Start fine-tuning the ASR model on the current labels?\n\nThis rents a GPU, and on success the production tag moves to the new model — the central hub starts transcribing with it.',
  'data.audio.retrainHint': 'Fine-tune GigaAM on the labelled clips. Not training from scratch: it takes the current model weights and adjusts them on our audio.',
  'data.audio.heldOut': 'Held out for evaluation',
  'data.audio.sortNewestRec': 'newest recordings first',
  'data.audio.sortOldestRec': 'oldest recordings first',
  'data.audio.view.imported': 'Imported',
  'data.audio.view.collected': 'From the pool',
  'data.audio.view.unlabeled': 'All unlabelled',
  'data.audio.view.human': 'Labelled by a human',
  'data.audio.view.ai': 'Labelled by AI',
  'data.audio.view.all': 'All labelled',
  'data.shelf.hint': 'Rate how full the shelf is: 0% is empty, 100% is full. Step 5%. An empty shelf is a real verdict, not "not labelled" — it is the case the alert fires on.',
  'data.shelf.usefulArea': 'Useful area',
  'data.shelf.usefulAreaHint': 'Grey covers where goods cannot sit on the shelf (the «Useful area» markup in polygon calibration). Dashed — the shelf polygon moved after marking, re-mark it. Counter — crops on this page that have the markup.',
  'data.shelf.allShelves': 'All shelves',
  'data.shelf.sortDefault': 'by shelf',
  'data.shelf.empty': 'No crops match these filters — switch filter or zone.',
  'data.shelf.cancelledBadge': 'corrected',
  'data.shelf.cancelledHint': 'Crops of racks where the operator disagreed with the model: it said stock was running out, a human said it is fine. Worth more than routine samples — they are what teaches the model not to repeat the mistake, so label these first.',
  'data.collect.descriptionShelf': 'Shelf crops from already-captured frames land in the «Неразмеченные» queue. Nothing is labelled automatically — this only collects data. Duplicates are not collected twice.',
  'data.shelf.shelfFilter': 'Filter by shelf',
  'data.shelf.keyDigits': '0%…90%',
  'data.shelf.keyClear': 'clear the verdict',
  'data.shelf.keyAgree': 'agree, take the credit',
  'data.sam.title': 'SAM 3 prompt bench',
  'data.sam.subtitle': 'try a prompt on a picture — nothing is saved',
  'data.sam.prompts': 'Prompts, comma separated',
  'data.sam.threshold': 'Threshold',
  'data.sam.maxFrac': 'Max instance share',
  'data.sam.maxFracHint': 'an instance bigger than this share of the frame is a tray or the case, not a product. 0.25 for a single-shelf crop; the fleet pass works on a rack crop, where it is 0.03',
  'data.sam.run': 'Run',
  'data.sam.clearImage': 'clear image',
  'data.sam.pasteHint': 'paste a picture with Ctrl+V',
  'data.sam.pasted': 'picture pasted',
  'data.sam.willUseFocused': 'without a paste it uses the focused crop',
  'data.sam.needImage': 'nothing to segment: paste a picture or focus a crop',
  'data.sam.failed': 'the request failed',
  'data.sam.paneOriginal': 'original',
  'data.sam.paneMasked': 'after SAM 3',
  'data.sam.coverage': 'coverage',
  'data.sam.coverageShelf': 'this shelf\'s fullness by the SAM masks',
  'data.sam.notProduction': 'the fleet pass measures on the whole rack crop with a 0.03 cut; this is one shelf with 0.25, so the number is a close relative, not the same one',
  'data.sam.coveragePasted': 'share of the pasted picture the masks cover',
  'data.sam.pixels': 'pixels',
  'data.sam.takeFocused': 'take this crop',
  'data.sam.takenFocused': 'taken from the grid',
  'data.sam.preview': 'what goes to SAM 3',
  'data.sam.reset': 'defaults',
  'data.mask.onlyWithMasks': 'only with masks',
  'data.mask.by.ai': 'AI',
  'data.mask.by.user': 'human',
  'data.pool.saveRetry': 'not saved — will retry on the next edit',
  'data.mask.notComputed': 'masks for this crop have not been computed yet',
  'data.mask.compute': 'run SAM 3',
  'data.mask.recut': 'retry wider',
  'data.mask.recutHint': 'cut the shelf from the original frame with room around it and look again',
  'data.mask.recutQueued': 're-cutting and looking again…',
  'data.mask.queued': 'queued',
  'data.mask.queuedHint': 'about a minute — Replicate allows 6 requests per minute',
  'data.mask.imgExpired': 'the picture link has expired (they last six hours) — reload the page',
  'data.mask.mode.view': 'view',
  'data.mask.mode.cursor': 'cursor',
  'data.mask.mode.pen': 'pen',
  'data.mask.delete': 'delete object',
  'data.mask.split': 'split',
  'data.mask.splitHint': 'break the object back into the outlines it was merged from, so what got swallowed can be deleted or moved',
  'data.mask.keysHint': 'Z undo, Y redo, S split the object',
  'data.mask.objects': 'objects',
  'data.mask.base': 'base (2+ prompts agreed)',
  'data.mask.byMasks': 'masks',
  'data.mask.emptyBase': 'nothing two prompts agreed on — tick a prompt to add its finds',
  'data.mask.prelabel': 'label with AI',
  'data.mask.prelabelHint': 'starts a job: SAM 3 finds the objects on unlabelled crops and records a percentage, moving them to "labelled by AI". About a minute a crop — Replicate rate limit',
  'data.mask.prelabelStarted': 'job started, crops:',
  'data.mask.prelabelFailed': 'could not start the job',
  'data.mask.byMasksHint': 'what the objects two or more prompts agreed on cover — the set the editor opens with',
  'data.mask.stored': 'stored',
  'data.mask.deduped': '{n} duplicates merged',
  'data.mask.save': 'save',
  'data.mask.confirm': 'agree, take it',
  'data.mask.saved': 'saved:',
  'data.mask.saveFailed': 'could not save',
  'data.mask.slider': 'how many objects count',
  'data.mask.viewHint': 'viewing: nothing changes',
  'data.mask.cursorHint': 'click selects, drag a white handle to move a corner, Delete removes',
  'data.mask.penHint': 'clicks add points, double-click or Enter closes the contour, Escape cancels',
  'data.sam.production': 'production set',
  'data.sam.productionHint': 'exactly what the pass runs: 14 prompts and a 0.03 cut — but that cut is calibrated for a rack crop, and this is one shelf',
  'data.sam.throttled': 'throttled',
  'data.sam.throttledHint': 'some prompts did not run: Replicate throttles while the account is under $5 — the prompts are fine, the total is incomplete',
  'data.sam.resetHint': 'the broad set worth starting from',
  'data.sam.unionOf': 'union of {n} prompts',
  'data.sam.overlapNote': 'per-prompt shares do not add up: masks overlap, the total is their union',
  'data.sam.colPrompt': 'prompt',
  'data.sam.colFound': 'found',
  'data.sam.colKept': 'kept',
  'data.sam.colDropped': 'dropped',
  'data.sam.colCoverage': 'coverage',
  'data.sam.calls': 'API calls',
  'data.shelf.legacyHint': 'Imported from an outside dataset (perek/xlebnik) — a different shop with different shelves. Useful for training, but it says nothing about quality at our points.',
  'data.shelf.lowBand': 'Nearly empty among them (0–20%)',
  'data.pool.refresh': 'Refresh',
  'data.pool.refreshHint': 'Recount facets and reload the page. Labels save immediately — refreshing is only needed to see updated numbers.',
  'data.pool.cancelledBadge': 'cancelled',
  'data.pool.reportFixBadge': 'fixed',
  'data.pool.reportFixHint': 'Frames of incidents that were corrected by hand in the report or Status: the model was wrong in a way the client saw. Most urgent — label these first, on every class.',
  'data.pool.sortLabel': 'Order',
  'data.pool.sortDefault': 'by table',
  'data.pool.sortHint': 'Order for crops that are already labelled. «Newest first» is the quick way back to what you just did — after a misclick, or when the connection dropped and it is unclear what got saved.',
  'data.pool.sortNewest': 'newest first',
  'data.pool.sortOldest': 'oldest first',
  'data.pool.batchStart': 'Build a batch',
  'data.pool.batchActive': 'My batch',
  'data.pool.listActive': 'Linked list',
  'data.pool.listHint': 'crops from the label audit, in link order',
  'data.pool.batchZones': 'zones',
  'data.pool.batchExit': 'exit',
  'data.pool.batchHint': 'Build yourself a labelling assignment: that many unlabelled crops from EVERY zone, picked at random. A zone with fewer left contributes what it has. The batch is yours for today — reloading returns the same one, not a new one.',
  'data.pool.cancelledHint': 'Crops from cancelled alerts: the model said "dirty", a human said no. Worth more than routine samples — they are what teaches the model not to repeat the mistake, so label these first.',
  'data.pool.inFilter': 'in filter',
  'data.pool.counterHint': 'Crop on this page / page size · "in filter" = how many match the filters · "left" = how many in the zone are still unlabelled at this stage.',
  'data.pool.cleanReviewed': 'clean (reviewed)',
  'data.pool.empty': 'No crops match these filters — switch stage, filter or zone.',
  'data.annotate.markReviewed': 'Reviewed',
  'data.annotate.reviewHint': 'Confirm the current labels of the visible crops as human-reviewed. Labels are unchanged — the crops just drop out of the "AI" filter so you do not re-review them next time.',
  'data.annotate.reviewConfirm': 'Mark {n} crops as human-reviewed? Labels stay the same; they will no longer appear in the "AI" filter.',
  'data.annotate.reviewedDone': 'Marked reviewed: {n} ✓',
  'data.annotate.humanBadge': 'Human-reviewed',
  'data.annotate.localVersion': 'Local copy',
  'data.annotate.point': 'Point',
  'data.annotate.version': 'Version',
  'data.annotate.zoomIn': 'Larger (fewer per row)',
  'data.annotate.zoomOut': 'Smaller (more per row)',
  'data.annotate.descLabel': 'Annotation note (optional)',
  'data.annotate.descHelp': 'A short note on what you annotated in this version — saved on the ClearML task when you push (visible in the dataset history).',
  'data.annotate.descPlaceholder': 'e.g.: re-checked occupancy on all tables, fixed dirty dishes on tables 12–18',
  'data.annotate.gate.in_frame.title': 'Do model 1 (people/items) first',
  'data.annotate.gate.in_frame.body': '"Table in frame" (model 2) is only annotated on crops with no people/items (occupied=false) — the same gate the production cascade uses. Do "People/items" first, then come back: only free crops will be shown.',
  'data.annotate.gate.state.title': 'Do models 1 and 2 first',
  'data.annotate.gate.state.body': 'Table state (model 3) is only annotated on crops with no people/items AND where the table is in frame. Do "People/items" and "Table in frame" first, then come back.',
  'data.annotate.gate.back': 'Back',
  'data.annotate.gate.ok': 'Got it, continue',
  'data.annotate.deleteLocal': 'Delete local copy',
  'data.annotate.deleteConfirm': 'Delete the local copy? Annotations not pushed to ClearML will be lost.',
  'data.annotate.deletePhoto': 'Delete photo from dataset',
  'data.annotate.deletePhotoConfirm': 'Delete this photo from the dataset together with its labels? It will be removed from the new version when you push to ClearML.',
  'data.annotate.photoDeleted': 'Photo deleted ✓',
  'data.annotate.uploaded': 'Pushed to ClearML ✓',
  'data.annotate.hint.presence': 'Model 1 — are there people/items at the table. Q = yes (occupied), W = free; the cursor auto-advances. All crops.',
  'data.annotate.hint.in_frame': 'Model 2 — is the table in frame or moved (<70% visible → moved). Q = in frame, W = moved. Only crops with no people/items.',
  'data.annotate.hint.state': 'Model 3 — the table SURFACE. Q/W/E/R toggle independent flags, Space = next. Only crops with no people/items AND table in frame.',

  // Superuser system — host-infra cron status page
  'system.hostInfra.title': 'Host Infrastructure',
  'system.hostInfra.subtitle': 'Cron scripts on linza-deployments and linza-dev',
  'system.hostInfra.installHeading': 'Installation',
  'system.hostInfra.installCurlError': '# failed to fetch the install command — refresh the page',
  'system.hostInfra.loadError': 'Failed to load cron script status.',
  'system.hostInfra.colHost': 'Host',
  'system.hostInfra.colScript': 'Script',
  'system.hostInfra.colPurpose': 'Purpose',
  'system.hostInfra.colSchedule': 'Schedule',
  'system.hostInfra.colStatus': 'Status',
  'system.hostInfra.colMtime': 'Last updated',
  'system.hostInfra.ago': 'ago',
  'system.hostInfra.showLog': 'log',
  'system.hostInfra.hideLog': 'hide',
  'system.hostInfra.deployedVersions': 'Versions',
  'system.hostInfra.emptyList': 'No canonical cron lines configured.',
  // Per-server labels (task #87).
  'system.hostInfra.purpose.dump_reverse_tunnels': 'Queries linza-dev (ssh.dev.linzametrics.com) every minute over SSH for the bound 23NN reverse-tunnel ports — the tunnels terminate there, not on this host.',
  'system.hostInfra.purpose.dump_wg_peers': 'Snapshots wg peers to /var/lib/linza/ every minute.',
  'system.hostInfra.purpose.model_deploy': "Restarts the central server's Triton when any deploy-tagged model changed in S3 (daily, 00:00 MSK).",
  'system.hostInfra.purpose.add_wg_peer': 'Applies enqueued wg peers.',
  'system.hostInfra.purpose.generate_hosts_from_wg': 'Generates /etc/hosts from wg config (daily).',
  'system.hostInfra.purpose.sync_lc_pubkeys_dev': 'Syncs every computer\'s SSH key to linza-dev every minute.',
  'system.hostInfra.devKeysPath.note': 'Dev/admin SSH keys allowed to log into LCs are maintained manually in',

  // Admin local computers (LocalComputer platform)
  'admin.lc.title': 'Linza Computers',
  'admin.lc.subtitle': 'On-site local computers by branch.',
  'admin.lc.searchPlaceholder': 'Search by name or deployment_key…',
  'admin.lc.empty': 'No computers.',
  'admin.lc.colName': 'Branch',
  'admin.lc.colDeviceNumber': 'No.',
  'admin.lc.colHostname': 'Host',
  'admin.lc.colWgIp': 'WireGuard',
  'admin.lc.colSshPort': 'SSH',
  'admin.lc.colHardware': 'Hardware',
  'admin.lc.colStage': 'Stage',
  'admin.lc.colHeartbeat': 'Last seen',
  'admin.lc.heartbeatNever': 'never',
  'admin.lc.unbound': 'Unbound',
  'admin.lc.unboundHint': 'Connected but not bound to a branch',
  'admin.lc.bindAction': 'Assign deployment key…',
  'admin.lc.bindDialog.title': 'Assign deployment key',
  'admin.lc.bindDialog.deploymentKeyLabel': 'Deployment key',
  'admin.lc.bindDialog.displayNameLabel': 'Human-readable name',
  'admin.lc.bindDialog.submit': 'Assign',

  // Discovery dialog (task #82 / xxvii) — replaces IssueTokenDialog.
  'admin.lc.discoverAction': 'Register',
  'admin.lc.emptyHint': 'To add the first computer, click "Register" above and run the resulting discovery curl on the device.',
  'admin.lc.discoveryDialog.title': 'Register a computer',
  'admin.lc.discoveryDialog.description': 'Run on the computer (sudo required). The script reads the MAC + any already-set keys and posts them to the server.',
  'admin.lc.discoveryDialog.waiting': 'Waiting for the first response from the computer…',
  'admin.lc.discoveryDialog.issuingToken': 'Issuing registration token…',
  // Legacy IssueTokenDialog strings — see RU dictionary.
  'admin.lc.issueAction': 'Enroll new (legacy)',
  'admin.lc.issueDialog.title': 'Enroll a new computer (legacy)',
  'admin.lc.issueDialog.titleIssued': 'Token issued',
  'admin.lc.issueDialog.displayNameHint': 'Optional human-readable branch name.',
  'admin.lc.issueDialog.deviceNumberLabel': 'Device number',
  'admin.lc.issueDialog.deviceNumberHint': '1..99, unique. Reserves reverse-SSH port 2300+N.',
  'admin.lc.issueDialog.deviceNumberInvalid': 'Device number must be an integer between 1 and 99.',
  'admin.lc.issueDialog.wgIpLabel': 'WireGuard IP',
  'admin.lc.issueDialog.wgIpHint': '10.99.0.X with X=2..254. Must be unique across all LCs.',
  'admin.lc.issueDialog.wgIpInvalid': 'WireGuard IP must match 10.99.0.X (X=2..254).',
  'admin.lc.issueDialog.submit': 'Create token',
  'admin.lc.issueDialog.successHint': 'Copy the curl below and run it on the computer. The token is valid for 24h and is single-use.',
  'admin.lc.issueDialog.curlLabel': 'Command for the computer',

  // Detail modal
  'admin.lc.detail.title': 'Computer',
  'admin.lc.detail.stagesHeading': 'Setup stages',
  'admin.lc.detail.actionNowDoing': 'Now: {{stage}}',
  'admin.lc.detail.actionFailedHint': 'Fix the issue on the device, then click "Reset keys" below and run curl again.',
  'admin.lc.detail.actionReissueFailedHint': 'Try "Reset keys" below — it clears stored keys and issues a new token.',
  'admin.lc.detail.curlContinueLabel': 'Run on the device to continue setup:',
  'admin.lc.detail.inProgressDetail.WG_CONFIGURED': 'Device is installing WireGuard and reporting its public key to the server.',
  'admin.lc.detail.inProgressDetail.WG_HANDSHAKE_VERIFIED': 'Waiting for the first WireGuard handshake from the device (≤60s after the host cron adds the peer).',
  'admin.lc.detail.inProgressDetail.SSH_PUBKEY_AUTHORIZED': 'Device generated an SSH key and reported it. The host cron will append it to /home/linza/.ssh/authorized_keys (~60s).',
  'admin.lc.detail.inProgressDetail.AUTHORIZED_KEYS_PULLED': 'Device is pulling authorized_keys.example from the server and merging with its local copy.',
  'admin.lc.detail.inProgressDetail.REVERSE_SSH_LIVE': 'Device is bringing up the reverse-SSH tunnel to ssh.dev.linzametrics.com.',
  'admin.lc.detail.inProgressDetail.TRAEFIK_REGISTERED': 'Registering the Traefik route.',
  'admin.lc.detail.inProgressDetail.DOCKER_RUNNING': 'Starting Docker containers (celery-cctv and friends).',
  'admin.lc.detail.field.id': 'ID',
  'admin.lc.detail.field.state': 'State',
  'admin.lc.detail.field.stateLive': 'Live',
  'admin.lc.detail.field.stateArchived': 'Archived',
  'admin.lc.detail.field.wgIp': 'WireGuard IP',
  'admin.lc.detail.field.sshPort': 'Reverse-SSH port',
  'admin.lc.detail.field.hostname': 'Hostname',
  'admin.lc.detail.field.hostnameHint': 'e.g. surf_iq.linza',
  'admin.lc.detail.field.hostnameInvalid': 'Latin letters, digits, dash, underscore and dots only — e.g. surf_iq.linza.',
  'admin.lc.detail.field.deviceNumber': 'Device number',
  'admin.lc.detail.field.hardware': 'Hardware',
  'admin.lc.detail.field.deployment': 'Deployment',
  'admin.lc.detail.field.deploymentNone': 'not bound',
  'admin.lc.detail.field.gitlabEnvironmentName': 'GitLab environment',
  'admin.lc.detail.field.prometheusDeploymentName': 'Prometheus name',
  'admin.lc.detail.field.bareMetalVariableName': 'GitLab variables key',
  // GitLab config subsection (#96 / #97).
  'admin.lc.detail.zoneBind.title': 'Bound branches',
  'admin.lc.detail.zoneBind.noKeyHint': 'Set deployment_key in the identity fields above before binding a branch.',
  'admin.lc.detail.zoneBind.noBound': 'No branch is bound to this device.',
  'admin.lc.detail.zoneBind.pickerPlaceholder': 'Pick a branch…',
  'admin.lc.detail.zoneBind.bindButton': 'Bind',
  'admin.lc.detail.zoneBind.unbindAria': 'Unbind',
  'admin.lc.detail.gitlabConfig.title': 'GitLab config',
  'admin.lc.detail.gitlabConfig.group.ssh': 'SSH access',
  'admin.lc.detail.gitlabConfig.group.runtime': 'Runtime config',
  'admin.lc.detail.gitlabConfig.group.secrets': 'Secrets',
  'admin.lc.detail.gitlabConfig.created': '✓ created',
  'admin.lc.detail.gitlabConfig.createdAt': 'created {{when}}',
  'admin.lc.detail.gitlabConfig.bool.on': 'on',
  'admin.lc.detail.gitlabConfig.bool.off': 'off',
  'admin.lc.detail.gitlabConfig.secret.set': '✓ set',
  'admin.lc.detail.gitlabConfig.secret.unset': 'not set',
  'admin.lc.detail.gitlabConfig.secret.setBtn': 'Set',
  'admin.lc.detail.gitlabConfig.secret.replace': 'Replace',
  'admin.lc.detail.gitlabConfig.secret.save': 'Save',
  'admin.lc.detail.gitlabConfig.secret.placeholder': 'new value',
  'admin.lc.detail.gitlabConfig.field.plugins_list': 'Plugins',
  'admin.lc.detail.gitlabConfig.field.plugins_list.hint': 'Comma-separated list: table_control,empty_shelf,…',
  'admin.lc.detail.gitlabConfig.field.modules_list': 'Modules',
  'admin.lc.detail.gitlabConfig.field.service_mode': 'Service mode',
  'admin.lc.detail.gitlabConfig.field.service_port': 'Service port',
  'admin.lc.detail.gitlabConfig.field.service_name': 'Service name',
  'admin.lc.detail.gitlabConfig.field.metal_machine_host': 'SSH proxy host',
  'admin.lc.detail.gitlabConfig.field.metal_machine_user': 'SSH proxy user',
  'admin.lc.detail.gitlabConfig.field.ssh_port': 'SSH proxy port',
  'admin.lc.detail.gitlabConfig.field.metal_machine_password': 'SSH proxy password',
  'admin.lc.detail.gitlabConfig.field.password.hint': 'Stored in GitLab. The BE only tracks the set/unset flag.',
  'admin.lc.detail.gitlabConfig.field.need_sstpc_vpn': 'Use SSTPC VPN',
  'admin.lc.detail.gitlabConfig.field.router_domain': 'Router domain',
  'admin.lc.detail.gitlabConfig.field.sstpc_user': 'SSTPC user',
  'admin.lc.detail.gitlabConfig.field.sstpc_password': 'SSTPC password',
  'admin.lc.detail.gitlabConfig.field.rebuild_triton': 'Rebuild Triton',
  'admin.lc.detail.gitlabConfig.field.proxy_url': 'Proxy URL',
  'admin.lc.detail.gitlabConfig.field.telegram_data_save_path': 'Telegram save path',
  // Phase B (#98) — advanced runtime config + additional secrets.
  // Hidden behind "Show advanced" toggle by default.
  'admin.lc.detail.gitlabConfig.advanced.show': 'Show advanced parameters',
  'admin.lc.detail.gitlabConfig.advanced.hide': 'Hide advanced parameters',
  'admin.lc.detail.gitlabConfig.field.batch_size': 'Batch size',
  'admin.lc.detail.gitlabConfig.field.queue_threads_num': 'Queue threads',
  'admin.lc.detail.gitlabConfig.field.default_triton_url': 'Triton URL',
  'admin.lc.detail.gitlabConfig.field.redis_url': 'Redis URL',
  'admin.lc.detail.gitlabConfig.field.gstreamer_pipeline': 'GStreamer pipeline',
  'admin.lc.detail.gitlabConfig.field.model_empty_shelf_name': 'Empty-shelf model',
  'admin.lc.detail.gitlabConfig.field.yolo_model_name': 'YOLO model',
  'admin.lc.detail.gitlabConfig.field.yolo_model_version': 'YOLO version',
  'admin.lc.detail.gitlabConfig.field.yolo_detectable_class_ids': 'YOLO class IDs',
  'admin.lc.detail.gitlabConfig.field.enable_s3': 'Enable S3',
  'admin.lc.detail.gitlabConfig.field.s3_bucket': 'S3 bucket',
  'admin.lc.detail.gitlabConfig.field.s3_access_key': 'S3 access key',
  'admin.lc.detail.gitlabConfig.field.frame_workload_enabled': 'Frame workload',
  'admin.lc.detail.gitlabConfig.field.conn_health_checks': 'Connection health checks',
  'admin.lc.detail.gitlabConfig.field.debug': 'Debug mode',
  'admin.lc.detail.gitlabConfig.field.postgres_password': 'Postgres password',
  'admin.lc.detail.gitlabConfig.field.django_salt': 'Django SECRET_KEY',
  'admin.lc.detail.gitlabConfig.field.s3_secret_access_key': 'S3 secret access key',
  'admin.lc.detail.gitlabConfig.field.sentry_dsn': 'Sentry DSN',
  'admin.lc.detail.gitlabConfig.field.telegram_alert_token': 'Telegram bot token',
  'admin.lc.detail.gitlabConfig.pull.button': 'Pull from GitLab',
  'admin.lc.detail.gitlabConfig.pull.pulling': 'Pulling…',
  'admin.lc.detail.gitlabConfig.pull.upToDate': 'Already in sync with GitLab.',
  'admin.lc.detail.gitlabConfig.pull.success': 'Updated {{count}} field(s). Changed: {{fields}}.',
  // 3-section workspace (task #82 / xxvii / commit 4e).
  'admin.lc.detail.backToList': 'Back to list',
  'admin.lc.detail.sections.params': 'Parameters',
  'admin.lc.detail.sections.setup': 'Setup',
  'admin.lc.detail.sections.steps': 'Setup steps',
  'admin.lc.detail.sections.nextStep': 'Current step',
  'admin.lc.detail.sections.maintenance': 'Maintenance',
  'admin.lc.detail.modelDeploy.title': 'Model update',
  'admin.lc.detail.modelDeploy.desc': 'The point pulls new model versions and restarts Triton once a day on its own.',
  'admin.lc.detail.modelDeploy.installBtn': 'Show install command',
  'admin.lc.detail.modelDeploy.installHint': 'Run once on the point (root):',
  'admin.lc.detail.modelConvert.title': 'Model conversion',
  'admin.lc.detail.modelConvert.desc': 'A convert-host builds the TensorRT .plan from a trained model and uploads it to S3. Designate the point and install the cron with the command below — the flag turns active once the jetson actually starts converting.',
  'admin.lc.detail.modelConvert.installBtn': 'Show conversion install command',
  'admin.lc.detail.modelConvert.designateBtn': 'Designate convert-host & show command',
  'admin.lc.detail.modelConvert.statusActive': 'active ✓',
  'admin.lc.detail.modelConvert.statusAwaiting': 'awaiting jetson',
  'admin.lc.detail.modelConvert.awaitingHint': "The flag turns active once the jetson's convert_drainer first polls the backend.",
  'admin.lc.detail.modelDeploy.modeLabel': 'Mode',
  'admin.lc.detail.modelDeploy.modeJetson': 'Jetson (download + restart)',
  'admin.lc.detail.modelDeploy.modeHost': 'Host (restart only)',
  'admin.lc.detail.modelDeploy.runs': 'Cron runs',
  'admin.lc.detail.modelDeploy.noRuns': 'No runs yet',
  'admin.lc.detail.modelDeploy.versions': 'Versions',
  'admin.lc.detail.modelDeploy.showLog': 'Log',
  'admin.lc.detail.modelDeploy.refresh': 'Refresh',
  'admin.lc.detail.modelDeploy.rc.0': 'success',
  'admin.lc.detail.modelDeploy.rc.1': 'no config',
  'admin.lc.detail.modelDeploy.rc.2': 'Triton not found',
  'admin.lc.detail.modelDeploy.rc.3': 'version request failed',
  'admin.lc.detail.modelDeploy.rc.4': 'missing model path',
  'admin.lc.detail.modelDeploy.rc.5': 'model download failed',
  'admin.lc.detail.modelDeploy.rc.6': 'Triton restart failed',
  'admin.lc.detail.modelDeploy.rc.7': 'Triton not ready',
  'admin.lc.detail.modelDeploy.rc.unknown': 'code {rc}',
  'admin.lc.detail.steps.fillParams': 'Fill in parameters below',
  'admin.lc.detail.field.displayName': 'Human-readable name',
  'admin.lc.detail.field.eth0Mac': 'eth0 MAC',
  'admin.lc.detail.field.wgPubkey': 'WireGuard pubkey',
  'admin.lc.detail.field.sshPubkey': 'SSH pubkey',
  'admin.lc.detail.field.wgIpLocked': 'Locked — WG handshake already observed.',
  'admin.lc.detail.field.deviceNumberLocked': 'Locked — reverse-SSH tunnel already live.',
  'admin.lc.detail.jetsonOriginatedHint': 'MAC, WG pubkey and SSH pubkey come from the device itself; they only refresh when the discovery curl below is run.',
  'admin.lc.detail.discoveryPanel.title': 'Refresh values from the device',
  'admin.lc.detail.discoveryPanel.hint': 'Run this command on the device to refresh MAC, WG pubkey and SSH pubkey on this record. Does not affect GitLab config (section below). The command carries a token bound to this LC — safe to run only on this device.',
  'admin.lc.detail.discoveryPanel.issuingToken': 'Issuing token…',
  // Section 3 states (xxvii — Alexey verbatim 2026-05-23).
  'admin.lc.detail.nextStep.running': 'Running «{{stage}}» — wait, the device is working.',
  'admin.lc.detail.nextStep.failure': 'Setup error',
  'admin.lc.detail.nextStep.failureStage': 'At stage: «{{stage}}».',
  'admin.lc.detail.nextStep.exitCode': 'Exit code: {{code}}',
  'admin.lc.detail.nextStep.failureHint': 'Check the device state and run the discovery curl above to refresh values. Once fixed, re-run the setup command.',
  'admin.lc.detail.nextStep.fillParamsHint': 'Fill in the missing parameters above — they\'re marked * — and a setup command will appear here.',
  'admin.lc.detail.nextStep.hostnameClashWarning': 'Default device hostname ({{hostname}}) — pick a meaningful "Display name" above (e.g. "Surf Coffee Lefort"), otherwise multiple devices will collide into a nameless list.',
  'admin.lc.detail.nextStep.runSetupHint': 'Run this command on the device to start the setup. The token is valid for 24h.',
  'admin.lc.detail.nextStep.issuingToken': 'Issuing token…',
  'admin.lc.detail.nextStep.retryIssue': 'Try again',
  'admin.lc.detail.nextStep.setupCurlLabel': 'Setup (one-shot)',
  'admin.lc.detail.nextStep.tokenStaleHint': 'token nearly expired',
  'admin.lc.detail.nextStep.refreshToken': 'Refresh token',
  'admin.lc.detail.discoveryPanel.label': 'Discovery (repeatable)',
  // Manual stages — see RU dictionary. No "Mark done" buttons per
  // Alexey 2026-05-23 — operator does external work, BE auto-detects.
  'admin.lc.detail.nextStep.openGitlab': 'Open GitLab',
  // GITLAB_REGISTERED desc unused since #99 (state machine in
  // GitlabMatchOrCreatePanel takes over). Kept for FE crossover safety.
  'admin.lc.detail.nextStep.manual.GITLAB_REGISTERED.desc': 'Needs one pipeline run in GitLab — it registers an environment for the computer in the deployment system, and this stage advances on its own. Trigger it manually or wait for the next scheduled run.',
  // GitLab match-or-create state machine (task #99 / Phase D).
  'admin.lc.detail.gitlabMatch.initialHint': 'Parameters are filled. Click "Continue" to check for a GitLab environment for this computer.',
  'admin.lc.detail.gitlabMatch.continue': 'Continue',
  'admin.lc.detail.gitlabMatch.checking': 'Checking for an existing environment in GitLab CI…',
  'admin.lc.detail.gitlabMatch.creating': 'Creating environment and variables in GitLab…',
  'admin.lc.detail.gitlabMatch.noMatch': 'No GitLab environment found by host: {{host}}, port: {{port}}. Create one?',
  'admin.lc.detail.gitlabMatch.recheck': 'Check again',
  'admin.lc.detail.gitlabMatch.createNew': 'Yes, create',
  'admin.lc.detail.gitlabMatch.clashTitle': 'Uniqueness conflict — cannot create',
  'admin.lc.detail.gitlabMatch.clashHint': 'Edit the relevant fields in the section above, then click "Back to Continue".',
  'admin.lc.detail.gitlabMatch.clash.duplicateLc': 'already used by record «{{lcName}}»',
  'admin.lc.detail.gitlabMatch.clash.envExists': 'environment «{{envName}}» already exists in GitLab',
  'admin.lc.detail.gitlabMatch.clash.varExists': 'variable «{{varKey}}» already exists in GitLab',
  'admin.lc.detail.gitlabMatch.backToContinue': 'Back to Continue',
  'admin.lc.detail.gitlabMatch.retry': 'Retry',
  'admin.lc.detail.nextStep.manual.TRAEFIK_REGISTERED.desc': 'Checking network configuration. This stage advances on its own.',
  'admin.lc.detail.nextStep.manual.DOCKER_RUNNING.desc': 'Needs a pipeline run in GitLab — it deploys the application to the computer. Once it\'s up, this stage advances on its own.',
  'admin.lc.detail.field.empty': 'click to fill',
  'admin.lc.detail.maintenance.deleteAction': 'Delete record',
  'admin.lc.detail.maintenance.deleteConfirm': 'Confirm delete',
  'admin.lc.detail.resetKeysAction': 'Reset keys',
  'admin.lc.detail.resetKeysConfirmAction': 'Reset',
  'admin.lc.detail.resetKeysConfirm': 'Clears the stored WireGuard and SSH pubkeys on the server. The device will need to run curl again. Existing peer entries in /etc/wireguard/wg0.conf and keys in /home/linza/.ssh/authorized_keys are NOT removed automatically — that requires manual sysadmin cleanup.',
  'admin.lc.detail.resetKeysWgLabel': 'WireGuard pubkey',
  'admin.lc.detail.resetKeysWgHint': 'Clears lc.wg_pubkey.',
  'admin.lc.detail.resetKeysSshLabel': 'SSH pubkey',
  'admin.lc.detail.resetKeysSshHint': 'Clears machine_facts.ssh_pubkey.',
  'admin.lc.detail.mismatchBanner': 'Device keys don\'t match',
  'admin.lc.detail.mismatchHint': 'The device reported a pubkey different from the one stored on the server. The device was likely re-installed. Reset the stored keys before running curl again.',
  'admin.lc.detail.curlPathLabel': 'Run on the computer:',
  'admin.lc.detail.curlExpiredHint': 'No active token. Use "Enroll new" to issue another.',
  'admin.lc.detail.curlReissuing': 'Refreshing token…',
  'admin.lc.detail.curlReissueFailed': 'Could not refresh token: {{error}}',
  'admin.lc.detail.curlReissueRetry': 'Retry',
  'admin.lc.detail.curlReissueAction': 'Get a new token',
  'admin.lc.detail.curlPostEnrolledHint': 'Curl token already consumed — the device is continuing setup. Watch the checklist below for the next stages.',
  'admin.lc.detail.curlTtyHint': 'Requires an interactive terminal: sudo will prompt for a password. Via reverse-ssh or any non-interactive SSH, launch screen or tmux before running the command.',
  'admin.lc.detail.alreadyConnectedToggle': 'Computer is already connected',
  'admin.lc.detail.connKindLabel': 'Connection type',
  'admin.lc.detail.connKind.wg': 'WireGuard',
  'admin.lc.detail.connKind.reverse_ssh': 'Reverse SSH',
  'admin.lc.detail.connKind.legacy': 'Legacy server',
  'admin.lc.detail.wgIpLabel': 'WireGuard IP',
  'admin.lc.detail.wgPubkeyLabel': 'WireGuard public key',
  'admin.lc.detail.wgPubkeyHint': 'From /etc/wireguard/wg0.conf on the server (near this IP).',
  'admin.lc.detail.wgPubkeyFetched': 'WireGuard pubkey (from server)',
  'admin.lc.detail.wgCommentFromConf': 'Comment from wg0.conf',
  'admin.lc.detail.wgHandshakeRecent': 'wg handshake: recent',
  'admin.lc.detail.wgHandshakeNone': 'wg handshake: none',
  'admin.lc.detail.wgPeerNotFound': 'This IP is not configured as a wg peer on the server',
  'admin.lc.detail.wgPeerUnavailable': 'wg state unavailable — try again later',
  'admin.lc.detail.reverseSshPortLabel': 'Reverse SSH port',
  'admin.lc.detail.legacyEndpointLabel': 'SSH endpoint',
  'admin.lc.detail.legacyEndpointHint': 'e.g. ssh linza@62.84.114.224 -p 2234. Saved to notes as plain text — NOT executed by the system; informational only.',
  'admin.lc.detail.checkAction': 'Check',
  'admin.lc.detail.registerAction': 'Register as connected',
  'admin.lc.detail.fullySetupLabel': 'Fully set up (Docker already running)',
  'admin.lc.detail.checkBadWgIp': 'IP must be in 10.99.0.0/24',
  'admin.lc.detail.checkBadPubkey': 'Public key looks wrong',
  'admin.lc.detail.checkBadPort': 'Port must be a number',
  'admin.lc.detail.checkBadLegacy': 'Enter the SSH endpoint',
  'admin.lc.detail.checkClashWgIp': 'IP already taken: {{name}}',
  'admin.lc.detail.checkClashPubkey': 'Pubkey already taken: {{name}}',
  'admin.lc.detail.checkClashPort': 'Port already taken: {{name}}',
  'admin.lc.detail.checkOkWg': 'OK — pubkey fetched from server',
  'admin.lc.detail.checkOkRevSsh': 'OK — port is free',
  'admin.lc.detail.checkWgHandshakeOk': 'OK — pubkey found, handshake live',
  'admin.lc.detail.checkWgNoHandshake': 'Pubkey found, but no recent handshake — computer may be offline',
  'admin.lc.detail.deleteAction': 'Delete',
  'admin.lc.detail.deleteConfirm': 'Confirm delete?',
  'admin.lc.detail.checkOkLegacy': 'OK — will store in notes',
  'admin.lc.detail.wgPeerWaiting': 'Device is not connected to WG yet',
  'admin.lc.detail.wgPeerWaitingHint': 'Run the curl on the device to establish the tunnel.',
  'admin.lc.detail.wgPeerShowCurl': 'Show curl',
  'admin.lc.detail.networkIdentityCurlRerunHint': 'Changing wg_ip / device # requires re-running the curl on the device (the new reverse-SSH port / WG IP won\'t bind automatically).',
  'admin.lc.detail.wgPeerMissingHeading': 'WG peer not registered on the server',
  'admin.lc.detail.wgPeerMissingHint': 'Auto-add daemon (#48) didn\'t run. Verify the host cron add_wg_peer.sh is alive.',
  'admin.lc.detail.wgPeerMissingCta': 'Open Host Infrastructure',
  'admin.lc.detail.wgPeerConnected': 'WireGuard connected, handshake {{ago}}',
  'admin.lc.detail.ago': 'ago',
  // SSH-pubkey copy-paste keys dropped 2026-05-22 — see RU dictionary above.
  'admin.lc.detail.infraSnippetsHeading': 'Wire into infrastructure',
  // Whole `snippet*` block removed — these served the old
  // manual-deploy flow (copy-paste snippets + operator "mark done"
  // buttons). The detail page no longer renders any of them;
  // the strings were orphans.
  'admin.lc.detail.nodeExporterHeading': 'node_exporter',
  'admin.lc.detail.nodeExporterProbe': 'Probe :9100',
  'admin.lc.detail.nodeExporterNoWg': 'wg_ip not set — probe unavailable.',
  'admin.lc.detail.nodeExporterUp': 'OK — {{url}} responding',
  'admin.lc.detail.nodeExporterDown': 'Down: {{reason}}',
  'admin.lc.detail.lastErrorHeading': '{{at}} · stage {{stage}} · exit {{exit_code}}',
  'admin.lc.detail.scriptFailedHeading': 'Script failed — fix the issue and run curl again',
  'admin.lc.detail.curlPostFailureHint': 'Get a new token and run curl on the device again. Full error log was sent to Telegram.',
  'admin.lc.detail.bindHeading': 'Assign deployment key',
  'admin.lc.detail.editHeading': 'Edit',
  'admin.lc.detail.notesLabel': 'Notes',

  // Equipment-side LocalComputer panel
  'equipment.lc.title': 'Linza Computer',
  'equipment.lc.lastSeen': 'last seen',
  'equipment.lc.loadError': 'Failed to load computer info.',
  // Group D — peer discovery on the LC card (2026-06-02 redesign).
  'equipment.lc.discovery.title': 'Discover devices on the network',
  'equipment.lc.discovery.idleHint': 'Find cameras, NVRs and a router on the jetson\'s LAN.',
  'equipment.lc.discovery.start': 'Start scan',
  'equipment.lc.discovery.runAgain': 'Scan again',
  'equipment.lc.discovery.dismiss': 'Close',
  'equipment.lc.discovery.headerTitle': 'Device discovery',
  'equipment.lc.discovery.searching': 'Scanning the jetson\'s subnet…',
  'equipment.lc.discovery.emptyTerminal': 'No matching devices found. Check that the jetson is on the right subnet.',
  'equipment.lc.discovery.candidatesTitle': 'Discovered devices',
  'equipment.lc.discovery.candidatesHelp': 'Pick what to import — camera, NVR, or router. The triple-dots menu overrides the type and runs connectivity checks.',
  'equipment.lc.discovery.othersTitle': 'Other devices on the network',
  'equipment.lc.discovery.othersHelp': 'Type not auto-detected. Use the triple-dots menu to designate one explicitly.',
  'equipment.lc.discovery.peersCount': 'found {{count}}',
  'equipment.lc.discovery.actions.addAsNvrTitle': 'Add device as an NVR',
  'equipment.lc.discovery.actions.addAsRouterTitle': 'Add device as a router',
  // Equipment-side NVR panel
  'equipment.nvr.title': 'Video Recorder (NVR)',
  'equipment.nvr.vendor': 'Vendor',
  'equipment.nvr.ipAddress': 'LAN IP',
  'equipment.nvr.port': 'Port',
  'equipment.nvr.username': 'Username',
  'equipment.nvr.password': 'Password',
  'equipment.nvr.model': 'Model',
  'equipment.nvr.serialNumber': 'Serial number',
  'equipment.nvr.firmwareVersion': 'Firmware',
  'equipment.nvr.deviceId': 'Device ID',
  'equipment.nvr.macAddress': 'MAC address',
  'equipment.nvr.identity': 'Identity',
  'equipment.nvr.notes': 'Notes',
  'equipment.nvr.show': 'Show',
  'equipment.nvr.hide': 'Hide',
  'equipment.nvr.importCameras': 'Import cameras',
  'equipment.nvr.importResult': 'Added: {{added}}, existing: {{existing}}, errors: {{errors}}.',
  'equipment.nvr.delete': 'Delete',
  'equipment.nvr.deleteConfirm': 'Delete this NVR?',
  // Equipment-side Router panel (Brick 7)
  'equipment.router.title': 'Router',
  'equipment.router.empty': 'No router configured. Add credentials for remote access.',
  'equipment.router.add': 'Add router',
  'equipment.router.modelName': 'Model',
  'equipment.router.modelName.keenetic': 'Keenetic',
  'equipment.router.modelName.linzaRouter': 'Linza Metrics router',
  'equipment.router.modelName.mikrotik': 'Mikrotik',
  'equipment.router.modelName.asus': 'ASUS',
  'equipment.router.modelName.tplink': 'TP-Link',
  'equipment.router.modelName.other': 'Other',
  'equipment.router.modelName.otherPlaceholder': 'Vendor name',
  'equipment.router.gatewayIp': 'LAN IP',
  'equipment.router.adminUrl': 'Admin panel URL',
  'equipment.router.remoteAccessUrl': 'Remote access',
  'equipment.router.username': 'Username',
  'equipment.router.password': 'Password',
  'equipment.router.notes': 'Notes',
  'equipment.router.show': 'Show',
  'equipment.router.hide': 'Hide',
  'equipment.router.delete': 'Delete',
  'equipment.router.deleteConfirm': 'Confirm delete?',
  // Router autodiscovery Phase A — read-only RCI probe + LAN host preview
  'equipment.router.autodiscover': 'Find devices',
  'equipment.router.probe.wgState': 'WireGuard',
  'equipment.router.probe.wgConfigured': 'configured',
  'equipment.router.probe.wgAbsent': 'absent',
  'equipment.router.probe.wgWrongScope': 'routes exceed scope',
  'equipment.router.probe.lanHosts': 'Devices on LAN',
  'equipment.router.probe.existingForwards': 'Port forwards',
  'equipment.router.probe.likelyCameras': 'Likely cameras',
  'equipment.router.probe.suggestedCameras': 'Suggested cameras',
  'equipment.router.probe.suggestedCamerasHelp': 'Tick the cameras to add to this zone. Devices without a 554 forward aren’t reachable yet.',
  'equipment.router.probe.showHosts': 'Show devices',
  'equipment.router.probe.showAllHosts': 'Other devices on the network',
  'equipment.router.probe.offline': 'offline',
  'equipment.router.probe.credentialsRejected': 'Login or password rejected',
  'equipment.router.probe.unreachable': 'Could not reach the router',
  'equipment.router.probe.enumerateFailed': 'Router answered but data was unreadable',
  'equipment.router.probe.searching': 'Detecting model and network…',
  'equipment.router.editDialog.title': 'Edit router',
  'equipment.router.editDialog.advanced': 'Advanced settings',
  'equipment.router.editDialog.probeFailed': 'Could not detect model — fill it in manually.',
  'equipment.router.editDialog.detected': 'detected automatically',
  'equipment.router.editDialog.bridgeLayoutShow': 'JSON',
  'equipment.router.editDialog.bridgeLayoutCount': '{{count}} interfaces',
  'equipment.router.wanIp': 'WAN IP',
  'equipment.router.modelFullSku': 'Full model',
  'equipment.router.firmware': 'Firmware',
  'equipment.router.firmwareFactory': 'Factory firmware',
  'equipment.router.bridgeLayout': 'Network interfaces',
  'equipment.router.remoteAccessUrlHelp': 'Optional alternate URL for when the main one is unreachable (e.g. keenetic.link or DDNS).',
  'equipment.router.refresh': 'Refresh',
  'equipment.router.refreshTooltip': 'Re-scan devices and network',
  'equipment.router.fetchedAt': 'updated at {{time}}',
  'equipment.router.fetchedJustNow': 'updated just now',
  'equipment.router.fetchedNever': 'No data yet — hit Refresh in the top right.',
  'equipment.router.refreshing': 'Refreshing…',
  'equipment.router.connection': 'Connection',
  'equipment.router.status': 'Overview',
  'equipment.router.devicesCount': 'Devices on network',
  'equipment.router.camerasCount': 'Likely cameras',
  'equipment.router.forwardsCount': 'Port forwards',
  'equipment.router.statusWgConfigured': 'configured · {{ip}}',
  'equipment.router.statusWgAbsent': 'not configured',
  'equipment.router.statusWgWrongScope': 'routes exceed scope',
  'equipment.router.dash': '—',
  'equipment.router.actionsLabel': 'Actions',
  'equipment.router.refreshError': 'Could not refresh — showing previous data.',
  'equipment.router.suggested': 'Suggested cameras',
  'equipment.router.suggestedOthers': 'Other devices',
  'equipment.router.actionsMore': 'More',
  'equipment.router.forwards.title': 'Port forwards',
  'equipment.router.forwards.add': 'Add forward',
  'equipment.router.forwards.delete': 'Delete',
  'equipment.router.forwards.empty': 'No forwards yet.',
  'equipment.router.forwards.field.interface': 'Interface',
  'equipment.router.forwards.field.protocol': 'Protocol',
  'equipment.router.forwards.field.externalPort': 'External port',
  'equipment.router.forwards.field.internalPort': 'Internal port',
  'equipment.router.forwards.field.toHost': 'LAN host IP/MAC',
  'equipment.router.forwards.field.comment': 'Comment',
  'equipment.router.forwards.field.commentPlaceholder': 'Optional — what is this stream',
  'equipment.router.forwards.addDialog.title': 'New port forward',
  'equipment.router.forwards.addDialog.submit': 'Add',
  'equipment.router.forwards.deleteDialog.title': 'Delete forward?',
  'equipment.router.forwards.deleteDialog.body': 'The rule will be removed from the router. Cameras that rely on it will stop responding.',
  'equipment.router.forwards.errors.unsupported_router_model': 'This router model does not support rule writes.',
  'equipment.router.forwards.errors.credentials_rejected': 'The router rejected the username or password.',
  'equipment.router.forwards.errors.unreachable': 'Could not reach the router.',
  'equipment.router.forwards.errors.missing_field': 'Some required fields are empty.',
  'equipment.router.forwards.errors.bad_protocol': 'Protocol must be TCP or UDP.',
  'equipment.router.forwards.errors.bad_external_port': 'External port must be between 1 and 65535.',
  'equipment.router.forwards.errors.bad_internal_port': 'Internal port must be between 1 and 65535.',
  'equipment.router.forwards.errors.bad_comment': 'Comment must be a single line of up to 200 characters.',
  'equipment.router.forwards.errors.external_port_reserved': 'Port 80 is reserved for the router admin UI — pick another (e.g. 8080).',
  'equipment.router.forwards.errors.device_rejected': 'The router did not accept the rule (CLI parse error).',
  'equipment.router.forwards.errors.readback_missing': 'Write went through but the rule is not in the config — try again.',
  'equipment.router.forwards.errors.readback_still_present': 'Delete went through but the rule is still in the config — try again.',
  // Router import-cameras (autodiscovery Phase A.5)
  'equipment.router.probe.forwardLabel': 'RTSP',
  'equipment.router.probe.noForward': 'No forward — add one on the router',
  'equipment.router.probe.noForwardYet': 'No 554 forward yet',
  'equipment.router.import.button': 'Import selected',
  'equipment.router.import.dialogTitle': 'Import cameras from router',
  'equipment.router.import.dialogIntro': 'These credentials apply to every selected camera. You can change them later on the Cameras tab.',
  'equipment.router.import.username': 'Username',
  'equipment.router.import.password': 'Password',
  'equipment.router.import.submit': 'Import',
  'equipment.router.import.cancel': 'Cancel',
  'equipment.router.import.selected': 'Selected',
  'equipment.router.import.wgRequired': 'Configure the WireGuard tunnel on the router first — without it the cameras are unreachable from central.',
  'equipment.router.import.successCreated': 'Cameras created',
  'equipment.router.import.successSkipped': 'Skipped (already exist)',
  'equipment.router.import.errorRows': 'Errors',
  'equipment.router.import.error': 'Import failed',
  // Router redesign 2026-06-02 — see RU dictionary for rationale.
  'equipment.router.modelSubcaption': 'model',
  'equipment.router.modelUnknown': 'Model unknown',
  'equipment.router.firmwareInline': 'firmware {{version}}',
  'equipment.router.subcard.connection': 'Connection',
  'equipment.router.subcard.overview': 'Overview',
  'equipment.router.sectionForwards.collapsed': 'Port forwards',
  'equipment.router.sectionForwards.expand': 'Expand',
  'equipment.router.sectionForwards.collapse': 'Collapse',
  'equipment.router.sectionDevices.collapsed': 'Possible cameras',
  'equipment.router.sectionDevices.expand': 'Expand',
  'equipment.router.sectionDevices.collapse': 'Collapse',
  'equipment.router.sectionDevices.othersTitle': 'Other devices on the network',
  'equipment.router.sectionDevices.othersHelp': 'Tap “This is a camera / NVR / router” if something was not auto-classified.',
  'equipment.router.sectionDevices.alreadyImported': 'Already added',
  'equipment.discoveredPeer.import.camera': 'Add as camera',
  'equipment.discoveredPeer.import.nvr': 'Add as NVR',
  'equipment.discoveredPeer.import.router': 'Add as router',
  'equipment.discoveredPeer.alreadyImported': 'Already added',
  'equipment.discoveredPeer.viaNvr': 'via NVR',
  'equipment.discoveredPeer.jetsonNote': 'Linza device — no forward needed',
  'equipment.discoveredPeer.bulkSelect': 'Select',
  'equipment.discoveredPeer.bulkUnselect': 'Clear selection',
  'equipment.discoveredPeer.designate.camera': 'This is a camera',
  'equipment.discoveredPeer.designate.nvr': 'This is an NVR',
  'equipment.discoveredPeer.designate.router': 'This is a router',
  'equipment.discoveredPeer.designate.reset': 'Reset',
  'equipment.discoveredPeer.check.ping': 'Ping',
  'equipment.discoveredPeer.check.tcp': 'Port open',
  'equipment.discoveredPeer.check.rtsp': 'RTSP stream',
  'equipment.discoveredPeer.check.running': 'checking…',
  'equipment.discoveredPeer.check.fail': 'no answer',
  'equipment.discoveredPeer.check.ms': '{{ms}} ms',
  'equipment.discoveredPeer.check.idleTooltip': 'click to run a check',
  'equipment.discoveredPeer.check.noForwardHint': 'Create a port forward for this device first — without it the router cannot test connectivity.',
  'equipment.discoveredPeer.check.err.host_unreachable': 'host unreachable',
  'equipment.discoveredPeer.check.err.port_closed': 'port closed',
  'equipment.discoveredPeer.check.err.rtsp_unauthorized': 'credentials required',
  'equipment.discoveredPeer.check.err.rtsp_no_stream': 'stream not found',
  'equipment.discoveredPeer.check.err.timeout': 'timeout',
  'equipment.discoveredPeer.check.err.target_required': 'refresh the page',
  'equipment.discoveredPeer.menu.label': 'Actions',
  'equipment.discoveredPeer.menu.checksGroup': 'Connectivity checks',
  'equipment.discoveredPeer.menu.designateGroup': 'Designate device',
  'equipment.discoveredPeer.import.confirm.existingForward.title': 'Import camera?',
  'equipment.discoveredPeer.import.confirm.existingForward.body': 'Camera will be added at {{addr}}.',
  'equipment.discoveredPeer.import.confirm.autoForward.title': 'Create forward and import?',
  'equipment.discoveredPeer.import.confirm.autoForward.body': 'A forward {{externalPort}} → {{internalPort}} will be created on {{iface}}. The camera will be added as inactive — fill credentials in its settings.',
  'equipment.discoveredPeer.import.confirm.autoForward.bodyPending': 'A forward 554 → 554 will be created (external port chosen automatically). The camera will be added as inactive — fill credentials in its settings.',
  'equipment.discoveredPeer.import.confirm.submit': 'Import',
  'equipment.discoveredPeer.import.confirm.cancel': 'Cancel',
  'equipment.discoveredPeer.import.confirm.credsHelp': 'Fill the camera username and password in its settings after import — these are not the router credentials.',
  'equipment.discoveredPeer.import.confirm.credsLater': 'fill after import',
  'equipment.discoveredPeer.import.confirm.storedAs': 'In Linza Metrics:',
  'equipment.discoveredPeer.import.confirm.routerPath': 'On the router:',
  'equipment.discoveredPeer.import.error.no_reachable_path': 'Cannot forward port: the router has no WireGuard tunnel and no public WAN IP.',
  'equipment.discoveredPeer.import.error.endpoint_not_deployed': 'Auto-forward endpoint is not deployed on the BE yet.',
  'equipment.discoveredPeer.import.error.autoForwardNoPort': 'The router did not return an external port — camera import aborted to avoid an orphan record.',
  'equipment.discoveredPeer.import.error.generic': 'Import failed',
  // Source-type picker + EZVIZ RTSP-retrieval card.
  'equipment.discoveredPeer.import.sourceType': 'Source type',
  'equipment.discoveredPeer.import.ezviz.title': 'Ezviz RTSP retrieval',
  'equipment.discoveredPeer.import.ezviz.run': 'Run',
  'equipment.discoveredPeer.import.ezviz.runAgain': 'Run again',
  'equipment.discoveredPeer.import.ezviz.running': 'Running…',
  'equipment.discoveredPeer.import.ezviz.close': 'Close',
  'equipment.discoveredPeer.import.ezviz.done': 'Done',
  'equipment.discoveredPeer.import.ezviz.successTitle': 'Camera "{{name}}" added',
  'equipment.discoveredPeer.import.ezviz.successHint': 'RTSP enabled; resolution and codec saved',
  'equipment.discoveredPeer.import.ezviz.verificationCode': 'Verification code',
  'equipment.discoveredPeer.import.ezviz.verificationCodePlaceholder': 'code on the camera label',
  'equipment.discoveredPeer.import.ezviz.needVerificationCode': 'Enter the camera verification code (on the label) — it doubles as the RTSP password.',
  'equipment.discoveredPeer.import.ezviz.forwardsDone': 'RTSP → external {{rtsp}}, SDK → external {{sdk}}',
  'equipment.discoveredPeer.import.ezviz.alreadyRunning': 'An RTSP-enable is already in progress for this camera — wait and run again.',
  'equipment.discoveredPeer.import.ezviz.bootstrapFailed': 'Could not enable RTSP over the SDK.',
  'equipment.discoveredPeer.import.ezviz.probeNoMeta': 'Stream is reachable but metadata could not be determined.',
  'equipment.discoveredPeer.import.ezviz.previewAlt': 'RTSP preview frame',
  'equipment.discoveredPeer.import.ezviz.step.forwards': 'Port forwards (RTSP 554 + SDK 8000)',
  'equipment.discoveredPeer.import.ezviz.step.rtsp': 'Enable RTSP on the camera (Hik SDK)',
  'equipment.discoveredPeer.import.ezviz.step.import': 'Import camera',
  'equipment.discoveredPeer.import.ezviz.step.probe': 'Probe RTSP: resolution & codec',
  'equipment.discoveredPeer.bulk.footer': 'Selected: {{count}}',
  'equipment.discoveredPeer.bulk.importCameras': 'Import as cameras',
  'equipment.discoveredPeer.bulk.createForwards': 'Create 554 forwards',
  'equipment.discoveredPeer.bulk.cancel': 'Cancel',
  'equipment.router.forwards.field.toHost.picker': 'LAN device',
  'equipment.router.forwards.field.toHost.pickerPlaceholder': 'Pick a device…',
  'equipment.router.forwards.field.toHost.alreadyImported': 'already imported',
  'equipment.router.forwards.field.toHost.alreadyImportedHint': 'a camera already exists for this device',
  'equipment.router.forwards.field.family': 'Purpose',
  'equipment.router.forwards.field.family.rtsp': 'Camera: RTSP',
  'equipment.router.forwards.field.family.api': 'Camera: API',
  'equipment.router.forwards.field.family.other': 'Other',
  'equipment.router.forwards.field.family.cameraPrefix': 'Camera:',
  'equipment.router.forwards.field.family.shortRtsp': 'RTSP',
  'equipment.router.forwards.field.family.shortApi': 'API',
  'equipment.router.forwards.field.family.shortOther': 'Other',
  'equipment.router.forwards.internalPortMismatch': 'Does not match the suggested {{suggested}} for "{{family}}".',
  'equipment.router.forwards.autoPort': 'auto',
  'equipment.router.forwards.autoPortHint': 'router picks a free one',
  'equipment.router.forwards.errors.no_reachable_path': 'Cannot forward port: the router has no WireGuard tunnel and no public WAN IP.',
  'equipment.router.forwards.errors.endpoint_not_deployed': 'Auto-forward endpoint is not deployed on the BE yet — using manual mode.',
  // On-demand admin tunnel button (issue #34)
  'equipment.adminTunnel.open': 'Admin panel',
  'equipment.adminTunnel.tooltip': 'Open device admin panel through the jetson',
  'equipment.adminTunnel.error': 'Could not open tunnel',
  // Vendor-API parameter tweaks for cameras (issue #34 part 3)
  'equipment.vendorParams.title': 'Image parameters',
  'equipment.vendorParams.subtitle': 'Values are read from and written to the camera directly',
  'equipment.vendorParams.brightness': 'Brightness',
  'equipment.vendorParams.contrast': 'Contrast',
  'equipment.vendorParams.saturation': 'Saturation',
  'equipment.vendorParams.sharpness': 'Sharpness',
  'equipment.vendorParams.hue': 'Hue',
  'equipment.vendorParams.backlightEnabled': 'Backlight compensation',
  'equipment.vendorParams.backlightLevel': 'Backlight compensation level',
  'equipment.vendorParams.loadError': 'Failed to read parameters',
  'equipment.vendorParams.writeError': 'Failed to write value',
  'equipment.vendorParams.clickToOpen': 'Click to read live values from the camera',
  'equipment.vendorParams.unsupported': 'This camera does not expose its parameters over the API',
  'equipment.vendorParams.loadingValues': 'Reading values from the camera…',
  'equipment.vendorParams.refresh': 'Re-read from the camera',
  // Targets — where the image settings live
  'equipment.vendorParams.target.nvr': 'On NVR',
  'equipment.vendorParams.target.camera': 'On camera',
  // Groups (image-knob section headers)
  'equipment.vendorParams.wdr': 'WDR (wide dynamic range)',
  'equipment.vendorParams.wdr.mode': 'WDR mode',
  'equipment.vendorParams.wdr.level': 'WDR level',
  'equipment.vendorParams.wdr.mode.auto': 'Auto',
  'equipment.vendorParams.wdr.mode.off': 'Off',
  'equipment.vendorParams.wdr.mode.on': 'On',
  'equipment.vendorParams.blc': 'BLC (backlight compensation)',
  'equipment.vendorParams.blc.enabled': 'Enable BLC',
  'equipment.vendorParams.blc.mode': 'Compensation direction',
  'equipment.vendorParams.blc.level': 'BLC level',
  'equipment.vendorParams.blc.mode.off': 'Off',
  'equipment.vendorParams.blc.mode.up': 'Up',
  'equipment.vendorParams.blc.mode.down': 'Down',
  'equipment.vendorParams.blc.mode.left': 'Left',
  'equipment.vendorParams.blc.mode.right': 'Right',
  'equipment.vendorParams.blc.mode.center': 'Center',
  'equipment.vendorParams.hlc': 'HLC (highlight compensation)',
  'equipment.vendorParams.hlc.enabled': 'Enable HLC',
  'equipment.vendorParams.hlc.level': 'HLC level',
  'equipment.vendorParams.color': 'Color',
  'equipment.vendorParams.shutter': 'Shutter',
  'equipment.vendorParams.shutter.level': 'Shutter speed',
  'equipment.vendorParams.supplementLight': 'Supplement light',
  'equipment.vendorParams.supplementLight.mode': 'Supplement-light mode',
  'equipment.vendorParams.supplementLight.whiteBrightness': 'White-light brightness',
  'equipment.vendorParams.supplementLight.irBrightness': 'IR brightness',
  'equipment.vendorParams.supplementLight.mode.off': 'Off',
  'equipment.vendorParams.supplementLight.mode.ir': 'IR',
  'equipment.vendorParams.supplementLight.mode.colorVu': 'ColorVu (white light)',
  'equipment.vendorParams.supplementLight.mode.eventIntel': 'Event-triggered',
  'equipment.vendorParams.imageFlip': 'Image flip',
  'equipment.vendorParams.imageFlip.enabled': 'Enable flip',
  'equipment.vendorParams.imageFlip.style': 'Flip style',
  // Live 1 fps preview in camera detail (issue #34 part 2)
  'equipment.liveStream.title': 'Live camera view',
  'equipment.liveStream.subtitle': 'Refreshes about once a second',
  'equipment.liveStream.error': 'Failed to fetch frame',
  'equipment.liveStream.noFrame': 'No frame',
  'equipment.liveStream.idle': 'Click Play to start the preview',
  'equipment.liveStream.play': 'Play',
  'equipment.liveStream.stop': 'Stop',
  'equipment.liveStream.unsupported': 'This camera does not expose snapshots over the API',
  // EZVIZ pan/tilt pad in camera detail
  'equipment.ptz.title': 'Camera aim',
  'equipment.ptz.up': 'Up',
  'equipment.ptz.down': 'Down',
  'equipment.ptz.left': 'Left',
  'equipment.ptz.right': 'Right',
  'equipment.ptz.savePosition': 'Save position',
  'equipment.ptz.gotoPosition': 'Go to saved position',
  'equipment.ptz.error': 'Could not move the camera',
  // Equipment-side autodiscovery flow (2026-05-17 design)
  'equipment.discovery.creds.title': 'Credentials required',
  'equipment.discovery.creds.lastTried': 'last tried username: {{username}}',
  'equipment.discovery.creds.addRow': 'Add another',
  'equipment.discovery.creds.removeRow': 'Remove row',
  'equipment.discovery.creds.submit': 'Try',
  'equipment.discovery.creds.skip': 'Skip this device',
  'equipment.discovery.idleHint': 'Auto-detect router, NVR, and cameras on the jetson’s network.',
  'equipment.discovery.startMaster': 'Start autodiscovery',
  'equipment.discovery.headerTitle': 'Autodiscovery',
  'equipment.discovery.collapse': 'Collapse',
  'equipment.discovery.expand': 'Expand',
  'equipment.discovery.cancel': 'Cancel',
  'equipment.discovery.runAgain': 'Run again',
  'equipment.discovery.done': 'Done',
  'equipment.discovery.collapsedHint': 'Autodiscovery in progress ({{status}}).',
  'equipment.discovery.status.created': 'starting',
  'equipment.discovery.status.running': 'running',
  'equipment.discovery.status.paused_on_creds': 'awaiting creds',
  'equipment.discovery.status.ok': 'done',
  'equipment.discovery.status.partial': 'partial',
  'equipment.discovery.status.failed': 'failed',
  'equipment.discovery.status.cancelled': 'cancelled',
  'equipment.discovery.summary.terminal.ok': 'Autodiscovery completed successfully.',
  'equipment.discovery.summary.terminal.partial': 'Autodiscovery finished with some devices skipped.',
  'equipment.discovery.summary.terminal.failed': 'Autodiscovery failed.',
  'equipment.discovery.summary.terminal.cancelled': 'Autodiscovery cancelled.',
  'equipment.discovery.summary.kind.router': 'Routers',
  'equipment.discovery.summary.kind.nvr': 'NVR',
  'equipment.discovery.summary.kind.camera': 'Cameras',
  'equipment.discovery.summary.line': '{{added}} added, {{existing}} existing, {{skipped}} skipped',
  'equipment.discovery.summary.errors': 'Errors during discovery: {{n}}',
  // Equipment-side "+ Add device" dropdown (2026-05-17 design §2.3)
  'equipment.addDevice.button': 'Add device',
  'equipment.addDevice.router': 'Router',
  'equipment.addDevice.nvr': 'NVR',
  'equipment.addDevice.camera': 'Camera',
  'equipment.addDevice.microphone': 'Microphone',
  // Microphone panel + new-mic form (audio capture device on the Jetson).
  'equipment.mic.title': 'Microphone',
  'equipment.mic.alsaDevice': 'ALSA device',
  'equipment.mic.cardName': 'Sound card',
  'equipment.mic.capture': 'Capture',
  'equipment.mic.enabled': 'Enabled',
  'equipment.mic.disabled': 'Disabled',
  'equipment.mic.delete': 'Delete',
  'equipment.mic.deleteConfirm': 'Confirm delete?',
  'equipment.mic.networkTitle': 'Network microphone (router)',
  'equipment.mic.address': 'Address',
  'equipment.mic.check': 'Check sound',
  'equipment.mic.checking': 'Listening…',
  'equipment.mic.online': 'online',
  'equipment.mic.offline': 'not responding',
  'equipment.mic.levels': 'average {{rms}} dB · peaks {{peak}} dB',
  'equipment.newMic.title': 'New microphone',
  'equipment.newMic.discover': 'Discover devices',
  'equipment.newMic.discovered': 'Discovered devices',
  'equipment.newMic.noDevices': 'No microphones found on the Jetson.',
  'equipment.newMic.alsaDevice': 'ALSA device',
  'equipment.newMic.alsaHint': 'An hw:X,Y address. Pick one above or type it manually.',
  'equipment.newMic.alsaDeviceRequired': 'Enter an ALSA device (e.g. hw:2,0).',
  'equipment.newMic.kindUsb': 'USB on the Jetson',
  'equipment.newMic.kindNetwork': 'Network (router)',
  'equipment.newMic.address': 'Microphone address',
  'equipment.newMic.addressHint': 'WG address of the router with the mic and its port, usually 5555. Central records it.',
  'equipment.newMic.addressInvalid': 'Use an address like tcp://10.99.0.N:5555.',
  'equipment.newRouter.title': 'New router',
  'equipment.newNVR.title': 'New NVR',
  'equipment.newNVR.ipAddress': 'IP address',
  'equipment.newNVR.port': 'HTTP port (ISAPI)',
  'equipment.newNVR.username': 'Username',
  'equipment.newNVR.password': 'Password',
  'equipment.newNVR.vendor': 'Vendor',
  'equipment.newNVR.notes': 'Notes',
  'equipment.newNVR.ipAddressRequired': 'NVR IP address is required.',
  'admin.lc.live': 'Online',
  'admin.lc.notReady': 'Not set up',
  'admin.lc.archived': 'Archived',
  'admin.lc.stage.ENROLLED': 'Enrollment',
  'admin.lc.stage.WG_CONFIGURED': 'WireGuard setup',
  'admin.lc.stage.WG_HANDSHAKE_VERIFIED': 'WireGuard handshake',
  'admin.lc.stage.SSH_PUBKEY_AUTHORIZED': 'SSH key authorization',
  'admin.lc.stage.AUTHORIZED_KEYS_PULLED': 'Key sync',
  'admin.lc.stage.REVERSE_SSH_LIVE': 'Reverse SSH',
  'admin.lc.stage.GITLAB_REGISTERED': 'GitLab CI registration',
  'admin.lc.stage.TRAEFIK_REGISTERED': 'Traefik registration',
  'admin.lc.stage.DOCKER_RUNNING': 'Docker startup',

  // Admin user list
  'admin.branches.title': 'Branches',
  'admin.branches.subtitle': 'All branches in the system',
  'admin.branches.searchPlaceholder': 'Search branches…',
  'admin.branches.empty': 'No branches found',
  'admin.branches.total': 'Total: {{n}}',
  'admin.branches.colName': 'Name',
  'admin.branches.colType': 'Type',
  'admin.branches.colTimezone': 'Timezone',
  'admin.branches.colStatus': 'Status',
  'admin.branches.archived': 'Archived',
  'admin.branches.active': 'Active',
  'admin.branches.openSettings': 'Settings',
  'admin.branches.colCapture': 'Capture',
  'admin.branches.captureLc': 'On-site computer',
  'admin.branches.captureRouter': 'Router',
  'admin.users.title': 'Users',
  'admin.users.subtitle': 'Manage system accounts.',
  'admin.users.searchPlaceholder': 'Search by username or email…',
  'admin.users.colUsername': 'Username',
  'admin.users.colEmail': 'Email',
  'admin.users.colRole': 'Role',
  'admin.users.colBranches': 'Branches',
  'admin.users.colLastLogin': 'Last login',
  'admin.users.neverLoggedIn': 'never',
  'admin.users.openProfile': 'Open',
  'admin.users.empty': 'No users.',
  'admin.users.pageOf': '{{from}}–{{to}} of {{total}}',
  'admin.users.prev': 'Previous page',
  'admin.users.next': 'Next page',
  'admin.users.roleSuperuser': 'Superuser',
  'admin.users.roleStaff': 'Staff',
  'admin.users.roleMember': 'User',

  // Admin user detail
  'admin.user.title': 'User profile',
  'admin.user.subtitle': 'Access, roles, and password reset.',
  'admin.user.backToList': 'Back to user list',
  'admin.user.profile': 'Profile',
  'admin.user.profileDescription': 'Account {{username}}.',
  'admin.user.flagSuperuser': 'Superuser',
  'admin.user.flagSuperuserDescription': 'Full access to everything: BE endpoints, Django admin, every branch.',
  'admin.user.flagStaff': 'Staff (Django admin access)',
  'admin.user.flagStaffDescription': 'Lets the user sign in to /core/admin/. Doesn\'t grant rights on its own, but admin is unreachable without it.',
  'admin.user.cannotSelfRevoke': 'You cannot revoke your own superuser status.',
  'admin.user.staffImpliedBySuperuser': 'Superusers are staff automatically.',
  'admin.user.password': 'Reset password',
  'admin.user.passwordDescription': 'Set a new password for the user. At least {{n}} characters. The current password is not required.',
  'admin.user.passwordSubmit': 'Reset password',
  'admin.user.passwordResetSuccess': 'Password for {{username}} updated.',
  'admin.user.telegram.title': 'Telegram account',
  'admin.user.telegram.hint': 'Bind this user\'s Telegram login so signing in via TG lands them on this account. Without a binding, a random person whose TG handle happens to match this username cannot claim it.',
  'admin.user.telegram.placeholder': 'username (without @)',
  'admin.user.telegram.bind': 'Bind',
  'admin.user.telegram.unbind': 'Unbind',
  'admin.user.telegram.usernameRequired': 'Enter a telegram username.',
  'admin.user.telegram.verified': '✓ verified',
  'admin.user.telegram.pending': 'awaiting first login',
  'admin.user.branches': 'Branch access',
  'admin.user.branchesDescription': 'Branches the user can access and their role in each one.',
  'admin.user.noBranches': 'The user has no branch access.',
  'admin.user.noBranchesAvailable': 'All branches already added.',
  'admin.user.grantBranch': 'Grant branch access',
  'admin.user.pickBranch': 'Pick a branch',
  'admin.user.grant': 'Grant',
  'admin.user.removeBranch': 'Remove access',
  'admin.user.removeBranchConfirm': 'Remove access to "{{zone}}"?',
  'admin.user.inheritedFromGroup': 'Inherited from group: {{groups}}',
  'admin.user.roleLockedHint': 'Access is granted via a group — change the role or remove access there.',

  'admin.groups.title': 'Groups',
  'admin.groups.subtitle': 'User groups and branch groups — access is granted group-to-group.',
  'admin.groups.userGroupsTitle': 'User groups',
  'admin.groups.userGroupsDescription': 'Sets of users you can grant access to in one action.',
  'admin.groups.newUserGroup': 'New group',
  'admin.groups.newUserGroupPrompt': 'User group name',
  'admin.groups.noUserGroups': 'No user groups yet.',
  'admin.groups.memberCount': '{{n}} members',
  'admin.groups.noMembers': 'No one in this group yet.',
  'admin.groups.pickUser': 'Pick a user',
  'admin.groups.addMember': 'Add',
  'admin.groups.removeMember': 'Remove from group',
  'admin.groups.deleteGroup': 'Delete group',
  'admin.groups.deleteUserGroupConfirm': 'Delete user group "{{name}}"? Members lose any access granted through it.',
  'admin.groups.grantsOnThisGroup': 'Access granted to this group',

  'admin.groups.branchGroupsTitle': 'Branch groups',
  'admin.groups.branchGroupsDescription': 'Sets of branches — adding a branch to a group instantly grants it to everyone with a role on that group.',
  'admin.groups.newBranchGroup': 'New group',
  'admin.groups.newBranchGroupPrompt': 'Branch group name',
  'admin.groups.noBranchGroups': 'No branch groups yet.',
  'admin.groups.zoneCount': '{{n}} branches',
  'admin.groups.branchesInGroup': 'Branches in this group',
  'admin.groups.noBranchesInGroup': 'No branches in this group yet.',
  'admin.groups.pickBranch': 'Pick a branch',
  'admin.groups.addBranch': 'Add',
  'admin.groups.removeBranch': 'Remove from group',
  'admin.groups.grantsTitle': 'Who has access to this group',
  'admin.groups.noGrants': 'No access granted yet.',
  'admin.groups.pickUserGroup': 'Pick a user group',
  'admin.groups.addGrant': 'Grant',
  'admin.groups.removeGrant': 'Revoke',
  'admin.groups.deleteBranchGroupConfirm': 'Delete branch group "{{name}}"? Access granted through it disappears.',

  'visits.featureDescription': 'Periodic on-site quality checks against a scoring template.',
  'visits.enableLabel': 'Enable Visits for this branch',
  'visits.enableHint': 'Off by default. Turning it on adds a "Visits" tab under Live.',
  'visits.templatesTitle': 'Scoring templates',
  'visits.templatesDescription': 'Parameter groups, yes/no weights, and each group\'s coefficient in the overall formula.',
  'visits.newTemplate': 'New template',
  'visits.newTemplatePrompt': 'Template name',
  'visits.noTemplates': 'No templates yet.',
  'visits.zoneCount': '{{n}} branches',
  'visits.attachToThisBranch': 'Attach to this branch',
  'visits.detachFromThisBranch': 'Detach from this branch',
  'visits.attachToBranchGroup': 'Attach to a branch group…',
  'visits.attachToBranchGroupAction': 'Attach group',
  'visits.chooseTemplatePrompt': 'This branch has more than one visits template — choose which one to conduct',
  'visits.attachedBranches': 'Attached branches',
  'visits.viewMode': 'View',
  'visits.editMode': 'Edit',
  'visits.deleteTemplate': 'Delete template',
  'visits.deleteTemplateConfirm': 'Delete template "{{name}}"?',
  'visits.formulaCoefficient': 'coefficient',
  'visits.deleteGroup': 'Delete group',
  'visits.deleteGroupConfirm': 'Delete parameter group "{{name}}"?',
  'visits.newGroupPlaceholder': 'Parameter group name',
  'visits.addGroup': 'Add group',
  'visits.yes': 'yes',
  'visits.no': 'no',
  'visits.deleteParameter': 'Delete parameter',
  'visits.deleteParameterConfirm': 'Delete parameter "{{name}}"?',
  'visits.newParameterPlaceholder': 'Parameter name',
  'visits.addParameter': 'Add parameter',

  // VISITS-3 (#176): Live-tab «Визиты» — taking/viewing an actual visit.
  'visits.liveTitle': 'Visits',
  'visits.liveSubtitle': 'On-site quality checks',
  'visits.notEnabled': 'Visits are not enabled for this branch.',
  'visits.startHint': 'Start a visit to score the spot against the template.',
  'visits.draftInProgress': 'You have an unfinished visit draft.',
  'visits.startVisit': 'Start visit',
  'visits.continueDraft': 'Continue draft',
  'visits.empty': 'No visits yet.',
  'visits.draftBadge': 'Draft',
  'visits.notFound': 'Visit not found or not accessible.',
  'visits.backToList': 'Back to visits',
  'visits.submittedAt': 'Submitted {{time}}',
  'visits.readOnly': 'Read-only',
  'visits.visitTime': 'Visit time',
  'visits.total': 'Total',
  'visits.generalComment': 'General comment about the spot',
  'visits.generalCommentPlaceholder': 'Comment about the spot…',
  'visits.submit': 'Submit visit',
  'visits.sendToTeam': 'Send to team',
  'visits.sendToTeamSent': 'Sent',
  'visits.sendToTeamError': 'Failed to send',
  'visits.sendConfirm': 'Confirm',
  'visits.chatSectionTitle': 'Telegram chat (ID and topic)',
  'visits.chatIdLabel': 'Telegram chat ID',
  'visits.chatThreadLabel': 'Topic (thread) ID',
  'visits.chatSectionHint': 'Empty = messages go to this branch\'s default chat.',
  'visits.deleteDraft': 'Delete draft',
  'visits.deleteDraftConfirm': 'Delete this draft visit? This cannot be undone.',
  'visits.deleteVisit': 'Delete visit',
  'visits.deleteVisitConfirm': 'Delete this visit? This cannot be undone.',
  'visits.noComment': 'No comment.',

  // VISITS-3: report-tab panel + statistics table.
  'visits.reportPanelTitle': 'Visits',
  'visits.reportPanelEmpty': 'No visits in this period.',
  'visits.reportPanelCount': '{{n}} visits',
  'visits.statsColAuthor': 'Conducted by',
  'visits.statsColTime': 'Time',
  'visits.statsColTotal': 'Total',
  'visits.statsEmpty': 'No visits in the selected period.',
};

// Feature-registry + «Отзывы» strings live in their own file (see featuresDict.ts).
export const dictionaries: Record<Lang, Dict> = {
  ru: { ...ru, ...featuresRu },
  en: { ...en, ...featuresEn },
};
